// Service landing page content: copy, curated photos (caption + alt text) and videos.
// Photo and video paths are old-site uploads served locally (see lib/media.js).
// Generated from the service copy brief; edit freely — this file is the source of truth.

export const SERVICE_LANDINGS = {
  "bathroom-renovations": {
    "metaTitle": "Bathroom Renovations Calgary | MRE Developments",
    "metaDescription": "Bathroom renovations in Calgary, Airdrie and Cochrane: walk-in showers, tile, heated floors and waterproofing by MRE Developments. Get a free quote today.",
    "headline": "Calgary Bathroom Renovations Built for Daily Use and Lasting Style",
    "subheadline": "From tired main baths to spa-grade ensuites, we design, waterproof, tile and finish your bathroom with one licensed, insured team, so you get a space that looks right and holds up.",
    "hero": "2026/02/20241119_124235-scaled.jpg",
    "heroAlt": "Renovated Calgary ensuite with frameless glass walk-in shower, marble-look porcelain tile and long dark vanity",
    "overviewTitle": "Bathroom Renovations, Start to Finish",
    "summary": "MRE Developments renovates ensuites, main bathrooms and basement baths across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our team handles design, plumbing, waterproofing, tile and fixture installation as one coordinated project. Every bathroom is built around how you use it, with materials chosen to stay good-looking and easy to clean for years.",
    "highlights": [
      "Ensuites, main baths and basement bathrooms",
      "Walk-in tiled showers with benches",
      "Waterproofed shower systems behind every tile",
      "Heated floors and custom niches",
      "Accessible layouts with grab bars",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Walk-In Showers Done Properly",
        "body": "A tiled walk-in shower is the upgrade most Calgary homeowners ask for, and it is also where poor workmanship shows up first. We build each shower from the substrate out: sloped base, full waterproofing membrane, then tile, benches and niches laid out so grout lines meet cleanly.",
        "benefit": "You get a shower that stays dry behind the walls and looks sharp for years.",
        "image": "/projects/bathroom-test-1.webp",
        "imageAlt": "Walk-in tiled shower with built-in bench, beige porcelain walls and white mosaic floor in a Calgary bathroom"
      },
      {
        "title": "Tile Work With Clean Detailing",
        "body": "Pebble shower floors, linear drains, marble-look porcelain and trimmed niches all demand careful layout and patient setting. Our installers plan cuts around fixtures and edges before the first tile goes down, so transitions, corners and drains finish flush.",
        "benefit": "Your bathroom reads as one finished design, with no awkward cuts or uneven edges.",
        "image": "2026/02/20241119_124738-scaled.jpg",
        "imageAlt": "Glass walk-in shower with tiled bench, river pebble floor, linear drain and marble-look porcelain walls"
      },
      {
        "title": "Finishes Chosen Around You",
        "body": "We help you select vanities, counters, mirrors and fixtures that suit the room and your routine, from backlit mirrors and hexagon wainscot to double vanities and soaker tubs. For clients planning ahead, we design accessible bathrooms with walk-in showers, grab bars and non-slip flooring.",
        "benefit": "A bathroom that fits your taste today and stays practical as your needs change.",
        "image": "2026/02/3-scaled.jpg",
        "imageAlt": "Backlit LED mirror over a granite-look vanity with black faucet and white hexagon wall tile"
      }
    ],
    "galleryIntro": "Recent bathroom renovations by our team in Calgary and area, from walk-in showers to full ensuite remodels.",
    "photos": [
      {
        "src": "/projects/bathroom-test-1.webp",
        "caption": "Walk-in shower with built-in tiled bench",
        "alt": "Bathroom renovation in Calgary with walk-in tiled shower, bench, mosaic floor and new vanity"
      },
      {
        "src": "/projects/bathroom-test-2.webp",
        "caption": "Mosaic shower floor with square drain",
        "alt": "White patterned mosaic shower floor with square drain and porcelain-capped bench in a Calgary bathroom renovation"
      },
      {
        "src": "/projects/bathroom-test-3.webp",
        "caption": "Tiled bench in a large-format shower",
        "alt": "Corner of a renovated shower showing tiled bench, large-format beige porcelain and mosaic floor"
      },
      {
        "src": "/projects/bathroom-test-4.webp",
        "caption": "Rain shower head and matching tile",
        "alt": "Walk-in shower with ceiling rain head, wall-mounted valve and floor-to-ceiling beige porcelain tile"
      },
      {
        "src": "2026/02/1-scaled.jpg",
        "caption": "Marble-look tub surround and shower panel",
        "alt": "Tub and shower combination finished in marble-look porcelain with black shower panel and vanity"
      },
      {
        "src": "2026/02/2-scaled.jpg",
        "caption": "Recessed niche in marble-look tile",
        "alt": "Recessed shower niche with black edge trim set into marble-look porcelain wall tile"
      },
      {
        "src": "2026/02/3-scaled.jpg",
        "caption": "Backlit mirror over granite-look vanity",
        "alt": "Bathroom renovation detail with backlit mirror, granite-look counter, black faucet and hexagon wall tile"
      },
      {
        "src": "2026/02/4-scaled.jpg",
        "caption": "Hexagon tile wainscot and lit mirror",
        "alt": "Hexagon tile wainscot, backlit mirror and dark vanity with granite-look counter in a renovated bathroom"
      },
      {
        "src": "2026/02/20241119_124235-scaled.jpg",
        "caption": "Frameless glass shower and long vanity",
        "alt": "Calgary ensuite renovation with frameless glass shower, marble-look tile, backlit mirror and long vanity"
      },
      {
        "src": "2026/02/20241119_124336-scaled.jpg",
        "caption": "Glass shower beside wall-hung toilet",
        "alt": "Glass walk-in shower with pebble floor beside a wall-hung toilet and marble-look porcelain walls"
      },
      {
        "src": "2026/02/20241119_124738-scaled.jpg",
        "caption": "Pebble floor, linear drain, shower bench",
        "alt": "Walk-in shower with river pebble floor, linear drain, tiled bench and glass panel in a Calgary home"
      },
      {
        "src": "2026/02/20241119_124848-scaled.jpg",
        "caption": "Pebble shower floor and glass door",
        "alt": "Overhead view of a pebble shower floor, glass shower door with black handle and granite-look counter"
      },
      {
        "src": "2026/02/20240610_160002-scaled.jpg",
        "caption": "Double vanity with black-framed mirror",
        "alt": "Bathroom renovation with navy double vanity, black-framed mirror and glass shower with dark tile"
      },
      {
        "src": "2026/02/20240610_160446-scaled.jpg",
        "caption": "Soaker tub beside framed glass shower",
        "alt": "Overhead view of a soaker tub with marble-look tile surround next to a black-framed glass shower"
      },
      {
        "src": "2026/02/20240610_160659-scaled.jpg",
        "caption": "Marble-look floor and navy vanity",
        "alt": "Bathroom renovation with marble-look porcelain floor, alcove tub and navy double vanity"
      },
      {
        "src": "2026/02/IMG-20240613-WA0019.jpg",
        "caption": "Navy double vanity with black mirror",
        "alt": "Navy double vanity with white top, black-framed mirror and alcove tub in a renovated bathroom"
      },
      {
        "src": "2026/02/1-1-scaled.jpg",
        "caption": "Compact bath with pebble shower floor",
        "alt": "Compact bathroom renovation with floating wood vanity, vessel sink and black pebble shower floor"
      },
      {
        "src": "2026/02/2-1-scaled.jpg",
        "caption": "Black pebble floor with metal edge trim",
        "alt": "Black pebble stone shower floor framed by white wall tile and black metal edge trim"
      },
      {
        "src": "2026/02/3-1-scaled.jpg",
        "caption": "Trimmed recessed shower niche",
        "alt": "Large recessed shower niche finished with white tile and black metal trim"
      },
      {
        "src": "2026/02/4-1-scaled.jpg",
        "caption": "Floating wood vanity and black faucet",
        "alt": "Floating wood-tone vanity with white sink, black faucet and toilet beside a pebble shower floor"
      },
      {
        "src": "2026/02/20161025_130010-scaled.jpg",
        "caption": "Double vanity beside a soaker tub",
        "alt": "Renovated ensuite with dark double vanity, vessel sinks and tiled soaker tub under a window"
      },
      {
        "src": "2026/02/20161025_130001-scaled.jpg",
        "caption": "Bright ensuite with glass shower",
        "alt": "Bright ensuite renovation with frameless glass shower enclosure and white vessel sinks"
      },
      {
        "src": "2026/02/20161025_130038-scaled.jpg",
        "caption": "Espresso double vanity with vessel sinks",
        "alt": "Ensuite renovation with espresso double vanity, quartz top, vessel sinks and full-width mirror"
      },
      {
        "src": "2026/02/20230405_210002-scaled.jpg",
        "caption": "Basement bathroom with tub and round mirror",
        "alt": "Basement bathroom renovation with soaker tub, white vanity, round mirror and black fixtures"
      },
      {
        "src": "2026/02/20230405_210017-scaled.jpg",
        "caption": "Marble-look tub surround, black fixtures",
        "alt": "Tub and shower surround in large marble-look tile with black hand shower and trim"
      },
      {
        "src": "2026/02/20230405_210031-scaled.jpg",
        "caption": "White vanity with matte black hardware",
        "alt": "White shaker vanity with matte black faucet, towel bar and round mirror in a renovated bathroom"
      },
      {
        "src": "2026/02/20230405_210332-scaled.jpg",
        "caption": "Round mirror and quartz vanity top",
        "alt": "Round hanging mirror above a quartz-topped vanity with black faucet, looking into a hallway"
      }
    ],
    "videos": [
      "2025/10/19.mp4"
    ],
    "faqs": [
      {
        "q": "How much does a bathroom renovation cost in Calgary?",
        "a": "Most of our residential bathroom projects fall into three planning ranges: $7,500 to $15,000, $15,000 to $25,000, and $25,000 to $50,000 (CAD). These are planning ranges, not quotes. Your final price depends on the scope, the finishes you choose and what we find once walls and floors are opened up, and it is set out in a detailed, project-specific quote."
      },
      {
        "q": "Which areas do you serve for bathroom renovations?",
        "a": "We renovate bathrooms throughout Calgary, including communities such as the Hamptons, Edgemont, Mount Royal, Pump Hill and Aspen Woods. We also work in Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "How long will my bathroom renovation take?",
        "a": "Timing depends on the size of the room, whether plumbing or walls are moving, tile complexity, and lead times on vanities, glass and fixtures. Once the scope is clear, we provide a schedule with your quote so you know what to expect before work begins."
      },
      {
        "q": "How do you prevent leaks in a tiled shower?",
        "a": "Every tiled shower we build gets a properly sloped base and a continuous waterproofing membrane before any tile goes on. Benches, niches and corners are sealed as part of that system, not treated as afterthoughts."
      },
      {
        "q": "Can you make a bathroom more accessible?",
        "a": "Yes. We design and build accessible bathrooms with features such as walk-in showers, grab bars, non-slip flooring and practical fixture heights, so the room works safely for everyone in your household."
      },
      {
        "q": "What warranty comes with a bathroom renovation?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you can review them before you commit. MRE Developments is licensed and insured."
      }
    ],
    "ctaTitle": "Plan Your Bathroom Renovation",
    "ctaSubtitle": "Tell us about your bathroom and how you want it to work. We will follow up to arrange a free, detailed quote for your Calgary-area home.",
    "projects": [
      {
        "title": "Beige tile walk-in shower with bench",
        "summary": "Large-format beige tile shower with built-in bench, mosaic floor, niche and rain head.",
        "dates": "",
        "photos": [
          "/projects/bathroom-test-1.webp",
          "/projects/bathroom-test-2.webp",
          "/projects/bathroom-test-3.webp",
          "/projects/bathroom-test-4.webp"
        ]
      },
      {
        "title": "Marble-look ensuite with pebble shower floor",
        "summary": "Floor-to-ceiling marble-look tile, pebble shower floor, glass enclosure, backlit mirror and stone-top vanity.",
        "dates": "Nov 2024",
        "photos": [
          "2026/02/1-scaled.jpg",
          "2026/02/2-scaled.jpg",
          "2026/02/3-scaled.jpg",
          "2026/02/4-scaled.jpg",
          "2026/02/20241119_124235-scaled.jpg",
          "2026/02/20241119_124336-scaled.jpg",
          "2026/02/20241119_124738-scaled.jpg",
          "2026/02/20241119_124848-scaled.jpg"
        ]
      },
      {
        "title": "Double-vanity bathroom with soaker tub",
        "summary": "Marble-look floor and tub surround, black-framed glass shower, navy double vanity and large black mirror.",
        "dates": "Jun 2024",
        "photos": [
          "2026/02/20240610_160002-scaled.jpg",
          "2026/02/20240610_160446-scaled.jpg",
          "2026/02/20240610_160659-scaled.jpg",
          "2026/02/IMG-20240613-WA0019.jpg"
        ]
      },
      {
        "title": "Compact bathroom with pebble shower",
        "summary": "White wall tile, black pebble shower floor, black-trimmed niche, floating wood vanity.",
        "dates": "Feb 2026",
        "photos": [
          "2026/02/1-1-scaled.jpg",
          "2026/02/2-1-scaled.jpg",
          "2026/02/3-1-scaled.jpg",
          "2026/02/4-1-scaled.jpg"
        ]
      },
      {
        "title": "Ensuite with glass shower and double vanity",
        "summary": "Bright ensuite with tiled glass shower, soaker tub, double vessel sinks and dark cabinetry.",
        "dates": "Oct 2016",
        "photos": [
          "2026/02/20161025_130010-scaled.jpg",
          "2026/02/20161025_130001-scaled.jpg",
          "2026/02/20161025_130038-scaled.jpg"
        ]
      },
      {
        "title": "Tub-shower bathroom with marble-look surround",
        "summary": "Marble-look tile tub surround, white vanity, round mirror and matte black fixtures.",
        "dates": "Apr 2023",
        "photos": [
          "2026/02/20230405_210002-scaled.jpg",
          "2026/02/20230405_210017-scaled.jpg",
          "2026/02/20230405_210031-scaled.jpg",
          "2026/02/20230405_210332-scaled.jpg"
        ]
      }
    ]
  },
  "concrete-cutting": {
    "metaTitle": "Concrete Cutting Calgary | MRE Developments",
    "metaDescription": "Concrete cutting, openings, core drilling and removal for renovation and construction projects in Calgary, Airdrie and Cochrane. Request a free quote.",
    "headline": "Concrete Cutting in Calgary for Renovation and Construction",
    "subheadline": "Clean, accurate cuts for slab openings, utility trenches and controlled removal, so your next trade can start on a tidy, construction-ready surface.",
    "hero": "2026/04/20251108_110133-scaled.jpg",
    "heroAlt": "Walk-behind wet saw cutting a straight line through a concrete slab with water controlling the dust",
    "overviewTitle": "Precise Cuts, Controlled Removal",
    "summary": "MRE Developments provides concrete cutting for residential and commercial projects across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We cut slabs and walls for doors, windows, plumbing and electrical, carry out core drilling and expansion joint cutting, and remove the cut concrete so the area is ready for the next phase. Wet cutting methods keep dust down and the work controlled.",
    "highlights": [
      "Slab and wall openings for renovations",
      "Trenches for plumbing and electrical",
      "Core drilling and expansion joints",
      "Wet cutting for dust control",
      "Concrete removal and surface preparation",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "Openings Laid Out Before Cutting",
        "body": "Every cutting project starts with a review of the location and the opening you need. We mark the layout on the slab or wall, confirm it against your renovation plans, and then saw along those lines. This approach suits basement developments, new door and window openings and slab modifications for plumbing or electrical runs.",
        "benefit": "Your openings land exactly where the plans call for them, with straight, clean edges.",
        "image": "2026/04/20251108_120639-scaled.jpg",
        "imageAlt": "Concrete saw cutting a slab beside rigid foam insulation board during a Calgary renovation"
      },
      {
        "title": "Wet Cutting for a Cleaner Site",
        "body": "We use walk-behind floor saws and hand saws with water feed, which cools the blade and captures the dust that dry cutting throws into the air. The result is a cleaner, safer work area and a more consistent cut through the full depth of the slab.",
        "benefit": "You get accurate cuts with far less dust in your home or commercial space.",
        "image": "2026/04/20251108_095136-scaled.jpg",
        "imageAlt": "Wet concrete saw cutting a slab next to a house, with water running along the cut line"
      },
      {
        "title": "Removal and Prep for What's Next",
        "body": "Once the cutting is done, our crew breaks out the cut sections, removes the debris and prepares the base for new concrete or other installations. Because the same team handles cutting, removal and new concrete, there is no gap between contractors.",
        "benefit": "You are left with a construction-ready area, not a pile of broken concrete.",
        "image": "2026/04/20251108_140539-scaled.jpg",
        "imageAlt": "Cut concrete slab section partly removed with a breaker hammer resting on the slab"
      }
    ],
    "galleryIntro": "These concrete cutting photos show saw cuts, wet cutting in progress and slab sections being removed for the next stage of work.",
    "photos": [
      {
        "src": "2026/04/20251108_095136-scaled.jpg",
        "caption": "Cutting a slab beside the house",
        "alt": "Concrete cutting next to a home with water feed controlling dust"
      },
      {
        "src": "2026/04/20251108_101207-scaled.jpg",
        "caption": "Hand saw at the slab edge",
        "alt": "Handheld concrete saw positioned on a slab beside protective plastic sheeting"
      },
      {
        "src": "2026/04/20251108_101949-scaled.jpg",
        "caption": "Marked cut lines before sawing",
        "alt": "Layout lines marked on a concrete slab before concrete cutting begins"
      },
      {
        "src": "2026/04/20251108_110123-scaled.jpg",
        "caption": "Floor saw with water feed",
        "alt": "Floor saw with water hose cutting through a concrete slab outside a house"
      },
      {
        "src": "2026/04/20251108_110133-scaled.jpg",
        "caption": "Wet saw cutting a straight line",
        "alt": "Walk-behind wet saw cutting a concrete slab along a marked line in Calgary"
      },
      {
        "src": "2026/04/20251108_112503-scaled.jpg",
        "caption": "Laying out cuts across the slab",
        "alt": "Saw cutting multiple lines across a concrete slab for removal"
      },
      {
        "src": "2026/04/20251108_120639-scaled.jpg",
        "caption": "Cutting next to new insulation",
        "alt": "Concrete saw cutting a slab next to rigid foam insulation during a renovation"
      },
      {
        "src": "2026/04/20251108_140539-scaled.jpg",
        "caption": "Breaking out the cut section",
        "alt": "Cut concrete section being broken out with a breaker hammer for removal"
      }
    ],
    "videos": [
      "2025/11/rr.mp4"
    ],
    "faqs": [
      {
        "q": "What concrete cutting services do you offer?",
        "a": "We cut slabs and walls for new openings, cut trenches for plumbing and electrical, and provide core drilling, expansion joint cutting and controlled demolition. We also remove the cut concrete and prepare the area. We serve residential and commercial projects in Calgary and the surrounding region."
      },
      {
        "q": "What information do you need to quote a cutting project?",
        "a": "Tell us where the cut is, the size of the opening, the slab or wall thickness if known, and what the opening is for. Photos and any renovation drawings help. We review the details and provide a free, project-specific quote."
      },
      {
        "q": "Is concrete cutting part of a larger project?",
        "a": "Usually, yes. Cutting is often one stage of a basement development, renovation or utility upgrade, and we can follow it with new concrete, patching the trench or preparing the surface for the next trade."
      },
      {
        "q": "How do you control dust and mess?",
        "a": "We use wet cutting methods that cool the blade and keep dust out of the air. We protect surrounding areas, manage the slurry and clear debris when the cut sections are removed."
      },
      {
        "q": "Do you cut structural walls or slabs?",
        "a": "Openings in structural or load-bearing concrete need to be reviewed before cutting. We will discuss what your project requires, including any engineering or permit steps, as part of the quote."
      }
    ],
    "ctaTitle": "Plan Your Concrete Cutting Project",
    "ctaSubtitle": "Share the location and the opening you need, and we will review the project and prepare a free quote.",
    "projects": [
      {
        "title": "Saw-cutting a residential slab",
        "summary": "Wet saw cutting lines through an existing slab, then breaking out the cut section.",
        "dates": "Nov 2025",
        "photos": [
          "2026/04/20251108_095136-scaled.jpg",
          "2026/04/20251108_101207-scaled.jpg",
          "2026/04/20251108_101949-scaled.jpg",
          "2026/04/20251108_110123-scaled.jpg",
          "2026/04/20251108_110133-scaled.jpg",
          "2026/04/20251108_112503-scaled.jpg",
          "2026/04/20251108_120639-scaled.jpg",
          "2026/04/20251108_140539-scaled.jpg"
        ]
      }
    ]
  },
  "concrete-flatwork": {
    "metaTitle": "Concrete Flatwork Calgary | MRE Developments",
    "metaDescription": "Concrete floors, garage pads and walkways in Calgary, Airdrie and Cochrane, graded and reinforced for Alberta winters. Request your free quote from MRE.",
    "headline": "Concrete Flatwork in Calgary: Floors, Garage Pads and Walkways",
    "subheadline": "Level, well-drained concrete floors, garage pads and walks that resist cracking and heaving, with grading, reinforcement and finishing handled by our own crew.",
    "hero": "2026/04/IMG_20191031_110154-scaled.jpg",
    "heroAlt": "Newly finished concrete garage slab inside a wood-framed garage with the sun casting light across the floor",
    "overviewTitle": "Flatwork Done Right From the Base Up",
    "summary": "MRE Developments pours concrete floors, garage pads, basement slabs and walkways for homes and properties across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We focus on precision grading, proper drainage and reinforcement so each surface performs in every season. Clear communication and a tidy site keep disruption to your daily routine to a minimum.",
    "highlights": [
      "Garage pads and detached garage floors",
      "Basement and interior concrete floors",
      "Walkways, sidewalks and steps",
      "Grading, compaction and drainage planning",
      "Vapour barrier and reinforcement installed",
      "Broom, trowel and edged finishes"
    ],
    "features": [
      {
        "title": "Garage Pads Built for Weight",
        "body": "A garage pad carries vehicles, storage and years of salt and meltwater dripping off tires. We set the slab to the right elevation and slope so water runs out the door, not toward the walls, and reinforce it for the loads it will carry. The same attention goes into shop floors and other working slabs.",
        "benefit": "You get a flat, durable floor that drains properly and is ready for framing or parking.",
        "image": "2026/04/IMG_20191031_110222-scaled.jpg",
        "imageAlt": "Smooth finished concrete garage pad inside new wood framing with a window and door rough opening"
      },
      {
        "title": "Hand-Finished Edges and Joints",
        "body": "After the pour, our finishers bull float the surface, cut control joints and tool every edge by hand. Control joints are placed so that the inevitable shrinkage cracks follow a planned line rather than wandering across the slab. A broom finish is then added on outdoor surfaces for traction in wet and icy conditions.",
        "benefit": "Your walkways look crisp and stay safer underfoot through Calgary winters.",
        "image": "2026/04/20220923_175100-scaled.jpg",
        "imageAlt": "Finisher running a jointer tool across a fresh concrete walkway beside a vinyl-sided house"
      },
      {
        "title": "Basement Floors on a Proper Base",
        "body": "For basement and interior slabs we lay poly vapour barrier over a prepared base before concrete is pumped in and levelled. That moisture control matters in Calgary-area basements, where flooring and finished walls depend on a dry, flat slab. Our crew places and finishes the floor in one continuous pour.",
        "benefit": "Your new floor is ready for development, with moisture managed from the start.",
        "image": "2026/04/IMG_20191109_093755-scaled.jpg",
        "imageAlt": "Basement prepared with poly vapour barrier across the floor before a concrete slab pour"
      }
    ],
    "galleryIntro": "These concrete flatwork projects show garage pads, basement floors and walkways from base preparation to final finish.",
    "photos": [
      {
        "src": "2026/04/1-scaled.jpg",
        "caption": "Compacting the base before forming",
        "alt": "Plate compactor packing the gravel base before a concrete flatwork pour"
      },
      {
        "src": "2026/04/2-scaled.jpg",
        "caption": "Raking concrete into place",
        "alt": "Worker raking freshly placed concrete into position during a flatwork pour"
      },
      {
        "src": "2026/04/3-scaled.jpg",
        "caption": "Screeding the slab to the forms",
        "alt": "Screed board levelling fresh concrete against wood forms on a flatwork pour"
      },
      {
        "src": "2026/04/4-scaled.jpg",
        "caption": "Hand floating the slab edge",
        "alt": "Gloved hand using a float to finish the edge of a fresh concrete slab"
      },
      {
        "src": "2026/04/20220923_175026-scaled.jpg",
        "caption": "Bull floating a walkway beside steps",
        "alt": "Finisher bull floating a new concrete walkway next to wooden steps and a house"
      },
      {
        "src": "2026/04/20220923_175100-scaled.jpg",
        "caption": "Cutting control joints by hand",
        "alt": "Hand jointer cutting a control joint in a fresh concrete walkway"
      },
      {
        "src": "2026/04/20220923_175138-scaled.jpg",
        "caption": "Broom-finished walkway with tooled edge",
        "alt": "Broom-finished concrete walkway with a tooled edge beside wood forms"
      },
      {
        "src": "2026/04/20220923_175650-scaled.jpg",
        "caption": "Broom texture for winter traction",
        "alt": "Concrete slab receiving a broom finish for traction, Calgary flatwork project"
      },
      {
        "src": "2026/04/IMG_20191109_093755-scaled.jpg",
        "caption": "Vapour barrier laid before the pour",
        "alt": "Poly vapour barrier laid across a basement floor before concrete flatwork"
      },
      {
        "src": "2026/04/IMG_20191109_102813-scaled.jpg",
        "caption": "Crew placing the basement slab",
        "alt": "Workers spreading concrete for a basement floor slab over vapour barrier"
      },
      {
        "src": "2026/04/IMG_20191109_102946-scaled.jpg",
        "caption": "Levelling concrete across the basement",
        "alt": "Crew levelling fresh concrete across a basement floor in a Calgary-area home"
      },
      {
        "src": "2026/04/IMG_20191109_103139-scaled.jpg",
        "caption": "Pumping a basement floor pour",
        "alt": "Crew pumping concrete for a basement floor slab under floor joists"
      },
      {
        "src": "2026/04/IMG_20191031_110154-scaled.jpg",
        "caption": "Finished garage slab, ready for walls",
        "alt": "Finished concrete flatwork garage slab inside wood framing on a Calgary property"
      },
      {
        "src": "2026/04/IMG_20191031_110222-scaled.jpg",
        "caption": "Garage pad with smooth trowel finish",
        "alt": "Smooth trowel-finished concrete garage pad inside a newly framed garage"
      },
      {
        "src": "2026/04/IMG_20191031_110631-scaled.jpg",
        "caption": "New basement floor, freshly finished",
        "alt": "Freshly finished concrete basement floor with steel posts and wood framing"
      },
      {
        "src": "2026/04/IMG_20191031_110636-scaled.jpg",
        "caption": "Level basement slab across the room",
        "alt": "Wide view of a level new concrete basement floor beneath floor joists"
      }
    ],
    "videos": [
      "2026/04/qa.mp4"
    ],
    "faqs": [
      {
        "q": "What types of concrete flatwork do you install?",
        "a": "We pour garage pads, basement and interior floors, walkways, sidewalks and similar flat concrete surfaces for properties in Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Each project includes the site preparation needed for that surface, from excavation and compaction to forming and finishing."
      },
      {
        "q": "How do you reduce cracking in concrete flatwork?",
        "a": "No concrete is entirely crack-free, but most problems come from poor preparation. We compact the base, plan grading and drainage, add reinforcement and cut control joints so shrinkage happens along planned lines. These steps are what help flatwork hold up through Alberta freeze-thaw cycles."
      },
      {
        "q": "Can you pour a garage pad for a new detached garage?",
        "a": "Yes. We prepare the base, form the pad to the required size and elevation, reinforce it and finish it so it is ready for framing. We will review your plans and any permit requirements when we quote the project."
      },
      {
        "q": "What finish options are available?",
        "a": "Outdoor flatwork usually gets a broom finish for traction, while garage and basement floors are typically trowelled smooth. If you want a stamped pattern or exposed aggregate, our Custom Concrete service covers decorative finishes."
      },
      {
        "q": "How long before I can use my new slab?",
        "a": "That depends on the slab, the mix, the weather and how the surface will be used, since foot traffic and vehicle loads have different requirements. We explain the curing period for your specific project, and your quote includes a schedule."
      },
      {
        "q": "How is my flatwork project priced?",
        "a": "Pricing reflects the area, slab thickness, reinforcement, excavation, site access and finish. We provide a free, detailed quote after reviewing the site so you can see each part of the scope."
      }
    ],
    "ctaTitle": "Get a Quote for Your Concrete Flatwork",
    "ctaSubtitle": "Share the size and location of your garage pad, floor or walkway and we will prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Raised backyard patio slab",
        "summary": "Base compaction, placing and raking, bull floating, edging and broom finish on a raised patio.",
        "dates": "Sep 2022",
        "photos": [
          "2026/04/1-scaled.jpg",
          "2026/04/2-scaled.jpg",
          "2026/04/3-scaled.jpg",
          "2026/04/4-scaled.jpg",
          "2026/04/20220923_175026-scaled.jpg",
          "2026/04/20220923_175100-scaled.jpg",
          "2026/04/20220923_175138-scaled.jpg",
          "2026/04/20220923_175650-scaled.jpg"
        ]
      },
      {
        "title": "Basement floor slab pour",
        "summary": "Poly vapour barrier laid, then crew placing and finishing the basement floor slab.",
        "dates": "Nov 2019",
        "photos": [
          "2026/04/IMG_20191109_093755-scaled.jpg",
          "2026/04/IMG_20191109_102813-scaled.jpg",
          "2026/04/IMG_20191109_102946-scaled.jpg",
          "2026/04/IMG_20191109_103139-scaled.jpg"
        ]
      },
      {
        "title": "Garage floor slab",
        "summary": "Freshly poured and finished concrete floor inside a newly framed garage.",
        "dates": "Oct 2019",
        "photos": [
          "2026/04/IMG_20191031_110154-scaled.jpg",
          "2026/04/IMG_20191031_110222-scaled.jpg",
          "2026/04/IMG_20191031_110631-scaled.jpg",
          "2026/04/IMG_20191031_110636-scaled.jpg"
        ]
      }
    ]
  },
  "concrete-foundations": {
    "metaTitle": "Concrete Foundations Calgary | MRE Developments",
    "metaDescription": "Footings, foundation walls, grade beams and slabs for homes and commercial builds in Calgary, Airdrie and Okotoks. Request a free foundation quote today.",
    "headline": "Concrete Foundations in Calgary Built Level, Square and Solid",
    "subheadline": "Footings, foundation walls, grade beams and slabs for new homes, additions and commercial builds, planned with your engineer and poured to code in every season.",
    "hero": "2025/11/20180115_121727-scaled.jpg",
    "heroAlt": "Concrete boom pump extended over formed foundation walls on a winter job site in the Calgary area",
    "overviewTitle": "Concrete & Foundations From the Ground Up",
    "summary": "MRE Developments delivers complete foundation construction for residential and commercial projects in Calgary, Airdrie, Cochrane, Okotoks and the surrounding region. Our work runs from excavation and footings through foundation walls, grade beams and slab-on-grade, finished to be strong, durable and code-compliant. We also handle driveways, garage pads and other structural concrete that rely on the same careful approach.",
    "highlights": [
      "Footings, foundation walls and grade beams",
      "Slab-on-grade foundations",
      "New homes, additions and commercial builds",
      "Coordination with your engineer",
      "Retaining walls and structural pads",
      "Licensed and insured crew"
    ],
    "features": [
      {
        "title": "Foundations for New Builds and Additions",
        "body": "Whether you are building a new home, adding an extension or starting a commercial project, the foundation sets the standard for everything above it. We build footings and foundation walls to the dimensions and elevations on your drawings, keeping walls plumb, level and square. Framers and trades that follow can then work from an accurate base.",
        "benefit": "You start your build on a foundation that matches the plans and supports the structure for decades.",
        "image": "2025/11/20180115_121720-scaled.jpg",
        "imageAlt": "Crew guiding a concrete pump hose into tall foundation wall forms on a snowy Calgary-area site"
      },
      {
        "title": "Engineered, Reinforced and Code-Compliant",
        "body": "We work with engineers and clients to match each foundation to the building's structural needs. Footings, grade beams and walls are reinforced and placed using proper forming and pumping methods, so concrete fills the forms fully and cures as designed.",
        "benefit": "Your foundation meets the design requirements and passes inspection with confidence.",
        "image": "2025/11/20180115_120952-scaled.jpg",
        "imageAlt": "Concrete truck beside braced foundation wall forms with a boom pump overhead in winter"
      },
      {
        "title": "Year-Round Structural Concrete",
        "body": "Alberta construction does not stop for winter, and neither does foundation work when it is planned properly. Our crews protect fresh concrete from frost and keep pours on track in cold conditions. We also build retaining walls, pads and grade beams that hold loads and prevent soil movement around your property.",
        "benefit": "Your project keeps moving, with concrete protected so it reaches its intended strength.",
        "image": "2026/04/20180115_121845-scaled.jpg",
        "imageAlt": "Inside a formed foundation with pile tubes and covered footings protected from snow and frost"
      }
    ],
    "galleryIntro": "These photos follow a winter foundation pour from formed walls to protected footings on a project in the Calgary region.",
    "photos": [
      {
        "src": "2025/11/20180115_120952-scaled.jpg",
        "caption": "Braced forms ready for concrete",
        "alt": "Braced wood foundation forms beside a concrete truck and pump boom on a winter site"
      },
      {
        "src": "2025/11/20180115_121720-scaled.jpg",
        "caption": "Pouring foundation walls in winter",
        "alt": "Workers placing concrete into foundation wall forms from a pump hose in snow"
      },
      {
        "src": "2025/11/20180115_121727-scaled.jpg",
        "caption": "Boom pump over foundation wall forms",
        "alt": "Concrete boom pump reaching over formed foundation walls on a Calgary-area job site"
      },
      {
        "src": "2026/04/20180115_121845-scaled.jpg",
        "caption": "Pile tubes and footings under protection",
        "alt": "Concrete foundation interior with pile tubes and footings covered against frost"
      }
    ],
    "videos": [
      "2025/11/20180115_121730.mp4"
    ],
    "faqs": [
      {
        "q": "What foundation services do you provide in Calgary?",
        "a": "We build footings, foundation walls, grade beams and slab-on-grade foundations for new homes, additions and commercial buildings. We also complete retaining walls, structural pads, driveways and garage pads. Our service area includes Calgary, Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "Do you work with engineers and architects?",
        "a": "Yes. Foundations are designed around the building's structural requirements, and we build to the engineered drawings for your project. Where the design calls for it, we coordinate with your engineer on reinforcement and details."
      },
      {
        "q": "Can foundations be poured in winter?",
        "a": "Yes, with the right planning. Cold-weather pours need frost protection for the ground and fresh concrete, and we schedule and protect each pour so the concrete can cure properly."
      },
      {
        "q": "Do you handle permits for foundation work?",
        "a": "Permit requirements depend on your project and municipality. We will review what applies to your build during the quote process and explain how permits and inspections fit into the schedule."
      },
      {
        "q": "Can you address cracking or settling in an existing foundation?",
        "a": "We take on foundation repair and reinforcement as part of planned projects, such as before a renovation or addition. We start by assessing the condition and cause, then recommend a scope of work rather than a quick patch."
      },
      {
        "q": "How long does a foundation take, and what does it cost?",
        "a": "Both depend on the size and design of the foundation, excavation, site access, weather and inspection timing. We provide a free, detailed quote with a project-specific schedule, and warranty and workmanship terms are set out in writing with it."
      }
    ],
    "ctaTitle": "Start Your Foundation on Solid Ground",
    "ctaSubtitle": "Send us your plans or project details and we will prepare a free, detailed quote for your foundation work.",
    "projects": [
      {
        "title": "Winter foundation wall pour",
        "summary": "Formed foundation walls and footings pumped full of concrete on a snowy site.",
        "dates": "Jan 2018",
        "photos": [
          "2025/11/20180115_120952-scaled.jpg",
          "2025/11/20180115_121720-scaled.jpg",
          "2025/11/20180115_121727-scaled.jpg",
          "2026/04/20180115_121845-scaled.jpg"
        ]
      }
    ]
  },
  "concrete-repairs-and-maintenance": {
    "metaTitle": "Concrete Repairs & Maintenance Calgary | MRE Developments",
    "metaDescription": "Cracked, settled or worn concrete in Calgary, Airdrie or Okotoks? MRE reviews its condition and plans the right scope of work. Request a free assessment.",
    "headline": "Concrete Repairs & Maintenance in Calgary, Planned Properly",
    "subheadline": "Cracking, settling or surface wear rarely fixes itself. We review your existing concrete, find the cause and plan the right scope, from restoration to full replacement.",
    "overviewTitle": "Start With a Condition Review",
    "summary": "MRE Developments helps property owners in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region decide what to do with existing concrete that is showing its age. We review driveways, walkways, patios, garage pads and foundations, look at drainage and base conditions, and recommend a project scope that addresses the cause. When repair is not the right answer, our flatwork and foundation crews can plan replacement.",
    "highlights": [
      "On-site condition review",
      "Cause of cracking and settling identified",
      "Clear scope of work recommended",
      "Restoration or replacement project planning",
      "Maintenance advice for longer life",
      "Residential and commercial properties"
    ],
    "features": [
      {
        "title": "An Honest Look at Condition",
        "body": "We begin by walking the site with you and examining the concrete itself: crack patterns, settlement, spalling, drainage and how the surface meets your building. Calgary's freeze-thaw cycles, de-icing salt and poor original base preparation are common culprits. Understanding the cause is what separates a lasting solution from a cosmetic one.",
        "benefit": "You know what is actually wrong with your concrete before you spend money on it."
      },
      {
        "title": "The Right Scope for the Problem",
        "body": "Some surfaces can be restored as part of a larger project, while others have reached the point where replacement is the better investment. We lay out the options, explain the trade-offs and prepare a scope that covers the affected areas, drainage corrections and any related work.",
        "benefit": "You get a clear recommendation and a detailed quote, not a patch that fails next spring."
      },
      {
        "title": "Maintenance That Extends Its Life",
        "body": "Well-built concrete still benefits from care. We advise on sealing, joint and drainage maintenance and winter practices that slow wear in the Calgary climate. If replacement is needed, our Concrete Flatwork, Concrete Foundations and Custom Concrete teams can carry the project through.",
        "benefit": "Your concrete stays safer, better looking and serviceable for longer."
      }
    ],
    "galleryIntro": "Project photos for concrete repairs and maintenance will be added soon; in the meantime, see our concrete flatwork and custom concrete galleries.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Do you take on small, single concrete repairs?",
        "a": "MRE Developments focuses on planned projects rather than one-off patch jobs. We are a good fit when existing concrete needs a proper assessment and a defined scope, such as restoring or replacing a driveway, walkway, patio or garage pad, or concrete work tied to a renovation."
      },
      {
        "q": "Why is my concrete cracking or sinking?",
        "a": "Common causes include poor base compaction, drainage directing water under the slab, freeze-thaw cycles, de-icing salts and missing or poorly placed control joints. Our condition review looks for the specific cause on your property so the scope of work addresses it."
      },
      {
        "q": "Should I repair or replace my concrete?",
        "a": "It depends on how widespread the damage is, whether the base has failed and how the surface is used. Where damage is limited, restoration may make sense; where settlement or cracking is extensive, replacement is often the better long-term investment. We explain both options before you decide."
      },
      {
        "q": "What happens during a condition review?",
        "a": "We visit the site, examine the concrete and surrounding drainage, and discuss your goals for the space. From there we recommend a scope of work and prepare a free, detailed quote."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We serve Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River, for both residential and commercial properties."
      }
    ],
    "ctaTitle": "Book a Review of Your Existing Concrete",
    "ctaSubtitle": "Tell us about the concrete that concerns you and we will arrange a condition review and a free, detailed quote for the right scope of work.",
    "hero": "2026/04/IMG_20191031_110222-scaled.jpg",
    "heroAlt": "Smooth trowel-finished concrete pad inside a newly framed garage, Calgary area"
  },
  "concrete": {
    "metaTitle": "Concrete Contractor Calgary | MRE Developments",
    "metaDescription": "Concrete foundations, flatwork, cutting and custom finishes for Calgary, Airdrie, Cochrane and Okotoks properties. Request a free, detailed quote today.",
    "headline": "Concrete Contractor in Calgary for Residential and Commercial Work",
    "subheadline": "Foundations, flatwork, cutting and custom finishes from one licensed, insured team, so your concrete is planned, poured and finished to last through Alberta freeze-thaw cycles.",
    "hero": "2026/04/20240824_193528-1-scaled.jpg",
    "heroAlt": "Finished dark stamped concrete patio in a Calgary backyard with a play structure and lawn",
    "overviewTitle": "Concrete Services Built to Last",
    "summary": "MRE Developments handles concrete for homes and commercial properties across Calgary, Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River. Our work covers five areas: Concrete Flatwork, Concrete Foundations, Concrete Cutting, Custom Concrete and Concrete Repairs & Maintenance. Every pour starts with proper grading, base preparation and reinforcement, then finishes with the surface texture or decorative pattern your project calls for.",
    "highlights": [
      "Residential and commercial concrete projects",
      "Foundations, footings and structural concrete",
      "Driveways, patios, walkways and garage pads",
      "Stamped and exposed aggregate finishes",
      "Precise cutting, openings and removal",
      "Licensed, insured, with free quotes"
    ],
    "features": [
      {
        "title": "Concrete for Homes and Businesses",
        "body": "From sidewalks and curbs at new commercial buildings to backyard patios and side walkways, we plan each pour around how the surface will be used. Concrete Flatwork and Concrete Foundations give your property a level, stable base, while Concrete Cutting creates clean openings when an existing slab needs to change.",
        "benefit": "You work with one contractor for the structural and finished concrete on your Calgary-area project.",
        "image": "2026/04/20220810_150709-scaled.jpg",
        "imageAlt": "New broom-finished concrete sidewalk running along a commercial retail building under construction in Calgary"
      },
      {
        "title": "Preparation Under Every Slab",
        "body": "The strength of a slab is decided before the truck arrives. Our crews set forms, compact the base, lay rigid insulation where required and place rebar on a grid before concrete is pumped and screeded. That groundwork, combined with proper drainage and control joints, is what keeps concrete from heaving and cracking in Alberta winters.",
        "benefit": "You get a surface built to handle freeze-thaw cycles, not just one that looks good on day one.",
        "image": "2026/04/20251121_133436-scaled.jpg",
        "imageAlt": "Concrete slab forms with purple rigid insulation, rebar grid and pump hose ready for the pour"
      },
      {
        "title": "Custom Finishes and Long-Term Care",
        "body": "Our Custom Concrete service adds stamped patterns, colour and exposed aggregate finishes to patios, walkways and driveways. When existing concrete is showing its age, Concrete Repairs & Maintenance starts with a condition review so the right scope of work is planned rather than patched.",
        "benefit": "Your concrete suits the style of your home and stays in good condition for years.",
        "image": "2026/04/20240929_124022-scaled.jpg",
        "imageAlt": "Completed stamped concrete patio behind a two-storey Calgary home with a wood fence and artificial turf"
      }
    ],
    "galleryIntro": "Browse recent concrete projects from MRE Developments, from commercial sidewalks to stamped patios and exposed aggregate walkways around Calgary.",
    "photos": [
      {
        "src": "2026/04/20240821_165327-scaled.jpg",
        "caption": "Hand-edged slab beside the lawn",
        "alt": "Hand edging tool finishing the edge of a fresh concrete slab next to grass"
      },
      {
        "src": "2026/04/20240821_171721-scaled.jpg",
        "caption": "Fresh slab with tooled control joints",
        "alt": "Freshly finished concrete slab with tooled control joints and trowel lines"
      },
      {
        "src": "2026/04/20240821_183329-scaled.jpg",
        "caption": "Finishing a scored concrete slab",
        "alt": "Worker applying finishing product across a scored concrete slab"
      },
      {
        "src": "2026/04/20240824_193528-1-scaled.jpg",
        "caption": "Stamped concrete patio with dark finish",
        "alt": "Dark stamped concrete patio in a Calgary backyard with play structure and stepping stones"
      },
      {
        "src": "2026/04/20240829_112428-scaled.jpg",
        "caption": "Backyard before the patio pour",
        "alt": "Grass backyard behind a two-storey Calgary home before a concrete patio was installed"
      },
      {
        "src": "2026/04/20240903_163340-scaled.jpg",
        "caption": "Setting forms beside a planter",
        "alt": "Worker fastening wood forms beside a brick planter before a concrete pour"
      },
      {
        "src": "2026/04/20240905_194437-scaled.jpg",
        "caption": "Stamping mats on fresh concrete",
        "alt": "Crew placing stamping mats on fresh concrete to create a decorative pattern"
      },
      {
        "src": "2026/04/20240929_124022-scaled.jpg",
        "caption": "Stamped backyard patio, fence to fence",
        "alt": "Completed stamped concrete patio filling a residential backyard behind a stucco home in Calgary"
      },
      {
        "src": "2026/04/1-3-scaled.jpg",
        "caption": "Rear yard before new concrete",
        "alt": "Backyard lawn behind a vinyl-sided home before new concrete patio work"
      },
      {
        "src": "2026/04/2-3-scaled.jpg",
        "caption": "Pumping concrete into the forms",
        "alt": "Concrete pump hose placing concrete into wood forms on a job site"
      },
      {
        "src": "2026/04/3-4-scaled.jpg",
        "caption": "Power screed levelling a large slab",
        "alt": "Power screed levelling a large fresh concrete slab"
      },
      {
        "src": "2026/04/4-4-scaled.jpg",
        "caption": "New patio slab under rear deck",
        "alt": "Freshly finished concrete patio slab under a backyard deck, forms still in place, Calgary home"
      },
      {
        "src": "2026/04/20251109_120703-scaled.jpg",
        "caption": "Side yard before the new slab",
        "alt": "Bare side yard between two homes before a new concrete slab was poured"
      },
      {
        "src": "2026/04/20251120_124225-scaled.jpg",
        "caption": "Walkway forms and gravel base",
        "alt": "Wood forms and compacted gravel base set for a concrete walkway beside a house"
      },
      {
        "src": "2026/04/20251120_124653-scaled.jpg",
        "caption": "Cutting rigid insulation to fit",
        "alt": "Worker measuring and cutting rigid foam insulation for under a concrete walkway"
      },
      {
        "src": "2026/04/20251120_140954-scaled.jpg",
        "caption": "Insulated walkway forms in winter",
        "alt": "Walkway forms lined with rigid insulation beside a Calgary home in light snow"
      },
      {
        "src": "2026/04/20251121_133436-scaled.jpg",
        "caption": "Insulation and rebar before the pour",
        "alt": "Slab forms with rigid insulation, rebar grid and concrete pump hose before pouring"
      },
      {
        "src": "2026/04/20251121_140247-scaled.jpg",
        "caption": "Crew placing concrete from the pump",
        "alt": "Concrete crew in safety vests placing concrete from a pump hose into slab forms"
      },
      {
        "src": "2026/04/20251121_141820-scaled.jpg",
        "caption": "Side yard slab between two homes",
        "alt": "Freshly poured concrete slab in a narrow side yard between two Calgary houses"
      },
      {
        "src": "2026/04/20251121_154907-scaled.jpg",
        "caption": "Walkway screeded beside the house",
        "alt": "Crew screeding and floating a new concrete walkway along a house and white vinyl fence"
      },
      {
        "src": "2026/04/20220810_150709-scaled.jpg",
        "caption": "Commercial sidewalk along new retail units",
        "alt": "Broom-finished concrete sidewalk beside timber columns at a new commercial building in Calgary"
      },
      {
        "src": "2026/04/20220810_150842-scaled.jpg",
        "caption": "Curved curb and sidewalk corner",
        "alt": "Curved concrete curb and sidewalk corner at a commercial building under construction"
      },
      {
        "src": "2026/04/20220810_151138-scaled.jpg",
        "caption": "Sidewalk ready for final grading",
        "alt": "Finished concrete sidewalk along a commercial storefront with the lot ready for grading"
      },
      {
        "src": "2026/04/20220810_151500-scaled.jpg",
        "caption": "Commercial site before flatwork",
        "alt": "Graded commercial site in front of a new strip of retail units before concrete work"
      },
      {
        "src": "2026/04/20220830_130035-scaled.jpg",
        "caption": "Finishing a commercial curb",
        "alt": "Crew finishing a formed concrete curb at a commercial site in the Calgary area"
      },
      {
        "src": "2026/04/20220830_133012-scaled.jpg",
        "caption": "Grinding a curb edge smooth",
        "alt": "Worker grinding the edge of a concrete curb on a commercial job site"
      },
      {
        "src": "2026/04/20220830_134311-scaled.jpg",
        "caption": "Site preparation with a skid steer",
        "alt": "Crew in hard hats preparing a concrete site with a skid steer and hand tools"
      },
      {
        "src": "2026/04/20220830_142940-scaled.jpg",
        "caption": "Curb forms with stakes and steel",
        "alt": "Wood curb forms with steel stakes being filled with concrete on a commercial site"
      },
      {
        "src": "2026/04/20240914_133144-scaled.jpg",
        "caption": "Revealing aggregate along the foundation",
        "alt": "Worker in boots pressure washing exposed aggregate concrete next to a house"
      },
      {
        "src": "2026/04/20240914_140435-scaled.jpg",
        "caption": "Exposed aggregate step edge",
        "alt": "Pressure washing the edge of an exposed aggregate concrete step beside a stucco wall"
      },
      {
        "src": "2026/04/20240914_145232-scaled.jpg",
        "caption": "Washing an exposed aggregate walkway",
        "alt": "Pressure washing an exposed aggregate concrete walkway beside a home's foundation wall"
      },
      {
        "src": "2026/04/20240914_145350-1-scaled.jpg",
        "caption": "Exposed aggregate driveway edge reveal",
        "alt": "Worker pressure washing an exposed aggregate concrete driveway edge to reveal the stone"
      }
    ],
    "videos": [
      "2024/08/MRE-Concrete-YYC-VID-1-1.mp4"
    ],
    "faqs": [
      {
        "q": "What concrete services does MRE Developments offer in Calgary?",
        "a": "We provide Concrete Flatwork, Concrete Foundations, Concrete Cutting, Custom Concrete and Concrete Repairs & Maintenance. That covers footings and foundations, driveways, patios, walkways and garage pads, stamped and exposed aggregate finishes, and cutting or removal of existing concrete. We serve Calgary, Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "Do you work on both residential and commercial concrete projects?",
        "a": "Yes. Our crews pour patios, walkways and foundations for homeowners and also complete sidewalks, curbs and slabs for commercial buildings. Each project is scoped to its own structural and site requirements."
      },
      {
        "q": "How do you make concrete last in Calgary's climate?",
        "a": "Freeze-thaw cycles are hard on poorly built concrete, so we focus on what goes underneath. That means proper grading and drainage, a compacted base, reinforcement and, where required, rigid insulation, followed by control joints placed to manage cracking."
      },
      {
        "q": "How much does a concrete project cost?",
        "a": "Cost depends on the size of the area, the thickness and reinforcement required, site access, excavation and the finish you choose. We provide a free, detailed quote after reviewing your project so you can see exactly what is included."
      },
      {
        "q": "How long will my concrete project take?",
        "a": "Timelines depend on the scope, site preparation, weather and the curing time the concrete needs before it can be used. Your quote includes a project-specific schedule so you know what to expect."
      },
      {
        "q": "What warranty do you provide on concrete work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before work begins. MRE Developments is licensed and insured."
      }
    ],
    "ctaTitle": "Plan Your Concrete Project in Calgary",
    "ctaSubtitle": "Tell us about your foundation, flatwork, cutting or custom concrete project and we will prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Stamped backyard patio with dark border",
        "summary": "Forms, pour and stamping through to a sealed dark stamped patio beside the lawn and play structure.",
        "dates": "Aug 2024",
        "photos": [
          "2026/04/20240821_165327-scaled.jpg",
          "2026/04/20240821_171721-scaled.jpg",
          "2026/04/20240821_183329-scaled.jpg",
          "2026/04/20240824_193528-1-scaled.jpg"
        ]
      },
      {
        "title": "Stamped patio for a two-storey home",
        "summary": "Bare backyard before, form work, stamping mats in use, then the finished stamped patio.",
        "dates": "Aug 2024 – Sep 2024",
        "photos": [
          "2026/04/20240829_112428-scaled.jpg",
          "2026/04/20240903_163340-scaled.jpg",
          "2026/04/20240905_194437-scaled.jpg",
          "2026/04/20240929_124022-scaled.jpg"
        ]
      },
      {
        "title": "Backyard patio slab under a deck",
        "summary": "Lawn before, pump pour and power screed, then the new broom-finished patio slab.",
        "dates": "Sep 2022",
        "photos": [
          "2026/04/1-3-scaled.jpg",
          "2026/04/2-3-scaled.jpg",
          "2026/04/3-4-scaled.jpg",
          "2026/04/4-4-scaled.jpg"
        ]
      },
      {
        "title": "Insulated side-yard walkway and slab",
        "summary": "Side yard before, forms and foam insulation in snow, pump pour and finishing.",
        "dates": "Nov 2025",
        "photos": [
          "2026/04/20251109_120703-scaled.jpg",
          "2026/04/20251120_124225-scaled.jpg",
          "2026/04/20251120_124653-scaled.jpg",
          "2026/04/20251120_140954-scaled.jpg",
          "2026/04/20251121_133436-scaled.jpg",
          "2026/04/20251121_140247-scaled.jpg",
          "2026/04/20251121_141820-scaled.jpg",
          "2026/04/20251121_154907-scaled.jpg"
        ]
      },
      {
        "title": "Commercial plaza sidewalks and curbs",
        "summary": "Finished storefront sidewalks and curb ramp, then curb forming, cutting and pouring on site.",
        "dates": "Aug 2022",
        "photos": [
          "2026/04/20220810_150709-scaled.jpg",
          "2026/04/20220810_150842-scaled.jpg",
          "2026/04/20220810_151138-scaled.jpg",
          "2026/04/20220810_151500-scaled.jpg",
          "2026/04/20220830_130035-scaled.jpg",
          "2026/04/20220830_133012-scaled.jpg",
          "2026/04/20220830_134311-scaled.jpg",
          "2026/04/20220830_142940-scaled.jpg"
        ]
      },
      {
        "title": "Exposed aggregate wash-off",
        "summary": "Crew pressure-washing fresh concrete to reveal the exposed aggregate finish along a home.",
        "dates": "Sep 2024",
        "photos": [
          "2026/04/20240914_133144-scaled.jpg",
          "2026/04/20240914_140435-scaled.jpg",
          "2026/04/20240914_145232-scaled.jpg",
          "2026/04/20240914_145350-1-scaled.jpg"
        ]
      }
    ]
  },
  "custom-concrete-work": {
    "metaTitle": "Custom & Decorative Concrete Calgary | MRE Developments",
    "metaDescription": "Stamped and exposed aggregate concrete patios, walkways and driveways for homes in Calgary, Cochrane and Okotoks. Book a free design review and quote.",
    "headline": "Custom Concrete in Calgary: Stamped and Exposed Aggregate",
    "subheadline": "Replace tired, shifting pavers with decorative concrete patios and walkways designed around your yard, finished in stamped patterns or exposed aggregate that lasts.",
    "hero": "2026/04/7-1-scaled.jpg",
    "heroAlt": "Finished exposed aggregate concrete patio outside patio doors at a white-sided Calgary home",
    "overviewTitle": "Decorative Concrete, Designed for You",
    "summary": "MRE Developments creates custom concrete patios, walkways, steps and driveways for residential and commercial properties in Calgary, Cochrane, Okotoks, Airdrie and Chestermere. We offer stamped patterns such as slate and wood grain, colour options and exposed aggregate finishes. From the first design review to final finishing, the process is transparent and focused on detail.",
    "highlights": [
      "Stamped slate, stone and wood-grain patterns",
      "Exposed aggregate patios and walkways",
      "Replacement of old paver patios",
      "Design review and finish selection",
      "Site preparation and removal included",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "From Shifting Pavers to Concrete",
        "body": "Many Calgary backyards still have paver patios and walks that have heaved, sunk and grown weeds between the joints. We remove the old surface, prepare a proper base and pour a continuous decorative slab in its place. Exposed aggregate gives a textured, slip-resistant surface that suits patios, side yards and stair landings.",
        "benefit": "Your outdoor space becomes easier to maintain and looks finished and intentional.",
        "image": "2026/04/8-scaled.jpg",
        "imageAlt": "Exposed aggregate concrete patio and walkway crossing a fenced Calgary backyard to the garage"
      },
      {
        "title": "Stamped Patterns Applied by Hand",
        "body": "Stamped concrete depends on timing and handwork. Our crew sets textured stamping mats while the concrete is at the right stage, tamps each one in, then details the edges and joints by hand so the pattern runs cleanly to the borders. Colour and release agents add depth to stone, slate and wood-grain looks.",
        "benefit": "You get the character of stone or wood with the durability of a single concrete slab.",
        "image": "2026/04/20250510_141939-scaled.jpg",
        "imageAlt": "Finisher pressing coloured stamping mats into fresh concrete to create a decorative pattern"
      },
      {
        "title": "Designed Around Your Property",
        "body": "Every property is different, so we start with a design review covering layout, pattern, colour and how the surface will connect to steps, doors and lawn. We confirm grading and drainage at the same time so water moves away from your home. The result is a custom surface that fits the space instead of a standard pad.",
        "benefit": "Your new concrete improves curb appeal while performing through Alberta winters.",
        "image": "2026/04/20240929_123753-scaled.jpg",
        "imageAlt": "Close-up of wood-grain stamped concrete showing plank texture and joints"
      }
    ],
    "galleryIntro": "See custom concrete projects that replaced worn paver patios with exposed aggregate and stamped concrete, including before and process shots.",
    "photos": [
      {
        "src": "2026/04/2-1-scaled.jpg",
        "caption": "Before: pavers by the garden steps",
        "alt": "Paver patio beside wooden steps and siding before custom concrete work"
      },
      {
        "src": "2026/04/3-2-scaled.jpg",
        "caption": "Before: uneven paver patio",
        "alt": "Uneven paver patio and walkway in a backyard before decorative concrete"
      },
      {
        "src": "2026/04/4-2-scaled.jpg",
        "caption": "Before: heaved paver patio",
        "alt": "Heaved brick paver patio in a fenced yard before replacement with concrete"
      },
      {
        "src": "2026/04/1-1-scaled.jpg",
        "caption": "Before: worn paver walkway",
        "alt": "Old brick paver walkway through a backyard before custom concrete replacement"
      },
      {
        "src": "2026/04/7-scaled.jpg",
        "caption": "Exposed aggregate walk to the garage",
        "alt": "Exposed aggregate walkway across a lawn to a detached garage in Calgary"
      },
      {
        "src": "2026/04/8-scaled.jpg",
        "caption": "Patio and walkway across the yard",
        "alt": "Exposed aggregate concrete patio and walkway leading through a fenced backyard"
      },
      {
        "src": "2026/04/5-scaled.jpg",
        "caption": "New aggregate walk to patio doors",
        "alt": "New exposed aggregate walkway leading to patio doors, replacing old pavers"
      },
      {
        "src": "2026/04/6-scaled.jpg",
        "caption": "Aggregate pad beside garden steps",
        "alt": "Exposed aggregate concrete pad beside wooden garden steps and planters"
      },
      {
        "src": "2026/04/3-3-scaled.jpg",
        "caption": "Before: paver patio at back door",
        "alt": "Paver patio outside patio doors before replacement with exposed aggregate concrete"
      },
      {
        "src": "2026/04/2-2-scaled.jpg",
        "caption": "Before: paver walk along the fence",
        "alt": "Narrow paver walkway along a wood fence before custom concrete replacement"
      },
      {
        "src": "2026/04/4-3-scaled.jpg",
        "caption": "Before: paver landing by the deck",
        "alt": "Paver landing beside deck stairs and an evergreen before new concrete"
      },
      {
        "src": "2026/04/1-2-scaled.jpg",
        "caption": "Before: paver pad under the stairs",
        "alt": "Old paver pad beneath exterior stairs before an exposed aggregate upgrade"
      },
      {
        "src": "2026/04/8-1-scaled.jpg",
        "caption": "Aggregate landing at the deck stairs",
        "alt": "Exposed aggregate concrete landing at the base of deck stairs beside an evergreen"
      },
      {
        "src": "2026/04/5-1-scaled.jpg",
        "caption": "Side yard pad beside the stairs",
        "alt": "Exposed aggregate concrete pad in a side yard beside white exterior stairs"
      },
      {
        "src": "2026/04/7-1-scaled.jpg",
        "caption": "Exposed aggregate patio at the back door",
        "alt": "Exposed aggregate custom concrete patio outside patio doors at a Calgary home"
      },
      {
        "src": "2026/04/6-1-scaled.jpg",
        "caption": "Walkway edging a new lawn",
        "alt": "Exposed aggregate concrete walkway running alongside a green lawn and house"
      },
      {
        "src": "2026/04/20240905_190602-scaled.jpg",
        "caption": "Hand-detailing the stamped border",
        "alt": "Finisher hand-detailing the edge of a stamped concrete slab along the forms"
      },
      {
        "src": "2026/04/20240905_193419-scaled.jpg",
        "caption": "Stamp mats laid across the slab",
        "alt": "Stamping mats laid across a fresh concrete patio during decorative finishing"
      },
      {
        "src": "2026/04/20240905_193608-scaled.jpg",
        "caption": "Stamping with release powder",
        "alt": "Crew stamping concrete with release powder creating a light dust haze"
      },
      {
        "src": "2026/04/20240929_123753-scaled.jpg",
        "caption": "Wood-grain stamped texture",
        "alt": "Close-up of wood-grain stamped decorative concrete texture"
      },
      {
        "src": "2026/04/20250510_134740-scaled.jpg",
        "caption": "Edging and floating the walkway",
        "alt": "Finishers edging and floating a fresh concrete walkway inside wood forms"
      },
      {
        "src": "2026/04/20250510_141939-scaled.jpg",
        "caption": "Coloured stamping mats in place",
        "alt": "Coloured stamping mats being pressed into fresh custom concrete"
      },
      {
        "src": "2026/04/20250510_142441-scaled.jpg",
        "caption": "Slate pattern stamped and coloured",
        "alt": "Freshly stamped slate-pattern decorative concrete with dark colour inside forms"
      },
      {
        "src": "2026/04/20250510_152023-scaled.jpg",
        "caption": "Tamping a stamp into fresh concrete",
        "alt": "Worker tamping a yellow stamping mat into fresh concrete by hand"
      }
    ],
    "videos": [
      "2026/04/20240914_134759-1.mp4"
    ],
    "faqs": [
      {
        "q": "What custom concrete finishes do you offer?",
        "a": "We offer stamped concrete in patterns such as slate, stone and wood grain, coloured concrete and exposed aggregate. These finishes suit patios, walkways, steps, landings and driveways for homes and commercial properties in Calgary and the surrounding area."
      },
      {
        "q": "Can you replace an old paver patio with concrete?",
        "a": "Yes, this is one of our most common custom projects. We remove the existing pavers, correct the base and grading, and pour a new decorative concrete surface that will not shift or grow weeds between joints the way pavers can."
      },
      {
        "q": "Is stamped or exposed aggregate better for my yard?",
        "a": "Exposed aggregate offers natural stone texture and good traction, which many homeowners like for walkways and stair landings. Stamped concrete recreates the look of stone, slate or wood and pairs well with colour. We discuss both during the design review based on your style and how the space is used."
      },
      {
        "q": "How do I care for decorative concrete?",
        "a": "Decorative concrete is low maintenance, but periodic cleaning and resealing help protect the finish and colour. We explain the recommended care for your chosen finish when the project is complete."
      },
      {
        "q": "What affects the cost of custom concrete?",
        "a": "Cost depends on the area, removal of the existing surface, base preparation, the finish and pattern, colour and site access. We provide a free, detailed quote, along with a schedule for the work."
      }
    ],
    "ctaTitle": "Design Your Custom Concrete Project",
    "ctaSubtitle": "Tell us about the patio, walkway or driveway you have in mind and we will arrange a design review and a free, detailed quote.",
    "projects": [
      {
        "title": "Paver walkway replaced with exposed aggregate",
        "summary": "Sunken brick paver walkway and patio before, then new exposed aggregate walkway, patio and steps.",
        "dates": "Jun 2024",
        "photos": [
          "2026/04/2-1-scaled.jpg",
          "2026/04/3-2-scaled.jpg",
          "2026/04/4-2-scaled.jpg",
          "2026/04/1-1-scaled.jpg",
          "2026/04/7-scaled.jpg",
          "2026/04/8-scaled.jpg",
          "2026/04/5-scaled.jpg",
          "2026/04/6-scaled.jpg"
        ]
      },
      {
        "title": "Paver patio replaced with exposed aggregate",
        "summary": "Worn paver patio and side path before, then finished exposed aggregate patio and walkway.",
        "dates": "Jul 2024",
        "photos": [
          "2026/04/3-3-scaled.jpg",
          "2026/04/2-2-scaled.jpg",
          "2026/04/4-3-scaled.jpg",
          "2026/04/1-2-scaled.jpg",
          "2026/04/8-1-scaled.jpg",
          "2026/04/5-1-scaled.jpg",
          "2026/04/7-1-scaled.jpg",
          "2026/04/6-1-scaled.jpg"
        ]
      },
      {
        "title": "Wood-plank stamped concrete patio",
        "summary": "Stamping mats pressed into fresh concrete, then the finished wood-grain stamped surface.",
        "dates": "Sep 2024",
        "photos": [
          "2026/04/20240905_190602-scaled.jpg",
          "2026/04/20240905_193419-scaled.jpg",
          "2026/04/20240905_193608-scaled.jpg",
          "2026/04/20240929_123753-scaled.jpg"
        ]
      },
      {
        "title": "Coloured stamped concrete slab",
        "summary": "Finishing a fresh slab, stamping with texture mats and the stamped result before sealing.",
        "dates": "May 2025",
        "photos": [
          "2026/04/20250510_134740-scaled.jpg",
          "2026/04/20250510_141939-scaled.jpg",
          "2026/04/20250510_142441-scaled.jpg",
          "2026/04/20250510_152023-scaled.jpg"
        ]
      }
    ]
  },
  "decks-fences": {
    "metaTitle": "Deck Builder Calgary | Decks, Pergolas | MRE Developments",
    "metaDescription": "Custom decks, pergolas, fences and railings built in Calgary, Cochrane, Airdrie and Okotoks. Wood and composite, designed for Alberta. Get a free quote.",
    "headline": "Custom Decks, Pergolas and Fences Built for Calgary Backyards",
    "subheadline": "Multi-level decks, shaded pergolas, privacy screens and fences designed around how you use your yard, framed solidly and finished to handle Alberta sun, snow and chinooks.",
    "hero": "2025/11/Screenshot_20180902-125936_Instagram.jpg",
    "heroAlt": "Cedar pergola over an outdoor lounge on a wood deck with black railings overlooking trees in Calgary",
    "overviewTitle": "Outdoor Living, Designed and Built",
    "summary": "MRE Developments designs and builds wood and composite decks, pergolas, fences, railings and stairs for homes across Calgary, Cochrane, Airdrie, Okotoks and Chestermere. We handle the project from layout and framing through to finishing, railings and outdoor features like privacy screens and built-in seating. Every build starts with a free, detailed quote.",
    "highlights": [
      "Multi-level wood and composite decks",
      "Custom pergolas for shade and style",
      "Fences and privacy screens",
      "Glass and aluminium railings, stairs",
      "Built-in seating, planters and lighting",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Complete Deck Construction",
        "body": "We build new decks and replace old ones, from ground-level platforms to two-storey decks with stairs and covered areas below. Framing, decking, stairs and railings are all handled by our team.",
        "benefit": "A safe, solid outdoor space that adds usable living area to your home.",
        "image": "2025/11/20180820_094057.jpg",
        "imageAlt": "Two-level wood deck with glass-railed upper balcony, stairs and covered dining area below in Calgary"
      },
      {
        "title": "Solid Framing, Clean Finishing",
        "body": "Decking is laid with consistent spacing over properly sized framing, then stained or sealed where wood is used. Step-downs, borders and transitions are planned so the deck looks intentional from every angle.",
        "benefit": "Boards that stay tight and a finish that protects the wood through Calgary winters.",
        "image": "2025/11/Screenshot_20180719-191403_Instagram.jpg",
        "imageAlt": "Freshly stained cedar deck boards with a raised step-down section and neat edges"
      },
      {
        "title": "Pergolas, Screens and Fences",
        "body": "Add shade, privacy and definition with a custom pergola, horizontal privacy screen or fence matched to your deck and home. We can include built-in seating, planters and integrated lighting.",
        "benefit": "An outdoor room tailored to your yard, with privacy where you want it.",
        "image": "2025/11/Screenshot_20180902-125748_Instagram.jpg",
        "imageAlt": "Horizontal cedar privacy screen behind an outdoor sectional and fire table on a raised deck"
      }
    ],
    "galleryIntro": "Decks, pergolas and privacy screens built for Calgary-area homes, from framing to finished outdoor living spaces.",
    "photos": [
      {
        "src": "2025/11/Screenshot_20180717-230656_Instagram.jpg",
        "caption": "Pergola slats overhead",
        "alt": "View up through cedar pergola slats over a deck"
      },
      {
        "src": "2025/11/Screenshot_20180719-191248_Instagram.jpg",
        "caption": "Cedar deck and pergola framing",
        "alt": "Stained cedar deck with pergola framing under construction near a treed ravine"
      },
      {
        "src": "2025/11/Screenshot_20180719-191330_Instagram.jpg",
        "caption": "Covered deck framing in progress",
        "alt": "Covered deck roof framing being built against a two-storey stucco home"
      },
      {
        "src": "2025/11/Screenshot_20180719-191403_Instagram.jpg",
        "caption": "Stained cedar with step-down",
        "alt": "Stained cedar deck boards with a raised step-down section"
      },
      {
        "src": "2025/11/20180724_063638.jpg",
        "caption": "Lower deck nearing completion",
        "alt": "New lower wood deck under an upper balcony during final construction in Calgary"
      },
      {
        "src": "2025/11/20180724_232443.jpg",
        "caption": "Privacy screen posts going up",
        "alt": "Cedar posts and frame for a deck privacy screen being built"
      },
      {
        "src": "2025/11/20180820_094057.jpg",
        "caption": "Upper balcony with stairs down",
        "alt": "Deck building project with upper glass-railed deck, timber posts and lower patio"
      },
      {
        "src": "2025/11/Screenshot_20180902-125732_Instagram.jpg",
        "caption": "Covered patio under upper deck",
        "alt": "Lower wood deck with dining area under a glass-railed upper deck and stairs"
      },
      {
        "src": "2025/11/Screenshot_20180902-125748_Instagram.jpg",
        "caption": "Privacy screen and lounge area",
        "alt": "Cedar privacy screen wall with outdoor sectional on a raised deck"
      },
      {
        "src": "2025/11/Screenshot_20180902-125800_Instagram.jpg",
        "caption": "Timber posts and step-down deck",
        "alt": "Heavy timber posts supporting an upper deck above a step-down lower deck"
      },
      {
        "src": "2025/11/Screenshot_20180902-125846_Instagram.jpg",
        "caption": "Deck with glass panel railing",
        "alt": "Wood deck with glass panel railing and patio seating overlooking a Calgary neighbourhood"
      },
      {
        "src": "2025/11/Screenshot_20180902-125936_Instagram.jpg",
        "caption": "Cedar pergola over lounge deck",
        "alt": "Cedar pergola over a lounge area on a wood deck with black railings in Calgary"
      },
      {
        "src": "2025/11/sdfsd.jpg",
        "caption": "Two-level deck with glass balcony",
        "alt": "Two-level wood deck with stairs to a glass-railed balcony on a Calgary home"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do you build both wood and composite decks?",
        "a": "Yes. We build wood and composite decks and help you compare appearance, maintenance and budget during the quote. We serve Calgary, Cochrane, Airdrie, Okotoks, Chestermere and the surrounding area."
      },
      {
        "q": "Can you design a custom deck or pergola for my yard?",
        "a": "Yes. We work with you on layout, levels, materials and features such as pergolas, privacy screens, built-in seating, planters and lighting. The design is shaped around how you plan to use the space."
      },
      {
        "q": "Do you install fences and railings too?",
        "a": "Yes. We build fences and privacy screens and install railings and stairs, including glass and aluminium railing systems, to match your deck and home."
      },
      {
        "q": "Do I need a permit for my deck?",
        "a": "Many decks in Calgary need a building permit, depending on height, size and attachment to the house. We review the requirements for your project during the quote and explain what applies."
      },
      {
        "q": "How long does a deck or pergola build take?",
        "a": "Timing depends on the size and number of levels, materials, permit requirements and weather. A project schedule comes with your quote."
      },
      {
        "q": "What warranty comes with a new deck?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before construction starts."
      }
    ],
    "ctaTitle": "Plan Your Outdoor Space With MRE",
    "ctaSubtitle": "Share your yard, your ideas and how you want to use the space. We will prepare a free, detailed quote for your Calgary-area deck, pergola or fence.",
    "projects": [
      {
        "title": "Two-level cedar deck with pergola",
        "summary": "Lower deck, pergola and privacy walls built under an upper glass-railed deck, then finished and furnished.",
        "dates": "Jul 2018 – Aug 2018",
        "photos": [
          "2025/11/Screenshot_20180717-230656_Instagram.jpg",
          "2025/11/Screenshot_20180719-191248_Instagram.jpg",
          "2025/11/Screenshot_20180719-191330_Instagram.jpg",
          "2025/11/Screenshot_20180719-191403_Instagram.jpg",
          "2025/11/20180724_063638.jpg",
          "2025/11/20180724_232443.jpg",
          "2025/11/20180820_094057.jpg",
          "2025/11/Screenshot_20180902-125732_Instagram.jpg",
          "2025/11/Screenshot_20180902-125748_Instagram.jpg",
          "2025/11/Screenshot_20180902-125800_Instagram.jpg",
          "2025/11/Screenshot_20180902-125846_Instagram.jpg",
          "2025/11/Screenshot_20180902-125936_Instagram.jpg",
          "2025/11/sdfsd.jpg"
        ]
      }
    ]
  },
  "demolition": {
    "metaTitle": "Demolition Contractor Calgary | MRE Developments",
    "metaDescription": "Interior strip-outs, residential and commercial demolition, debris removal and site prep in Calgary and area. Clean, controlled work. Request a free quote.",
    "headline": "Calgary Demolition and Interior Strip-Outs",
    "subheadline": "Controlled residential and commercial demolition that protects what stays, clears what goes and leaves a clean, safe site ready for the next phase of construction.",
    "hero": "2026/02/2-8-scaled.jpg",
    "heroAlt": "Basement stripped to the joists and studs during an interior demolition in a Calgary home",
    "overviewTitle": "Clean, Controlled Demolition",
    "summary": "MRE Developments handles residential and commercial demolition across Calgary, Airdrie, Cochrane and Okotoks, from selective interior strip-outs of kitchens, bathrooms and basements to garages, sheds and full structural removal. Our licensed and insured team works with a safety-first approach, protecting the areas that stay and keeping the site organized. We remove the debris, recycle where possible and prepare the space for construction.",
    "highlights": [
      "Interior strip-outs for renovations",
      "Kitchen, bathroom and basement demolition",
      "Garage, shed and full structure removal",
      "Commercial and office strip-outs",
      "Debris removal and recycling where possible",
      "Site preparation for the next phase"
    ],
    "features": [
      {
        "title": "Interior Strip-Outs for Renovations",
        "body": "Before a renovation can start, old finishes have to come out. We strip basements, kitchens, bathrooms and whole floors down to the studs and joists, removing paneling, drywall, flooring, ceilings and fixtures in a controlled sequence.",
        "benefit": "A clean, open shell that is ready for framing, mechanical and new finishes.",
        "image": "2026/02/6-4-scaled.jpg",
        "imageAlt": "Basement stripped to the studs with paneling and flooring removed during a Calgary interior demolition"
      },
      {
        "title": "Selective Removal That Protects the Rest",
        "body": "Partial demolition means taking out exactly what the project calls for, such as a tub surround, tile or a wall, without damaging the structure or the finishes that remain. Our team works carefully around plumbing, wiring and adjacent rooms.",
        "benefit": "Less collateral damage, fewer surprises and lower repair costs later in the project.",
        "image": "2026/02/u5-scaled.jpg",
        "imageAlt": "Worker carefully removing a tub surround panel during a selective bathroom demolition"
      },
      {
        "title": "Debris Removal and Site Preparation",
        "body": "We haul away the waste, recycle materials where possible and leave the space swept and ready for the next trade. For residential and commercial projects in Calgary, Chestermere, Strathmore and High River, that keeps the schedule on track from day one.",
        "benefit": "A tidy, organized site and a smooth handoff to construction.",
        "image": "2026/02/resized_12000x9000-scaled.jpg",
        "imageAlt": "Bathroom stripped to the studs and cleaned up, ready for the next phase of renovation"
      }
    ],
    "galleryIntro": "Recent demolition and strip-out projects, showing spaces before and after the old finishes came out.",
    "photos": [
      {
        "src": "2026/02/1-9-scaled.jpg",
        "caption": "Before: paneled basement",
        "alt": "Wood-paneled basement with carpet tiles before an interior demolition in Calgary"
      },
      {
        "src": "2026/02/3-7-scaled.jpg",
        "caption": "Before: basement room with paneling",
        "alt": "Basement room with wood paneling and carpet tiles before strip-out"
      },
      {
        "src": "2026/02/5-4-scaled.jpg",
        "caption": "Before: basement with built-ins",
        "alt": "Basement with built-in shelving and flooring before a residential demolition"
      },
      {
        "src": "2026/02/7-4-scaled.jpg",
        "caption": "Before: paneled stairwell",
        "alt": "Wood-paneled basement stairwell before it was stripped during demolition"
      },
      {
        "src": "2026/02/6-4-scaled.jpg",
        "caption": "Basement cleared for redevelopment",
        "alt": "Basement cleared to studs and vapour barrier ready for redevelopment after demolition"
      },
      {
        "src": "2026/02/4-18-scaled.jpg",
        "caption": "Paneling removed down to the walls",
        "alt": "Basement with wood paneling removed to the walls during a residential demolition in Calgary"
      },
      {
        "src": "2026/02/2-8-scaled.jpg",
        "caption": "Basement opened to joists and studs",
        "alt": "Basement stripped to the joists and studs during an interior demolition project in Calgary"
      },
      {
        "src": "2026/02/8-4-scaled.jpg",
        "caption": "Stairwell stripped to its framing",
        "alt": "Basement stairwell stripped down to the framing during an interior strip-out"
      },
      {
        "src": "2026/02/u1-scaled.jpg",
        "caption": "Before: ensuite with glass shower",
        "alt": "Ensuite bathroom with a glass shower and double vanity before demolition"
      },
      {
        "src": "2026/02/u3-scaled.jpg",
        "caption": "Removing upper wall finishes",
        "alt": "Worker removing tile and wall finishes above a tub during a bathroom demolition"
      },
      {
        "src": "2026/02/u4-scaled.jpg",
        "caption": "Tub surround cut back to framing",
        "alt": "Tub surround and wall finishes removed to the framing during a bathroom demolition"
      },
      {
        "src": "2026/02/u5-scaled.jpg",
        "caption": "Taking out the tub surround",
        "alt": "Worker removing a tub surround panel during a selective bathroom demolition"
      },
      {
        "src": "2026/02/u6-scaled.jpg",
        "caption": "Shower walls opened to the studs",
        "alt": "Worker removing shower wall panels to expose framing during a selective demolition"
      },
      {
        "src": "2026/02/u7-scaled.jpg",
        "caption": "Prying out the bathtub",
        "alt": "Worker using a pry bar to remove a bathtub during a bathroom demolition"
      },
      {
        "src": "2026/02/u8-scaled.jpg",
        "caption": "Tub lifted out of the alcove",
        "alt": "Bathtub being lifted out of its alcove during a residential demolition"
      },
      {
        "src": "2026/02/resized_12000x9000-scaled.jpg",
        "caption": "Bathroom taken back to the studs",
        "alt": "Bathroom stripped to the studs and cleaned after demolition in a Calgary home"
      },
      {
        "src": "2026/02/20230613_153417-scaled.jpg",
        "caption": "Before: kitchen ready for removal",
        "alt": "Kitchen with island and wood cabinets before a kitchen demolition"
      },
      {
        "src": "2026/02/20230614_185839-scaled.jpg",
        "caption": "Chipping off wall tile",
        "alt": "Worker chipping old wall tile off with a hammer during a kitchen or bathroom demolition"
      },
      {
        "src": "2026/02/20230614_195129-scaled.jpg",
        "caption": "Kitchen island and cabinets removed",
        "alt": "Kitchen island and cabinets removed with plumbing exposed during a kitchen demolition"
      },
      {
        "src": "2026/02/b5-scaled.jpg",
        "caption": "Kitchen cleared down to the subfloor",
        "alt": "Kitchen cleared of cabinets and flooring down to the subfloor during a renovation demolition"
      },
      {
        "src": "2026/02/1-10-scaled.jpg",
        "caption": "Before: bathroom with corner shower",
        "alt": "Bathroom with a corner shower and vanity before a bathroom demolition"
      },
      {
        "src": "2026/02/3-8-scaled.jpg",
        "caption": "Removing finishes around the fireplace",
        "alt": "Worker removing ceiling and wall finishes around a fireplace during a home demolition"
      },
      {
        "src": "2026/02/4-19-scaled.jpg",
        "caption": "Ceiling coming down in the family room",
        "alt": "Worker removing a ceiling in a family room during an interior demolition in Calgary"
      },
      {
        "src": "2026/02/2-9-scaled.jpg",
        "caption": "Shower tile and base removed",
        "alt": "Bathroom with shower tile and surround removed during a bathroom demolition"
      },
      {
        "src": "2026/02/1-11-scaled.jpg",
        "caption": "Carpet removal underway",
        "alt": "Worker removing carpet in a living room at the start of an interior demolition"
      },
      {
        "src": "2026/02/2-10-scaled.jpg",
        "caption": "Scraping flooring off the subfloor",
        "alt": "Worker scraping old flooring off the subfloor during a residential strip-out"
      },
      {
        "src": "2026/02/4-20-scaled.jpg",
        "caption": "Living room cleared of flooring",
        "alt": "Living room with flooring removed down to the subfloor during an interior demolition"
      },
      {
        "src": "2026/02/3-9-scaled.jpg",
        "caption": "Lifting flooring with pry bars",
        "alt": "Crew lifting old flooring with pry bars during an interior demolition in Calgary"
      }
    ],
    "videos": [
      "2026/02/MRE-Demolition-YYC-VID-1-2.mp4"
    ],
    "faqs": [
      {
        "q": "What kinds of demolition do you do?",
        "a": "We handle residential demolition including interior walls, kitchens, bathrooms, basements, garages, sheds and full home demolitions, as well as commercial demolition of offices, retail spaces and commercial buildings. We also do partial demolition and interior strip-outs for renovation projects."
      },
      {
        "q": "Can you remove part of a space without damaging the rest?",
        "a": "Yes. Selective demolition is a large part of our work. We remove walls, flooring, ceilings and fixtures as the project requires while protecting the structure and the finishes that remain."
      },
      {
        "q": "Do you remove the debris?",
        "a": "Yes. We handle waste removal, recycle materials where possible and leave the site clean and prepared for the next phase of construction."
      },
      {
        "q": "How long does demolition take?",
        "a": "It depends on the size of the space, the materials being removed, access, disposal requirements and any structural or mechanical items that need to be dealt with. Your quote includes a schedule for your project."
      },
      {
        "q": "Can MRE also complete the renovation after demolition?",
        "a": "Yes. As a general contractor, we can carry the project from demolition through framing, mechanical and finishing, so one team manages the whole job."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We take on demolition projects across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      }
    ],
    "ctaTitle": "Get a Quote for Your Demolition Project",
    "ctaSubtitle": "Describe what needs to come out and we will prepare a free, detailed demolition quote for your Calgary area project.",
    "projects": [
      {
        "title": "Basement wood panelling and wall demolition",
        "summary": "Before: wood-panelled basement. After: panelling, partitions and flooring stripped to framing.",
        "dates": "May 2025 – Jun 2025",
        "photos": [
          "2026/02/1-9-scaled.jpg",
          "2026/02/3-7-scaled.jpg",
          "2026/02/5-4-scaled.jpg",
          "2026/02/7-4-scaled.jpg",
          "2026/02/6-4-scaled.jpg",
          "2026/02/4-18-scaled.jpg",
          "2026/02/2-8-scaled.jpg",
          "2026/02/8-4-scaled.jpg"
        ]
      },
      {
        "title": "Bathroom tub surround tear-out",
        "summary": "Bathroom before, then tub surround and fixtures removed down to studs and drains.",
        "dates": "Feb 2022 – Apr 2022",
        "photos": [
          "2026/02/u1-scaled.jpg",
          "2026/02/u3-scaled.jpg",
          "2026/02/u4-scaled.jpg",
          "2026/02/u5-scaled.jpg",
          "2026/02/u6-scaled.jpg",
          "2026/02/u7-scaled.jpg",
          "2026/02/u8-scaled.jpg",
          "2026/02/resized_12000x9000-scaled.jpg"
        ]
      },
      {
        "title": "Kitchen and tile demolition",
        "summary": "Kitchen before, then tile, cabinets and island removed down to the subfloor.",
        "dates": "Jun 2023",
        "photos": [
          "2026/02/20230613_153417-scaled.jpg",
          "2026/02/20230614_185839-scaled.jpg",
          "2026/02/20230614_195129-scaled.jpg",
          "2026/02/b5-scaled.jpg"
        ]
      },
      {
        "title": "Bathroom and family room ceiling demo",
        "summary": "Bathroom shower removed, family room ceiling and finishes taken down.",
        "dates": "Dec 2023",
        "photos": [
          "2026/02/1-10-scaled.jpg",
          "2026/02/3-8-scaled.jpg",
          "2026/02/4-19-scaled.jpg",
          "2026/02/2-9-scaled.jpg"
        ]
      },
      {
        "title": "Carpet and flooring removal",
        "summary": "Carpeted living room stripped to the subfloor, tack strip and staples pulled.",
        "dates": "Nov 2022",
        "photos": [
          "2026/02/1-11-scaled.jpg",
          "2026/02/2-10-scaled.jpg",
          "2026/02/4-20-scaled.jpg",
          "2026/02/3-9-scaled.jpg"
        ]
      }
    ]
  },
  "electrical": {
    "metaTitle": "Electrical Contractor Calgary | MRE Developments",
    "metaDescription": "Panel upgrades, wiring, lighting and EV chargers for homes, suites and commercial builds in Calgary and area. Permits handled. Get your free quote today.",
    "headline": "Calgary Electrical Contractor for Homes and New Builds",
    "subheadline": "Panel upgrades, full wiring, lighting and EV chargers installed safely to code, with permits and inspections handled so your project moves forward without surprises.",
    "hero": "2025/11/tf2-scaled.jpg",
    "heroAlt": "Electrician connecting a multi-unit meter bank on the exterior of a new Calgary residential building",
    "overviewTitle": "Safe, Inspected Electrical Work",
    "summary": "MRE Developments installs complete electrical systems for new homes, multi-family buildings, basement suites, renovations and commercial spaces across Calgary, Airdrie, Cochrane and Okotoks. Our licensed and insured team handles wiring, panels, lighting, outlets, smart home controls and EV chargers. We obtain the permits, build to national building codes and see every inspection through to approval.",
    "highlights": [
      "Panel upgrades for modern loads",
      "Wiring and rewiring, new or existing",
      "Interior, exterior and landscape lighting",
      "EV charger installation",
      "Permits and inspections handled",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "Complete Electrical Installations",
        "body": "Whether you are building a new home, developing a basement suite or renovating, we install the full system: service, panel, wiring, outlets, switches and fixtures. Circuits are planned around how each space will be used, then run neatly through the framing before walls are closed.",
        "benefit": "A reliable, fully functional electrical system designed for your layout from day one.",
        "image": "2025/11/20220222_124851-scaled.jpg",
        "imageAlt": "Electrician running yellow cable through open floor joists during new construction wiring in Calgary"
      },
      {
        "title": "Panel Upgrades and Safe Wiring",
        "body": "Older or overloaded panels struggle with today's appliances, heat pumps and EV chargers. We replace outdated panels, organize circuits and use quality materials so the system is safer, more efficient and ready for added demand.",
        "benefit": "More capacity, fewer tripped breakers and lower risk of electrical hazards.",
        "image": "2025/11/tf5-scaled.jpg",
        "imageAlt": "Electrician terminating circuits in an open breaker panel during an electrical panel upgrade"
      },
      {
        "title": "Lighting That Finishes the Space",
        "body": "Lighting shapes how a room looks and works. We install ambient, task and accent lighting, including recessed pot lights, exterior security lights and landscape lighting for homes in Calgary, Chestermere, Strathmore and High River.",
        "benefit": "Bright, efficient and good-looking spaces, inside and out.",
        "image": "2026/04/1-14-1-scaled.jpg",
        "imageAlt": "Finished basement suite in Calgary with recessed pot lights over the kitchen and living area"
      }
    ],
    "galleryIntro": "Electrical work from recent residential, multi-family and commercial projects around Calgary.",
    "photos": [
      {
        "src": "2026/04/1-14-scaled.jpg",
        "caption": "Bright, evenly lit suite living area",
        "alt": "Basement suite living area and kitchen lit by recessed ceiling lights after electrical work"
      },
      {
        "src": "2026/04/2-12-scaled.jpg",
        "caption": "Kitchen lighting and appliance circuits",
        "alt": "Basement suite kitchen with pot lights and appliance circuits completed by an electrical contractor"
      },
      {
        "src": "2026/04/3-11-scaled.jpg",
        "caption": "Finished bedroom ready for move-in",
        "alt": "Finished basement suite bedroom with lighting and outlets installed in a Calgary home"
      },
      {
        "src": "2026/04/1-14-1-scaled.jpg",
        "caption": "Pot lights in a finished basement suite",
        "alt": "Finished basement suite with warm recessed pot lights and a white kitchen, electrical by MRE in Calgary"
      },
      {
        "src": "2026/04/2-12-1-scaled.jpg",
        "caption": "Suite kitchen with completed circuits",
        "alt": "Basement suite kitchen with range, fridge and lighting circuits completed by MRE Developments"
      },
      {
        "src": "2026/04/3-11-1-scaled.jpg",
        "caption": "Recessed lighting in a suite bedroom",
        "alt": "Bright basement suite bedroom with recessed pot lights after a Calgary electrical installation"
      },
      {
        "src": "2025/11/1-2-scaled.jpg",
        "caption": "Fixture housings in a steel-stud build",
        "alt": "Electrician preparing fixture housings in a steel-stud commercial space during electrical rough-in"
      },
      {
        "src": "2025/11/2-1-scaled.jpg",
        "caption": "Running cable through steel studs",
        "alt": "Electrician feeding cable through steel studs during a commercial electrical installation"
      },
      {
        "src": "2025/11/4-11-scaled.jpg",
        "caption": "Commercial space wiring from the ladder",
        "alt": "Electrician on a ladder running cable in an open commercial space during an electrical installation"
      },
      {
        "src": "2025/11/tf2-scaled.jpg",
        "caption": "Multi-unit meter bank installation",
        "alt": "Electrician connecting a multi-unit meter bank on a new residential building in Calgary"
      },
      {
        "src": "2025/11/tf3-scaled.jpg",
        "caption": "Underground service cable going in",
        "alt": "Crew installing underground electrical service cable in a trench beside a new home in the Calgary area"
      },
      {
        "src": "2025/11/tf5-scaled.jpg",
        "caption": "Breaker panel wiring and terminations",
        "alt": "Electrician working on circuit terminations inside an open breaker panel during a panel upgrade"
      },
      {
        "src": "2025/11/20220222_124851-scaled.jpg",
        "caption": "New construction wiring through joists",
        "alt": "Electrician pulling yellow cable through open floor joists during new home electrical rough-in"
      }
    ],
    "videos": [
      "2025/11/20220303_140953.mp4"
    ],
    "faqs": [
      {
        "q": "What electrical projects do you take on?",
        "a": "We handle full electrical installations for new homes, multi-family buildings, basement developments and legal suites, garage and backyard suites, renovations and commercial spaces. That includes panels, wiring and rewiring, lighting, outlets and switches, smart home systems and EV chargers. We focus on project work rather than one-off service calls."
      },
      {
        "q": "Do I need a panel upgrade?",
        "a": "A panel upgrade is often needed when you add a suite, an EV charger, a hot tub, a heat pump or major appliances, or when an older panel is undersized or outdated. We review your current panel and planned loads during the quote and recommend what your project needs."
      },
      {
        "q": "Can you install an EV charger at my home?",
        "a": "Yes. We assess panel capacity, run a dedicated circuit to your garage or driveway and install the charger to code, with the required permit and inspection. If your panel needs more capacity, we include that in the quote."
      },
      {
        "q": "Do you handle electrical permits and inspections?",
        "a": "Yes. We obtain the electrical permits, build to national building codes and make sure the required inspections are completed and approved."
      },
      {
        "q": "How long does an electrical project take?",
        "a": "Timing depends on the scope of the work, the size of the space, whether walls are open or finished, material availability and inspection scheduling. Your quote includes a schedule for your project."
      },
      {
        "q": "Do you serve areas outside Calgary?",
        "a": "Yes. We work throughout Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      }
    ],
    "ctaTitle": "Get a Quote for Your Electrical Project",
    "ctaSubtitle": "Tell us about your build, suite or upgrade and we will prepare a free, detailed electrical quote for your Calgary area project.",
    "projects": [
      {
        "title": "Basement suite with new pot lighting",
        "summary": "Finished basement suite: kitchen, living area and bedroom with recessed lighting, shown off and lit.",
        "dates": "Mar 2026",
        "photos": [
          "2026/04/1-14-scaled.jpg",
          "2026/04/2-12-scaled.jpg",
          "2026/04/3-11-scaled.jpg",
          "2026/04/1-14-1-scaled.jpg",
          "2026/04/2-12-1-scaled.jpg",
          "2026/04/3-11-1-scaled.jpg"
        ]
      },
      {
        "title": "Commercial wiring in steel-stud walls",
        "summary": "Running wire and setting boxes through steel stud framing in a commercial space.",
        "dates": "Jul 2023",
        "photos": [
          "2025/11/1-2-scaled.jpg",
          "2025/11/2-1-scaled.jpg",
          "2025/11/4-11-scaled.jpg"
        ]
      },
      {
        "title": "New-build service, meters and panel",
        "summary": "Underground service cable trenched in, multi-meter bank connected, then the panel wired.",
        "dates": "Oct 2024",
        "photos": [
          "2025/11/tf2-scaled.jpg",
          "2025/11/tf3-scaled.jpg",
          "2025/11/tf5-scaled.jpg"
        ]
      },
      {
        "title": "More electrical work",
        "summary": "Rough-in wiring run through open floor joists.",
        "dates": "Feb 2022",
        "photos": [
          "2025/11/20220222_124851-scaled.jpg"
        ]
      }
    ]
  },
  "epoxy-flooring": {
    "metaTitle": "Epoxy Floor Coatings Calgary | MRE Developments",
    "metaDescription": "Epoxy floor coatings for garages, basements, shops and warehouses in Calgary, Airdrie and Cochrane. Seamless, stain-resistant floors. Get a free quote.",
    "headline": "Epoxy Floor Coatings in Calgary for Garages, Shops and Warehouses",
    "subheadline": "Turn stained, dusty concrete into a seamless floor that resists salt, oil, moisture and heavy traffic, with grinding, crack repair and coating handled by our team.",
    "hero": "2026/05/D.jpg",
    "heroAlt": "Glossy grey flake epoxy floor coating in a large commercial shop with white walls and bright lighting",
    "overviewTitle": "Seamless Floors That Stand Up to Use",
    "summary": "MRE Developments installs epoxy floor coatings for garages, basements, utility areas, workshops, warehouses, retail spaces and offices across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our systems protect concrete from stains, chemicals, moisture and wear while giving a clean, polished look. We handle the surface preparation, including grinding, crack repair and resurfacing, that long-lasting adhesion depends on.",
    "highlights": [
      "Garage and basement epoxy floors",
      "Commercial and industrial floor coatings",
      "Flake, metallic and solid colour finishes",
      "Grinding and crack repair before coating",
      "Stain, chemical and moisture resistant",
      "Seamless, easy-to-clean surface"
    ],
    "features": [
      {
        "title": "Garage Floors That Shrug Off Salt",
        "body": "Calgary garage floors take a beating from road salt, slush, oil and hot tires. A flake epoxy system seals the concrete under a seamless coating that wipes clean and hides minor dust and debris between cleanings. The same durable systems suit basements, workshops and utility rooms.",
        "benefit": "You get a bright, clean garage floor that protects the concrete underneath.",
        "image": "2026/05/C-1.jpg",
        "imageAlt": "Close view of a glossy black, grey and white flake epoxy floor in a bright shop space"
      },
      {
        "title": "Preparation Comes First",
        "body": "Epoxy is only as good as its bond to the concrete. Our team grinds the surface to open the pores, repairs cracks and resurfaces where needed before any coating goes down. Primer and base coats are then spread with squeegees and back-rolled for even coverage.",
        "benefit": "Your coating bonds properly and resists peeling and lifting over time.",
        "image": "2026/03/gf7-scaled.jpg",
        "imageAlt": "Squeegee spreading the first epoxy coat over ground concrete along a block wall"
      },
      {
        "title": "Built for Commercial Traffic",
        "body": "For warehouses, workshops, retail spaces and offices, we install commercial and industrial epoxy systems designed for strength, slip resistance and long-term performance. Decorative options, including metallic finishes, flake blends and custom colours, let the floor match your brand or space.",
        "benefit": "Your business gets a floor that handles heavy use and still looks sharp.",
        "image": "2026/03/gf5-scaled.jpg",
        "imageAlt": "Installer spreading glossy epoxy coating across a large commercial warehouse floor in Calgary"
      }
    ],
    "galleryIntro": "These epoxy projects show commercial flake floors and large-area coatings from bare concrete to high-gloss finish, plus decorative marble-effect epoxy work.",
    "photos": [
      {
        "src": "2026/05/A-1.jpg",
        "caption": "Dense flake broadcast, ground level",
        "alt": "Ground-level view of a dense flake epoxy floor coating in a commercial space"
      },
      {
        "src": "2026/05/B-1.jpg",
        "caption": "Flake epoxy reflecting overhead lights",
        "alt": "Flake epoxy floor coating reflecting bright overhead lighting in a commercial building"
      },
      {
        "src": "2026/05/C-1.jpg",
        "caption": "Black, grey and white flake blend",
        "alt": "Close view of a black, grey and white flake epoxy floor in a shop"
      },
      {
        "src": "2026/05/D.jpg",
        "caption": "Commercial flake floor, high-gloss finish",
        "alt": "High-gloss flake epoxy floor coating in a large Calgary commercial shop"
      },
      {
        "src": "2026/03/df1-scaled.jpg",
        "caption": "Vanity masked around the sink",
        "alt": "Bathroom vanity masked around the sink and faucet before epoxy coating"
      },
      {
        "src": "2026/03/df2-scaled.jpg",
        "caption": "Base coat flowing to the edge",
        "alt": "White epoxy base coat flowing over the edge of a bathroom vanity top"
      },
      {
        "src": "2026/03/df3-scaled.jpg",
        "caption": "Pouring tint for the veins",
        "alt": "Installer pouring tinted epoxy onto a vanity top to create veining"
      },
      {
        "src": "2026/03/df4-scaled.jpg",
        "caption": "Laying in veins around the basin",
        "alt": "Grey veins being laid into white epoxy around a vanity sink"
      },
      {
        "src": "2026/03/df5-scaled.jpg",
        "caption": "Grey veining on white epoxy",
        "alt": "Grey veining flowing across a white epoxy vanity top near the sink"
      },
      {
        "src": "2026/03/df6-scaled.jpg",
        "caption": "Feathering a vein by hand",
        "alt": "Gloved hand feathering a grey vein into a white epoxy surface"
      },
      {
        "src": "2026/03/df7-scaled.jpg",
        "caption": "Smoothing the edge detail",
        "alt": "Installer smoothing marble-effect epoxy near the sink edge of a vanity"
      },
      {
        "src": "2026/03/df8-scaled.jpg",
        "caption": "Finished marble-look vanity",
        "alt": "Finished marble-look epoxy vanity top with a black faucet and undermount sink"
      },
      {
        "src": "2026/03/tr8-scaled.jpg",
        "caption": "Countertop masked for epoxy",
        "alt": "Countertop and cabinets masked with tape and plastic before epoxy coating"
      },
      {
        "src": "2026/03/tr1-scaled.jpg",
        "caption": "White base coat on the countertop",
        "alt": "White epoxy base coat spread over a countertop with a sink cut-out"
      },
      {
        "src": "2026/03/tr2-scaled.jpg",
        "caption": "Pouring the vein colour",
        "alt": "Grey epoxy being poured onto a white base coat to form veining"
      },
      {
        "src": "2026/03/tr3-scaled.jpg",
        "caption": "Coating around the sink cut-out",
        "alt": "Epoxy being brushed around a sink cut-out on a countertop coating"
      },
      {
        "src": "2026/03/tr4-scaled.jpg",
        "caption": "Adding grey veins to the coating",
        "alt": "Installer adding grey veins to a white epoxy countertop coating"
      },
      {
        "src": "2026/03/tr5-scaled.jpg",
        "caption": "Working the marble pattern by hand",
        "alt": "Gloved hand blending a marble pattern into a wet epoxy countertop coating"
      },
      {
        "src": "2026/03/tr6-scaled.jpg",
        "caption": "Marble-effect epoxy vanity top",
        "alt": "Marble-effect epoxy coating on a vanity countertop with grey veining"
      },
      {
        "src": "2026/05/20220518_135015-scaled.jpg",
        "caption": "Detailing veins in the epoxy",
        "alt": "Installer detailing grey veining in a marble-effect epoxy countertop"
      },
      {
        "src": "2026/03/gf1-scaled.jpg",
        "caption": "Bare warehouse slab before epoxy",
        "alt": "Bare concrete warehouse floor before epoxy floor coating installation"
      },
      {
        "src": "2026/03/gf2-scaled.jpg",
        "caption": "Mixing epoxy resin on site",
        "alt": "Epoxy resin being mixed in a pail with a paddle before application"
      },
      {
        "src": "2026/03/gf3-scaled.jpg",
        "caption": "Back-rolling for even coverage",
        "alt": "Roller back-rolling a fresh white epoxy floor coating for even coverage"
      },
      {
        "src": "2026/03/gf4-scaled.jpg",
        "caption": "Spreading epoxy along a laser line",
        "alt": "Epoxy coating spread with a squeegee across ground concrete guided by a laser line"
      },
      {
        "src": "2026/03/gf5-scaled.jpg",
        "caption": "Coating a large warehouse floor",
        "alt": "Installer spreading glossy epoxy across a large warehouse floor"
      },
      {
        "src": "2026/03/gf6-scaled.jpg",
        "caption": "Squeegeeing a glossy epoxy coat",
        "alt": "Squeegee spreading a glossy white epoxy floor coating"
      },
      {
        "src": "2026/03/gf7-scaled.jpg",
        "caption": "Primer coat over ground concrete",
        "alt": "Squeegee spreading primer epoxy over ground concrete next to a block wall"
      },
      {
        "src": "2026/03/gf8-scaled.jpg",
        "caption": "Prepared floor before coating",
        "alt": "Prepared commercial concrete floor before epoxy coating, with taped edges"
      }
    ],
    "videos": [
      "2026/03/r5.mp4"
    ],
    "faqs": [
      {
        "q": "Where can epoxy floor coatings be installed?",
        "a": "Epoxy works well on garage floors, basements, kitchens, utility areas, workshops, warehouses, retail spaces and offices. We install residential and commercial epoxy floor coatings in Calgary, Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "How do you prepare the concrete before coating?",
        "a": "We grind the concrete to create a surface the epoxy can bond to, repair cracks and resurface where needed. Proper preparation is the most important factor in how long an epoxy floor lasts."
      },
      {
        "q": "Is epoxy a good choice for a Calgary garage?",
        "a": "Yes. Epoxy seals the concrete against road salt, meltwater, oil and other stains, and the seamless surface is easy to clean. Flake systems also add texture and help hide everyday dirt."
      },
      {
        "q": "What finish options are available?",
        "a": "Options include flake systems, metallic finishes and solid custom colours. We review the look you want, the level of slip resistance needed and how the space is used before recommending a system."
      },
      {
        "q": "How long does installation take, and when can I use the floor?",
        "a": "It depends on the floor's size and condition, the amount of preparation and repair needed, the system chosen and curing conditions. Your quote includes a schedule and the recommended wait before foot and vehicle traffic."
      },
      {
        "q": "What does an epoxy floor cost?",
        "a": "Pricing depends on square footage, surface condition, crack repair, the coating system and the finish. We provide a free, detailed quote, and warranty and workmanship terms are set out in writing with it."
      }
    ],
    "ctaTitle": "Get a Quote for Your Epoxy Floor",
    "ctaSubtitle": "Tell us about your garage, basement or commercial space and we will prepare a free, detailed epoxy flooring quote.",
    "projects": [
      {
        "title": "Commercial flake epoxy floor",
        "summary": "Finished full-broadcast flake epoxy floor with high-gloss topcoat in a large commercial space.",
        "dates": "",
        "photos": [
          "2026/05/A-1.jpg",
          "2026/05/B-1.jpg",
          "2026/05/C-1.jpg",
          "2026/05/D.jpg"
        ]
      },
      {
        "title": "Marble-look epoxy bathroom vanity top",
        "summary": "Vanity top coated white, grey veining added and blended for a marble look.",
        "dates": "May 2022",
        "photos": [
          "2026/03/df1-scaled.jpg",
          "2026/03/df2-scaled.jpg",
          "2026/03/df3-scaled.jpg",
          "2026/03/df4-scaled.jpg",
          "2026/03/df5-scaled.jpg",
          "2026/03/df6-scaled.jpg",
          "2026/03/df7-scaled.jpg",
          "2026/03/df8-scaled.jpg"
        ]
      },
      {
        "title": "Marble-look epoxy countertop",
        "summary": "White base coat, veining poured and feathered into a glossy marble-look countertop.",
        "dates": "May 2022",
        "photos": [
          "2026/03/tr8-scaled.jpg",
          "2026/03/tr1-scaled.jpg",
          "2026/03/tr2-scaled.jpg",
          "2026/03/tr3-scaled.jpg",
          "2026/03/tr4-scaled.jpg",
          "2026/03/tr5-scaled.jpg",
          "2026/03/tr6-scaled.jpg",
          "2026/05/20220518_135015-scaled.jpg"
        ]
      },
      {
        "title": "White epoxy floor in commercial unit",
        "summary": "Bare concrete unit, mixing, then rolling and squeegeeing a white epoxy floor coating.",
        "dates": "May 2022",
        "photos": [
          "2026/03/gf1-scaled.jpg",
          "2026/03/gf2-scaled.jpg",
          "2026/03/gf3-scaled.jpg",
          "2026/03/gf4-scaled.jpg",
          "2026/03/gf5-scaled.jpg",
          "2026/03/gf6-scaled.jpg",
          "2026/03/gf7-scaled.jpg",
          "2026/03/gf8-scaled.jpg"
        ]
      }
    ]
  },
  "flooring": {
    "metaTitle": "Flooring Installer Calgary | MRE Developments",
    "metaDescription": "Hardwood, LVP, tile, marble, epoxy and heated floors installed in Calgary, Airdrie, Cochrane and Okotoks. Request a free, detailed flooring quote today.",
    "headline": "Calgary Flooring Installation, Level From the Subfloor Up",
    "subheadline": "Tile, marble, luxury vinyl plank, hardwood, epoxy and heated floors installed on a properly levelled base, so your new floors stay flat, quiet and good-looking for the long run.",
    "hero": "2026/03/kk1-1-1-scaled.jpg",
    "heroAlt": "Finished basement in Calgary with glossy large-format porcelain tile floor under a crystal chandelier",
    "overviewTitle": "Flooring Built on a Proper Foundation",
    "summary": "MRE Developments installs tile, marble, luxury vinyl plank, hardwood, epoxy and in-floor heating for homes and commercial spaces across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Every job starts with subfloor preparation and levelling, because a floor is only as flat as what sits beneath it. We are licensed and insured, and every project starts with a free, detailed quote.",
    "highlights": [
      "Tile, marble and natural stone floors",
      "Luxury vinyl plank and hardwood",
      "Electric in-floor heating systems",
      "Epoxy for garages and commercial spaces",
      "Self-levelling and subfloor preparation",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Stone and Tile, Whole-Home Scale",
        "body": "We install polished marble, natural stone and large-format porcelain through entries, main floors and basements. Layouts are planned so lines run straight through doorways and grout joints stay consistent from room to room.",
        "benefit": "You get a durable, easy-to-clean floor that raises the finish level of the entire home.",
        "image": "2026/03/gg1-1-scaled.jpg",
        "imageAlt": "Polished grey stone-look tile flooring through an open entry and staircase in a Calgary home"
      },
      {
        "title": "Heated Floors and Level Subfloors",
        "body": "Before any tile goes down we pour self-levelling compound where needed, then set an uncoupling membrane and electric heating cable in a measured pattern. Thinset is combed in over the cable so the tile beds evenly with no hollow spots.",
        "benefit": "Warm, even floors through a Calgary winter, on a base built to resist cracking.",
        "image": "2026/03/jj5-scaled.jpg",
        "imageAlt": "Electric floor heating cable being set into an orange uncoupling membrane before tile installation"
      },
      {
        "title": "Epoxy for Garages and Commercial",
        "body": "For garages, basements and commercial or warehouse spaces we apply poured epoxy systems, spread with squeegees and back-rolled for an even, glossy coat. The result resists stains, moisture and heavy wear.",
        "benefit": "A seamless, low-maintenance floor that stands up to vehicles, equipment and foot traffic.",
        "image": "2026/03/sw5-scaled.jpg",
        "imageAlt": "Installer spreading a glossy white epoxy floor coating across a large commercial space in Calgary"
      }
    ],
    "galleryIntro": "Finished floors and the prep work behind them, from heated marble-look tile to vinyl plank and commercial epoxy.",
    "photos": [
      {
        "src": "2026/03/jj1-scaled.jpg",
        "caption": "Main floor ready for final clean",
        "alt": "Large open main floor with new grey flooring and protected cabinets during a renovation"
      },
      {
        "src": "2026/03/jj2-scaled.jpg",
        "caption": "Unrolling uncoupling membrane",
        "alt": "Roll of orange uncoupling membrane being laid over a prepared subfloor"
      },
      {
        "src": "2026/03/jj3-scaled.jpg",
        "caption": "Combed thinset over membrane",
        "alt": "Combed thinset spread over orange floor membrane before tile is set"
      },
      {
        "src": "2026/03/jj4-scaled.jpg",
        "caption": "Thinset spread across large room",
        "alt": "Crew spreading thinset over heated floor membrane in a large open room"
      },
      {
        "src": "2026/03/jj5-scaled.jpg",
        "caption": "Heating cable laid in membrane",
        "alt": "Electric in-floor heating cable laid in an orange uncoupling membrane before tiling"
      },
      {
        "src": "2026/03/jj6-scaled.jpg",
        "caption": "Whole main floor under heat membrane",
        "alt": "Entire open main floor covered in orange heated floor membrane ahead of tile flooring"
      },
      {
        "src": "2026/03/jj7-scaled.jpg",
        "caption": "Thinset over heating cables",
        "alt": "Thinset troweled over in-floor heating cables on an orange membrane"
      },
      {
        "src": "2026/03/jj8-scaled.jpg",
        "caption": "Large tile set over heated membrane",
        "alt": "Large-format tile being set over thinset on a heated floor membrane"
      },
      {
        "src": "2026/03/kk1-1-1-scaled.jpg",
        "caption": "Large-format porcelain basement floor",
        "alt": "Glossy large-format porcelain tile flooring in a finished Calgary basement with chandelier"
      },
      {
        "src": "2026/03/kk2-1-1-scaled.jpg",
        "caption": "Continuous tile across basement living space",
        "alt": "Large-format tile flooring across a finished basement living space with kitchen island"
      },
      {
        "src": "2026/03/kk3-1-1-scaled.jpg",
        "caption": "Porcelain floor in basement gym area",
        "alt": "Glossy porcelain tile flooring in a basement with gym area and wet bar"
      },
      {
        "src": "2026/03/kk4-1-scaled.jpg",
        "caption": "Tile floor at basement wet bar",
        "alt": "Polished porcelain tile flooring at a basement wet bar with island and LED-lit cabinets"
      },
      {
        "src": "2026/03/kk5-1-scaled.jpg",
        "caption": "Tile flooring through basement rooms",
        "alt": "Porcelain tile flooring continuing through basement rooms and hallway"
      },
      {
        "src": "2026/03/kk6-1-scaled.jpg",
        "caption": "Open-plan basement in porcelain tile",
        "alt": "Open-plan basement with continuous glossy porcelain tile flooring and staircase"
      },
      {
        "src": "2026/03/kk7-1-scaled.jpg",
        "caption": "Porcelain floor beside lit media wall",
        "alt": "Porcelain tile floor in a basement living area beside a backlit dark media cabinet"
      },
      {
        "src": "2026/03/kk8-1-scaled.jpg",
        "caption": "Wet bar and island on tile",
        "alt": "Porcelain tile flooring under a basement wet bar and island in a Calgary renovation"
      },
      {
        "src": "2026/03/gg1-1-scaled.jpg",
        "caption": "Polished stone-look tile through open entry",
        "alt": "Polished grey tile flooring in an open entry with black staircase railing in a Calgary home"
      },
      {
        "src": "2026/03/gg2-1-scaled.jpg",
        "caption": "Grey stone tile from front door",
        "alt": "Grey natural stone tile flooring from the front door into a living room in a Calgary home"
      },
      {
        "src": "2026/03/gg3-1-scaled.jpg",
        "caption": "Stone tile through main floor hallway",
        "alt": "Grey stone tile flooring through a main floor hallway with white trim"
      },
      {
        "src": "2026/03/gg4-1-scaled.jpg",
        "caption": "High-gloss tile hallway to the stairs",
        "alt": "High-gloss grey tile flooring running down a bright hallway past a staircase"
      },
      {
        "src": "2026/03/sw1-scaled.jpg",
        "caption": "Commercial concrete before epoxy",
        "alt": "Bare concrete floor in a commercial building before epoxy flooring"
      },
      {
        "src": "2026/03/sw2-scaled.jpg",
        "caption": "Mixing epoxy components",
        "alt": "Epoxy flooring components being mixed in a bucket"
      },
      {
        "src": "2026/03/sw3-scaled.jpg",
        "caption": "Back-rolling the epoxy coat",
        "alt": "Spiked roller spreading white epoxy flooring coat evenly"
      },
      {
        "src": "2026/03/sw4-scaled.jpg",
        "caption": "Even roll-out on white epoxy",
        "alt": "Close-up of roller working white epoxy coating across the floor"
      },
      {
        "src": "2026/03/sw5-scaled.jpg",
        "caption": "Commercial epoxy pour in progress",
        "alt": "Worker spreading glossy epoxy flooring across a commercial building floor"
      },
      {
        "src": "2026/03/sw6-scaled.jpg",
        "caption": "Squeegee spreading epoxy",
        "alt": "Squeegee spreading glossy white epoxy across a commercial floor"
      },
      {
        "src": "2026/03/sw7-scaled.jpg",
        "caption": "Epoxy flowed to the edges",
        "alt": "Epoxy flooring being squeegeed toward the edges of a commercial space"
      },
      {
        "src": "2026/03/sw8-scaled.jpg",
        "caption": "Concrete prep before epoxy",
        "alt": "Commercial concrete floor during surface preparation for epoxy coating"
      },
      {
        "src": "2026/03/jj1-1-scaled.jpg",
        "caption": "Cutting vinyl plank to length",
        "alt": "Installer cutting luxury vinyl plank flooring with a circular saw"
      },
      {
        "src": "2026/03/jj2-1-scaled.jpg",
        "caption": "Clicking vinyl planks into place",
        "alt": "Installer locking luxury vinyl plank flooring boards together"
      },
      {
        "src": "2026/03/jj3-1-scaled.jpg",
        "caption": "Light grey vinyl plank layout",
        "alt": "Light grey luxury vinyl plank flooring being laid across a room"
      },
      {
        "src": "2026/03/jj4-1-scaled.jpg",
        "caption": "Tapping planks tight with mallet",
        "alt": "Installer tapping vinyl plank flooring tight with a rubber mallet"
      },
      {
        "src": "2026/03/jj5-1-scaled.jpg",
        "caption": "Measuring plank cuts at the saw",
        "alt": "Installer measuring a vinyl plank at the mitre saw before cutting"
      },
      {
        "src": "2026/03/jj6-1-scaled.jpg",
        "caption": "Fitting planks along the wall",
        "alt": "Vinyl plank flooring being fitted along a wall during installation"
      },
      {
        "src": "2026/03/jj7-1-scaled.jpg",
        "caption": "Staggered vinyl plank joints",
        "alt": "Installer placing vinyl plank flooring with staggered end joints"
      },
      {
        "src": "2026/03/jj8-1-scaled.jpg",
        "caption": "Vinyl plank install in progress",
        "alt": "Luxury vinyl plank flooring installation in progress in a Calgary home"
      },
      {
        "src": "2026/03/fd1-scaled.jpg",
        "caption": "Pouring self-levelling compound",
        "alt": "Self-levelling compound being poured onto a subfloor before new flooring"
      },
      {
        "src": "2026/03/fd2-scaled.jpg",
        "caption": "Spreading leveller for a flat base",
        "alt": "Installer spreading self-levelling compound across a basement floor"
      },
      {
        "src": "2026/03/fd3-scaled.jpg",
        "caption": "Mixing self-levelling compound",
        "alt": "Self-levelling compound being mixed in a bucket for floor preparation"
      },
      {
        "src": "2026/03/fd4-scaled.jpg",
        "caption": "Membrane over levelled subfloor",
        "alt": "Orange floor membrane being placed over a freshly levelled subfloor"
      },
      {
        "src": "2026/03/fd5-scaled.jpg",
        "caption": "Setting membrane in basement",
        "alt": "Installer pressing orange uncoupling membrane into thinset in a basement"
      },
      {
        "src": "2026/03/fd6-scaled.jpg",
        "caption": "Basement hallway membrane install",
        "alt": "Orange floor membrane installed down a long basement hallway in Calgary"
      },
      {
        "src": "2026/03/fd7-scaled.jpg",
        "caption": "Floor heating cable spool",
        "alt": "Spool of electric floor heating cable on a membrane-covered floor"
      },
      {
        "src": "2026/03/fd8-scaled.jpg",
        "caption": "Routing heating cable by hand",
        "alt": "Installer pressing in-floor heating cable into membrane studs by hand"
      }
    ],
    "videos": [
      "2026/03/ac.mp4"
    ],
    "faqs": [
      {
        "q": "Which flooring types do you install in Calgary?",
        "a": "We install ceramic and porcelain tile, marble and natural stone, luxury vinyl plank, hardwood and engineered hardwood, and epoxy coatings. We also install electric in-floor heating under tile and stone. Our crews work across Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area."
      },
      {
        "q": "Can you add heated floors to my bathroom, kitchen or basement?",
        "a": "Yes. We install electric heating cable within an uncoupling membrane, then set tile or stone over it. Heated floors work well in bathrooms, kitchens, basements and main living areas, and we confirm layout and controls with you during the quote."
      },
      {
        "q": "Why does subfloor preparation matter?",
        "a": "Uneven or flexing subfloors are the main reason tile cracks and planks separate. We check the subfloor, pour self-levelling compound where needed and use the right underlayment or membrane for the floor you have chosen."
      },
      {
        "q": "Do you install epoxy floors for garages and commercial spaces?",
        "a": "Yes. We apply epoxy flooring in garages, basements and commercial or warehouse spaces. The surface is prepared first, then the epoxy is poured, spread and rolled for an even, durable finish."
      },
      {
        "q": "How long does a flooring project take?",
        "a": "Timing depends on the square footage, the flooring type, how much subfloor preparation is needed and curing times for levellers, thinset or epoxy. You receive a project schedule along with your quote."
      },
      {
        "q": "What warranty comes with your flooring work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before work begins."
      }
    ],
    "ctaTitle": "Plan Your New Floors With MRE",
    "ctaSubtitle": "Tell us about the rooms, the flooring you have in mind and whether you want heat underneath. We will follow up with a free, detailed quote for your Calgary-area project.",
    "projects": [
      {
        "title": "Basement with heated large-format porcelain tile",
        "summary": "Uncoupling membrane and heating cable laid, large tiles set, then the finished glossy basement living space.",
        "dates": "Aug 2023 – Oct 2023",
        "photos": [
          "2026/03/jj1-scaled.jpg",
          "2026/03/jj2-scaled.jpg",
          "2026/03/jj3-scaled.jpg",
          "2026/03/jj4-scaled.jpg",
          "2026/03/jj5-scaled.jpg",
          "2026/03/jj6-scaled.jpg",
          "2026/03/jj7-scaled.jpg",
          "2026/03/jj8-scaled.jpg",
          "2026/03/kk1-1-1-scaled.jpg",
          "2026/03/kk2-1-1-scaled.jpg",
          "2026/03/kk3-1-1-scaled.jpg",
          "2026/03/kk4-1-scaled.jpg",
          "2026/03/kk5-1-scaled.jpg",
          "2026/03/kk6-1-scaled.jpg",
          "2026/03/kk7-1-scaled.jpg",
          "2026/03/kk8-1-scaled.jpg"
        ]
      },
      {
        "title": "Natural stone tile through main floor",
        "summary": "Finished stone-look tile running through the entry, hallway and open main floor.",
        "dates": "Oct 2016",
        "photos": [
          "2026/03/gg1-1-scaled.jpg",
          "2026/03/gg2-1-scaled.jpg",
          "2026/03/gg3-1-scaled.jpg",
          "2026/03/gg4-1-scaled.jpg"
        ]
      },
      {
        "title": "Commercial epoxy floor coating",
        "summary": "Bare warehouse concrete primed, then glossy white epoxy poured and spread across the space.",
        "dates": "May 2022",
        "photos": [
          "2026/03/sw1-scaled.jpg",
          "2026/03/sw2-scaled.jpg",
          "2026/03/sw3-scaled.jpg",
          "2026/03/sw4-scaled.jpg",
          "2026/03/sw5-scaled.jpg",
          "2026/03/sw6-scaled.jpg",
          "2026/03/sw7-scaled.jpg",
          "2026/03/sw8-scaled.jpg"
        ]
      },
      {
        "title": "Luxury vinyl plank installation",
        "summary": "Planks measured, cut and tapped into place across a light-coloured floor.",
        "dates": "Nov 2022",
        "photos": [
          "2026/03/jj1-1-scaled.jpg",
          "2026/03/jj2-1-scaled.jpg",
          "2026/03/jj3-1-scaled.jpg",
          "2026/03/jj4-1-scaled.jpg",
          "2026/03/jj5-1-scaled.jpg",
          "2026/03/jj6-1-scaled.jpg",
          "2026/03/jj7-1-scaled.jpg",
          "2026/03/jj8-1-scaled.jpg"
        ]
      },
      {
        "title": "Self-levelling and heated floor prep",
        "summary": "Self-levelling compound poured and smoothed, then uncoupling membrane and heating cable installed.",
        "dates": "Aug 2024",
        "photos": [
          "2026/03/fd1-scaled.jpg",
          "2026/03/fd2-scaled.jpg",
          "2026/03/fd3-scaled.jpg",
          "2026/03/fd4-scaled.jpg",
          "2026/03/fd5-scaled.jpg",
          "2026/03/fd6-scaled.jpg",
          "2026/03/fd7-scaled.jpg",
          "2026/03/fd8-scaled.jpg"
        ]
      }
    ]
  },
  "framing": {
    "metaTitle": "Framing Contractor Calgary | MRE Developments",
    "metaDescription": "Structural framing for custom homes, single-family and multi-family builds, additions and renovations in Calgary and area. Request your free framing quote.",
    "headline": "Calgary Framing Contractor for Custom and New Homes",
    "subheadline": "Straight walls, square corners and solid structure for custom homes, multi-family builds and additions, framed to the plans so every trade after us starts on a true base.",
    "hero": "2026/03/IMG_20190514_125407-scaled.jpg",
    "heroAlt": "Framed and sheathed walls of a new single-family home with lumber packages staged on the lot",
    "overviewTitle": "The Structure Everything Relies On",
    "summary": "MRE Developments frames custom homes, single-family homes and multi-family buildings, as well as additions and interior renovations, across Calgary, Airdrie, Cochrane and Okotoks. Our licensed and insured crew builds wall, floor and roof systems with quality lumber and proven techniques, working closely with builders, architects and homeowners. The result is a precise, code-compliant frame that supports both the design and the long-term performance of the building.",
    "highlights": [
      "Custom home framing to architectural plans",
      "Single-family and multi-family builds",
      "Walls, floors and roof systems",
      "Beams and load-bearing assemblies",
      "Additions and interior renovation framing",
      "Free, detailed project-specific quotes"
    ],
    "features": [
      {
        "title": "New Home Framing, Plumb and True",
        "body": "We frame single-family, multi-family and custom homes from subfloor to roof. Walls are laid out to the plans, braced and checked for plumb and square so window openings, stairs and finishes line up the way the designer intended.",
        "benefit": "Fewer problems for drywall, cabinets and finishing trades, and a home that looks right.",
        "image": "2026/03/oi3-scaled.jpg",
        "imageAlt": "Framed exterior walls with window openings on the subfloor of a new home under construction near Calgary"
      },
      {
        "title": "Quality Lumber and Roof Systems",
        "body": "A strong frame starts with good material. We use quality dimensional lumber, structural sheathing and engineered roof trusses, installed with proven fastening and bracing methods that meet safety standards and building codes.",
        "benefit": "A stable, durable structure that carries loads properly for decades.",
        "image": "2026/03/oi4-scaled.jpg",
        "imageAlt": "Engineered wood roof trusses stacked on site and ready for installation on a new home"
      },
      {
        "title": "Custom Designs, Additions and Renovations",
        "body": "Custom homes bring vaulted roofs, large openings and unique layouts, and we work with your builder or architect to frame them accurately. We also frame additions that tie seamlessly into existing homes and interior layouts for renovations across Calgary, Chestermere, Strathmore and High River.",
        "benefit": "Your design is built as drawn, whether it is a new custom home or a new room.",
        "image": "2026/03/20180423_174731-scaled.jpg",
        "imageAlt": "Roof trusses and framed walls seen from inside a custom home under construction against a blue sky"
      }
    ],
    "galleryIntro": "Framing from recent new-home projects, from subfloor and walls through to roof trusses.",
    "photos": [
      {
        "src": "2026/03/IMG_20190514_125407-scaled.jpg",
        "caption": "Framed and sheathed new home",
        "alt": "Fully framed and sheathed new home with lumber staged on site, framing by MRE near Calgary"
      },
      {
        "src": "2026/03/IMG_20190514_125433-scaled.jpg",
        "caption": "First sheathed walls standing",
        "alt": "First sheathed exterior walls standing on the subfloor of a new home"
      },
      {
        "src": "2026/03/oi2-scaled.jpg",
        "caption": "Wall bracing during framing",
        "alt": "Framed wall held by diagonal bracing on a new home subfloor"
      },
      {
        "src": "2026/03/IMG_20190514_125735-scaled.jpg",
        "caption": "Walls braced on the subfloor",
        "alt": "Newly raised walls braced on the subfloor during new home framing"
      },
      {
        "src": "2026/03/IMG_20190514_130403-scaled.jpg",
        "caption": "Framed room with window openings",
        "alt": "Framed room with window openings and lumber offcuts on the subfloor of a new home"
      },
      {
        "src": "2026/03/oi3-scaled.jpg",
        "caption": "Wall openings framed for windows",
        "alt": "Framed walls with window openings on a new home subfloor during framing in the Calgary area"
      },
      {
        "src": "2026/03/oi1-scaled.jpg",
        "caption": "Subfloor going down on the foundation",
        "alt": "Framer installing OSB subfloor on a new home foundation at the start of framing"
      },
      {
        "src": "2026/03/oi4-scaled.jpg",
        "caption": "Engineered roof trusses delivered",
        "alt": "Bundle of engineered wood roof trusses delivered to a new home framing site"
      },
      {
        "src": "2026/03/20180423_174533-scaled.jpg",
        "caption": "Exterior sheathing panel stood up",
        "alt": "Exterior gypsum sheathing panel stood up and braced on a framing site"
      },
      {
        "src": "2026/03/20180423_174548-1-scaled.jpg",
        "caption": "Exterior walls braced on the foundation",
        "alt": "Braced exterior wall framing on a concrete foundation during new home construction"
      },
      {
        "src": "2026/03/20180423_174551-1-scaled.jpg",
        "caption": "Temporary bracing on raised walls",
        "alt": "Diagonal temporary bracing holding newly raised wall framing on a foundation"
      },
      {
        "src": "2026/03/20180423_174609-1-scaled.jpg",
        "caption": "Large wall section braced in place",
        "alt": "Tall framed wall section braced in place over a foundation during home framing"
      },
      {
        "src": "2026/03/20180423_174731-scaled.jpg",
        "caption": "Roof trusses set over framed walls",
        "alt": "View up through framed walls to installed roof trusses on a new home framing project"
      },
      {
        "src": "2026/03/20180423_174735-scaled.jpg",
        "caption": "Truss profile against a clear sky",
        "alt": "Roof truss profile and wall framing against a blue sky on a framing project"
      },
      {
        "src": "2026/03/20180423_174817-scaled.jpg",
        "caption": "Interior walls under the truss line",
        "alt": "Interior wall framing beneath roof trusses with a door opening in a new home"
      },
      {
        "src": "2026/03/20180423_174819-scaled.jpg",
        "caption": "Hallway and room layouts framed",
        "alt": "Framed interior hallway and room partitions inside a new home before drywall"
      },
      {
        "src": "2026/03/20180423_175110-scaled.jpg",
        "caption": "Wall framing from the basement",
        "alt": "Framed walls and bracing viewed from the basement of a new home under construction"
      },
      {
        "src": "2026/03/20180423_175111-scaled.jpg",
        "caption": "Gable wall framing and bracing",
        "alt": "Framed gable wall with diagonal bracing on a new home under construction"
      },
      {
        "src": "2026/03/20180423_175127-scaled.jpg",
        "caption": "Sheathed wall with large opening",
        "alt": "Sheathed exterior wall with a large framed opening on a new home build"
      },
      {
        "src": "2026/03/20180423_175130-scaled.jpg",
        "caption": "Sheathed walls on the foundation",
        "alt": "OSB-sheathed exterior walls framed on a concrete foundation for a new home"
      }
    ],
    "videos": [
      "2026/03/20180423_174736.mp4"
    ],
    "faqs": [
      {
        "q": "What types of framing projects do you take on?",
        "a": "We frame custom homes, single-family homes and multi-family buildings, as well as home additions and interior framing for renovations and remodels. We build wall, floor and roof systems and work alongside builders, architects and homeowners."
      },
      {
        "q": "Can you frame from architectural or engineered plans?",
        "a": "Yes. Custom home framing is a core part of our work. We frame to the architectural and engineered drawings, including beams and load-bearing assemblies, and raise questions early if anything on the plans needs clarification."
      },
      {
        "q": "Do you frame additions to existing homes?",
        "a": "Yes. We frame additions that integrate with the existing structure, paying close attention to measurements, connections and structural integrity so the new space ties in cleanly."
      },
      {
        "q": "How long does framing take?",
        "a": "Framing time depends on the size and complexity of the building, roof design, material delivery and weather. Your quote includes a schedule, and we coordinate with the other trades to keep the project moving."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We take on framing projects across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty comes with your framing work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you can review them before work begins."
      }
    ],
    "ctaTitle": "Get a Quote for Your Framing Project",
    "ctaSubtitle": "Send us your plans or project details and we will prepare a free, detailed framing quote for your Calgary area build.",
    "projects": [
      {
        "title": "New home framing, walls and roof trusses",
        "summary": "Subfloor sheathing, exterior walls stood and braced, roof trusses delivered on site.",
        "dates": "May 2019",
        "photos": [
          "2026/03/IMG_20190514_125407-scaled.jpg",
          "2026/03/IMG_20190514_125433-scaled.jpg",
          "2026/03/oi2-scaled.jpg",
          "2026/03/IMG_20190514_125735-scaled.jpg",
          "2026/03/IMG_20190514_130403-scaled.jpg",
          "2026/03/oi3-scaled.jpg",
          "2026/03/oi1-scaled.jpg",
          "2026/03/oi4-scaled.jpg"
        ]
      },
      {
        "title": "New build wall and truss framing",
        "summary": "Sheathed exterior walls on the foundation, interior partitions and roof trusses in place.",
        "dates": "Apr 2018",
        "photos": [
          "2026/03/20180423_174533-scaled.jpg",
          "2026/03/20180423_174548-1-scaled.jpg",
          "2026/03/20180423_174551-1-scaled.jpg",
          "2026/03/20180423_174609-1-scaled.jpg",
          "2026/03/20180423_174731-scaled.jpg",
          "2026/03/20180423_174735-scaled.jpg",
          "2026/03/20180423_174817-scaled.jpg",
          "2026/03/20180423_174819-scaled.jpg",
          "2026/03/20180423_175110-scaled.jpg",
          "2026/03/20180423_175111-scaled.jpg",
          "2026/03/20180423_175127-scaled.jpg",
          "2026/03/20180423_175130-scaled.jpg"
        ]
      }
    ]
  },
  "gas-fitting": {
    "metaTitle": "Gas Fitter Calgary | Gas Line Installation | MRE",
    "metaDescription": "Gas line installation, appliance hookups and garage heaters for homes, suites and commercial builds in Calgary and area. Permits handled. Get a free quote.",
    "headline": "Calgary Gas Line Installation for Homes and New Builds",
    "subheadline": "Safe, code-compliant gas lines for appliances, heating systems and garage heaters, with permits and inspections handled and the work coordinated with the rest of your project.",
    "hero": "https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Modern Calgary-area home exterior",
    "overviewTitle": "Gas Work Done Safely and to Code",
    "summary": "MRE Developments designs and installs gas lines and heating connections for new homes, multi-family construction, basement suites, kitchen renovations and commercial projects across Calgary, Airdrie, Cochrane and Okotoks. Our licensed and insured team sizes and routes each line to suit your layout and appliances. We obtain the gas permits, build to national building codes and see the required inspections through to approval.",
    "highlights": [
      "Gas lines for appliances and heating",
      "Range, dryer and fireplace hookups",
      "Garage heater installation",
      "Gas service for suites and additions",
      "Permits and inspections handled for you",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "Gas Lines Planned for Your Layout",
        "body": "We design and install gas piping for furnaces, water heaters, ranges, fireplaces, barbecues and other appliances. Each line is sized for the connected load and routed to fit cleanly with your framing, mechanical and finishing plans.",
        "benefit": "Appliances that run as intended, on a system built safely for the long term."
      },
      {
        "title": "Permits, Testing and Inspection",
        "body": "Gas work leaves no room for shortcuts. We obtain the gas permits, pressure-test the system, build to national building codes and arrange the required inspections so every installation is approved before it goes into service.",
        "benefit": "Confidence that your gas system is safe, documented and fully compliant."
      },
      {
        "title": "Garage Heaters and Project Integration",
        "body": "A properly installed gas heater keeps a garage or workshop usable through Calgary winters. We also bring gas service to new builds, legal suites, garage suites and additions in Chestermere, Strathmore and High River, coordinated with every other trade on the job.",
        "benefit": "Year-round comfort and one team managing the gas work within your larger project."
      }
    ],
    "galleryIntro": "Project photos for our gas fitting work are coming soon; contact us to discuss your project.",
    "photos": [],
    "videos": [
      "2026/04/gas-landing-page-video.mp4"
    ],
    "faqs": [
      {
        "q": "What gas fitting projects do you handle?",
        "a": "We install gas lines and heating connections for new home and multi-family construction, commercial construction, basement developments and legal suites, garage and backyard suites, kitchen renovations and full-home renovations. We also install gas garage heaters. Our focus is project work rather than one-off service calls."
      },
      {
        "q": "Can you run a gas line for a new range, fireplace or barbecue?",
        "a": "Yes. Adding a gas range, fireplace, outdoor barbecue line or similar appliance is a common part of kitchen renovations and home upgrades. We size the line for the appliance, route it safely and handle the permit and inspection."
      },
      {
        "q": "Do you install garage heaters?",
        "a": "Yes. We install gas garage heaters for homeowners, workshops and investment properties, including the gas line, venting and connections required for a safe, code-compliant installation."
      },
      {
        "q": "Do you handle gas permits and inspections?",
        "a": "Yes. We obtain the gas permits, build every installation to national building codes and make sure the required inspections are completed and approved."
      },
      {
        "q": "How long does gas line installation take?",
        "a": "The timeline depends on the number of appliances, the length and route of the line, access through finished or open walls and inspection scheduling. Your quote includes a schedule for your project."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We take on gas fitting projects across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      }
    ],
    "ctaTitle": "Plan Your Gas Line Installation",
    "ctaSubtitle": "Tell us which appliances or heating you are adding and we will prepare a free, detailed gas fitting quote for your Calgary area project."
  },
  "home-additions": {
    "metaTitle": "Home Additions Calgary | MRE Developments",
    "metaDescription": "Home additions in Calgary, Airdrie, Cochrane and Okotoks: room extensions, second storeys and breezeways built to match your home. Request a free quote.",
    "headline": "Home Additions in Calgary That Look Like They Were Always There",
    "subheadline": "Need more room without leaving the neighbourhood you love? We design and build additions from foundation to finish, matched to your home's structure, rooflines and exterior.",
    "hero": "2026/01/757-scaled.jpg",
    "heroAlt": "Completed home addition in Calgary with dark siding matching the house, white entry door and window",
    "overviewTitle": "More Space, Built to Match",
    "summary": "MRE Developments builds home additions across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, from room extensions and second-storey additions to breezeways that connect new space to your home. We handle planning, foundations, framing, structural reinforcement and finishing, and work with you and your architect on the design. Every addition is built to code and finished to blend with the existing house.",
    "highlights": [
      "Full home and room additions",
      "Second-storey additions",
      "Breezeways and connecting spaces",
      "Foundations, framing and structural reinforcement",
      "Exterior finishes matched to your home",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Additions That Blend In",
        "body": "A good addition should not look bolted on. We match siding, trim, windows and rooflines to the existing house and plan the new space so it flows naturally from the rooms around it, whether that is a larger living room, a new bedroom, a home office or a sunroom.",
        "benefit": "You gain living space without compromising how your home looks from the street or the yard.",
        "image": "2026/01/752-scaled.jpg",
        "imageAlt": "Finished home addition with dark siding, white door and window beside the existing deck in a Calgary backyard"
      },
      {
        "title": "Built From the Ground Up",
        "body": "Our crew prepares the site, forms and pours the concrete slab or foundation, and frames walls and roof to tie properly into the existing structure. Reinforcement and structural upgrades are completed where the new load requires them.",
        "benefit": "A solid, code-compliant addition designed to last through Calgary winters.",
        "image": "2026/01/7511-scaled.jpg",
        "imageAlt": "MRE crew finishing a fresh concrete slab for a home addition between two buildings in Calgary"
      },
      {
        "title": "Breezeways and Second Storeys",
        "body": "Some homes have room to grow out, others only up. We build second-storey additions and breezeways that link a new structure or garage to the house, with roof framing and connections planned to suit the existing building.",
        "benefit": "Convenient, weather-protected connections and more square footage on the lot you already own.",
        "image": "2026/01/7520-scaled.jpg",
        "imageAlt": "Carpenters installing roof trusses on a home addition framed against the existing house"
      }
    ],
    "galleryIntro": "One of our Calgary home additions from site preparation and concrete to framing and the finished exterior.",
    "photos": [
      {
        "src": "2026/01/751-scaled.jpg",
        "caption": "Patio between home and addition",
        "alt": "New concrete patio running between the existing home and the finished addition"
      },
      {
        "src": "2026/01/752-scaled.jpg",
        "caption": "New addition beside the existing deck",
        "alt": "Finished home addition with white door and dark siding next to the existing house deck"
      },
      {
        "src": "2026/01/753-scaled.jpg",
        "caption": "Finished addition and new concrete patio",
        "alt": "Completed home addition beside a new concrete patio and the existing house in a Calgary backyard"
      },
      {
        "src": "2026/01/754-scaled.jpg",
        "caption": "Addition entry door and large window",
        "alt": "Exterior of a completed home addition with white entry door, large window and exterior lighting"
      },
      {
        "src": "2026/01/755-scaled.jpg",
        "caption": "Side yard before construction",
        "alt": "Side yard between home and outbuilding cleared and graded before a home addition"
      },
      {
        "src": "2026/01/756-scaled.jpg",
        "caption": "Site prepared for the addition",
        "alt": "Prepared ground beside a house ready for a home addition foundation"
      },
      {
        "src": "2026/01/757-scaled.jpg",
        "caption": "Finished addition with matching dark siding",
        "alt": "Completed home addition in Calgary with dark siding, white entry door and window matching the house"
      },
      {
        "src": "2026/01/758-scaled.jpg",
        "caption": "Graded area ready for forming",
        "alt": "Graded side yard ready for concrete forming for a home addition"
      },
      {
        "src": "2026/01/759-scaled.jpg",
        "caption": "Placing concrete for the slab",
        "alt": "Crew placing concrete from a pump hose for a home addition slab in Calgary"
      },
      {
        "src": "2026/01/7510-scaled.jpg",
        "caption": "Spreading concrete at the house",
        "alt": "Workers spreading concrete next to the house for a home addition foundation slab"
      },
      {
        "src": "2026/01/7511-scaled.jpg",
        "caption": "Finishing the new concrete slab",
        "alt": "Worker finishing a fresh concrete slab for a home addition between house and outbuilding"
      },
      {
        "src": "2026/01/7512-scaled.jpg",
        "caption": "Formed and poured addition slab",
        "alt": "Newly poured concrete slab inside timber forms for a home addition in a Calgary yard"
      },
      {
        "src": "2026/01/7513-scaled.jpg",
        "caption": "Nailing the header framing",
        "alt": "Framer nailing a header for a home addition with the existing siding behind"
      },
      {
        "src": "2026/01/7514-scaled.jpg",
        "caption": "Framing walls and headers",
        "alt": "Carpenter with nail gun framing walls and headers for a home addition"
      },
      {
        "src": "2026/01/7515-scaled.jpg",
        "caption": "Header and top-plate framing",
        "alt": "Carpenter fastening header and top plates while framing a home addition"
      },
      {
        "src": "2026/01/7516-scaled.jpg",
        "caption": "Crew raising wall framing",
        "alt": "Two carpenters raising and fastening wall framing for a home addition"
      },
      {
        "src": "2026/01/7517-scaled.jpg",
        "caption": "Wall framing on the new slab",
        "alt": "Framed walls and window openings for a home addition standing on the new concrete slab"
      },
      {
        "src": "2026/01/7518-scaled.jpg",
        "caption": "Tying framing into the existing house",
        "alt": "Framer tying new addition framing into the wall of the existing house"
      },
      {
        "src": "2026/01/7519-scaled.jpg",
        "caption": "Framing the roof structure",
        "alt": "Carpenter working on the roof framing of a home addition against blue sky"
      },
      {
        "src": "2026/01/7520-scaled.jpg",
        "caption": "Roof trusses going up",
        "alt": "Crew setting roof trusses on a home addition framed beside the existing house in Calgary"
      }
    ],
    "videos": [
      "2025/12/4r.mp4"
    ],
    "faqs": [
      {
        "q": "What types of home additions do you build?",
        "a": "We build full home additions, second-storey additions, room extensions such as larger living rooms, bedrooms, sunrooms and home offices, and breezeways that connect new structures to the house."
      },
      {
        "q": "Can you work with my architect?",
        "a": "Yes. We regularly collaborate with clients and architects on addition design, focusing on flow, natural light and a consistent look with the existing home."
      },
      {
        "q": "Will the addition match my existing house?",
        "a": "That is the goal on every project. We match exterior finishes, rooflines and interior details as closely as the materials allow, and we tie framing and structure properly into the original building."
      },
      {
        "q": "How long does a home addition take?",
        "a": "It depends on the size of the addition, foundation work, permit approvals, weather and material lead times. We provide a project schedule with your quote once the design is set."
      },
      {
        "q": "Do you build additions outside Calgary?",
        "a": "Yes. Along with Calgary, we build additions in Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty comes with an addition?",
        "a": "Warranty and workmanship terms are set out in writing with your quote. MRE Developments is licensed and insured, and all structural work is built to meet building code."
      }
    ],
    "ctaTitle": "Talk to Us About Your Addition",
    "ctaSubtitle": "Tell us how much space you need and how you plan to use it. We will follow up to arrange a free, detailed quote.",
    "projects": [
      {
        "title": "Backyard addition from slab to framing",
        "summary": "Side-yard patio area prepared, concrete slab poured, walls framed and roof trusses set.",
        "dates": "Oct 2025 – Nov 2025",
        "photos": [
          "2026/01/751-scaled.jpg",
          "2026/01/752-scaled.jpg",
          "2026/01/753-scaled.jpg",
          "2026/01/754-scaled.jpg",
          "2026/01/755-scaled.jpg",
          "2026/01/756-scaled.jpg",
          "2026/01/757-scaled.jpg",
          "2026/01/758-scaled.jpg",
          "2026/01/759-scaled.jpg",
          "2026/01/7510-scaled.jpg",
          "2026/01/7511-scaled.jpg",
          "2026/01/7512-scaled.jpg",
          "2026/01/7513-scaled.jpg",
          "2026/01/7514-scaled.jpg",
          "2026/01/7515-scaled.jpg",
          "2026/01/7516-scaled.jpg",
          "2026/01/7517-scaled.jpg",
          "2026/01/7518-scaled.jpg",
          "2026/01/7519-scaled.jpg",
          "2026/01/7520-scaled.jpg"
        ]
      }
    ]
  },
  "home-renovations": {
    "metaTitle": "Full Home Renovations Calgary | MRE Developments",
    "metaDescription": "Whole-home renovations in Calgary, Airdrie and Cochrane: structural changes, kitchens, baths, basements and permits by MRE Developments. Plan yours today.",
    "headline": "Whole-Home Renovations in Calgary, Planned and Built by One Team",
    "subheadline": "When patching room by room no longer makes sense, we renovate the whole house: layout, structure, plumbing, electrical and finishes, coordinated under one licensed, insured contractor.",
    "hero": "2025/11/10-2-scaled.jpg",
    "heroAlt": "Renovated Calgary kitchen with granite-topped island, white upper cabinets and black full-height pantry cabinet",
    "overviewTitle": "Full Home Renovations, Fully Managed",
    "summary": "MRE Developments takes on medium and large whole-house renovations in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks and Chestermere. We handle design, structural changes, plumbing and electrical upgrades, flooring, painting and interiors, along with the permits the work requires. Projects typically carry planning budgets from $100,000 to $200,000 and up to $500,000 or more.",
    "highlights": [
      "Medium and large whole-house renovations",
      "Structural and layout changes",
      "Plumbing and electrical upgrades throughout",
      "Kitchens, bathrooms and basements together",
      "Permit handling included",
      "Free, detailed project-specific quotes"
    ],
    "features": [
      {
        "title": "One Plan for the Whole House",
        "body": "Renovating every level at once lets us solve problems that piecemeal projects cannot: tired layouts, outdated wiring and plumbing, and finishes that no longer match from room to room. We plan the house as a whole so kitchens, bathrooms, flooring and lighting work together.",
        "benefit": "A home that feels new and consistent from the front door to the basement.",
        "image": "2025/10/4-1.jpeg",
        "imageAlt": "Calgary home renovation kitchen with new white cabinets, stainless refrigerator and light vinyl plank flooring"
      },
      {
        "title": "Systems and Structure First",
        "body": "Before the finishes, we address what sits behind the walls. Structural changes, plumbing and electrical upgrades are completed and inspected before drywall, tile and cabinetry go in, with permits handled as part of the project.",
        "benefit": "Finishes that are built on sound, code-compliant work, not covering old problems.",
        "image": "2025/11/8-2-scaled.jpg",
        "imageAlt": "Rebuilt bathroom with marble-look tub surround, white vanity, round mirror and new lighting in a full home renovation"
      },
      {
        "title": "Basements Brought Into the Plan",
        "body": "Many of our full-home projects include a finished lower level with a kitchen, bathroom and bedrooms. We rebuild stairwells, open up living areas and add pot lighting so the basement feels like part of the house, not an afterthought.",
        "benefit": "More usable, comfortable living space under the same roof.",
        "image": "2025/12/2-5-scaled.jpg",
        "imageAlt": "Renovated basement kitchen with white and black cabinets, quartz counter and arched faucet"
      }
    ],
    "galleryIntro": "Full home renovations completed by our team in Calgary, including before and after views of the same homes.",
    "photos": [
      {
        "src": "2025/11/1-5-scaled.jpg",
        "caption": "Before: worn closet and trim",
        "alt": "Before the renovation: worn closet with dark trim and marked walls"
      },
      {
        "src": "2025/11/3-3-scaled.jpg",
        "caption": "Before: dark hallway and trim",
        "alt": "Before the renovation: hallway with dark trim, worn walls and older flooring"
      },
      {
        "src": "2025/11/7-2-scaled.jpg",
        "caption": "Before: bathroom ready for rebuild",
        "alt": "Before the renovation: worn bathroom with old tub surround and damaged floor"
      },
      {
        "src": "2025/11/9-1-1-scaled.jpg",
        "caption": "Before: dated dark kitchen",
        "alt": "Before the home renovation: dated kitchen with dark cabinets, worn tile backsplash and damaged floor"
      },
      {
        "src": "2025/11/13-2-scaled.jpg",
        "caption": "Before: stained, damaged wall",
        "alt": "Before the renovation: stained and damaged interior wall with old light fixture"
      },
      {
        "src": "2025/11/11-2-scaled.jpg",
        "caption": "Before: original kitchen sink wall",
        "alt": "Before the renovation: original kitchen sink wall with dark cabinets and worn flooring"
      },
      {
        "src": "2025/12/9-2-scaled.jpg",
        "caption": "Before: lower-level room",
        "alt": "Before the renovation: lower-level room with teal walls and worn patterned flooring"
      },
      {
        "src": "2025/12/11-3-scaled.jpg",
        "caption": "Before: room during demolition",
        "alt": "Before the renovation: room with damaged walls and patterned flooring during demolition"
      },
      {
        "src": "2025/12/3-4-scaled.jpg",
        "caption": "Before: basement with patterned floor",
        "alt": "Before the renovation: basement room with blue walls and patterned vinyl floor"
      },
      {
        "src": "2025/12/5-3-scaled.jpg",
        "caption": "Before: dated tub and tile",
        "alt": "Before the renovation: dated bathroom with tiled tub surround and older vanity"
      },
      {
        "src": "2025/12/1-6-scaled.jpg",
        "caption": "Before: original basement kitchen",
        "alt": "Before the renovation: original basement kitchen with worn cabinets and laminate counter"
      },
      {
        "src": "2025/12/7-3-scaled.jpg",
        "caption": "Before: dark basement stairwell",
        "alt": "Before the renovation: dark, unfinished basement stairwell"
      },
      {
        "src": "2025/11/12-3-scaled.jpg",
        "caption": "White cabinets with granite counters",
        "alt": "Renovated kitchen with white flat-panel cabinets, granite counter, double sink and window view"
      },
      {
        "src": "2025/11/14-1-scaled.jpg",
        "caption": "Granite island facing a bright bay window",
        "alt": "Renovated kitchen island with granite top and white base cabinets facing a large living room window"
      },
      {
        "src": "2025/11/10-2-scaled.jpg",
        "caption": "New kitchen with granite-topped island",
        "alt": "Full home renovation in Calgary with new kitchen, granite island, white uppers and black pantry cabinet"
      },
      {
        "src": "2025/11/2-4-scaled.jpg",
        "caption": "New interior doors and trim",
        "alt": "Renovated hallway with white six-panel doors, new trim and grey vinyl plank flooring"
      },
      {
        "src": "2025/11/4-14-scaled.jpg",
        "caption": "Hallway with fresh paint and flooring",
        "alt": "Long renovated hallway with white walls, panel doors and new flooring in a Calgary home"
      },
      {
        "src": "2025/11/8-2-scaled.jpg",
        "caption": "Marble-look tub surround and round mirror",
        "alt": "Renovated bathroom with marble-look tile tub surround, white vanity, round mirror and new lighting"
      },
      {
        "src": "2025/12/10-3-scaled.jpg",
        "caption": "Basement hallway with new doors",
        "alt": "Finished basement hallway with new white panel doors, trim and vinyl plank flooring"
      },
      {
        "src": "2025/12/12-4-scaled.jpg",
        "caption": "Finished lower-level room",
        "alt": "Finished basement room with white walls, new door and flooring after a home renovation"
      },
      {
        "src": "2025/12/4-15-scaled.jpg",
        "caption": "Basement living area with pot lights",
        "alt": "Finished basement living area with pot lights, white walls and vinyl plank flooring"
      },
      {
        "src": "2025/12/6-3-scaled.jpg",
        "caption": "Glass sliding shower and round mirror",
        "alt": "Renovated bathroom with glass sliding shower door, grey tile walls and round mirror"
      },
      {
        "src": "2025/12/2-5-scaled.jpg",
        "caption": "Basement kitchen in white and black",
        "alt": "Renovated basement kitchen with white and black cabinets, quartz counter and window"
      },
      {
        "src": "2025/12/8-3-scaled.jpg",
        "caption": "Rebuilt stairwell with painted treads",
        "alt": "Renovated basement stairwell with white walls and grey painted stair treads"
      },
      {
        "src": "2025/10/1-1-4.jpg",
        "caption": "Before: original living room",
        "alt": "Before the home renovation: furnished original living room with older finishes"
      },
      {
        "src": "2025/10/3-1-3.jpg",
        "caption": "Before: original oak kitchen",
        "alt": "Before the home renovation: original oak kitchen cabinets and tile backsplash"
      },
      {
        "src": "2025/10/5-1-4.jpg",
        "caption": "Before: oak kitchen, other angle",
        "alt": "Before the renovation: oak kitchen cabinets, dishwasher and older counters"
      },
      {
        "src": "2025/10/7-4.jpg",
        "caption": "Before: kitchen with older appliances",
        "alt": "Before the renovation: kitchen with oak cabinets, white range and older fixtures"
      },
      {
        "src": "2025/10/9-4.jpg",
        "caption": "Before: original bathroom",
        "alt": "Before the renovation: original bathroom with dated vanity, mirror and shower curtain"
      },
      {
        "src": "2025/10/11-5.jpg",
        "caption": "Before: basement room with carpet",
        "alt": "Before the renovation: basement room with carpet, mirrored closet and drop ceiling"
      },
      {
        "src": "2025/10/2-4.jpg",
        "caption": "Open living room, new floors and paint",
        "alt": "Renovated living room in a Calgary home with fresh white paint, new flooring and large windows"
      },
      {
        "src": "2025/10/4-1.jpeg",
        "caption": "Bright white kitchen with vinyl plank floor",
        "alt": "Whole-home renovation kitchen with white cabinets, stainless fridge and light vinyl plank flooring"
      },
      {
        "src": "2025/10/6-1.jpeg",
        "caption": "Clean white kitchen with range hood",
        "alt": "White renovated kitchen with range hood, stainless fridge and open sightlines to the hallway"
      },
      {
        "src": "2025/10/8-1.jpeg",
        "caption": "Full-height pantry wall in white",
        "alt": "Renovated kitchen with full-height white pantry cabinets, stainless fridge and vinyl plank flooring"
      },
      {
        "src": "2025/10/10-1.jpeg",
        "caption": "Updated bath with white vanity",
        "alt": "Renovated bathroom with white vanity, wide mirror, toilet and tub with white surround"
      },
      {
        "src": "2025/10/12-1.jpeg",
        "caption": "Bedroom with new closet doors",
        "alt": "Renovated bedroom with new flooring, white closet doors and ceiling light"
      }
    ],
    "videos": [
      "2025/10/1-1.mp4"
    ],
    "faqs": [
      {
        "q": "What size of home renovation projects do you take on?",
        "a": "We focus on medium and large whole-house renovations rather than small, single-room jobs. Planning budgets typically start around $100,000 to $200,000 and can reach $500,000 or more, depending on the size of the home and the scope of work. These are planning figures; your project-specific quote sets out the actual cost."
      },
      {
        "q": "How do I start planning a full home renovation?",
        "a": "Use our full-home renovation planner to outline your home, goals and budget range, or contact us directly. We review the details with you, visit the property and then prepare a free, detailed quote."
      },
      {
        "q": "Do you handle permits and structural changes?",
        "a": "Yes. Structural changes, plumbing and electrical upgrades and the permits they require are all part of our full home renovation service, so you are not left coordinating approvals on your own."
      },
      {
        "q": "How long does a whole-home renovation take?",
        "a": "It depends on the size of the house, how much structural and mechanical work is involved, permit approvals and material lead times. We provide a schedule with your quote once the scope is defined."
      },
      {
        "q": "Which communities do you serve?",
        "a": "We renovate homes throughout Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty comes with a full home renovation?",
        "a": "Warranty and workmanship terms are set out in writing with your quote. MRE Developments is licensed and insured, and we go over those terms with you before the project begins."
      }
    ],
    "ctaTitle": "Plan Your Full Home Renovation",
    "ctaSubtitle": "Tell us about your home and what you want to change. We will follow up to arrange a site visit and a free, detailed quote.",
    "projects": [
      {
        "title": "Whole-home renovation, main floor and basement",
        "summary": "Dated kitchens, bathrooms and stained rooms gutted and rebuilt with new cabinets, flooring, tile and paint.",
        "dates": "Sep 2023 – Jun 2024",
        "photos": [
          "2025/11/1-5-scaled.jpg",
          "2025/11/3-3-scaled.jpg",
          "2025/11/7-2-scaled.jpg",
          "2025/11/9-1-1-scaled.jpg",
          "2025/11/13-2-scaled.jpg",
          "2025/11/11-2-scaled.jpg",
          "2025/12/9-2-scaled.jpg",
          "2025/12/11-3-scaled.jpg",
          "2025/12/3-4-scaled.jpg",
          "2025/12/5-3-scaled.jpg",
          "2025/12/1-6-scaled.jpg",
          "2025/12/7-3-scaled.jpg",
          "2025/11/12-3-scaled.jpg",
          "2025/11/14-1-scaled.jpg",
          "2025/11/10-2-scaled.jpg",
          "2025/11/2-4-scaled.jpg",
          "2025/11/4-14-scaled.jpg",
          "2025/11/8-2-scaled.jpg",
          "2025/12/10-3-scaled.jpg",
          "2025/12/12-4-scaled.jpg",
          "2025/12/4-15-scaled.jpg",
          "2025/12/6-3-scaled.jpg",
          "2025/12/2-5-scaled.jpg",
          "2025/12/8-3-scaled.jpg"
        ]
      },
      {
        "title": "Main floor refresh, before and after",
        "summary": "Living room, kitchen, bathroom and bedroom updated with new flooring, white cabinets and fresh paint.",
        "dates": "Jan 1980",
        "photos": [
          "2025/10/1-1-4.jpg",
          "2025/10/3-1-3.jpg",
          "2025/10/5-1-4.jpg",
          "2025/10/7-4.jpg",
          "2025/10/9-4.jpg",
          "2025/10/11-5.jpg",
          "2025/10/2-4.jpg",
          "2025/10/4-1.jpeg",
          "2025/10/6-1.jpeg",
          "2025/10/8-1.jpeg",
          "2025/10/10-1.jpeg",
          "2025/10/12-1.jpeg"
        ]
      }
    ]
  },
  "kerdi-shower-waterproofing": {
    "metaTitle": "Kerdi Shower Waterproofing Calgary | MRE Developments",
    "metaDescription": "Schluter-Kerdi shower systems installed in Calgary, Airdrie, Cochrane and Okotoks. Membrane, tray and drain, waterproofed to tile-ready. Get a free quote.",
    "headline": "Schluter-Kerdi Shower Systems Installed Across Calgary",
    "subheadline": "Membrane, sloped tray, drain, niches and bench sealed as one continuous waterproof system, so your tiled shower stays free of leaks, rot and mould behind the walls.",
    "hero": "2026/03/de8-scaled.jpg",
    "heroAlt": "Shower fully covered in orange Schluter-Kerdi membrane with sloped tray, centre drain and recessed niche",
    "overviewTitle": "Waterproofing Behind Every Tile",
    "summary": "MRE Developments installs complete Schluter-Kerdi shower systems for new bathrooms and renovations across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We prepare the substrate, set the Kerdi shower tray and drain, and bond Kerdi membrane over every wall, niche, bench and seam. The finished shower is fully sealed and ready for tile.",
    "highlights": [
      "Complete Schluter-Kerdi shower systems",
      "Sloped Kerdi trays and integrated drains",
      "Sealed niches, benches and curbs",
      "Walk-in and custom shower layouts",
      "Upgrades of old shower assemblies",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "One Continuous Waterproof Envelope",
        "body": "Kerdi membrane is bonded over every wall surface, inside corner and seam, wrapping niches and benches so there are no gaps for water to find. The shower walls and floor work together as a single sealed system.",
        "benefit": "Protection against hidden leaks, mould and costly damage to framing and subfloors.",
        "image": "2026/03/kk8-scaled.jpg",
        "imageAlt": "Shower walls, niches and bench fully sealed with orange Kerdi waterproofing membrane before tile"
      },
      {
        "title": "Tray and Drain Set Right",
        "body": "We bed the Kerdi shower tray in thinset over a prepared subfloor and connect it to the integrated drain flange. The pre-sloped tray directs water to the drain without guesswork.",
        "benefit": "Water drains away cleanly with no pooling on the shower floor.",
        "image": "2026/03/de4-scaled.jpg",
        "imageAlt": "Orange Kerdi shower tray installed with centre drain over a prepared subfloor"
      },
      {
        "title": "Ready for the Tile You Want",
        "body": "Once waterproofing is complete the shower is tile-ready for porcelain, marble-look or pebble finishes. When we renovate an existing bathroom we remove the old assembly, reinforce the structure if needed and rebuild with Kerdi.",
        "benefit": "A finished shower that looks great and is built to last underneath.",
        "image": "2026/03/de9.jpg",
        "imageAlt": "Finished tiled shower with marble-look walls, pebble floor and niche built over a Kerdi system"
      }
    ],
    "galleryIntro": "Step-by-step Schluter-Kerdi shower installations, from tray and drain to sealed walls and finished tile.",
    "photos": [
      {
        "src": "2026/03/de2-scaled.jpg",
        "caption": "Thinset combed on shower tray",
        "alt": "Combed thinset on a Kerdi shower tray before membrane installation"
      },
      {
        "src": "2026/03/de3-scaled.jpg",
        "caption": "Drain flange bedded in thinset",
        "alt": "Shower drain flange bedded in thinset on the subfloor"
      },
      {
        "src": "2026/03/de4-scaled.jpg",
        "caption": "Kerdi tray with centre drain",
        "alt": "Orange Kerdi shower tray set with centre drain on a prepared floor"
      },
      {
        "src": "2026/03/de5-scaled.jpg",
        "caption": "Troweling membrane onto curb",
        "alt": "Installer troweling thinset to bond Kerdi membrane onto a shower curb"
      },
      {
        "src": "2026/03/de6-scaled.jpg",
        "caption": "Curb wrapped in membrane",
        "alt": "Shower curb fully wrapped in orange Kerdi waterproofing membrane"
      },
      {
        "src": "2026/03/de7-scaled.jpg",
        "caption": "Membrane into combed thinset",
        "alt": "Kerdi membrane being pressed into combed thinset on a shower wall"
      },
      {
        "src": "2026/03/de8-scaled.jpg",
        "caption": "Fully membraned shower with niche",
        "alt": "Shower walls and tray fully covered in orange Kerdi membrane with recessed niche"
      },
      {
        "src": "2026/03/de9.jpg",
        "caption": "Finished tile over Kerdi system",
        "alt": "Finished tiled shower with pebble floor and niche built on a Kerdi waterproofing system in Calgary"
      },
      {
        "src": "2026/03/kk1-1-scaled.jpg",
        "caption": "Corner bench and Kerdi drain",
        "alt": "Shower with Kerdi board walls, corner bench and Kerdi drain before membrane"
      },
      {
        "src": "2026/03/kk2-1-scaled.jpg",
        "caption": "Cutting membrane to fit",
        "alt": "Installer fitting a sheet of Kerdi membrane in a shower enclosure"
      },
      {
        "src": "2026/03/kk3-1-scaled.jpg",
        "caption": "Membrane hung on shower walls",
        "alt": "Installer applying Kerdi membrane to shower walls beside a window"
      },
      {
        "src": "2026/03/kk4-scaled.jpg",
        "caption": "Bonding membrane wall panels",
        "alt": "Installer bonding a large sheet of Kerdi membrane to a shower wall"
      },
      {
        "src": "2026/03/kk5-scaled.jpg",
        "caption": "Smoothing seams by hand",
        "alt": "Hand smoothing an overlapping Kerdi membrane seam for a watertight bond"
      },
      {
        "src": "2026/03/kk6-scaled.jpg",
        "caption": "Sealing the niche and tray",
        "alt": "Installer sealing a shower niche and tray with Kerdi membrane"
      },
      {
        "src": "2026/03/kk7-scaled.jpg",
        "caption": "Fastening the drain flange",
        "alt": "Installer drilling to secure a Kerdi drain flange in the shower floor"
      },
      {
        "src": "2026/03/kk8-scaled.jpg",
        "caption": "Sealed niches and built-in bench",
        "alt": "Kerdi shower waterproofing over walls, double niches and bench in a Calgary bathroom"
      }
    ],
    "videos": [
      "2026/03/oo.mp4"
    ],
    "faqs": [
      {
        "q": "What is a Schluter-Kerdi shower system?",
        "a": "It is a complete shower waterproofing system made up of Kerdi membrane, a pre-sloped shower tray, an integrated drain and matching seam and corner pieces. Installed together, they create a continuous waterproof layer directly beneath the tile."
      },
      {
        "q": "How is Kerdi different from your general waterproofing service?",
        "a": "This service covers Schluter-Kerdi shower systems specifically, inside bathrooms. Our separate Waterproofing service deals with other areas of a building. If you are unsure which you need, we can advise during your free quote."
      },
      {
        "q": "Can you install Kerdi in an existing bathroom?",
        "a": "Yes. During a renovation we remove the old shower materials, check and reinforce the structure if needed, then install a new Kerdi tray, drain and membrane. We work on homes throughout Calgary, Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "Do you tile the shower as well?",
        "a": "Yes. Our team can carry the project through to finished tile, including niches, benches, pebble or mosaic floors and large-format wall tile. The waterproofing and tile are planned together so drains, niches and grout lines align."
      },
      {
        "q": "How long does a Kerdi shower installation take?",
        "a": "It depends on the shower size, the number of niches and benches, any demolition or structural work and the tile chosen. A project schedule comes with your quote."
      },
      {
        "q": "What warranty do you provide?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before we start."
      }
    ],
    "ctaTitle": "Build a Leak-Free Shower With MRE",
    "ctaSubtitle": "Tell us about your bathroom and the shower you have in mind. We will send a free, detailed quote for a Schluter-Kerdi installation in the Calgary area.",
    "projects": [
      {
        "title": "Shower pan and bench with Kerdi membrane",
        "summary": "Mortar bed and drain set, membrane over floor, bench and walls, then the finished tiled shower.",
        "dates": "May 2022 – Jun 2022",
        "photos": [
          "2026/03/de2-scaled.jpg",
          "2026/03/de3-scaled.jpg",
          "2026/03/de4-scaled.jpg",
          "2026/03/de5-scaled.jpg",
          "2026/03/de6-scaled.jpg",
          "2026/03/de7-scaled.jpg",
          "2026/03/de8-scaled.jpg",
          "2026/03/de9.jpg"
        ]
      },
      {
        "title": "Kerdi-Board shower with bench and niches",
        "summary": "Shower walls, bench and niches wrapped in waterproof membrane and drain flange installed.",
        "dates": "Jan 2026",
        "photos": [
          "2026/03/kk1-1-scaled.jpg",
          "2026/03/kk2-1-scaled.jpg",
          "2026/03/kk3-1-scaled.jpg",
          "2026/03/kk4-scaled.jpg",
          "2026/03/kk5-scaled.jpg",
          "2026/03/kk6-scaled.jpg",
          "2026/03/kk7-scaled.jpg",
          "2026/03/kk8-scaled.jpg"
        ]
      }
    ]
  },
  "kitchen-renovations": {
    "metaTitle": "Kitchen Renovations Calgary | MRE Developments",
    "metaDescription": "Kitchen renovations in Calgary, Airdrie and Okotoks: custom cabinetry, quartz counters, islands and open layouts by MRE Developments. Request a free quote.",
    "headline": "Calgary Kitchen Renovations That Work as Hard as You Do",
    "subheadline": "Cramped layout, dated cabinets, not enough counter space? We redesign and rebuild kitchens around how you cook and gather, with cabinetry, counters, lighting and appliances handled by one team.",
    "hero": "2026/07/f8b21d2acdc10f354adb1277e6d9396a.jpeg",
    "heroAlt": "Renovated Calgary kitchen with white shaker cabinets, quartz island with bar stools, pendant lights and wood flooring",
    "overviewTitle": "Kitchens Planned Around Your Household",
    "summary": "MRE Developments renovates kitchens across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, from cabinet and counter upgrades to complete layout changes. We manage design, cabinetry, countertops, backsplash, flooring, lighting, plumbing, electrical and appliance installation as one coordinated project. The result is a kitchen that is easier to cook in, easier to clean and built to last.",
    "highlights": [
      "Custom cabinetry or cost-effective cabinet refacing",
      "Quartz and granite countertops and islands",
      "Open-concept layout reconfiguration",
      "Backsplash, lighting and flooring included",
      "Appliance and fixture integration",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Layouts That Open Up Space",
        "body": "Many Calgary kitchens were built closed off, with little prep space and awkward traffic flow. We rework the plan by adding or enlarging islands, relocating sinks and appliances, and opening walls where the structure allows, so the kitchen connects to the rest of your main floor.",
        "benefit": "More counter space, better flow and a kitchen that suits family meals and entertaining.",
        "image": "2026/07/Screenshot_20181027-134741_Instagram.jpg",
        "imageAlt": "Kitchen renovation with navy blue island, white shaker cabinets, pendant lights and stainless built-in refrigerator"
      },
      {
        "title": "Counters and Backsplash, Precisely Set",
        "body": "We install quartz, granite, tile, luxury vinyl and hardwood, and we take care with the details that show every day: tight seams, level surfaces and backsplash tile cut cleanly around outlets, hoods and window returns.",
        "benefit": "Surfaces that look polished on day one and stand up to daily cooking.",
        "image": "2026/07/c17-scaled.jpg",
        "imageAlt": "Induction cooktop set into a white quartz counter with marble-look subway tile backsplash and glass range hood"
      },
      {
        "title": "Cabinetry Built for Your Storage",
        "body": "Whether you choose new custom cabinets or refacing of sound existing boxes, we plan storage around what you actually keep in the kitchen. Pantry pull-outs, built-in microwaves, wall ovens and full-height uppers are all part of the design conversation.",
        "benefit": "A cleaner-looking kitchen where everything has a place.",
        "image": "2026/07/FB_IMG_1754278772904.jpg",
        "imageAlt": "High-gloss white kitchen cabinets with black pulls, stainless double wall oven and white subway tile backsplash"
      }
    ],
    "galleryIntro": "A look at kitchen renovations we have completed for homeowners in Calgary and the surrounding area.",
    "photos": [
      {
        "src": "2026/07/f8b21d2acdc10f354adb1277e6d9396a.jpeg",
        "caption": "Open-concept kitchen with seating island",
        "alt": "Calgary kitchen renovation with white shaker cabinets, quartz island with stools and pendant lighting"
      },
      {
        "src": "2026/07/76da2b4e4ae86da1e59570899baf1b7d.jpeg",
        "caption": "Undermount sink with pantry beyond",
        "alt": "Kitchen renovation detail with undermount sink, pull-down faucet, stainless range and pantry shelving"
      },
      {
        "src": "2026/07/9a3e78eb18370a5b214faf696991db57.jpeg",
        "caption": "Island kitchen opening to front entry",
        "alt": "Long view of a renovated kitchen with island, bar stools and pendants opening to the front entry"
      },
      {
        "src": "2026/07/2d76c9dc8d59e6e3379c88f80c6ee813.jpeg",
        "caption": "Range, chimney hood and built-in microwave",
        "alt": "White shaker kitchen with gas range, chimney hood, built-in microwave and subway tile backsplash"
      },
      {
        "src": "2026/07/c15-scaled.jpg",
        "caption": "L-shaped layout with quartz island",
        "alt": "L-shaped kitchen renovation with quartz island, black faucet, white cabinets and stainless appliances"
      },
      {
        "src": "2026/07/c16-scaled.jpg",
        "caption": "Grey island facing white cabinetry",
        "alt": "Grey kitchen island with quartz top and black faucet facing white cabinets and stainless fridge"
      },
      {
        "src": "2026/07/c17-scaled.jpg",
        "caption": "Cooktop with marble-look tile backsplash",
        "alt": "Induction cooktop in quartz counter with marble-look backsplash tile and glass chimney hood"
      },
      {
        "src": "2026/07/c18-scaled.jpg",
        "caption": "Matte black faucet over double sink",
        "alt": "Close-up of a matte black pull-down faucet over an undermount double sink in a quartz counter"
      },
      {
        "src": "2026/07/Screenshot_20181027-134704_Instagram.jpg",
        "caption": "Navy island beneath a bright window",
        "alt": "Navy kitchen island with white quartz top, range hood and white cabinets under a large window"
      },
      {
        "src": "2026/07/Screenshot_20181027-134727_Instagram.jpg",
        "caption": "Navy island and double-door fridge",
        "alt": "Navy island with undermount sink, white quartz counter and stainless double-door refrigerator"
      },
      {
        "src": "2026/07/Screenshot_20181027-134741_Instagram.jpg",
        "caption": "Navy island with white shaker cabinets",
        "alt": "Kitchen renovation with navy island, white shaker cabinets, under-cabinet lighting and stainless fridge"
      },
      {
        "src": "2026/07/1-9-scaled.jpg",
        "caption": "Gloss uppers over subway tile backsplash",
        "alt": "High-gloss white upper cabinets above a subway tile backsplash and stainless sink"
      },
      {
        "src": "2026/07/2-8-scaled.jpg",
        "caption": "Sink wall with gloss white cabinets",
        "alt": "Kitchen sink wall with stainless faucet, white subway tile and high-gloss white upper cabinets"
      },
      {
        "src": "2026/07/3-7-scaled.jpg",
        "caption": "Quartz corner run with gloss cabinets",
        "alt": "Corner of a renovated kitchen with white quartz counter and high-gloss white cabinets"
      },
      {
        "src": "2026/07/4-1-scaled.jpg",
        "caption": "Black hood against gloss white cabinets",
        "alt": "Kitchen renovation with black range hood, stainless range, gloss white cabinets and subway tile"
      },
      {
        "src": "2026/07/FB_IMG_1754278772904.jpg",
        "caption": "Gloss white cabinets and double wall oven",
        "alt": "High-gloss white kitchen with black hardware, double wall oven, subway tile and geometric pendant"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do you handle the whole kitchen renovation, including plumbing and electrical?",
        "a": "Yes. From the design consultation to final installation, we manage cabinetry, countertops, backsplash, flooring, lighting, plumbing, electrical and appliance installation, so you are not coordinating separate trades."
      },
      {
        "q": "Should I replace my cabinets or reface them?",
        "a": "If your cabinet boxes are solid and the layout works, refacing can give you a fresh look for less. If you want to change the layout, add an island or improve storage, new custom cabinetry is usually the better investment. We walk through both options with you when we see the space."
      },
      {
        "q": "Can you remove a wall to create an open-concept kitchen?",
        "a": "Often, yes. Whether a wall can come out depends on what it carries and what runs through it. We assess the structure and plan the change before it goes into your quote."
      },
      {
        "q": "How long does a kitchen renovation take?",
        "a": "The timeline depends on whether the layout is changing, the cabinetry and countertop lead times, and how much plumbing and electrical work is involved. We give you a schedule with your quote once the scope is set."
      },
      {
        "q": "Do you renovate kitchens outside Calgary?",
        "a": "Yes. Along with Calgary, we work in Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty do you offer on kitchen work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote. MRE Developments is licensed and insured, and we review those terms with you before work begins."
      }
    ],
    "ctaTitle": "Start Planning Your New Kitchen",
    "ctaSubtitle": "Share a few details about your kitchen and what is not working today. We will arrange a free, transparent quote for your project.",
    "projects": [
      {
        "title": "Open white kitchen with large island",
        "summary": "Shaker cabinets, quartz island with seating, subway backsplash, stainless appliances and pendant lights.",
        "dates": "",
        "photos": [
          "2026/07/f8b21d2acdc10f354adb1277e6d9396a.jpeg",
          "2026/07/76da2b4e4ae86da1e59570899baf1b7d.jpeg",
          "2026/07/9a3e78eb18370a5b214faf696991db57.jpeg",
          "2026/07/2d76c9dc8d59e6e3379c88f80c6ee813.jpeg"
        ]
      },
      {
        "title": "White kitchen with grey island",
        "summary": "White cabinets, grey island, marble-look counters and backsplash, black faucet, stainless appliances.",
        "dates": "Jun 2023",
        "photos": [
          "2026/07/c15-scaled.jpg",
          "2026/07/c16-scaled.jpg",
          "2026/07/c17-scaled.jpg",
          "2026/07/c18-scaled.jpg"
        ]
      },
      {
        "title": "Navy island kitchen with white cabinets",
        "summary": "White shaker cabinets, navy blue island, quartz counters, pendants and stainless appliances.",
        "dates": "",
        "photos": [
          "2026/07/Screenshot_20181027-134704_Instagram.jpg",
          "2026/07/Screenshot_20181027-134727_Instagram.jpg",
          "2026/07/Screenshot_20181027-134741_Instagram.jpg"
        ]
      },
      {
        "title": "Gloss white kitchen with subway tile",
        "summary": "High-gloss white cabinets, white subway backsplash, quartz counters and black range hood.",
        "dates": "Apr 2023",
        "photos": [
          "2026/07/1-9-scaled.jpg",
          "2026/07/2-8-scaled.jpg",
          "2026/07/3-7-scaled.jpg",
          "2026/07/4-1-scaled.jpg"
        ]
      },
      {
        "title": "More kitchen renovation work",
        "summary": "Additional finished kitchen with gloss white cabinets, double wall oven and subway tile.",
        "dates": "",
        "photos": [
          "2026/07/FB_IMG_1754278772904.jpg"
        ]
      }
    ]
  },
  "new-home-construction": {
    "metaTitle": "New Home Construction Calgary | MRE Developments",
    "metaDescription": "New home construction in Calgary and area: custom single-family homes, duplexes, fourplexes and infills built by MRE Developments. Request a free quote.",
    "headline": "New Home Construction in Calgary, From Permit to Possession",
    "subheadline": "Building a family home, a duplex or a multi-unit investment? We coordinate design, engineering, permits and every trade so your project stays organized, efficient and built to last.",
    "hero": "2026/06/yy1-scaled.jpg",
    "heroAlt": "Newly built Calgary-area bungalow with tan siding, stone accents, front porch and double attached garage",
    "overviewTitle": "Residential Builds, Fully Managed",
    "summary": "MRE Developments builds new homes for homeowners, investors and developers across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks and Chestermere. We take on custom single-family homes, infill builds, duplexes, fourplexes and multi-unit residential projects. Our team coordinates design development, drafting, engineering, permits and inspections, then manages construction through to completion.",
    "highlights": [
      "Custom single-family and infill homes",
      "Duplex and semi-detached construction",
      "Fourplexes and multi-unit residential projects",
      "Design, drafting and engineering coordination",
      "Permit applications and municipal approvals",
      "Full project management, start to finish"
    ],
    "features": [
      {
        "title": "Homes Built Around How You Live",
        "body": "For homeowners, a new build is a chance to get the layout right from the start. We work with you on open living areas, functional kitchens, storage and natural light, then build with the craftsmanship and materials that keep a home performing for decades.",
        "benefit": "A home designed for your family's needs today and for years to come.",
        "image": "2026/06/sd3-scaled.jpg",
        "imageAlt": "Open-concept main floor of a new Calgary home with kitchen island, pot lights and light vinyl plank flooring"
      },
      {
        "title": "Proactive Planning and Coordination",
        "body": "Many contractors simply build what is on the plans. We identify potential challenges early, coordinate closely with designers, engineers, inspectors and suppliers, and find practical solutions before they turn into delays or unnecessary costs.",
        "benefit": "Fewer surprises and a smoother building experience from concept to completion.",
        "image": "2026/06/lk2-scaled.jpg",
        "imageAlt": "New home kitchen with wood island, pendant lighting, herringbone floor and open staircase beyond"
      },
      {
        "title": "Infill and Multi-Unit Projects",
        "body": "For investors and developers, success depends on balancing construction cost, schedule and market demand. We build duplexes, fourplexes and infill homes that make efficient use of the lot, suit the surrounding neighbourhood and are built to hold their value.",
        "benefit": "A residential project designed to maximize land use, rental potential and long-term return.",
        "image": "2026/06/sd1-scaled.jpg",
        "imageAlt": "Newly built semi-detached bungalow with two attached garages and grey and tan siding"
      }
    ],
    "galleryIntro": "New homes our team has built in Calgary and the surrounding area, from exterior elevations to finished interiors.",
    "photos": [
      {
        "src": "2026/06/lk1-scaled.jpg",
        "caption": "Herringbone floors and open staircase",
        "alt": "New home great room with herringbone flooring, fireplace, chandelier and open staircase"
      },
      {
        "src": "2026/06/lk2-scaled.jpg",
        "caption": "Wood island under pendant lights",
        "alt": "New Calgary home kitchen with wood island, pendant lights, herringbone floor and staircase"
      },
      {
        "src": "2026/06/lk3-1-scaled.jpg",
        "caption": "Dining area with statement lighting",
        "alt": "New home dining and kitchen area with dome pendant, brass chandelier and herringbone floor"
      },
      {
        "src": "2026/06/lk6-scaled.jpg",
        "caption": "Double vanity with brass sconces",
        "alt": "New home bathroom with white double vanity, wide mirror and brass wall sconces"
      },
      {
        "src": "2026/06/lk7-scaled.jpg",
        "caption": "Glass shower and quartz vanity",
        "alt": "New home bathroom with glass-enclosed shower, quartz vanity and modern fixtures"
      },
      {
        "src": "2026/06/lk8-scaled.jpg",
        "caption": "Developed lower level with stairs",
        "alt": "Developed lower level in a new home with carpeted stairs and a bright window"
      },
      {
        "src": "2026/06/lk10-scaled.jpg",
        "caption": "White cabinets with brass hardware",
        "alt": "Tall white shaker cabinets with brass hardware in a new Calgary-area home"
      },
      {
        "src": "2026/06/lk11-scaled.jpg",
        "caption": "Upper landing with herringbone floor",
        "alt": "Upper landing in a new home with herringbone flooring, railing and pendant light"
      },
      {
        "src": "2026/06/yy6-scaled.jpg",
        "caption": "Bedroom with sliding closet",
        "alt": "Bedroom in a newly built home with sliding closet doors and vinyl plank flooring"
      },
      {
        "src": "2026/06/yy2-scaled.jpg",
        "caption": "Fireplace wall open to the kitchen",
        "alt": "Open living area in a new home with linear fireplace, skylight and kitchen beyond"
      },
      {
        "src": "2026/06/yy3-scaled.jpg",
        "caption": "Living room with skylight and fireplace",
        "alt": "New home living room with skylight, linear fireplace and light vinyl plank flooring"
      },
      {
        "src": "2026/06/yy4-scaled.jpg",
        "caption": "Wood-grain kitchen with large island",
        "alt": "New home kitchen with wood-grain cabinets, large island, stainless appliances and quartz counters"
      },
      {
        "src": "2026/06/yy5-scaled.jpg",
        "caption": "Island sink and dishwasher",
        "alt": "New home kitchen island with undermount sink, pull-down faucet and dishwasher"
      },
      {
        "src": "2026/06/yy7-scaled.jpg",
        "caption": "Covered rear balcony",
        "alt": "Rear of a newly built home with covered balcony and tan siding on a fresh lot"
      },
      {
        "src": "2026/06/yy8-scaled.jpg",
        "caption": "Rear elevation with raised deck",
        "alt": "Rear of a newly built home with raised deck, black railing and large windows"
      },
      {
        "src": "2026/06/yy1-scaled.jpg",
        "caption": "New bungalow with attached double garage",
        "alt": "New home construction near Calgary: bungalow with tan siding, stone accents and attached garage"
      },
      {
        "src": "2026/06/sd2.jpg",
        "caption": "Vaulted living room with skylight",
        "alt": "New home living room with vaulted ceiling, skylight, linear fireplace and patio doors"
      },
      {
        "src": "2026/06/sd3-scaled.jpg",
        "caption": "Open-concept kitchen and living",
        "alt": "Open-concept main floor in a new home with kitchen island and pot lights"
      },
      {
        "src": "2026/06/sd4-scaled.jpg",
        "caption": "Island with sink facing living room",
        "alt": "Kitchen island with sink and dishwasher facing the living room in a new home"
      },
      {
        "src": "2026/06/sd5-scaled.jpg",
        "caption": "Primary bedroom with double closets",
        "alt": "Primary bedroom in a new home with two sets of sliding closet doors"
      },
      {
        "src": "2026/06/sd6-scaled.jpg",
        "caption": "Long double vanity in wood grain",
        "alt": "New home bathroom with long wood-grain double vanity, quartz top and wide mirror"
      },
      {
        "src": "2026/06/sd8-scaled.jpg",
        "caption": "Rear deck on a new build",
        "alt": "Newly built home with rear deck and black railing before final landscaping"
      },
      {
        "src": "2026/06/sd1-scaled.jpg",
        "caption": "Semi-detached build with two garages",
        "alt": "Newly built semi-detached bungalow with two attached garages and stone-accented front"
      },
      {
        "src": "2026/06/de1-1-scaled.jpg",
        "caption": "Entry with tile flooring",
        "alt": "Front entry of a new home with natural stone-look tile and glass-panel door"
      },
      {
        "src": "2026/06/de2-2-scaled.jpg",
        "caption": "Open-to-below fireplace feature wall",
        "alt": "Two-storey living room in a new home with dark fireplace feature wall and black railing"
      },
      {
        "src": "2026/06/de3-2-scaled.jpg",
        "caption": "Bonus room with patio doors",
        "alt": "Upper bonus room in a new home with patio doors, ceiling fan and black railing"
      },
      {
        "src": "2026/06/de4-2-scaled.jpg",
        "caption": "Upper hallway with black railing",
        "alt": "Upper hallway in a new home with black spindle railing overlooking the living room"
      },
      {
        "src": "2026/06/de5-1-scaled.jpg",
        "caption": "Double vanity beside soaker tub",
        "alt": "New home ensuite with dark double vanity, vessel sinks and tiled soaker tub"
      },
      {
        "src": "2026/06/de6-1-scaled.jpg",
        "caption": "Ensuite with frameless glass shower",
        "alt": "New home ensuite with frameless glass shower, vessel sinks and bright windows"
      },
      {
        "src": "2026/06/de7-1-scaled.jpg",
        "caption": "Hallway to upper bedrooms",
        "alt": "Upper hallway in a new home leading to bedrooms, with black railing"
      },
      {
        "src": "2026/06/de8-1-scaled.jpg",
        "caption": "Foyer open to above with black railing",
        "alt": "Bright two-storey foyer in a new home with black spindle railing and tile flooring"
      },
      {
        "src": "2026/06/sd9-scaled.jpg",
        "caption": "Bungalow with dormer, pre-landscaping",
        "alt": "Newly built bungalow with front dormer before landscaping near Calgary"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What types of new homes do you build?",
        "a": "We build custom single-family homes, infill homes, duplexes and semi-detached homes, fourplexes and other multi-unit residential projects for homeowners, investors and developers."
      },
      {
        "q": "Do you help with design, engineering and permits?",
        "a": "Yes. We assist with design development, drafting, engineering coordination, permit applications and municipal approvals, so your project moves efficiently from concept to construction."
      },
      {
        "q": "Can you build on an infill lot in an established Calgary community?",
        "a": "Yes. Infill development is a core part of our work. We help turn underused lots into modern, efficient homes that complement the existing neighbourhood and make the most of the property."
      },
      {
        "q": "How long does it take to build a new home?",
        "a": "The timeline depends on the size and type of home, design and permit approval times, site conditions, weather and material lead times. We provide a project schedule with your quote once the plans are defined."
      },
      {
        "q": "Where do you build?",
        "a": "We build in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty comes with a new home?",
        "a": "Warranty and workmanship terms are set out in writing with your quote and contract. MRE Developments is licensed and insured, and we review those terms with you before construction begins."
      }
    ],
    "ctaTitle": "Talk to Us About Your New Build",
    "ctaSubtitle": "Tell us about your lot, your plans and your goals. We will follow up to discuss the project and prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Two-storey home with herringbone floors",
        "summary": "New build with herringbone flooring, open kitchen, staircase, bathrooms and developed basement.",
        "dates": "Jan 2026",
        "photos": [
          "2026/06/lk1-scaled.jpg",
          "2026/06/lk2-scaled.jpg",
          "2026/06/lk3-1-scaled.jpg",
          "2026/06/lk6-scaled.jpg",
          "2026/06/lk7-scaled.jpg",
          "2026/06/lk8-scaled.jpg",
          "2026/06/lk10-scaled.jpg",
          "2026/06/lk11-scaled.jpg"
        ]
      },
      {
        "title": "Bungalow with vaulted living room",
        "summary": "New bungalow with double garage, skylit living room, fireplace, kitchen island and rear deck.",
        "dates": "Jul 2020",
        "photos": [
          "2026/06/yy6-scaled.jpg",
          "2026/06/yy2-scaled.jpg",
          "2026/06/yy3-scaled.jpg",
          "2026/06/yy4-scaled.jpg",
          "2026/06/yy5-scaled.jpg",
          "2026/06/yy7-scaled.jpg",
          "2026/06/yy8-scaled.jpg",
          "2026/06/yy1-scaled.jpg"
        ]
      },
      {
        "title": "Bungalow with skylight and fireplace",
        "summary": "New bungalow with skylit living space, fireplace, wood-grain kitchen, ensuite and rear deck.",
        "dates": "Jun 2020",
        "photos": [
          "2026/06/sd2.jpg",
          "2026/06/sd3-scaled.jpg",
          "2026/06/sd4-scaled.jpg",
          "2026/06/sd5-scaled.jpg",
          "2026/06/sd6-scaled.jpg",
          "2026/06/sd8-scaled.jpg",
          "2026/06/sd1-scaled.jpg"
        ]
      },
      {
        "title": "Two-storey home with black railings",
        "summary": "New build with tile entry, open-to-below railing, feature fireplace and ensuite with glass shower.",
        "dates": "Oct 2016",
        "photos": [
          "2026/06/de1-1-scaled.jpg",
          "2026/06/de2-2-scaled.jpg",
          "2026/06/de3-2-scaled.jpg",
          "2026/06/de4-2-scaled.jpg",
          "2026/06/de5-1-scaled.jpg",
          "2026/06/de6-1-scaled.jpg",
          "2026/06/de7-1-scaled.jpg",
          "2026/06/de8-1-scaled.jpg"
        ]
      },
      {
        "title": "More new home construction work",
        "summary": "Additional new build exterior near completion.",
        "dates": "Oct 2018",
        "photos": [
          "2026/06/sd9-scaled.jpg"
        ]
      }
    ]
  },
  "painting": {
    "metaTitle": "Painting Contractor Calgary | MRE Developments",
    "metaDescription": "Interior, exterior and commercial painting in Calgary, Airdrie and Cochrane. Full masking, careful prep and spray-finished trim. Get a free painting quote.",
    "headline": "Calgary Painting Contractor for Interiors, Exteriors and Trim",
    "subheadline": "Dated panelling, tired trim and weathered exteriors refreshed with careful masking, thorough prep and smooth brushed, rolled or spray-applied finishes built for Calgary weather.",
    "hero": "2025/03/5.jpg",
    "heroAlt": "Wood-panelled room repainted bright white with windows and floors masked during a Calgary interior painting project",
    "overviewTitle": "Paint That Starts With Preparation",
    "summary": "MRE Developments paints home interiors, exteriors and commercial spaces across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We mask floors, windows and fixtures, prepare every surface and use quality paints suited to the job, from spray-finished trim and railings to exterior coatings that stand up to Alberta's climate. You get crisp lines, even coverage and a clean site when we leave.",
    "highlights": [
      "Whole-home interior painting",
      "Exterior painting for Alberta weather",
      "Spray-finished trim, doors and railings",
      "Panelling and fireplace makeovers",
      "Full masking and floor protection",
      "Commercial painting with minimal disruption"
    ],
    "features": [
      {
        "title": "Whole-Room Interior Transformations",
        "body": "We repaint full rooms and whole homes, including wood panelling, staircases, spindles and fireplace mantels that make a space feel dated. Walls, ceilings and trim are coordinated so the finished room reads as one clean design.",
        "benefit": "A brighter, updated home without the cost of tearing out finishes.",
        "image": "2025/03/20221202_134003-scaled.jpg",
        "imageAlt": "Staircase railing and spindles freshly painted white in a bright Calgary living room"
      },
      {
        "title": "Masking and Prep Done Properly",
        "body": "Before any paint is opened we cover floors, stairs, furniture and windows in plastic and paper. Surfaces are cleaned, filled and sanded so the topcoat bonds well and stays smooth.",
        "benefit": "Sharp lines, no overspray and a home left as clean as we found it.",
        "image": "2025/03/20221202_133538-scaled.jpg",
        "imageAlt": "Room fully masked in plastic sheeting with staircase protected before interior painting"
      },
      {
        "title": "Spray Finishing for Trim",
        "body": "Baseboards, casings, doors and railings can be spray-finished with an airless system for a smooth, brush-mark-free surface. Pieces are laid out and coated evenly before reinstallation where that gives the best result.",
        "benefit": "A factory-smooth finish on the details people notice most.",
        "image": "2025/03/mreyycpainting1.jpg",
        "imageAlt": "Painter spray-finishing rows of white trim boards inside a protected spray area"
      }
    ],
    "galleryIntro": "Recent interior painting and spray-finishing work, with the masking and prep that make the difference.",
    "photos": [
      {
        "src": "2025/03/4.jpg",
        "caption": "Dark panelling before painting",
        "alt": "Dark wood-panelled room masked and prepared before interior painting"
      },
      {
        "src": "2025/03/5.jpg",
        "caption": "Wood panelling repainted bright white",
        "alt": "Wood-panelled room repainted white during an interior painting project in Calgary"
      },
      {
        "src": "2025/03/20221202_132550-scaled.jpg",
        "caption": "Fireplace mantel refinished in white",
        "alt": "Fireplace mantel and surround painted white with masking still in place"
      },
      {
        "src": "2025/03/20221202_133538-scaled.jpg",
        "caption": "Full room masked before spraying",
        "alt": "Room and wood staircase covered in plastic before interior painting in Calgary"
      },
      {
        "src": "2025/03/20221202_134003-scaled.jpg",
        "caption": "Staircase spindles painted white",
        "alt": "White painted staircase railing and spindles in a bright Calgary home"
      },
      {
        "src": "2025/03/mreyycpainting2.jpg",
        "caption": "Preparing paint for the next coat",
        "alt": "Painter mixing a can of paint on a protected floor"
      },
      {
        "src": "2025/03/mreyycpainting7.jpg",
        "caption": "Clean edge beside dark tile",
        "alt": "Painter cutting in a clean wall edge beside dark tile"
      },
      {
        "src": "2025/03/mreyycpainting5.jpg",
        "caption": "Cutting in at the ceiling line",
        "alt": "Painter brushing a crisp line where the wall meets the ceiling"
      },
      {
        "src": "2025/03/mreyycpainting4.jpg",
        "caption": "Airless spraying of trim boards",
        "alt": "Painter using an airless sprayer to finish white trim boards"
      },
      {
        "src": "2025/03/mreyycpainting1.jpg",
        "caption": "Spray-finishing trim in batches",
        "alt": "Rows of trim boards being spray-painted white in a protected area"
      },
      {
        "src": "2025/03/mreyycpainting3.jpg",
        "caption": "Even coats on every board",
        "alt": "Painter spray-coating trim boards laid across sawhorses"
      },
      {
        "src": "2026/05/A-scaled.jpg",
        "caption": "Brushing baseboards by hand",
        "alt": "Painter brushing white paint onto baseboards along a protected floor"
      },
      {
        "src": "2026/05/B-scaled.jpg",
        "caption": "Rolling a smooth door finish",
        "alt": "Painter rolling white paint onto a panel door for a smooth finish"
      },
      {
        "src": "2026/05/C-scaled.jpg",
        "caption": "Roller and brushes on the ladder",
        "alt": "Paint bucket with roller and brush resting on a ladder during painting"
      }
    ],
    "videos": [
      "2024/08/3.mp4"
    ],
    "faqs": [
      {
        "q": "Do you paint both interiors and exteriors in Calgary?",
        "a": "Yes. We handle interior painting for single rooms within a larger project or entire homes, and exterior painting with products chosen for Calgary's temperature swings and sun exposure. We serve Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area."
      },
      {
        "q": "Can you paint wood panelling, railings and fireplace mantels?",
        "a": "Yes. Panelling, stair spindles, railings and mantels are some of the most effective updates we do. They are cleaned, sanded and primed with a bonding primer so the topcoat adheres and wears well."
      },
      {
        "q": "Do you offer spray finishing?",
        "a": "Yes. We spray-finish trim, doors, railings and similar details with an airless system when it gives a smoother result than brushing. Everything around the work area is fully masked first."
      },
      {
        "q": "Do you take on commercial painting?",
        "a": "Yes. We paint commercial properties and plan the work to keep disruption to your business operations to a minimum."
      },
      {
        "q": "How long will my painting project take?",
        "a": "Timing depends on the size of the space, how much prep and repair the surfaces need, the number of coats and, for exteriors, the weather. Your quote includes a project schedule."
      },
      {
        "q": "Is your painting work covered by a warranty?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so they are clear before work starts."
      }
    ],
    "ctaTitle": "Get a Fresh Finish From MRE",
    "ctaSubtitle": "Tell us which rooms or exterior surfaces you want painted. We will provide a free, detailed painting quote for your Calgary-area property.",
    "projects": [
      {
        "title": "Wood panelling painted white",
        "summary": "Dark wood-panelled room masked off, then repainted bright white.",
        "dates": "",
        "photos": [
          "2025/03/4.jpg",
          "2025/03/5.jpg"
        ]
      },
      {
        "title": "Main floor repaint with fireplace and railing",
        "summary": "House masked and protected, fireplace surround and stair spindles painted white.",
        "dates": "Dec 2022",
        "photos": [
          "2025/03/20221202_132550-scaled.jpg",
          "2025/03/20221202_133538-scaled.jpg",
          "2025/03/20221202_134003-scaled.jpg"
        ]
      },
      {
        "title": "Interior repaint with sprayed slats",
        "summary": "Paint prepared, walls and trim cut in by brush, and slats spray-finished white.",
        "dates": "Mar 2019",
        "photos": [
          "2025/03/mreyycpainting2.jpg",
          "2025/03/mreyycpainting7.jpg",
          "2025/03/mreyycpainting5.jpg",
          "2025/03/mreyycpainting4.jpg",
          "2025/03/mreyycpainting1.jpg",
          "2025/03/mreyycpainting3.jpg"
        ]
      },
      {
        "title": "Baseboard, door and trim painting",
        "summary": "Baseboards cut in, doors rolled and trim painted in a fresh white finish.",
        "dates": "Feb 2023",
        "photos": [
          "2026/05/A-scaled.jpg",
          "2026/05/B-scaled.jpg",
          "2026/05/C-scaled.jpg"
        ]
      }
    ]
  },
  "plumbing": {
    "metaTitle": "Plumbing Contractor Calgary | MRE Developments",
    "metaDescription": "Rough-ins, fixture installs, water heaters and Poly B repiping for renovations and new construction in Calgary and area. Request a free plumbing quote.",
    "headline": "Calgary Plumbing for Renovations and New Construction",
    "subheadline": "Rough-ins, fixtures, water heaters and full repipes planned around your project, permitted, inspected and coordinated with every other trade on site.",
    "hero": "2026/05/3-12-scaled.jpg",
    "heroAlt": "New PEX water supply manifold with red and blue lines and shut-off valves mounted on a plywood wall",
    "overviewTitle": "Plumbing Built Into Your Project",
    "summary": "MRE Developments designs and installs complete plumbing systems for new homes, multi-family builds, basement suites, kitchens, bathrooms and commercial construction across Calgary, Airdrie, Cochrane and Okotoks. Our licensed and insured team handles rough-ins, fixtures, water heaters and Poly B replacement, and we obtain the permits and arrange the inspections. Because plumbing is coordinated with the rest of your build, the work stays on track from framing to final finishes.",
    "highlights": [
      "New construction and renovation rough-ins",
      "Fixture and water heater installation",
      "Poly B replacement and full repipes",
      "Drain and sewer line work",
      "Permits and inspections handled for you",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "Poly B Replacement and Repiping",
        "body": "Many older Calgary homes still have Poly B supply lines, which are prone to leaks as they age. We replace them with modern PEX piping, routing new lines through small, planned ceiling and wall openings so the house is disturbed as little as possible.",
        "benefit": "You remove a known leak risk and protect the long-term value of your home.",
        "image": "2026/05/5-6-1-scaled.jpg",
        "imageAlt": "Plumber pulling new blue PEX water line through a ceiling opening during a Poly B repipe in Calgary"
      },
      {
        "title": "Clean, Code-Compliant Rough-Ins",
        "body": "Supply lines, manifolds and drains are laid out to match your floor plan and installed with proper fittings, crimps and support. Every system is built to meet national building and plumbing codes, and we arrange the required inspections before walls are closed.",
        "benefit": "A tidy, inspected system that is easy to service and built to last.",
        "image": "2026/05/4-22-scaled.jpg",
        "imageAlt": "Plumber crimping a brass PEX fitting onto a red hot water line during a rough-in"
      },
      {
        "title": "Fixtures, Drains and Water Heaters",
        "body": "From ABS drain assemblies and tub valves to energy-efficient water heaters, we install the components that make kitchens, bathrooms and legal secondary suites work. Projects in Calgary, Chestermere, Strathmore and High River get the same careful layout and testing.",
        "benefit": "Fixtures and drains that perform reliably from the first day you use them.",
        "image": "2026/05/3-14-1-scaled.jpg",
        "imageAlt": "Plumber fitting a black ABS drain trap and stack during a bathroom plumbing installation"
      }
    ],
    "galleryIntro": "Plumbing work from recent Calgary projects, from repipes and rough-ins to drain assemblies.",
    "photos": [
      {
        "src": "2026/05/1-16-scaled.jpg",
        "caption": "Brass and copper fittings ready to go",
        "alt": "Pile of brass PEX fittings and copper crimp rings prepared for a plumbing installation"
      },
      {
        "src": "2026/05/2-14-scaled.jpg",
        "caption": "Cutting PEX for a clean run",
        "alt": "Plumber cutting blue PEX tubing with pipe cutters during a plumbing rough-in"
      },
      {
        "src": "2026/05/3-12-scaled.jpg",
        "caption": "PEX manifold with labelled shut-offs",
        "alt": "New PEX supply manifold with red and blue lines and shut-off valves installed in a Calgary home"
      },
      {
        "src": "2026/05/4-22-scaled.jpg",
        "caption": "Brass fitting crimped on red PEX",
        "alt": "Close-up of a brass PEX fitting being crimped onto a red hot water line"
      },
      {
        "src": "2026/05/5-6-scaled.jpg",
        "caption": "Overhead supply lines in the joists",
        "alt": "Plumber connecting red and blue PEX supply lines between floor joists during a plumbing rough-in"
      },
      {
        "src": "2026/05/6-6-scaled.jpg",
        "caption": "Crimping fittings beside the drain stack",
        "alt": "Crimp tool securing a PEX fitting next to an ABS drain stack in a basement plumbing project"
      },
      {
        "src": "2026/05/1-16-1-scaled.jpg",
        "caption": "Planned ceiling access openings",
        "alt": "Ceiling with neat access openings cut for running new water lines during a Calgary repipe"
      },
      {
        "src": "2026/05/2-14-1-scaled.jpg",
        "caption": "Access opening above the old lines",
        "alt": "Ceiling access opening exposing existing pipes ahead of a Poly B replacement"
      },
      {
        "src": "2026/05/3-12-1-scaled.jpg",
        "caption": "New line routed past the joist",
        "alt": "Ceiling opening showing a new water line routed between joists during a home repipe"
      },
      {
        "src": "2026/05/5-6-1-scaled.jpg",
        "caption": "Pulling new PEX through the ceiling",
        "alt": "Plumber pulling blue PEX line through a ceiling opening during a Poly B replacement in Calgary"
      },
      {
        "src": "2026/05/4-22-1-scaled.jpg",
        "caption": "Whole-home repipe through ceiling access",
        "alt": "Plumber feeding blue PEX through ceiling openings during a whole-home repipe in Calgary"
      },
      {
        "src": "2026/05/6-6-1-scaled.jpg",
        "caption": "Living room ready for repipe access",
        "alt": "Living room with small ceiling openings and an open wall cavity for a Poly B repipe in Calgary"
      },
      {
        "src": "2026/05/1-17-scaled.jpg",
        "caption": "Original tub and shower before work",
        "alt": "Original tiled tub and shower with older fixtures before a bathroom plumbing upgrade"
      },
      {
        "src": "2026/05/2-15-scaled.jpg",
        "caption": "Removing the old shower valve",
        "alt": "Plumber removing an old shower valve from a tiled bathroom wall during a plumbing upgrade"
      },
      {
        "src": "2026/05/3-13-scaled.jpg",
        "caption": "Tub valve opening before upgrade",
        "alt": "Opened tile wall exposing an old tub valve before a bathroom plumbing replacement"
      },
      {
        "src": "2026/05/1-18-scaled.jpg",
        "caption": "Upgrading tub valve connections",
        "alt": "Plumber working on tub valve supply connections through an opened bathroom wall"
      },
      {
        "src": "2026/05/2-16-scaled.jpg",
        "caption": "Tub supply and drain opened up",
        "alt": "Wall opened behind a bathtub showing supply and drain plumbing ready for replacement"
      },
      {
        "src": "2026/05/3-14.jpg",
        "caption": "Copper supply behind the tub",
        "alt": "Opened wall showing copper supply lines and drain behind a bathtub before plumbing upgrades"
      },
      {
        "src": "2026/05/1-16-2-scaled.jpg",
        "caption": "Cutting tubing for a new supply run",
        "alt": "Plumber cutting tubing with an orange pipe cutter during a renovation plumbing project"
      },
      {
        "src": "2026/05/2-14-2-scaled.jpg",
        "caption": "Preparing ABS drain components",
        "alt": "Plumber priming black ABS drain fittings on a work mat before assembly"
      },
      {
        "src": "2026/05/3-12-2-scaled.jpg",
        "caption": "Solvent cement on ABS fittings",
        "alt": "Plumber applying solvent cement to black ABS drain fittings during a plumbing installation"
      },
      {
        "src": "2026/05/1-18-1-scaled.jpg",
        "caption": "Joining ABS pipe to a fitting",
        "alt": "Plumber joining a length of black ABS pipe to a fitting for a new drain line"
      },
      {
        "src": "2026/05/2-16-1-scaled.jpg",
        "caption": "Building a drain stack on site",
        "alt": "Plumber assembling a black ABS drain stack and trap during a bathroom plumbing project"
      },
      {
        "src": "2026/05/3-14-1-scaled.jpg",
        "caption": "ABS drain trap and stack assembled",
        "alt": "Assembled black ABS drain trap and vertical stack ready for a bathroom plumbing installation"
      }
    ],
    "videos": [
      "2026/05/1q.mp4"
    ],
    "faqs": [
      {
        "q": "What kinds of plumbing projects do you take on?",
        "a": "We handle plumbing for new home and multi-family construction, commercial construction, basement developments and legal secondary suites, garage and backyard suites, and kitchen, bathroom and full-home renovations. That includes rough-ins, fixtures, water heaters, drains and full repipes. We focus on project work rather than one-off service calls."
      },
      {
        "q": "Should I replace the Poly B plumbing in my home?",
        "a": "Poly B was widely used in older Calgary homes and is known to become prone to leaks as it ages. Replacing it with modern piping removes that risk and can help with insurance and resale. We assess your system and plan the repipe to keep wall and ceiling openings to a minimum."
      },
      {
        "q": "Do you handle plumbing permits and inspections?",
        "a": "Yes. We obtain the plumbing permits, build the system to meet national building codes and arrange the required inspections. You do not need to deal with the permit process yourself."
      },
      {
        "q": "How long will the plumbing work take?",
        "a": "The timeline depends on the size of the project, the number of fixtures, access to existing lines and inspection scheduling. Plumbing is also coordinated with framing, electrical and finishing trades. Your quote includes a schedule for your project."
      },
      {
        "q": "Do you work outside Calgary?",
        "a": "Yes. We take on plumbing projects throughout Calgary and the surrounding area, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty do you offer on plumbing work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote. Coverage on fixtures and water heaters follows the manufacturer terms for the products installed."
      }
    ],
    "ctaTitle": "Start Your Calgary Plumbing Project",
    "ctaSubtitle": "Share your plans for a renovation, suite or new build and we will prepare a free, detailed plumbing quote.",
    "projects": [
      {
        "title": "Whole-home PEX repipe with new manifold",
        "summary": "PEX fittings and manifold assembled, basement lines crimped, then new lines fished through ceiling openings.",
        "dates": "Apr 2026",
        "photos": [
          "2026/05/1-16-scaled.jpg",
          "2026/05/2-14-scaled.jpg",
          "2026/05/3-12-scaled.jpg",
          "2026/05/4-22-scaled.jpg",
          "2026/05/5-6-scaled.jpg",
          "2026/05/6-6-scaled.jpg",
          "2026/05/1-16-1-scaled.jpg",
          "2026/05/2-14-1-scaled.jpg",
          "2026/05/3-12-1-scaled.jpg",
          "2026/05/5-6-1-scaled.jpg",
          "2026/05/4-22-1-scaled.jpg",
          "2026/05/6-6-1-scaled.jpg"
        ]
      },
      {
        "title": "Bathtub valve replacement behind tile wall",
        "summary": "Tiled tub wall opened to reach the old valve; supply piping replaced inside the wall.",
        "dates": "Jan 2022",
        "photos": [
          "2026/05/1-17-scaled.jpg",
          "2026/05/2-15-scaled.jpg",
          "2026/05/3-13-scaled.jpg",
          "2026/05/1-18-scaled.jpg",
          "2026/05/2-16-scaled.jpg",
          "2026/05/3-14.jpg"
        ]
      },
      {
        "title": "ABS drain and P-trap assembly",
        "summary": "Black ABS drain fittings primed, glued and assembled into a trap and stack.",
        "dates": "Feb 2023",
        "photos": [
          "2026/05/1-16-2-scaled.jpg",
          "2026/05/2-14-2-scaled.jpg",
          "2026/05/3-12-2-scaled.jpg",
          "2026/05/1-18-1-scaled.jpg",
          "2026/05/2-16-1-scaled.jpg",
          "2026/05/3-14-1-scaled.jpg"
        ]
      }
    ]
  },
  "roofing": {
    "metaTitle": "Roofing Contractor Calgary | MRE Developments",
    "metaDescription": "Complete roof replacements and new roof installations for single-family and multi-family homes in Calgary and area. Request your free roofing quote today.",
    "headline": "Calgary Roof Replacement and New Roof Installation",
    "subheadline": "Complete tear-off replacements and new-build roofs for single-family and multi-family homes, built to stand up to Calgary hail, chinooks and heavy snow loads.",
    "hero": "2025/11/20251105_092404-scaled.jpg",
    "heroAlt": "Newly shingled residential roof with a metal vent stack after a complete roof replacement in Calgary",
    "overviewTitle": "Complete Roofing, Start to Finish",
    "summary": "MRE Developments replaces and installs complete roof systems for single-family and multi-family homes across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our licensed and insured crew handles every step, from inspection and tear-off to underlayment, flashing, venting and the final shingle course. We focus on full roofing projects only, so every job gets a properly planned, weather-tight system rather than a patch.",
    "highlights": [
      "Single-family roof replacement",
      "Multi-family roof replacement",
      "New roof installation for new builds",
      "Full tear-off down to the deck",
      "Licensed and insured roofing crew",
      "Free, detailed project-specific quotes"
    ],
    "features": [
      {
        "title": "Full Tear-Off Roof Replacement",
        "body": "When a roof has reached the end of its life or taken serious hail damage, we remove the old shingles right down to the roof deck. That lets us inspect the sheathing, address problem areas and build the new system on a sound base instead of layering over hidden issues.",
        "benefit": "You get a new roof built from the deck up, with no old problems trapped underneath.",
        "image": "2025/11/20251105_092650-scaled.jpg",
        "imageAlt": "Roofer tearing off worn asphalt shingles to expose the roof deck during a Calgary roof replacement"
      },
      {
        "title": "Layered Protection Against Weather",
        "body": "A durable roof depends on what goes under the shingles. Our crew installs underlayment, membranes, flashing and roof vents with care at every edge and penetration, the details that decide how well a roof handles Calgary freeze-thaw cycles and spring melt.",
        "benefit": "Your home is protected by a weather-resistant system, not just a new top layer.",
        "image": "2025/11/20251112_161240-scaled.jpg",
        "imageAlt": "Roofing crew rolling out membrane on a residential roof deck before new shingles go on"
      },
      {
        "title": "Single-Family and Multi-Family Roofs",
        "body": "We replace roofs on existing homes and install complete roofs on new single-family and multi-family builds throughout Calgary, Airdrie, Okotoks and High River. For new construction we help you weigh asphalt shingle, metal and low-slope options against your design, budget and long-term performance goals.",
        "benefit": "One accountable contractor for the whole roof, whether it is one house or a multi-unit building.",
        "image": "2025/11/20251112_162314-scaled.jpg",
        "imageAlt": "Roofer kneeling on a ridge line at sunset while installing shingles on a Calgary area home"
      }
    ],
    "galleryIntro": "A look at recent roof replacement work by our crew, from tear-off to finished shingles.",
    "photos": [
      {
        "src": "2025/11/20251105_092650-scaled.jpg",
        "caption": "Tear-off of worn asphalt shingles",
        "alt": "Roofer removing worn asphalt shingles and roof vent at the start of a Calgary roof replacement"
      },
      {
        "src": "2025/11/20251105_093530-scaled.jpg",
        "caption": "Old shingles stripped to the deck",
        "alt": "Partially stripped roof showing exposed roof deck during a full tear-off roof replacement in Calgary"
      },
      {
        "src": "2025/11/20251105_092404-scaled.jpg",
        "caption": "Finished shingles with new vent stack",
        "alt": "Completed asphalt shingle roof replacement with a new vent stack on a home in Calgary"
      },
      {
        "src": "2025/11/20251112_161240-scaled.jpg",
        "caption": "Membrane going down over the deck",
        "alt": "Roofers installing membrane over the roof deck before new shingles on a residential roofing project"
      },
      {
        "src": "2025/11/20251112_161412-scaled.jpg",
        "caption": "Roofing crew at work on the ridge",
        "alt": "Silhouetted roofing crew working on a residential roof during a Calgary roof replacement"
      },
      {
        "src": "2025/11/20251112_162314-scaled.jpg",
        "caption": "Shingle installation along the ridge",
        "alt": "Roofer installing new shingles near the ridge of a home at sunset in the Calgary area"
      }
    ],
    "videos": [
      "2025/11/qd.mp4"
    ],
    "faqs": [
      {
        "q": "Do you do roof repairs?",
        "a": "We focus on complete roofing projects: full roof replacements and new roof installations for single-family and multi-family homes. Concentrating on complete systems lets us plan and build each roof properly from the deck up. If your roof has widespread wear or hail damage, a replacement quote is the right place to start."
      },
      {
        "q": "How do I know if my roof needs to be replaced?",
        "a": "Common signs include curling or missing shingles, heavy granule loss, repeated leaks, sagging areas and significant hail damage. Age matters too, since an older roof may no longer protect your home well even if it looks acceptable from the ground. We inspect the roof during the quote and explain what we see."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We complete roofing projects across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River. Contact us with your address and project details and we will confirm scheduling for your area."
      },
      {
        "q": "How long does a roof replacement take?",
        "a": "The timeline depends on the size and pitch of the roof, the number of layers being removed, the condition of the roof deck, the materials chosen and the weather. Your quote includes a project schedule so you know what to expect before work begins."
      },
      {
        "q": "What warranty comes with a new roof?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you can review exactly what is covered before you commit. Manufacturer coverage on roofing materials depends on the products selected for your project."
      },
      {
        "q": "How do I get started?",
        "a": "Use our roofing planner on the Start page to describe your home and project, or request a free quote using the form on this page. We will review the details, visit the property and provide a detailed, project-specific quote."
      }
    ],
    "ctaTitle": "Plan Your Calgary Roof Replacement",
    "ctaSubtitle": "Tell us about your home and roof, or use our roofing planner, and we will prepare a free, detailed quote for your complete roofing project.",
    "projects": [
      {
        "title": "Asphalt shingle tear-off and re-roof",
        "summary": "Old shingles stripped to the deck, then new shingles and roof vents installed.",
        "dates": "Nov 2025",
        "photos": [
          "2025/11/20251105_092650-scaled.jpg",
          "2025/11/20251105_093530-scaled.jpg",
          "2025/11/20251105_092404-scaled.jpg"
        ]
      },
      {
        "title": "Roof replacement crew at work",
        "summary": "Crew laying underlayment and shingles at the end of the day.",
        "dates": "Nov 2025",
        "photos": [
          "2025/11/20251112_161240-scaled.jpg",
          "2025/11/20251112_161412-scaled.jpg",
          "2025/11/20251112_162314-scaled.jpg"
        ]
      }
    ]
  },
  "secondary-suites": {
    "metaTitle": "Legal Secondary Suites Calgary | MRE Developments",
    "metaDescription": "Legal basement, garage and backyard suites in Calgary, Airdrie and Cochrane. Permits, design and construction by MRE Developments. Get a free quote today.",
    "headline": "Legal Secondary Suites in Calgary, Designed and Built to Code",
    "subheadline": "Turn an unused basement or backyard into a legal, rental-ready suite. We handle permits, design and construction so your suite passes inspection and is ready for tenants or family.",
    "hero": "2025/11/q5-1.jpg",
    "heroAlt": "Legal basement suite in Calgary with new kitchen, light wood cabinets, stainless appliances and vinyl plank floor",
    "overviewTitle": "Secondary Suites, Permit to Possession",
    "summary": "MRE Developments designs and builds Secondary Suites (Basement, Backyard, Garage) for homeowners and investors in Calgary and nearby communities such as Airdrie, Cochrane, Okotoks and Chestermere. We manage the permit process, suite design, construction and finishing, and build every suite to meet Calgary's bylaws and building code. We also bring older basement apartments up to code with safety improvements, structural fixes and new finishes.",
    "highlights": [
      "Legal basement suites built to code",
      "Garage, laneway and backyard suites",
      "Permits and City approvals handled",
      "Full kitchens, bathrooms and separate entrances",
      "Upgrades for older, non-conforming suites",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Rental-Ready, Self-Contained Suites",
        "body": "A legal suite needs to work as a complete home: its own kitchen, bathroom, bedrooms, laundry and a separate entrance. We plan the floor plan around your basement or lot so the suite feels open and bright, with pot lighting, durable vinyl plank floors and full-size appliances.",
        "benefit": "A suite that attracts good tenants or comfortably houses family, and adds lasting value to your property.",
        "image": "2026/05/12-5-scaled.jpg",
        "imageAlt": "Basement suite kitchen with white shaker cabinets, marble-look backsplash, stainless range and dishwasher"
      },
      {
        "title": "Code Work Behind the Walls",
        "body": "Fire separation, ventilation, egress, mechanical and electrical requirements are what make a suite legal, and they are built in before drywall. Our team handles ductwork, framing, insulation and mechanical upgrades, then schedules the inspections the permit requires.",
        "benefit": "A suite that is safe, inspected and fully legal, not just finished on the surface.",
        "image": "2025/11/3-2-scaled.jpg",
        "imageAlt": "Installer fitting new ductwork in an open basement ceiling during secondary suite construction"
      },
      {
        "title": "Basement, Garage or Backyard",
        "body": "Not every property suits the same suite. Along with legal basement suites, we design and build garage and laneway suites and backyard suites that give tenants or guests a fully independent home without taking space from yours.",
        "benefit": "The right type of suite for your lot, your budget and your rental goals.",
        "image": "2026/05/20-scaled.jpg",
        "imageAlt": "Basement suite bathroom with frameless glass shower, rain head and matte black fixtures"
      }
    ],
    "galleryIntro": "Legal basement suites our team has built in Calgary, shown finished, during construction and before the work began.",
    "photos": [
      {
        "src": "2025/11/1-3-scaled.jpg",
        "caption": "Before: carpeted basement stairs",
        "alt": "Before the renovation: narrow basement stairs with worn teal carpet"
      },
      {
        "src": "2025/11/3-1-scaled.jpg",
        "caption": "Before: wood-panelled basement",
        "alt": "Before the suite build: wood-panelled basement with drop ceiling and teal carpet"
      },
      {
        "src": "2025/11/5-1-scaled.jpg",
        "caption": "Before: original basement kitchenette",
        "alt": "Before the suite build: original basement kitchenette with wood panelling and checkered floor"
      },
      {
        "src": "2025/11/7-scaled.jpg",
        "caption": "Before: dated basement living area",
        "alt": "Before the renovation: dated basement living area with panelling and carpet"
      },
      {
        "src": "2025/11/9-1-scaled.jpg",
        "caption": "Before: panelled room with carpet",
        "alt": "Before the suite build: wood-panelled basement room with teal carpet"
      },
      {
        "src": "2025/11/11-1-scaled.jpg",
        "caption": "Before: older basement doorways",
        "alt": "Before the suite build: older basement doorways and carpeted hallway"
      },
      {
        "src": "2025/11/13-scaled.jpg",
        "caption": "Before: basement bedroom",
        "alt": "Before the renovation: basement bedroom with drop ceiling and carpet"
      },
      {
        "src": "2025/11/15-1-scaled.jpg",
        "caption": "Before: unfinished utility area",
        "alt": "Before the suite build: unfinished utility area with water heater and washer"
      },
      {
        "src": "2025/11/2-2-scaled.jpg",
        "caption": "Refinished stairway to the suite",
        "alt": "Basement suite stairway after renovation with white walls and grey treads"
      },
      {
        "src": "2025/11/4-12-scaled.jpg",
        "caption": "Bright open suite after renovation",
        "alt": "Basement suite after renovation with white walls, pot lights and kitchen along the back wall"
      },
      {
        "src": "2025/11/6-scaled.jpg",
        "caption": "White kitchen across the open room",
        "alt": "White basement suite kitchen with range and cabinets across an open living space"
      },
      {
        "src": "2025/11/8-1-scaled.jpg",
        "caption": "Open suite living and kitchen space",
        "alt": "Finished basement suite living area opening to a white kitchen with black refrigerator"
      },
      {
        "src": "2025/11/10-scaled.jpg",
        "caption": "Bright finished room with window",
        "alt": "Finished basement suite room with window, pot lights and grey flooring"
      },
      {
        "src": "2025/11/12-1-scaled.jpg",
        "caption": "Finished suite hallway",
        "alt": "Finished hallway in a Calgary basement suite with white walls and new doors"
      },
      {
        "src": "2025/11/14-scaled.jpg",
        "caption": "Bedroom with bifold closet doors",
        "alt": "Finished basement suite bedroom with white bifold closet doors and new trim"
      },
      {
        "src": "2025/11/16-1-scaled.jpg",
        "caption": "Tankless water heater and new plumbing",
        "alt": "Basement suite mechanical room with tankless water heater and new plumbing lines"
      },
      {
        "src": "2026/05/13-3-scaled.jpg",
        "caption": "Before: dated basement bathroom",
        "alt": "Before the renovation: dated basement bathroom with patterned wallpaper"
      },
      {
        "src": "2026/05/15-1-scaled.jpg",
        "caption": "Before: original vanity and toilet",
        "alt": "Before the renovation: original basement bathroom vanity and toilet"
      },
      {
        "src": "2026/05/19-scaled.jpg",
        "caption": "Before: old framed shower",
        "alt": "Before the renovation: old framed shower enclosure and wallpapered walls"
      },
      {
        "src": "2026/05/21-scaled.jpg",
        "caption": "Before: panelled room, checkered floor",
        "alt": "Before the suite build: wood-panelled basement room with checkered carpet tiles"
      },
      {
        "src": "2026/05/5-5-scaled.jpg",
        "caption": "Before: panelled rec room",
        "alt": "Before the suite build: wood-panelled basement rec room with carpet tiles"
      },
      {
        "src": "2026/05/7-5-scaled.jpg",
        "caption": "Before: basement with built-in shelving",
        "alt": "Before the renovation: basement with built-in shelving, mural and carpet tiles"
      },
      {
        "src": "2026/05/9-3-scaled.jpg",
        "caption": "Before: stairs and panelled walls",
        "alt": "Before the renovation: basement stairs and wood-panelled walls"
      },
      {
        "src": "2026/05/11-4-scaled.jpg",
        "caption": "Before: demolition underway",
        "alt": "Basement during demolition before secondary suite construction"
      },
      {
        "src": "2026/05/6-5-scaled.jpg",
        "caption": "Living space next to the kitchen",
        "alt": "Basement suite living space beside the kitchen with stainless fridge and pot lights"
      },
      {
        "src": "2026/05/8-5-scaled.jpg",
        "caption": "Galley kitchen with window light",
        "alt": "Basement suite galley kitchen with white cabinets, black fridge and window in Calgary"
      },
      {
        "src": "2026/05/10-4-scaled.jpg",
        "caption": "Hallway leading to suite kitchen",
        "alt": "Secondary suite hallway with new doors and vinyl flooring leading to the kitchen"
      },
      {
        "src": "2026/05/12-5-scaled.jpg",
        "caption": "White shaker kitchen with marble backsplash",
        "alt": "Secondary suite kitchen with white shaker cabinets, marble-look backsplash, quartz counter and stainless range"
      },
      {
        "src": "2026/05/14-2-scaled.jpg",
        "caption": "Lit medicine cabinet over wood vanity",
        "alt": "Basement suite bathroom with lit medicine cabinet, wood vanity and black faucet"
      },
      {
        "src": "2026/05/16-1-scaled.jpg",
        "caption": "Wood vanity with black faucet",
        "alt": "Basement suite bathroom with wood-tone vanity, black faucet and toilet"
      },
      {
        "src": "2026/05/20-scaled.jpg",
        "caption": "Glass shower with rain head",
        "alt": "Basement suite bathroom with frameless glass shower, rain shower head and black fixtures"
      },
      {
        "src": "2026/05/22-scaled.jpg",
        "caption": "Bedroom with egress-sized window",
        "alt": "Basement suite bedroom with large window, white walls and grey vinyl plank flooring"
      },
      {
        "src": "2025/11/q1-scaled.jpg",
        "caption": "Suite bathroom with marble-look walls",
        "alt": "Basement suite bathroom with marble-look tile, grey vanity, toilet and tub"
      },
      {
        "src": "2025/11/q4-scaled.jpg",
        "caption": "Living area with window and pot lights",
        "alt": "Secondary suite living room with window, pot lights and vinyl plank flooring"
      },
      {
        "src": "2025/11/q6-scaled.jpg",
        "caption": "Gas cooktop and matte black faucet",
        "alt": "Secondary suite kitchen detail with gas cooktop, quartz counter, black faucet and subway backsplash"
      },
      {
        "src": "2025/11/q5-1.jpg",
        "caption": "Full suite kitchen with stainless appliances",
        "alt": "Legal basement suite in Calgary with full kitchen, stainless fridge, pot lights and vinyl plank flooring"
      },
      {
        "src": "2026/05/kka1-scaled.jpg",
        "caption": "Open room with pot lights",
        "alt": "Finished basement suite room with pot lights and light vinyl plank flooring"
      },
      {
        "src": "2026/05/kka2-scaled.jpg",
        "caption": "White shaker kitchen, dark backsplash",
        "alt": "Secondary suite kitchen with white shaker cabinets and dark tile backsplash beside the entry door"
      },
      {
        "src": "2026/05/kka3-scaled.jpg",
        "caption": "Built-in microwave and pantry cabinet",
        "alt": "Basement suite kitchen with built-in microwave, tall pantry cabinet and dark backsplash"
      },
      {
        "src": "2026/05/kka4-scaled.jpg",
        "caption": "Corner sink with black faucet",
        "alt": "Secondary suite kitchen corner with undermount sink, black faucet and white shaker cabinets"
      },
      {
        "src": "2026/05/kka5-scaled.jpg",
        "caption": "Marble-look tub surround, black faucet",
        "alt": "Secondary suite bathroom with marble-look tub surround, white vanity and matte black faucet"
      },
      {
        "src": "2026/05/kka6-scaled.jpg",
        "caption": "White vanity and black hardware",
        "alt": "Secondary suite bathroom with white vanity, black faucet and matching black towel bar"
      },
      {
        "src": "2026/05/kka7-scaled.jpg",
        "caption": "Living room with recessed lighting",
        "alt": "Finished basement suite living room with recessed lighting and doors to bedroom and bath"
      },
      {
        "src": "2026/05/kka8-scaled.jpg",
        "caption": "Living area by the suite stairs",
        "alt": "Basement suite living area with pot lights next to the staircase"
      },
      {
        "src": "2025/11/tt1-scaled.jpg",
        "caption": "Bedroom with walk-in closet",
        "alt": "Secondary suite bedroom with walk-in closet, new doors and vinyl plank flooring"
      },
      {
        "src": "2025/11/tt2-scaled.jpg",
        "caption": "Compact bath with modern vanity",
        "alt": "Secondary suite bathroom with modern vanity, toilet and soaker tub"
      },
      {
        "src": "2025/11/tt3-scaled.jpg",
        "caption": "Vanity beside soaker tub",
        "alt": "Basement suite bathroom with white vanity top, toilet and soaker tub"
      },
      {
        "src": "2025/11/tt4-scaled.jpg",
        "caption": "Open living area to the kitchen",
        "alt": "Long view of a finished basement suite with pot lights, grey vinyl plank floor and kitchen at the end"
      },
      {
        "src": "2025/11/tt5-scaled.jpg",
        "caption": "Suite kitchen with blue stainless fridge",
        "alt": "Basement suite kitchen with blue stainless fridge, white cabinets and range under a window"
      },
      {
        "src": "2025/11/tt6-scaled.jpg",
        "caption": "Range, microwave and grey tile backsplash",
        "alt": "Secondary suite kitchen with stainless range, over-range microwave and grey tile backsplash"
      },
      {
        "src": "2025/11/tt7-scaled.jpg",
        "caption": "Hallway beside the suite kitchen",
        "alt": "Basement suite hallway with pot lights beside the kitchen refrigerator"
      },
      {
        "src": "2025/11/tt8-scaled.jpg",
        "caption": "Bright stairwell down to suite",
        "alt": "Bright, finished stairwell leading down to a secondary suite"
      },
      {
        "src": "2025/11/1-4-scaled.jpg",
        "caption": "Framing and mechanical rough-in",
        "alt": "Basement suite under construction with new framing, ductwork and insulation"
      },
      {
        "src": "2025/11/3-2-scaled.jpg",
        "caption": "Installing new ductwork",
        "alt": "Installer fitting new ductwork during legal basement suite construction in Calgary"
      },
      {
        "src": "2025/11/6-1.jpg",
        "caption": "Insulated, framed exterior walls",
        "alt": "Framed and insulated basement walls with vapour barrier for a secondary suite"
      },
      {
        "src": "2025/11/7-1.jpg",
        "caption": "Bulkhead framing around ducts",
        "alt": "Bulkhead framing built around ducts and mechanicals during basement suite construction"
      },
      {
        "src": "2025/11/8-1-1.jpg",
        "caption": "Vapour barrier before drywall",
        "alt": "Insulated basement wall with vapour barrier installed before drywall in a secondary suite"
      },
      {
        "src": "2025/11/10-1.jpg",
        "caption": "Drywall hung around the mechanical",
        "alt": "Basement suite with new drywall hung around the furnace and ductwork"
      },
      {
        "src": "2025/11/12-2.jpg",
        "caption": "Drywall taping in progress",
        "alt": "Drywall taping and mudding in progress during secondary suite construction"
      },
      {
        "src": "2025/11/13-1.jpg",
        "caption": "Mudded drywall ready for paint",
        "alt": "Mudded drywall in a basement suite ready for sanding and paint"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What makes a secondary suite legal in Calgary?",
        "a": "A legal suite must meet Calgary's land use bylaw and the building code, which cover items such as fire separation, smoke alarms, ventilation, egress windows, ceiling height and a separate entrance. It also needs the right permits and passed inspections. We plan and build to those requirements from the start."
      },
      {
        "q": "Do you handle the permits?",
        "a": "Yes. We understand Calgary's secondary suite bylaws, zoning rules and permit process, and we handle permits as part of your project along with suite design, construction and finishing."
      },
      {
        "q": "Can you bring an existing basement suite up to code?",
        "a": "Yes. We upgrade older basement apartments and secondary suites with safety improvements, structural fixes, new finishes and energy-efficient upgrades so the unit can become fully legal."
      },
      {
        "q": "Do you build garage and backyard suites too?",
        "a": "Yes. Along with basement suites, we design and build garage suites, laneway homes and backyard suites that provide a fully independent living space separate from the main house."
      },
      {
        "q": "How long does a secondary suite take to build?",
        "a": "It depends on the type of suite, the existing condition of the space, permit approval times and inspection scheduling. We provide a schedule with your quote once the design and scope are set."
      },
      {
        "q": "What warranty do you provide?",
        "a": "Warranty and workmanship terms are set out in writing with your quote. MRE Developments is licensed and insured, and we review those terms with you before construction starts."
      }
    ],
    "ctaTitle": "Start Your Legal Suite Project",
    "ctaSubtitle": "Tell us about your property and whether you are planning a basement, garage or backyard suite. We will follow up with a free, detailed quote.",
    "projects": [
      {
        "title": "Wood-panelled basement turned bright suite",
        "summary": "Panelling, carpet and dated kitchen replaced with white walls, new flooring, kitchen and mechanical room.",
        "dates": "Jul 2023 – Aug 2024",
        "photos": [
          "2025/11/1-3-scaled.jpg",
          "2025/11/3-1-scaled.jpg",
          "2025/11/5-1-scaled.jpg",
          "2025/11/7-scaled.jpg",
          "2025/11/9-1-scaled.jpg",
          "2025/11/11-1-scaled.jpg",
          "2025/11/13-scaled.jpg",
          "2025/11/15-1-scaled.jpg",
          "2025/11/2-2-scaled.jpg",
          "2025/11/4-12-scaled.jpg",
          "2025/11/6-scaled.jpg",
          "2025/11/8-1-scaled.jpg",
          "2025/11/10-scaled.jpg",
          "2025/11/12-1-scaled.jpg",
          "2025/11/14-scaled.jpg",
          "2025/11/16-1-scaled.jpg"
        ]
      },
      {
        "title": "Panelled basement converted to modern suite",
        "summary": "Wood panelling and carpet tiles replaced with a new kitchen, bathroom, glass shower and flooring.",
        "dates": "May 2025 – Mar 2026",
        "photos": [
          "2026/05/13-3-scaled.jpg",
          "2026/05/15-1-scaled.jpg",
          "2026/05/19-scaled.jpg",
          "2026/05/21-scaled.jpg",
          "2026/05/5-5-scaled.jpg",
          "2026/05/7-5-scaled.jpg",
          "2026/05/9-3-scaled.jpg",
          "2026/05/11-4-scaled.jpg",
          "2026/05/6-5-scaled.jpg",
          "2026/05/8-5-scaled.jpg",
          "2026/05/10-4-scaled.jpg",
          "2026/05/12-5-scaled.jpg",
          "2026/05/14-2-scaled.jpg",
          "2026/05/16-1-scaled.jpg",
          "2026/05/20-scaled.jpg",
          "2026/05/22-scaled.jpg"
        ]
      },
      {
        "title": "Suite with wood-grain kitchen",
        "summary": "Finished suite with light wood-grain cabinets, quartz counters, black faucet and full bathroom.",
        "dates": "Jun 2024",
        "photos": [
          "2025/11/q1-scaled.jpg",
          "2025/11/q4-scaled.jpg",
          "2025/11/q6-scaled.jpg",
          "2025/11/q5-1.jpg"
        ]
      },
      {
        "title": "Suite with grey shaker kitchen",
        "summary": "Finished suite with shaker cabinets, dark tile backsplash, new flooring and full bathroom.",
        "dates": "Mar 2026",
        "photos": [
          "2026/05/kka1-scaled.jpg",
          "2026/05/kka2-scaled.jpg",
          "2026/05/kka3-scaled.jpg",
          "2026/05/kka4-scaled.jpg",
          "2026/05/kka5-scaled.jpg",
          "2026/05/kka6-scaled.jpg",
          "2026/05/kka7-scaled.jpg",
          "2026/05/kka8-scaled.jpg"
        ]
      },
      {
        "title": "Suite with open kitchen and grey flooring",
        "summary": "Finished suite with white kitchen, grey plank flooring, bathroom and lit stairwell.",
        "dates": "Jan 2025",
        "photos": [
          "2025/11/tt1-scaled.jpg",
          "2025/11/tt2-scaled.jpg",
          "2025/11/tt3-scaled.jpg",
          "2025/11/tt4-scaled.jpg",
          "2025/11/tt5-scaled.jpg",
          "2025/11/tt6-scaled.jpg",
          "2025/11/tt7-scaled.jpg",
          "2025/11/tt8-scaled.jpg"
        ]
      },
      {
        "title": "Suite build from framing to drywall",
        "summary": "In-progress suite: ductwork, framing, insulation, vapour barrier, drywall and mudding.",
        "dates": "Oct 2022",
        "photos": [
          "2025/11/1-4-scaled.jpg",
          "2025/11/3-2-scaled.jpg",
          "2025/11/6-1.jpg",
          "2025/11/7-1.jpg",
          "2025/11/8-1-1.jpg",
          "2025/11/10-1.jpg",
          "2025/11/12-2.jpg",
          "2025/11/13-1.jpg"
        ]
      }
    ]
  },
  "side-entries": {
    "metaTitle": "Side & Separate Entries Calgary | MRE Developments",
    "metaDescription": "Side and separate basement entries in Calgary and area, engineered and permitted for legal suites. Built by MRE Developments. Request a free quote today.",
    "headline": "Side and Separate Entries in Calgary, Engineered and Permitted",
    "subheadline": "Need a private entrance for a basement suite or easier access to your home? We cut, form, pour and finish code-compliant entries, with engineering and City permits handled for you.",
    "hero": "2026/02/kk8-scaled.jpg",
    "heroAlt": "Finished below-grade separate entry in Calgary with poured concrete stairwell, black handrail and top railing",
    "overviewTitle": "Separate Entries Done Right",
    "summary": "MRE Developments builds side entries and basement separate entries for homes and secondary suites across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our engineers and designers manage planning and City of Calgary permit approvals, and our crew handles excavation, foundation cutting, concrete and finishing. Every entry is built to Calgary building code for safety and long-term durability.",
    "highlights": [
      "Basement separate entries for legal suites",
      "Grade-level side doors and mudroom access",
      "Engineered designs for foundation openings",
      "City of Calgary permit approvals managed",
      "Precise foundation cutting and concrete work",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Private Access for Suites",
        "body": "A separate entrance is a key requirement for most legal basement suites, and it gives tenants or family members their own way in. We build below-grade stairwells with poured concrete walls, steps and railings, finished to look like they belong to the house.",
        "benefit": "A safe, code-compliant entry that supports a legal suite and adds rental value.",
        "image": "2026/02/qq8-7-scaled.jpg",
        "imageAlt": "New poured concrete stairwell leading down to a basement separate entry beside a Calgary home"
      },
      {
        "title": "Precision Foundation Cutting",
        "body": "Opening a foundation wall is structural work. We follow an engineered design, excavate safely, and cut the opening with track-mounted wall saws for clean, square edges before installing the header, framing and door.",
        "benefit": "A clean opening that protects your foundation and keeps the house structurally sound.",
        "image": "2026/02/kk6-scaled.jpg",
        "imageAlt": "Operator cutting a concrete foundation wall with a track-mounted wall saw for a new separate entry"
      },
      {
        "title": "Entries Designed for Your Home",
        "body": "Not every entry goes below grade. We also build grade-level side doors and mudroom access points, with your choice of layout, doors, steps and finishes, so the entry is either discreet or a clear architectural feature.",
        "benefit": "An entry that improves daily convenience and suits your home's exterior.",
        "image": "2026/02/20241015_171931-scaled.jpg",
        "imageAlt": "New grade-level side entry door with white trim set into red siding on a Calgary house"
      }
    ],
    "galleryIntro": "Side and separate entries our crew has built in Calgary, from the first excavation and foundation cut to the finished stairwell.",
    "photos": [
      {
        "src": "2026/02/qq1-scaled.jpg",
        "caption": "Before: side yard ready for entry",
        "alt": "Before construction: side yard of a Calgary home where a separate entry was planned"
      },
      {
        "src": "2026/02/qq2-scaled.jpg",
        "caption": "Excavating along the foundation",
        "alt": "Excavation along a foundation wall with wheelbarrow and form tube for a separate entry"
      },
      {
        "src": "2026/02/qq3-scaled.jpg",
        "caption": "Checking rebar spacing",
        "alt": "Installer measuring rebar spacing before concrete is poured for a separate entry"
      },
      {
        "src": "2026/02/qq4-scaled.jpg",
        "caption": "Cutting the foundation in the excavation",
        "alt": "Worker cutting a concrete foundation wall inside an excavation for a separate entry"
      },
      {
        "src": "2026/02/qq5-scaled.jpg",
        "caption": "Excavation and forms beside the house",
        "alt": "Excavation beside a house with forms and opening prepared for a basement separate entry"
      },
      {
        "src": "2026/02/qq6-scaled.jpg",
        "caption": "Cutting lumber for forms",
        "alt": "Crew cutting lumber on site for side entry formwork"
      },
      {
        "src": "2026/02/qq7-1-scaled.jpg",
        "caption": "New walkway along the side entry",
        "alt": "Side of a Calgary home with new concrete walkway serving a separate entry"
      },
      {
        "src": "2026/02/qq8-7-scaled.jpg",
        "caption": "Poured concrete stairs to basement door",
        "alt": "Finished side entry with poured concrete stairs leading down to a basement suite door"
      },
      {
        "src": "2026/02/kk1-scaled.jpg",
        "caption": "Excavating the side yard",
        "alt": "Narrow side yard excavated and braced for a below-grade separate entry"
      },
      {
        "src": "2026/02/kk2-scaled.jpg",
        "caption": "Cutting stock for the formwork",
        "alt": "Worker cutting lumber with a circular saw for separate entry formwork"
      },
      {
        "src": "2026/02/kk3-scaled.jpg",
        "caption": "Formwork for the stairwell walls",
        "alt": "Timber formwork set up for the concrete walls of a separate entry stairwell"
      },
      {
        "src": "2026/02/kk4-scaled.jpg",
        "caption": "Poured stairwell walls and landing",
        "alt": "Newly poured concrete walls and landing for a below-grade separate entry"
      },
      {
        "src": "2026/02/kk5-scaled.jpg",
        "caption": "Finishing the cut concrete edges",
        "alt": "Worker dressing the cut edges of a foundation opening with a power tool"
      },
      {
        "src": "2026/02/kk6-scaled.jpg",
        "caption": "Track-mounted saw cutting the foundation",
        "alt": "Track-mounted wall saw cutting a foundation opening for a separate basement entry"
      },
      {
        "src": "2026/02/kk7-scaled.jpg",
        "caption": "Opening ready for the entry step",
        "alt": "Cut foundation opening with concrete step placed at the base of a separate entry"
      },
      {
        "src": "2026/02/kk8-scaled.jpg",
        "caption": "Finished stairwell with handrail and railing",
        "alt": "Completed separate basement entry in Calgary with concrete stairwell, black handrail and top railing"
      },
      {
        "src": "2026/02/20240628_154918-1-scaled.jpg",
        "caption": "Before: wall chosen for side door",
        "alt": "Before construction: exterior wall with red siding chosen for a new side entry"
      },
      {
        "src": "2026/02/20240916_092404-1-scaled.jpg",
        "caption": "Wall saw set on the foundation",
        "alt": "Concrete wall saw mounted on a foundation wall under red siding for a side entry"
      },
      {
        "src": "2026/02/20240916_093054-scaled.jpg",
        "caption": "Laying out the opening on siding",
        "alt": "Crew member laying out the new side entry opening on red exterior siding"
      },
      {
        "src": "2026/02/20240916_100612-scaled.jpg",
        "caption": "Foundation opening cut and cleared",
        "alt": "Foundation wall opening cut and cleared below the siding for a new side entry"
      },
      {
        "src": "2026/02/20240916_115838-scaled.jpg",
        "caption": "Marking the door location",
        "alt": "Crew marking the door location on red siding before cutting a side entry"
      },
      {
        "src": "2026/02/20240916_124224-scaled.jpg",
        "caption": "Framing the new door opening",
        "alt": "Carpenter framing and sheathing a new side entry door opening in an exterior wall"
      },
      {
        "src": "2026/02/20240916_134817-scaled.jpg",
        "caption": "Preparing form boards on site",
        "alt": "Worker measuring lumber on the lawn to build forms for a separate entry"
      },
      {
        "src": "2026/02/20241015_171931-scaled.jpg",
        "caption": "Grade-level side door in red siding",
        "alt": "New grade-level side entry door with white trim in red siding on a Calgary home"
      }
    ],
    "videos": [
      "2025/11/11-1.mp4"
    ],
    "faqs": [
      {
        "q": "Do I need a permit for a separate basement entry in Calgary?",
        "a": "Yes, cutting a new opening in a foundation and building a stairwell requires permits in Calgary. Our engineers and designers prepare the plans and manage the City of Calgary permit approval process from start to finish."
      },
      {
        "q": "Is a separate entrance required for a legal basement suite?",
        "a": "In most cases a legal secondary suite needs its own entrance that meets code. We build basement separate entries designed specifically to support legal suite requirements, and we can coordinate them with a full suite build."
      },
      {
        "q": "Will cutting into my foundation weaken my house?",
        "a": "Not when it is done properly. Each opening follows an engineered design, is cut cleanly with wall saws, and receives the required header and structural support before the door is installed."
      },
      {
        "q": "Can you build a side door at ground level instead?",
        "a": "Yes. Where the grade allows, we build residential side entries such as mudroom access points and private side doors, with steps, doors and finishes chosen to suit your home."
      },
      {
        "q": "How long does a side entry project take?",
        "a": "The timeline depends on permit approvals, excavation depth, soil conditions, concrete curing and weather. We provide a schedule with your quote once the design is confirmed."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We build side and separate entries throughout Calgary and in Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River. Warranty and workmanship terms are provided in writing with every quote."
      }
    ],
    "ctaTitle": "Plan Your Side or Separate Entry",
    "ctaSubtitle": "Tell us about your home and how the entry will be used. We will follow up to arrange a free, detailed quote.",
    "projects": [
      {
        "title": "Side entry with full concrete stairwell",
        "summary": "Excavation, rebar, foundation cut, formwork and a finished concrete stairwell beside the house.",
        "dates": "Sep 2023 – Jan 2024",
        "photos": [
          "2026/02/qq1-scaled.jpg",
          "2026/02/qq2-scaled.jpg",
          "2026/02/qq3-scaled.jpg",
          "2026/02/qq4-scaled.jpg",
          "2026/02/qq5-scaled.jpg",
          "2026/02/qq6-scaled.jpg",
          "2026/02/qq7-1-scaled.jpg",
          "2026/02/qq8-7-scaled.jpg"
        ]
      },
      {
        "title": "Side entry stairwell with railing",
        "summary": "Excavation, formwork, poured walls, foundation cut and finished stairs with handrail and railing.",
        "dates": "Jul 2023 – Nov 2023",
        "photos": [
          "2026/02/kk1-scaled.jpg",
          "2026/02/kk2-scaled.jpg",
          "2026/02/kk3-scaled.jpg",
          "2026/02/kk4-scaled.jpg",
          "2026/02/kk5-scaled.jpg",
          "2026/02/kk6-scaled.jpg",
          "2026/02/kk7-scaled.jpg",
          "2026/02/kk8-scaled.jpg"
        ]
      },
      {
        "title": "Side door cut through foundation wall",
        "summary": "Foundation saw-cut, header framing and sheathing, finished with a new exterior door.",
        "dates": "Jun 2024 – Oct 2024",
        "photos": [
          "2026/02/20240628_154918-1-scaled.jpg",
          "2026/02/20240916_092404-1-scaled.jpg",
          "2026/02/20240916_093054-scaled.jpg",
          "2026/02/20240916_100612-scaled.jpg",
          "2026/02/20240916_115838-scaled.jpg",
          "2026/02/20240916_124224-scaled.jpg",
          "2026/02/20240916_134817-scaled.jpg",
          "2026/02/20241015_171931-scaled.jpg"
        ]
      }
    ]
  },
  "structural-renovations": {
    "metaTitle": "Load-Bearing Wall Removal Calgary | MRE Developments",
    "metaDescription": "Load-bearing wall removal, engineered beams and open-concept renovations in Calgary and area, with engineering and permits coordinated. Get a free quote.",
    "headline": "Load-Bearing Wall Removal and Open-Concept Renovations in Calgary",
    "subheadline": "Open up closed-off kitchens and living rooms safely. We coordinate engineering, permits and inspections, install the beams and posts, and leave you with a bright, open layout.",
    "hero": "2026/05/xz8-scaled.jpg",
    "heroAlt": "Open-concept kitchen and living area after load-bearing wall removal in a Calgary home",
    "overviewTitle": "Open Up Your Home the Right Way",
    "summary": "MRE Developments helps Calgary homeowners turn compartmentalized floor plans into open, light-filled spaces through load-bearing wall removal, beam installation and engineered structural modifications. We work with qualified engineers and manage the project from planning, drawings and permits through construction and final inspection. Homeowners in Calgary, Airdrie, Cochrane and Okotoks get one licensed and insured team responsible for the structure and the finish.",
    "highlights": [
      "Load-bearing wall removal",
      "LVL, engineered wood and steel beams",
      "Posts and load paths to the foundation",
      "Open-concept kitchens and living areas",
      "Engineering, permits and inspections coordinated",
      "Structural work for suites and basements"
    ],
    "features": [
      {
        "title": "Open-Concept Living, Done Safely",
        "body": "Many older homes have closed kitchens, narrow openings and walls that block natural light. We remove structural walls and replace them with properly engineered support, combining rooms into the open kitchen, dining and living space modern families want.",
        "benefit": "Better flow, more natural light and a layout that suits the way you live.",
        "image": "2026/05/q4-1-scaled.jpg",
        "imageAlt": "Bright open living area with a large window after a structural wall was removed in a Calgary home"
      },
      {
        "title": "Engineered Beams and Load Paths",
        "body": "Every opening needs a beam sized for the loads above it and posts that carry those loads down to the foundation. We install LVL, engineered wood and steel beam systems designed for your project, with solid bearing points and a continuous load path.",
        "benefit": "A wide-open space that is structurally sound and built to perform for decades.",
        "image": "2026/06/ee6-scaled.jpg",
        "imageAlt": "Carpenter fitting a steel beam into floor joists during a structural renovation in a Calgary basement"
      },
      {
        "title": "Suites, Basements and Reconfigured Layouts",
        "body": "Creating a legal suite, finishing a basement or reworking room layouts often means moving structure. We plan these modifications with an engineer, coordinate drawings and municipal approvals, and complete the work for homes across Calgary, Chestermere, Strathmore and High River.",
        "benefit": "More usable space from your home without compromising its structural integrity.",
        "image": "2026/06/ee8-scaled.jpg",
        "imageAlt": "New steel beam spanning a basement with framed walls below during a structural modification"
      }
    ],
    "galleryIntro": "Before, during and after photos from load-bearing wall removals and open-concept renovations in Calgary.",
    "photos": [
      {
        "src": "2026/05/xz1-scaled.jpg",
        "caption": "Before: closed-off kitchen layout",
        "alt": "Closed-off kitchen behind a partition wall before a structural renovation in Calgary"
      },
      {
        "src": "2026/05/xz2-scaled.jpg",
        "caption": "Temporary shoring at the opening",
        "alt": "Carpenter installing temporary shoring under a ceiling before removing a load-bearing wall"
      },
      {
        "src": "2026/05/xz3-scaled.jpg",
        "caption": "Kitchen stripped for the new layout",
        "alt": "Kitchen stripped to the studs with the wall opened during an open-concept renovation"
      },
      {
        "src": "2026/05/xz4-scaled.jpg",
        "caption": "Opening up the drywall",
        "alt": "Worker cutting drywall with an oscillating tool to expose a structural wall"
      },
      {
        "src": "2026/05/xz5-scaled.jpg",
        "caption": "Cutting out the old wall",
        "alt": "Worker cutting out wall framing with a reciprocating saw during a structural renovation"
      },
      {
        "src": "2026/06/xz6-scaled.jpg",
        "caption": "Fastening the new header",
        "alt": "Carpenter fastening a new header at the ceiling during an open-concept renovation"
      },
      {
        "src": "2026/05/xz7-scaled.jpg",
        "caption": "Opened main floor with new posts",
        "alt": "Main floor opened up with new structural posts and pot lights during an open-concept renovation"
      },
      {
        "src": "2026/05/xz8-scaled.jpg",
        "caption": "Open kitchen with structural posts finished",
        "alt": "Finished open-concept kitchen with drywalled structural posts after load-bearing wall removal in Calgary"
      },
      {
        "src": "2026/05/v1-scaled.jpg",
        "caption": "Before: kitchen hidden behind a wall",
        "alt": "Room before structural renovation showing a wall separating the kitchen from the living area"
      },
      {
        "src": "2026/05/q1-2-scaled.jpg",
        "caption": "Before: wall with pass-through window",
        "alt": "Living room before renovation with a closed wall and small pass-through to the kitchen"
      },
      {
        "src": "2026/05/v3-scaled.jpg",
        "caption": "Before: narrow doorway and opening",
        "alt": "Living room before load-bearing wall removal with a narrow doorway and pass-through"
      },
      {
        "src": "2026/05/q3-scaled.jpg",
        "caption": "Before: dark dining room",
        "alt": "Dark dining room with a pass-through window before an open-concept renovation"
      },
      {
        "src": "2026/05/v4-scaled.jpg",
        "caption": "Living and kitchen joined as one",
        "alt": "Open-concept living room flowing into the kitchen after a structural renovation in Calgary"
      },
      {
        "src": "2026/05/q2-scaled.jpg",
        "caption": "Living room opened to the hallway",
        "alt": "Bright living room opened up after a structural wall was removed in a Calgary renovation"
      },
      {
        "src": "2026/05/v2-scaled.jpg",
        "caption": "Kitchen opened to the living area",
        "alt": "Renovated kitchen opened to the living area following load-bearing wall removal"
      },
      {
        "src": "2026/05/q4-1-scaled.jpg",
        "caption": "Former wall now a wide opening",
        "alt": "Open living space with a large window after load-bearing wall removal in a Calgary home"
      },
      {
        "src": "2026/06/ee1-scaled.jpg",
        "caption": "Drilling for beam connections",
        "alt": "Carpenter drilling into framing to connect a new beam in a basement structural renovation"
      },
      {
        "src": "2026/06/ee2-scaled.jpg",
        "caption": "Fastening the steel beam plate",
        "alt": "Drill fastening into a steel beam during a structural renovation in a Calgary basement"
      },
      {
        "src": "2026/06/ee3-scaled.jpg",
        "caption": "Basement framing around the new beam",
        "alt": "Basement ceiling joists and framing being reworked around a new structural beam"
      },
      {
        "src": "2026/06/ee4-scaled.jpg",
        "caption": "Cutting a bearing block to size",
        "alt": "Carpenter cutting a wood bearing block with a circular saw for a new beam support"
      },
      {
        "src": "2026/06/ee5-scaled.jpg",
        "caption": "Crew working under the new beam",
        "alt": "Renovation crew working beneath a newly installed beam during a basement structural modification"
      },
      {
        "src": "2026/06/ee6-scaled.jpg",
        "caption": "Fitting a steel beam into joists",
        "alt": "Carpenter fitting a steel beam into floor joists during load-bearing wall removal"
      },
      {
        "src": "2026/06/ee7-scaled.jpg",
        "caption": "Levelling the new beam",
        "alt": "Level placed on a new steel beam to confirm alignment during a structural renovation"
      },
      {
        "src": "2026/06/ee8-scaled.jpg",
        "caption": "Steel beam spanning the basement",
        "alt": "New steel beam spanning a basement ceiling during a structural renovation in Calgary"
      },
      {
        "src": "2026/06/20260401_132755-scaled.jpg",
        "caption": "Open dining area beside the stairs",
        "alt": "Open dining area beside a staircase after wall removal in a Calgary structural renovation"
      },
      {
        "src": "2026/06/20260420_115515-scaled.jpg",
        "caption": "Studs and ducts exposed in the wall",
        "alt": "Load-bearing wall opened to show studs and ductwork before beam installation"
      },
      {
        "src": "2026/06/20260428_125825-scaled.jpg",
        "caption": "Duct routed through the wall cavity",
        "alt": "Metal duct running through an opened wall cavity before load-bearing wall removal"
      },
      {
        "src": "2026/06/20260428_125843-scaled.jpg",
        "caption": "Drain stack inside the old wall",
        "alt": "Black drain stack exposed inside an opened wall during a structural renovation"
      },
      {
        "src": "2026/06/20260520_111845-scaled.jpg",
        "caption": "Installing support at the ceiling",
        "alt": "Carpenter installing structural support at the ceiling during load-bearing wall removal"
      },
      {
        "src": "2026/06/20260527_103109-scaled.jpg",
        "caption": "Marking lumber for the new posts",
        "alt": "Carpenter marking lumber with a speed square for new structural posts"
      },
      {
        "src": "2026/06/20260527_111903-scaled.jpg",
        "caption": "Cutting engineered lumber to length",
        "alt": "Carpenter cutting engineered lumber with a circular saw for a new beam"
      },
      {
        "src": "2026/06/20260531_195818-scaled.jpg",
        "caption": "Wall framing opened to the room",
        "alt": "Load-bearing wall opened down to its framing during an open-concept renovation in Calgary"
      }
    ],
    "videos": [
      "2026/06/q1-1.mp4"
    ],
    "faqs": [
      {
        "q": "Can any wall in my home be removed?",
        "a": "Many load-bearing walls can be removed or opened up, but the loads they carry must be identified and transferred to a properly designed beam and posts. Some walls also contain ducts, plumbing or wiring that need to be rerouted. We assess the wall and work with an engineer to confirm the right solution before any work begins."
      },
      {
        "q": "Do I need an engineer and a permit to remove a load-bearing wall?",
        "a": "Structural modifications typically require engineered drawings and municipal approval. We coordinate the engineering, drawings, permits and inspections as part of the project so you do not have to manage them yourself."
      },
      {
        "q": "What kind of beam will be used?",
        "a": "That depends on the span and the loads above. We install LVL, engineered wood and steel beam systems, sized by the engineer for your project, along with the posts and footings needed to carry the load to the foundation."
      },
      {
        "q": "How long does a load-bearing wall removal take?",
        "a": "The timeline depends on the span, beam type, any services in the wall that need rerouting, engineering and permit approvals, inspections and the finishing work afterward. Your quote includes a project schedule."
      },
      {
        "q": "Which areas do you serve?",
        "a": "We complete structural renovations across Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "What warranty do you provide?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know exactly what is covered before work starts."
      }
    ],
    "ctaTitle": "Plan Your Open-Concept Renovation",
    "ctaSubtitle": "Tell us which walls you would like to open up and we will prepare a free, detailed quote that covers engineering, permits and construction.",
    "projects": [
      {
        "title": "Load-bearing wall removal for open kitchen",
        "summary": "Closed-off rooms before, wall opened and posts set, finished as an open kitchen and living area.",
        "dates": "Aug 2024 – Nov 2024",
        "photos": [
          "2026/05/xz1-scaled.jpg",
          "2026/05/xz2-scaled.jpg",
          "2026/05/xz3-scaled.jpg",
          "2026/05/xz4-scaled.jpg",
          "2026/05/xz5-scaled.jpg",
          "2026/06/xz6-scaled.jpg",
          "2026/05/xz7-scaled.jpg",
          "2026/05/xz8-scaled.jpg"
        ]
      },
      {
        "title": "Main floor opened up with new flooring",
        "summary": "Before: pass-through window and hardwood. After: wall opened, new plank flooring and lighting.",
        "dates": "Feb 2025 – Sep 2025",
        "photos": [
          "2026/05/v1-scaled.jpg",
          "2026/05/q1-2-scaled.jpg",
          "2026/05/v3-scaled.jpg",
          "2026/05/q3-scaled.jpg",
          "2026/05/v4-scaled.jpg",
          "2026/05/q2-scaled.jpg",
          "2026/05/v2-scaled.jpg",
          "2026/05/q4-1-scaled.jpg"
        ]
      },
      {
        "title": "Basement beam installation and joist support",
        "summary": "Steel beam set, levelled and anchored under the floor joists with new framing.",
        "dates": "Mar 2025",
        "photos": [
          "2026/06/ee1-scaled.jpg",
          "2026/06/ee2-scaled.jpg",
          "2026/06/ee3-scaled.jpg",
          "2026/06/ee4-scaled.jpg",
          "2026/06/ee5-scaled.jpg",
          "2026/06/ee6-scaled.jpg",
          "2026/06/ee7-scaled.jpg",
          "2026/06/ee8-scaled.jpg"
        ]
      },
      {
        "title": "Main floor wall opening with rerouted ducts",
        "summary": "Wall stripped to studs, ductwork and drain rerouted, new lumber cut for the opening.",
        "dates": "Apr 2026 – May 2026",
        "photos": [
          "2026/06/20260401_132755-scaled.jpg",
          "2026/06/20260420_115515-scaled.jpg",
          "2026/06/20260428_125825-scaled.jpg",
          "2026/06/20260428_125843-scaled.jpg",
          "2026/06/20260520_111845-scaled.jpg",
          "2026/06/20260527_103109-scaled.jpg",
          "2026/06/20260527_111903-scaled.jpg",
          "2026/06/20260531_195818-scaled.jpg"
        ]
      }
    ]
  },
  "stucco": {
    "metaTitle": "Stucco & Parging Calgary | MRE Developments",
    "metaDescription": "Stucco installation, repairs, parging and foundation crack sealing in Calgary, Airdrie, Cochrane and Okotoks. Residential and commercial. Get a free quote.",
    "headline": "Calgary Stucco & Parging Built for Alberta Winters",
    "subheadline": "New stucco, re-stucco over old siding, repairs and foundation parging for homes, multi-family and commercial buildings, with textures matched and moisture kept out.",
    "hero": "2026/03/uu4-scaled.jpg",
    "heroAlt": "Finished grey stucco exterior around a white entry door and windows on a Calgary home",
    "overviewTitle": "Exterior Finishes That Protect",
    "summary": "MRE Developments installs and repairs stucco for single-family homes, multi-family buildings and commercial properties across Calgary, Airdrie, Cochrane, Okotoks, Chestermere and Strathmore. We also provide parging and foundation crack sealing to protect concrete and masonry from moisture. Every system is applied in proper coats over mesh and lath, with textures and colours chosen to suit your building.",
    "highlights": [
      "Single-family, multi-family and commercial stucco",
      "California textured and smooth finishes",
      "Stucco repairs with matched texture",
      "Foundation parging and crack sealing",
      "Woodpecker damage repair and proofing",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "New Stucco and Re-Stucco",
        "body": "We apply complete stucco systems to new builds and to existing homes whose siding or old finish needs replacing. Windows, doors and soffits are masked so edges finish cleanly against trim.",
        "benefit": "A durable, weather-resistant exterior that sharpens your home's curb appeal.",
        "image": "2026/04/uu3-scaled.jpg",
        "imageAlt": "Plasterer finishing a grey stucco side wall of a Calgary home with a hand trowel"
      },
      {
        "title": "Applied in Proper Coats",
        "body": "Each wall gets a base coat troweled into reinforcing mesh, followed by a finish coat once the base is ready. Working in layers this way is what gives stucco its strength and helps it resist cracking through freeze-thaw cycles.",
        "benefit": "An exterior shell that holds up to Calgary's cold winters and chinooks.",
        "image": "2026/03/uu2-scaled.jpg",
        "imageAlt": "Stucco base coat being troweled over reinforcing mesh on an exterior wall"
      },
      {
        "title": "Textures, Repairs and Parging",
        "body": "Choose California textured or smooth flat stucco, or let us match an existing finish when repairing cracks, impact or woodpecker damage. Parging adds a protective coat over exposed foundation walls and seals cracks against moisture.",
        "benefit": "Repairs that blend in and foundations protected from water.",
        "image": "2026/03/uu7-scaled.jpg",
        "imageAlt": "Smooth stucco finish coat being applied beside a textured base coat on a house wall"
      }
    ],
    "galleryIntro": "Stucco projects in progress and complete, showing the coats, masking and texture work on Calgary homes.",
    "photos": [
      {
        "src": "2026/03/uu1-scaled.jpg",
        "caption": "Exterior before new stucco",
        "alt": "House exterior with dark siding and entry door before stucco installation"
      },
      {
        "src": "2026/03/uu2-scaled.jpg",
        "caption": "Base coat into reinforcing mesh",
        "alt": "Stucco base coat troweled into reinforcing mesh on a house wall"
      },
      {
        "src": "2026/03/uu3-scaled.jpg",
        "caption": "Hawk and trowel at soffit",
        "alt": "Plasterer working stucco from a hawk under the soffit"
      },
      {
        "src": "2026/03/uu4-scaled.jpg",
        "caption": "Finished grey stucco at entry",
        "alt": "Finished grey stucco around a white entry door and windows on a Calgary home"
      },
      {
        "src": "2026/03/uu5-scaled.jpg",
        "caption": "Windows masked before stucco",
        "alt": "Plasterer applying stucco beside a window masked with green tape"
      },
      {
        "src": "2026/03/uu6-scaled.jpg",
        "caption": "Finish over textured scratch coat",
        "alt": "Plasterer applying stucco over a textured scratch coat on a Calgary home"
      },
      {
        "src": "2026/03/uu7-scaled.jpg",
        "caption": "Smooth coat beside textured base",
        "alt": "Smooth stucco coat applied beside textured base coat on an exterior wall"
      },
      {
        "src": "2026/03/uu8-scaled.jpg",
        "caption": "Troweling finish under soffit",
        "alt": "Plasterer troweling a grey stucco finish coat under the soffit"
      },
      {
        "src": "2026/04/uu2-scaled.jpg",
        "caption": "Stucco detail at the roofline",
        "alt": "Plasterer finishing stucco up to the roofline on a two-storey home"
      },
      {
        "src": "2026/04/uu3-scaled.jpg",
        "caption": "Full side wall in grey stucco",
        "alt": "Plasterer finishing a full side wall in grey stucco on a Calgary house"
      },
      {
        "src": "2026/04/uu1-scaled.jpg",
        "caption": "Clean line beneath fascia",
        "alt": "Stucco being finished cleanly beneath dark fascia trim"
      },
      {
        "src": "2026/04/uu4-scaled.jpg",
        "caption": "Stucco mix on the hawk",
        "alt": "Hawk loaded with fresh stucco mix on a scaffold"
      },
      {
        "src": "2026/04/uu5-scaled.jpg",
        "caption": "Crew working from scaffold",
        "alt": "Two plasterers applying stucco from scaffolding on a residential exterior"
      },
      {
        "src": "2026/04/uu6-scaled.jpg",
        "caption": "Tight edge at the trim line",
        "alt": "Stucco being troweled to a taped edge along exterior trim"
      },
      {
        "src": "2026/04/uu7-scaled.jpg",
        "caption": "Hand-troweled finish detail",
        "alt": "Close-up of a trowel smoothing a grey stucco finish coat"
      },
      {
        "src": "2026/04/uu8-scaled.jpg",
        "caption": "Finish coat around masked window",
        "alt": "Stucco crew applying the finish coat around a masked window from a ladder"
      }
    ],
    "videos": [
      "2026/03/11-1.mp4"
    ],
    "faqs": [
      {
        "q": "Do you install stucco on homes and commercial buildings?",
        "a": "Yes. We install stucco on single-family homes, multi-family buildings such as townhouses and apartments, and commercial properties including offices and retail buildings. We work throughout Calgary, Airdrie, Cochrane, Okotoks, Chestermere and Strathmore."
      },
      {
        "q": "What stucco finishes can I choose from?",
        "a": "We offer California textured stucco and smooth flat stucco, along with colour options to suit your building. If you are repairing existing stucco we match the texture so repairs blend in."
      },
      {
        "q": "What is parging and does my foundation need it?",
        "a": "Parging is a cement-based coating applied to the exposed portion of a concrete or masonry foundation. It improves appearance and adds protection against moisture and weather. We can assess your foundation and recommend parging or crack sealing as part of your project."
      },
      {
        "q": "Can you repair woodpecker damage or cracks in stucco?",
        "a": "Yes. We repair woodpecker holes, cracks and impact damage and can add preventive proofing. Repairs are blended to match the surrounding finish."
      },
      {
        "q": "Can stucco be applied in cold weather?",
        "a": "Stucco needs suitable temperatures to cure properly, so cold-weather work requires planning and protection. We discuss timing, conditions and scheduling with you and include a schedule in your quote."
      },
      {
        "q": "What warranty comes with your stucco work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before work begins."
      }
    ],
    "ctaTitle": "Protect Your Exterior With MRE",
    "ctaSubtitle": "Tell us about your building and whether you need new stucco, repairs or parging. We will follow up with a free, detailed quote for your Calgary-area property.",
    "projects": [
      {
        "title": "Rear addition stucco over brick-look siding",
        "summary": "Dark siding covered with new stucco: scratch coat, then smooth grey finish coat around door and windows.",
        "dates": "Jan 2026 – Feb 2026",
        "photos": [
          "2026/03/uu1-scaled.jpg",
          "2026/03/uu2-scaled.jpg",
          "2026/03/uu3-scaled.jpg",
          "2026/03/uu4-scaled.jpg",
          "2026/03/uu5-scaled.jpg",
          "2026/03/uu6-scaled.jpg",
          "2026/03/uu7-scaled.jpg",
          "2026/03/uu8-scaled.jpg"
        ]
      },
      {
        "title": "Charcoal stucco finish on house exterior",
        "summary": "Crew trowels a dark charcoal finish coat across a full side wall with windows masked.",
        "dates": "Mar 2026",
        "photos": [
          "2026/04/uu2-scaled.jpg",
          "2026/04/uu3-scaled.jpg",
          "2026/04/uu1-scaled.jpg",
          "2026/04/uu4-scaled.jpg",
          "2026/04/uu5-scaled.jpg",
          "2026/04/uu6-scaled.jpg",
          "2026/04/uu7-scaled.jpg",
          "2026/04/uu8-scaled.jpg"
        ]
      }
    ]
  },
  "tiling": {
    "metaTitle": "Tile Installer Calgary | Tiling by MRE Developments",
    "metaDescription": "Custom tile showers, floors, feature walls and fireplaces in Calgary, Airdrie, Cochrane and Okotoks. Porcelain, marble and stone. Get a free tiling quote.",
    "headline": "Calgary Tile Installation With Laser-Straight Precision",
    "subheadline": "Showers, floors, feature walls and fireplace surrounds in porcelain, marble and stone, laid out to the millimetre and set on properly prepared, waterproofed surfaces.",
    "hero": "2026/03/pp1.jpg",
    "heroAlt": "Bright bathroom with frameless glass tiled shower, freestanding soaker tub and large-format floor tile",
    "overviewTitle": "Tile Work Planned Before It Is Set",
    "summary": "MRE Developments installs ceramic, porcelain, marble and natural stone tile on floors, walls, showers and fireplaces in homes across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We lay out every wall with a laser level, use levelling clips on large-format tile and prepare each surface first so the finish stays flat and tight. The result is tile work that looks deliberate, from the first row to the last cut.",
    "highlights": [
      "Custom tiled showers with niches and benches",
      "Large-format porcelain and marble-look tile",
      "Mosaic, pebble and hexagon feature details",
      "Tiled fireplace surrounds and feature walls",
      "Laser layout and tile levelling systems",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Custom Showers and Bathrooms",
        "body": "We tile walk-in showers, tub surrounds and bathroom floors with recessed niches, built-in benches and matching shelves. Fixtures, niches and grout lines are planned together so everything lines up when the glass goes in.",
        "benefit": "A water-resistant, easy-to-clean bathroom that looks custom-built for your home.",
        "image": "2026/03/kkd2.jpeg",
        "imageAlt": "Dark grey marble-look tiled shower with rain head and brushed nickel fixtures in a Calgary bathroom"
      },
      {
        "title": "Laser Layout, Flat Large Tile",
        "body": "Each wall is laid out with a laser level before setting begins. Large-format tiles are back-buttered and set with a levelling clip system so edges sit flush and veining flows across joints.",
        "benefit": "Straight lines, tight joints and no lippage you can feel or see.",
        "image": "2026/03/de4-1-scaled.jpg",
        "imageAlt": "Large marble-look porcelain tiles held flat with red tile levelling clips on a shower wall"
      },
      {
        "title": "Feature Walls and Fireplaces",
        "body": "Beyond bathrooms we tile fireplace surrounds and feature walls in brick-look, marble-look and stacked stone, including backlit niches and floor-to-ceiling installs in homes across Calgary and Cochrane.",
        "benefit": "A focal point built to suit your design that stays durable for years.",
        "image": "2026/03/az1-scaled.jpg",
        "imageAlt": "Marble-look tile feature wall with a window ledge and colour-lit recessed niches"
      }
    ],
    "galleryIntro": "A look at recent tiled showers, bathrooms, fireplaces and feature walls, plus the layout and setting work behind them.",
    "photos": [
      {
        "src": "2026/03/fd1-1-scaled.jpg",
        "caption": "Pebble tile over waterproofing",
        "alt": "Pebble tile sheet laid on a shower floor over red waterproofing"
      },
      {
        "src": "2026/03/fd2-1-scaled.jpg",
        "caption": "Hand-fitting pebble mosaic",
        "alt": "Tile setter hand-fitting pebble mosaic tile on a shower floor"
      },
      {
        "src": "2026/03/fd3-1-scaled.jpg",
        "caption": "Pebble floor to linear drain",
        "alt": "Pebble mosaic shower floor being fitted around a linear drain"
      },
      {
        "src": "2026/03/fd4-1-scaled.jpg",
        "caption": "Pebble floor set, walls next",
        "alt": "Finished pebble shower floor with waterproofed walls ready for tile"
      },
      {
        "src": "2026/03/uy1-scaled.jpg",
        "caption": "Tiled ceiling with rain shower head",
        "alt": "Marble-look tile on shower walls and ceiling with square black rain shower head"
      },
      {
        "src": "2026/03/uy2-scaled.jpg",
        "caption": "Pebble shower floor with linear drain",
        "alt": "Marble-look tiled shower with black and white pebble floor and linear drain"
      },
      {
        "src": "2026/03/uy3-scaled.jpg",
        "caption": "Shower bench and recessed niche",
        "alt": "Marble-look shower tile with built-in bench and recessed niche"
      },
      {
        "src": "2026/03/uy4-scaled.jpg",
        "caption": "Niche with black metal trim",
        "alt": "Recessed shower niche finished with black metal tile trim"
      },
      {
        "src": "2026/03/az1-scaled.jpg",
        "caption": "Marble-look wall with lit niches",
        "alt": "Marble-look tile feature wall with window ledge and backlit niches in a Calgary home"
      },
      {
        "src": "2026/03/az2-scaled.jpg",
        "caption": "Feature wall with warm niche lighting",
        "alt": "Marble-look tile feature wall with warm-lit recessed niches"
      },
      {
        "src": "2026/03/az3-scaled.jpg",
        "caption": "Niches lit purple and blue",
        "alt": "Marble-look tile wall with purple and blue backlit niches"
      },
      {
        "src": "2026/03/az4-scaled.jpg",
        "caption": "Colour-change niche lighting",
        "alt": "Tiled feature wall with colour-changing LED niche lighting"
      },
      {
        "src": "2026/03/kkd4.jpeg",
        "caption": "Niche with stone shelves",
        "alt": "Recessed shower niche with black marble shelves in grey tile"
      },
      {
        "src": "2026/03/kkd3.jpeg",
        "caption": "Dark marble-look shower with niche",
        "alt": "Dark grey marble-look shower tiling with recessed niche and brushed nickel fixtures"
      },
      {
        "src": "2026/03/kkd1.jpeg",
        "caption": "Hex mosaic accent and corner bench",
        "alt": "Grey marble-look shower tile with hexagon mosaic feature wall and stone corner bench"
      },
      {
        "src": "2026/03/kkd2.jpeg",
        "caption": "Grey shower with rain head",
        "alt": "Grey marble-look shower tiling with rain head and slide bar in a Calgary bathroom"
      },
      {
        "src": "2026/03/ll1.jpg",
        "caption": "Subway shower with mosaic panel",
        "alt": "White subway tile shower with black mosaic feature panel and skylight above"
      },
      {
        "src": "2026/03/ll6.jpg",
        "caption": "Subway tile around skylight",
        "alt": "White subway tile wrapped around a shower skylight with hexagon mosaic accent"
      },
      {
        "src": "2026/03/ll7.jpg",
        "caption": "Black mosaic floor and tiled bench",
        "alt": "Subway tile shower with black mosaic floor and tiled bench"
      },
      {
        "src": "2026/03/ll8.jpg",
        "caption": "Subway tile with contrast band",
        "alt": "White subway tile shower with dark accent band, niche and bench"
      },
      {
        "src": "2026/03/ii4.jpg",
        "caption": "Bench and mosaic shower floor",
        "alt": "Marble-look tiled shower with bench and mosaic floor drain"
      },
      {
        "src": "2026/03/ii1.jpg",
        "caption": "Walk-in shower ready for glass",
        "alt": "Marble-look tiled walk-in shower with mosaic floor before glass install"
      },
      {
        "src": "2026/03/ii3.jpg",
        "caption": "Shower with mosaic floor and trim",
        "alt": "Tiled shower with marble-look walls, mosaic floor and black edge trim"
      },
      {
        "src": "2026/03/ii2.jpg",
        "caption": "Bathroom floor and shower tile",
        "alt": "Marble-look tile across bathroom floor and shower walls in a Calgary renovation"
      },
      {
        "src": "2026/03/de1-scaled.jpg",
        "caption": "Back-buttered tile for full coverage",
        "alt": "Combed thinset on the back of a tile for full mortar coverage"
      },
      {
        "src": "2026/03/de2-1-scaled.jpg",
        "caption": "Setting large marble-look tile",
        "alt": "Installer setting a large marble-look tile over waterproofed shower wall"
      },
      {
        "src": "2026/03/de3-1-scaled.jpg",
        "caption": "Levelling clips keep edges flush",
        "alt": "Red tile levelling clips holding marble-look tiles flush"
      },
      {
        "src": "2026/03/de4-1-scaled.jpg",
        "caption": "Clip system across shower wall",
        "alt": "Tile levelling clips across a large-format marble-look shower wall"
      },
      {
        "src": "2026/03/1-12-scaled.jpg",
        "caption": "Measuring large-format tile",
        "alt": "Tile setter measuring a large-format porcelain tile before cutting"
      },
      {
        "src": "2026/03/3-10-scaled.jpg",
        "caption": "Marking tile for precise cuts",
        "alt": "Tile installer marking a cut line on a porcelain tile"
      },
      {
        "src": "2026/03/2-11-scaled.jpg",
        "caption": "Laser level for tile layout",
        "alt": "Green laser level projecting layout lines for tile installation"
      },
      {
        "src": "2026/03/4-21-scaled.jpg",
        "caption": "Laser lines across shower walls",
        "alt": "Laser level lines across prepared shower walls before tiling"
      },
      {
        "src": "2026/03/ss1.jpg",
        "caption": "Fireplace wall tile in progress",
        "alt": "Large grey tile being installed on a fireplace feature wall"
      },
      {
        "src": "2026/03/ss2.jpg",
        "caption": "Brick-look fireplace with timber mantel",
        "alt": "Brick-look tile fireplace surround with dark timber mantel in a Calgary living room"
      },
      {
        "src": "2026/03/ss3.jpg",
        "caption": "Tall stone fireplace feature",
        "alt": "Tall stacked-stone tile fireplace feature wall framed by dark columns"
      },
      {
        "src": "2026/03/ss4.jpg",
        "caption": "Black marble-look fireplace wall",
        "alt": "Floor-to-ceiling black marble-look tile fireplace feature wall"
      },
      {
        "src": "2026/03/pp1.jpg",
        "caption": "Glass shower and freestanding tub ensuite",
        "alt": "Bathroom tiling with frameless glass shower, freestanding tub and large-format floor tile"
      },
      {
        "src": "2026/03/pp2.jpg",
        "caption": "Marble-look shower, black framed glass",
        "alt": "Marble-look tiled shower behind black framed glass door"
      },
      {
        "src": "2026/03/pp3.jpg",
        "caption": "Ensuite floor tile and stone wall",
        "alt": "Large ensuite with tile floor, stacked stone wall and freestanding tub"
      },
      {
        "src": "2026/03/pp4.jpg",
        "caption": "Marble-look shower, pebble floor",
        "alt": "Marble-look tiled walk-in shower with pebble floor, niche and bench"
      }
    ],
    "videos": [
      "2026/03/66.mp4"
    ],
    "faqs": [
      {
        "q": "What kinds of tile do you install?",
        "a": "We install ceramic, porcelain, marble, natural stone, mosaic and pebble tile on floors, walls, showers, backsplashes and fireplace surrounds. We work on homes throughout Calgary, Airdrie, Cochrane, Okotoks, Chestermere and nearby communities."
      },
      {
        "q": "Can you install large-format tile without uneven edges?",
        "a": "Yes. We prepare and flatten the surface, back-butter each tile for full mortar coverage and use a levelling clip system. This keeps edges flush and prevents the lippage that large tiles are prone to."
      },
      {
        "q": "Do you waterproof showers before tiling?",
        "a": "Every tiled shower we build is waterproofed before tile goes on, including the floor, walls, niches and benches. If you want a Schluter-Kerdi system specifically, see our Kerdi Kit Shower Waterproofing service."
      },
      {
        "q": "Can you create custom patterns, niches and feature walls?",
        "a": "Yes. We build recessed niches, benches and shelves, and install mosaic accents, herringbone or offset patterns and full feature walls. We plan the layout with you before setting begins so cuts land where they should."
      },
      {
        "q": "How long does a tiling project take?",
        "a": "It depends on the area, tile size and pattern, how much surface preparation is needed and drying times for waterproofing and grout. A schedule is included with your quote."
      },
      {
        "q": "What warranty do you offer on tile work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before we start."
      }
    ],
    "ctaTitle": "Start Your Tile Project With MRE",
    "ctaSubtitle": "Share the space, the tile you are considering and any inspiration photos. We will prepare a free, detailed tiling quote for your Calgary-area home.",
    "projects": [
      {
        "title": "Walk-in shower with pebble floor",
        "summary": "Pebble mosaic floor and linear drain set over waterproofing, then marble-look walls, bench and niche finished.",
        "dates": "Aug 2024 – Sep 2024",
        "photos": [
          "2026/03/fd1-1-scaled.jpg",
          "2026/03/fd2-1-scaled.jpg",
          "2026/03/fd3-1-scaled.jpg",
          "2026/03/fd4-1-scaled.jpg",
          "2026/03/uy1-scaled.jpg",
          "2026/03/uy2-scaled.jpg",
          "2026/03/uy3-scaled.jpg",
          "2026/03/uy4-scaled.jpg"
        ]
      },
      {
        "title": "Marble-look feature wall with LED niches",
        "summary": "Finished marble-look tile wall around a window with colour-changing lit niches.",
        "dates": "Nov 2024",
        "photos": [
          "2026/03/az1-scaled.jpg",
          "2026/03/az2-scaled.jpg",
          "2026/03/az3-scaled.jpg",
          "2026/03/az4-scaled.jpg"
        ]
      },
      {
        "title": "Grey marble-look shower with mosaic accent",
        "summary": "Finished shower with grey marble-look wall tile, hexagon mosaic panel, niche and corner shelf.",
        "dates": "Oct 2021",
        "photos": [
          "2026/03/kkd4.jpeg",
          "2026/03/kkd3.jpeg",
          "2026/03/kkd1.jpeg",
          "2026/03/kkd2.jpeg"
        ]
      },
      {
        "title": "White subway tile shower with mosaic panel",
        "summary": "Finished shower with white subway tile, black mosaic feature panel, bench and skylight.",
        "dates": "",
        "photos": [
          "2026/03/ll1.jpg",
          "2026/03/ll6.jpg",
          "2026/03/ll7.jpg",
          "2026/03/ll8.jpg"
        ]
      },
      {
        "title": "White marble-look shower and bathroom floor",
        "summary": "Marble-look shower walls with corner shelves, hexagon mosaic floor and matching bathroom floor tile.",
        "dates": "",
        "photos": [
          "2026/03/ii4.jpg",
          "2026/03/ii1.jpg",
          "2026/03/ii3.jpg",
          "2026/03/ii2.jpg"
        ]
      },
      {
        "title": "Large-format marble-look shower walls",
        "summary": "Thinset back-buttering and large marble-look wall tiles set with levelling clips.",
        "dates": "Mar 2022",
        "photos": [
          "2026/03/de1-scaled.jpg",
          "2026/03/de2-1-scaled.jpg",
          "2026/03/de3-1-scaled.jpg",
          "2026/03/de4-1-scaled.jpg"
        ]
      },
      {
        "title": "Laser layout for large-format tile",
        "summary": "Tile measured and marked, with a laser level setting out lines before setting.",
        "dates": "Aug 2024",
        "photos": [
          "2026/03/1-12-scaled.jpg",
          "2026/03/3-10-scaled.jpg",
          "2026/03/2-11-scaled.jpg",
          "2026/03/4-21-scaled.jpg"
        ]
      },
      {
        "title": "More tiling work",
        "summary": "Tiled fireplace surrounds and finished bathrooms and showers from other jobs.",
        "dates": "",
        "photos": [
          "2026/03/ss1.jpg",
          "2026/03/ss2.jpg",
          "2026/03/ss3.jpg",
          "2026/03/ss4.jpg",
          "2026/03/pp1.jpg",
          "2026/03/pp2.jpg",
          "2026/03/pp3.jpg",
          "2026/03/pp4.jpg"
        ]
      }
    ]
  },
  "tree-cutting": {
    "metaTitle": "Tree Cutting & Removal Calgary | MRE Developments",
    "metaDescription": "Tree cutting, removal, stump cleanup and land clearing in Calgary, Airdrie, Cochrane and Okotoks. Residential and commercial sites. Request a free quote.",
    "headline": "Calgary Tree Cutting and Removal for Homes and Building Sites",
    "subheadline": "Hazardous, damaged or in-the-way trees taken down in controlled sections, chipped and cleared, so your property is safe and your site is ready for what comes next.",
    "hero": "2026/03/ku1-scaled.jpg",
    "heroAlt": "Crew member making a felling cut with a chainsaw at the base of a large spruce in a Calgary yard",
    "overviewTitle": "Controlled Tree Removal and Cleanup",
    "summary": "MRE Developments removes trees for residential and commercial properties across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, including land clearing ahead of construction or landscaping. Our crew uses professional saws, climbing gear and chipping equipment to take trees down safely while protecting nearby structures. We finish with stump work and cleanup so the area is clear and level.",
    "highlights": [
      "Hazardous and damaged tree removal",
      "Land clearing for construction projects",
      "Climbing and sectional takedowns",
      "Stump removal and full cleanup",
      "Chipping and debris haul-away",
      "Residential and commercial properties"
    ],
    "features": [
      {
        "title": "Safe, Planned Takedowns",
        "body": "Every removal starts with an assessment of the tree, its lean and what is around it. Felling cuts are marked and made deliberately, and larger trees near houses or fences are taken down in sections.",
        "benefit": "The tree comes down where it should, with your home and landscaping protected.",
        "image": "2026/03/ku6-scaled.jpg",
        "imageAlt": "Crew member in helmet and gloves cutting a notch in a large spruce trunk beside a Calgary street"
      },
      {
        "title": "Professional Gear and Rigging",
        "body": "Our crew works with professional chainsaws, climbing harnesses and ropes, and keeps equipment maintained and sharp. That lets us reach trees in tight yards where a straight fell is not an option.",
        "benefit": "Tree removal in confined spaces without putting your property at risk.",
        "image": "2026/03/ku5-scaled.jpg",
        "imageAlt": "Climbing harness, carabiners and rope worn by a tree removal crew member at the base of a tree"
      },
      {
        "title": "Cleanup and Site Preparation",
        "body": "Branches go through the chipper, logs are cut and removed, and stumps are cut low. For construction and landscaping projects we clear trees, brush and debris so the lot is ready to build on.",
        "benefit": "A clean, level site with nothing left behind to deal with.",
        "image": "2026/03/ku3-scaled.jpg",
        "imageAlt": "Orange wood chipper and dump truck parked on a Calgary street during tree removal cleanup"
      }
    ],
    "galleryIntro": "Tree removal work across Calgary neighbourhoods, from the first cut to the final cleanup.",
    "photos": [
      {
        "src": "2026/03/rf1-scaled.jpg",
        "caption": "Chainsaw and safety gloves",
        "alt": "Crew member in cut-resistant gloves holding a chainsaw for tree cutting"
      },
      {
        "src": "2026/03/rf3-scaled.jpg",
        "caption": "Saws fuelled for the job",
        "alt": "Two chainsaws and a fuel can set out on snow before tree cutting"
      },
      {
        "src": "2026/03/rf4-scaled.jpg",
        "caption": "Climber harnessed beside the house",
        "alt": "Arborist in helmet and climbing harness preparing to remove a tree beside a house"
      },
      {
        "src": "2026/03/rf7-scaled.jpg",
        "caption": "Sectioning the trunk",
        "alt": "Crew member cutting a felled spruce trunk into rounds amid branches"
      },
      {
        "src": "2026/03/rf9-scaled.jpg",
        "caption": "Stump and rounds ready to haul",
        "alt": "Tree stump with cut log rounds ready for removal"
      },
      {
        "src": "2026/03/rf10-scaled.jpg",
        "caption": "Log rounds cut to size",
        "alt": "Large log round cut to size during tree removal"
      },
      {
        "src": "2026/03/rf13-scaled.jpg",
        "caption": "Stump cut low and level",
        "alt": "Freshly cut tree stump cut low and level after tree removal"
      },
      {
        "src": "2026/03/rf16-scaled.jpg",
        "caption": "Stump before final cleanup",
        "alt": "Cut tree stump surrounded by sawdust before final cleanup"
      },
      {
        "src": "2026/03/ku2-scaled.jpg",
        "caption": "Sharpening the chain on site",
        "alt": "Crew member sharpening a chainsaw chain on site"
      },
      {
        "src": "2026/03/ku3-scaled.jpg",
        "caption": "Chipper and truck on site",
        "alt": "Wood chipper and dump truck set up for tree removal cleanup on a Calgary street"
      },
      {
        "src": "2026/03/ku4-scaled.jpg",
        "caption": "Trunk marked for the cut",
        "alt": "Spruce trunk marked with a cut line before felling"
      },
      {
        "src": "2026/03/ku5-scaled.jpg",
        "caption": "Climbing harness and rigging rope",
        "alt": "Climbing harness, carabiners and rigging rope used for tree removal"
      },
      {
        "src": "2026/03/ku6-scaled.jpg",
        "caption": "Notch cut on a mature spruce",
        "alt": "Tree cutting crew member making a notch cut in a mature spruce in Calgary"
      },
      {
        "src": "2026/03/ku1-scaled.jpg",
        "caption": "Felling cut at the base",
        "alt": "Chainsaw felling cut at the base of a large spruce during tree removal"
      },
      {
        "src": "2026/03/ku7-scaled.jpg",
        "caption": "Bucking branches for the chipper",
        "alt": "Crew member cutting spruce branches into sections for chipping"
      },
      {
        "src": "2026/03/ku8-scaled.jpg",
        "caption": "Trunk down beside the steps",
        "alt": "Felled and limbed tree trunk lying beside concrete front steps in Calgary"
      }
    ],
    "videos": [
      "2026/03/ezgif-368a1d547c34915f.mp4"
    ],
    "faqs": [
      {
        "q": "What kinds of tree cutting projects do you take on?",
        "a": "We remove hazardous, damaged or unwanted trees for residential and commercial properties, and clear trees and brush to prepare land for construction or landscaping. We work across Calgary, Airdrie, Cochrane, Okotoks, Chestermere and nearby communities."
      },
      {
        "q": "Can you remove a tree that is close to my house or fence?",
        "a": "Yes. When there is no room to fell a tree in one piece, our crew climbs and removes it in controlled sections. We assess the tree and its surroundings first and plan the takedown to protect structures and landscaping."
      },
      {
        "q": "Do you remove storm-damaged trees?",
        "a": "Yes. We remove trees and large limbs damaged by wind, snow or ice that pose a risk to your property. Contact us with photos and details and we will discuss access and next steps."
      },
      {
        "q": "Is cleanup and stump work included?",
        "a": "We cut stumps low, chip branches and haul away logs and debris so the area is left clear and level. The cleanup and stump scope for your property is set out in your quote."
      },
      {
        "q": "Do I need permission to remove a tree in Calgary?",
        "a": "Trees on private property are generally the owner's responsibility, but trees on city land or shared boundaries have their own rules. We talk through ownership and access during the quote so the work proceeds properly."
      },
      {
        "q": "How long does tree removal take?",
        "a": "It depends on the number and size of trees, access, proximity to structures and how much cleanup is involved. A schedule is provided along with your quote."
      }
    ],
    "ctaTitle": "Talk to MRE About Your Tree Project",
    "ctaSubtitle": "Tell us about the trees, the property and any construction plans. We will discuss access and scope and provide a free, detailed quote.",
    "projects": [
      {
        "title": "Tree removal and stump cut-down",
        "summary": "Climber removes a tree beside a house, trunk sections cut and stumps cut low.",
        "dates": "Mar 2022",
        "photos": [
          "2026/03/rf1-scaled.jpg",
          "2026/03/rf3-scaled.jpg",
          "2026/03/rf4-scaled.jpg",
          "2026/03/rf7-scaled.jpg",
          "2026/03/rf9-scaled.jpg",
          "2026/03/rf10-scaled.jpg",
          "2026/03/rf13-scaled.jpg",
          "2026/03/rf16-scaled.jpg"
        ]
      },
      {
        "title": "Large spruce removal with chipping",
        "summary": "Climbing gear set, trunk notched and felled, branches chipped and logs cleared.",
        "dates": "Jan 2022",
        "photos": [
          "2026/03/ku2-scaled.jpg",
          "2026/03/ku3-scaled.jpg",
          "2026/03/ku4-scaled.jpg",
          "2026/03/ku5-scaled.jpg",
          "2026/03/ku6-scaled.jpg",
          "2026/03/ku1-scaled.jpg",
          "2026/03/ku7-scaled.jpg",
          "2026/03/ku8-scaled.jpg"
        ]
      }
    ]
  },
  "ai-automation": {
    "metaTitle": "AI & Automation Services Calgary | MRE Developments",
    "metaDescription": "AI chatbots, lead concierges, workflow automation and dashboards for Calgary and Canadian businesses. Book a free AI strategy consultation with MRE today.",
    "headline": "Practical AI & Automation for Calgary Businesses",
    "subheadline": "Missed enquiries, manual data entry and scattered spreadsheets cost hours each week. We build AI assistants and automations that capture leads and handle routine work.",
    "hero": "https://images.unsplash.com/photo-1497215842964-222b430dc094?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Desk with a desktop computer and laptop beside a large window overlooking city buildings",
    "overviewTitle": "AI That Saves Time and Wins Leads",
    "summary": "MRE Developments builds AI automation services for businesses in Calgary and across Canada, from AI chatbots and lead concierges to workflow automation, analytics dashboards and data integration. The chat assistant and instant estimator on this website are our own work and show the approach in practice. We focus on practical tools that fit your existing systems, with clear scope and transparent pricing.",
    "highlights": [
      "AI chat assistants and lead concierges",
      "Instant quote and estimate tools",
      "Workflow automation between your apps",
      "Live analytics dashboards",
      "CRM and data integration",
      "Built around your existing tools"
    ],
    "features": [
      {
        "title": "AI Assistants and Lead Concierges",
        "body": "An AI concierge answers common questions, qualifies enquiries and collects contact details at any hour, then passes leads to your team or CRM. It is trained on your services and policies, and set up to hand off to a person when a question needs one.",
        "benefit": "Fewer missed enquiries and better-qualified leads arriving in your inbox."
      },
      {
        "title": "Automation for Repetitive Work",
        "body": "We map the tasks your team repeats every day, such as copying form data, sending follow-ups or updating spreadsheets, and connect your apps so they happen automatically. Each workflow is documented and tested before it goes live.",
        "benefit": "Your staff spend their hours on customers instead of admin."
      },
      {
        "title": "Dashboards and Data Integration",
        "body": "We bring data from your website, ads, CRM and accounting tools into one dashboard so you can see leads, sales and performance in one place. Integrations are built to keep information accurate across systems.",
        "benefit": "Clear, current numbers to guide decisions without manual reporting."
      }
    ],
    "galleryIntro": "Live demos, including the assistant and estimator on this site, are shown during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What can an AI assistant do for my business?",
        "a": "It can answer frequently asked questions, qualify enquiries, collect contact details, book appointments and route leads to the right person. The chat assistant on this site is an example. We scope what your assistant should and should not handle during the consultation."
      },
      {
        "q": "Will AI replace my staff?",
        "a": "That is not the goal. We automate repetitive, low-value tasks so your team has more time for the work that needs people, such as sales conversations, service and problem solving."
      },
      {
        "q": "Will it work with the software I already use?",
        "a": "In most cases, yes. We review your current tools, including CRMs, email, forms, spreadsheets and accounting software, and design automations around them before recommending anything new."
      },
      {
        "q": "How do you handle data privacy?",
        "a": "We design each system to collect only the data it needs and discuss where information is stored and who can access it. Privacy and security requirements are confirmed in the scope before any build begins."
      },
      {
        "q": "How much does AI and automation cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number of workflows, the systems being connected, the complexity of the assistant and any ongoing hosting or monitoring. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free AI Strategy Consultation",
    "ctaSubtitle": "Tell us where your team loses time or leads. We will identify practical automations and outline a clear scope."
  },
  "animation": {
    "metaTitle": "Animation & Motion Graphics Calgary | MRE Developments",
    "metaDescription": "Explainer videos, logo animation, 2D animation and motion graphics for Calgary and Canadian businesses. Book a free animation consultation with MRE today.",
    "headline": "Animation & Motion Graphics for Calgary and Canada",
    "subheadline": "Complex services are hard to explain in a paragraph. We create explainer videos, logo animations and motion graphics that make your message clear and memorable.",
    "hero": "https://images.unsplash.com/photo-1526887593587-a307ea5d46b4?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Bright, minimal workstation with a monitor and laptop on a desk against a white wall",
    "overviewTitle": "Make Your Message Move",
    "summary": "MRE Developments is an animation studio serving businesses in Calgary and across Canada, producing motion graphics, explainer videos, 2D animation and logo animation. We take your idea from script and storyboard through to final animation, sound and delivery in the formats you need. Projects are produced remotely with clear scope, review stages and transparent pricing.",
    "highlights": [
      "Explainer videos for products and services",
      "Logo animation and brand intros",
      "2D animation and illustration",
      "Motion graphics for social and ads",
      "Script, storyboard and voiceover",
      "Delivered for web, social and screens"
    ],
    "features": [
      {
        "title": "Explainer Videos That Simplify",
        "body": "We turn complex services, processes or products into short animated explainers. The process starts with a script and storyboard, so you approve the message and visual direction before animation begins.",
        "benefit": "Customers understand what you do, and why it matters, in under two minutes."
      },
      {
        "title": "From Storyboard to Final Render",
        "body": "Each project moves through clear stages: script, storyboard, style frames, animation, sound and final delivery. Review points at each stage keep the project on track and avoid costly changes late in production.",
        "benefit": "A polished animation with no surprises along the way."
      },
      {
        "title": "Logo Animation and Social Motion",
        "body": "A short animated logo gives videos, presentations and social posts a professional open or close. We also create motion graphics sized for social feeds and ads, designed to catch attention in the first seconds.",
        "benefit": "Your brand looks more dynamic across every channel."
      }
    ],
    "galleryIntro": "Animation samples and style references are shared during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What is the difference between motion graphics and 2D animation?",
        "a": "Motion graphics animate text, shapes, icons and data, and are well suited to explainers and social ads. 2D animation adds illustrated characters and scenes for more narrative storytelling. Many projects combine both."
      },
      {
        "q": "Do you provide the script and voiceover?",
        "a": "Yes. We can write the script based on your goals and arrange professional voiceover, or work from a script you provide. This is confirmed in the project scope."
      },
      {
        "q": "How long does an animation take to produce?",
        "a": "It depends on the length, style and complexity of the animation and how quickly reviews come back at each stage. A production schedule is provided with the scope after the consultation."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. Animation is produced entirely remotely, so we work with businesses across Canada, with reviews handled online."
      },
      {
        "q": "How much does animation cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the length of the animation, the style and level of detail, whether scriptwriting and voiceover are included and the number of versions or formats needed. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Animation Strategy Consultation",
    "ctaSubtitle": "Tell us what you need to explain or promote. We will recommend a style, format and clear scope."
  },
  "basement-development": {
    "metaTitle": "Basement Development Calgary | MRE Developments",
    "metaDescription": "Basement development in Calgary, Airdrie and Okotoks: finished basements, legal suites, egress windows and permits by MRE Developments. Get a free quote.",
    "headline": "Basement Development in Calgary, From Bare Concrete to Living Space",
    "subheadline": "Turn an unused basement into family space, a rental suite or a home gym. We handle permits, egress, framing, mechanical and finishing so the space is done right and built to code.",
    "hero": "2025/09/2-2.png",
    "heroAlt": "Finished basement suite in Calgary with white kitchen cabinets, stainless range and grey plank flooring",
    "overviewTitle": "Basements Developed to Code",
    "summary": "MRE Developments develops basements across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, from open recreation rooms to full secondary suites with kitchens and bathrooms. Our team manages permits, framing, electrical, plumbing, drywall and finishing so the work passes inspection and the space feels like part of the house. Whether you want more room for the family or rental income, we plan the layout around how you will use it.",
    "highlights": [
      "Full basement finishing from bare concrete",
      "Legal secondary suites with kitchens",
      "Egress windows and permits handled",
      "Wet bars, bathrooms and laundry",
      "Soundproofing between floors",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "More Living Space, Same Footprint",
        "body": "A developed basement adds bedrooms, a family room, an office or a gym without the cost of building an addition. We plan the layout around your furnace, water heater and support posts so the space flows and the mechanical room stays accessible.",
        "benefit": "Usable square footage that adds comfort and resale value to your home.",
        "image": "2025/09/2.png",
        "imageAlt": "Open developed basement with kitchenette, recessed lights and grey vinyl plank floor in a Calgary home"
      },
      {
        "title": "Framed, Wired and Finished Properly",
        "body": "We start with an unfinished basement and take it through framing, insulation, electrical, plumbing rough-in, drywall, flooring, trim and paint. Bulkheads are tidied around ductwork, pot lights are laid out evenly, and every stage is ready for City inspection.",
        "benefit": "A clean, durable finish with no shortcuts hidden behind the drywall.",
        "image": "2025/09/1-2.png",
        "imageAlt": "Unfinished Calgary basement with open joists and new stair framing before basement development begins"
      },
      {
        "title": "Legal Suites and Income Potential",
        "body": "If you want rental income or space for extended family, we can build a secondary suite with its own kitchen, bathroom and bedrooms. We address egress windows, fire separation, separate heating requirements and soundproofing so the suite can meet Calgary's legal suite rules.",
        "benefit": "A self-contained suite designed to meet code and attract good tenants.",
        "image": "2025/09/b.png",
        "imageAlt": "Basement suite kitchen with white cabinets, white range and open living area in a developed Calgary basement"
      }
    ],
    "galleryIntro": "Before-and-after views of basements developed by MRE Developments in and around Calgary, including full suites with kitchens.",
    "photos": [
      {
        "src": "2025/09/1-2.png",
        "caption": "Before: unfinished basement",
        "alt": "Unfinished Calgary basement with exposed joists, mechanical equipment and new stair framing before development"
      },
      {
        "src": "2025/09/3-1.png",
        "caption": "Before: bare concrete and insulation",
        "alt": "Undeveloped basement with concrete walls, exposed ceiling and stored items before finishing work"
      },
      {
        "src": "2025/09/5.png",
        "caption": "Before: open joists and bare walls",
        "alt": "Unfinished basement with wood stairs, exposed joists and concrete floor before basement development"
      },
      {
        "src": "2025/09/1.png",
        "caption": "Finished room with basement window",
        "alt": "Finished basement room in Calgary with window, white walls and grey plank flooring"
      },
      {
        "src": "2025/09/2-1.png",
        "caption": "Finished stairwell with handrail",
        "alt": "Finished basement stairwell with grey stairs, white walls and wall-mounted handrail"
      },
      {
        "src": "2025/09/4-1.png",
        "caption": "Pot lights and clean drywall",
        "alt": "Newly developed basement room with recessed lighting and freshly painted white walls"
      },
      {
        "src": "2025/09/2-2.png",
        "caption": "Suite kitchen with stainless appliances",
        "alt": "Basement suite kitchen in Calgary with white shaker cabinets, stainless range and microwave"
      },
      {
        "src": "2025/09/2.png",
        "caption": "Open kitchen and living area",
        "alt": "Developed basement in Calgary with open kitchenette, living space and grey plank flooring"
      },
      {
        "src": "2025/09/4-4.png",
        "caption": "Kitchenette and open floor space",
        "alt": "Developed basement with kitchenette along the wall and open living area with grey flooring"
      },
      {
        "src": "2025/09/6.png",
        "caption": "Stair landing beside suite kitchen",
        "alt": "Finished basement stairs opening onto a suite kitchen with stainless fridge and white doors"
      },
      {
        "src": "2025/09/b.png",
        "caption": "Galley kitchen in a basement suite",
        "alt": "Basement development with white cabinets, white range and recessed lighting along one wall"
      },
      {
        "src": "2025/09/c.png",
        "caption": "Open plan suite living area",
        "alt": "Basement suite living area with support post, fridge and kitchen cabinets in a Calgary home"
      },
      {
        "src": "2025/11/8-scaled.jpg",
        "caption": "Living space with kitchen beyond",
        "alt": "Developed basement living area with black fridge, white cabinets and plank flooring in Calgary"
      },
      {
        "src": "2025/11/12-1-1-scaled.jpg",
        "caption": "Hallway to bedrooms and bath",
        "alt": "Finished basement hallway in a Calgary home with doors leading to bedrooms and bathroom"
      },
      {
        "src": "2025/10/10-2-scaled.jpg",
        "caption": "New doors along finished wall",
        "alt": "Developed basement with two new interior doors, white baseboards and recessed lights"
      },
      {
        "src": "2025/10/4-11-1-scaled.jpg",
        "caption": "Recreation room with tidy bulkheads",
        "alt": "Bright finished basement room with drywall bulkhead, pot lights and grey vinyl plank floor"
      },
      {
        "src": "2025/11/q4-1-scaled.jpg",
        "caption": "Bedroom-ready room with window",
        "alt": "Finished basement room with window, baseboard heater and kitchen cabinetry in a Calgary suite"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do I need a permit to develop my basement in Calgary?",
        "a": "Yes. Basement development in Calgary generally needs a building permit, plus electrical and plumbing permits where that work is included. We prepare the drawings, apply for the permits and schedule the inspections as part of the project."
      },
      {
        "q": "Can you build a legal basement suite?",
        "a": "Yes. Suites with full kitchens, bathrooms and bedrooms are within the scope of our basement development work. A legal suite must meet requirements for egress windows, fire and sound separation, ceiling height, and heating, and we design to those requirements from the start."
      },
      {
        "q": "Do you install egress windows?",
        "a": "Yes. Bedrooms in a developed basement need a properly sized egress window, and we handle the foundation cutting, window well and installation as part of the project where one is required."
      },
      {
        "q": "How much does basement development cost?",
        "a": "Cost depends on the size of the basement, the layout, whether you are adding a bathroom, kitchen or full suite, and the finishes you choose. We provide a free, detailed quote after reviewing the space and your plans."
      },
      {
        "q": "How long does a basement development take?",
        "a": "The schedule depends on permit approval, the scope of plumbing and electrical work, inspection timing and finish selections. A project-specific schedule comes with your quote so you know what to expect at each stage."
      },
      {
        "q": "What warranty do you offer on basement development?",
        "a": "Our warranty and workmanship terms are set out in writing with your quote. We review them with you before work begins so you know exactly what is covered."
      }
    ],
    "ctaTitle": "Plan Your Basement Development",
    "ctaSubtitle": "Tell us how you want to use your basement and we will prepare a free, detailed quote for the work.",
    "projects": [
      {
        "title": "Unfinished basement developed into open space",
        "summary": "Bare concrete and exposed framing turned into finished rooms, stairs, lighting and flooring.",
        "dates": "",
        "photos": [
          "2025/09/1-2.png",
          "2025/09/3-1.png",
          "2025/09/5.png",
          "2025/09/1.png",
          "2025/09/2-1.png",
          "2025/09/4-1.png"
        ]
      },
      {
        "title": "Basement suite with kitchen and open layout",
        "summary": "Finished basement with white kitchen, plank flooring, pot lights and hallway to bedrooms.",
        "dates": "Aug 2024",
        "photos": [
          "2025/09/2-2.png",
          "2025/09/2.png",
          "2025/09/4-4.png",
          "2025/09/6.png",
          "2025/09/b.png",
          "2025/09/c.png",
          "2025/11/8-scaled.jpg",
          "2025/11/12-1-1-scaled.jpg"
        ]
      },
      {
        "title": "Basement with new flooring and lighting",
        "summary": "Finished basement rooms with plank flooring, pot lights and fresh paint.",
        "dates": "Jun 2024",
        "photos": [
          "2025/10/10-2-scaled.jpg",
          "2025/10/4-11-1-scaled.jpg"
        ]
      },
      {
        "title": "More basement development work",
        "summary": "Additional finished basement suite space.",
        "dates": "Jun 2024",
        "photos": [
          "2025/11/q4-1-scaled.jpg"
        ]
      }
    ]
  },
  "branding": {
    "metaTitle": "Branding & Identity Calgary | MRE Developments",
    "metaDescription": "Logo design, brand identity and brand guidelines for Calgary and Canadian businesses. Book a free strategy consultation with MRE Developments today.",
    "headline": "Branding & Identity for Calgary and Canadian Businesses",
    "subheadline": "If your logo, website and signage all look slightly different, customers notice. We build a brand identity that looks established, stays consistent and grows with you.",
    "hero": "https://images.unsplash.com/photo-1496664444929-8c75efb9546f?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Wooden studio desk with two monitors beside shelves of books and design references",
    "overviewTitle": "A Brand That Looks the Part",
    "summary": "MRE Developments is a branding agency based in Calgary, creating logos, brand identities and brand guidelines for businesses across Canada. We start with how you want to be seen, then build a visual system that works on screen, in print and on signage. Every project is scoped clearly and delivered remotely, with collaboration at each stage.",
    "highlights": [
      "Logo design and complete brand identity",
      "Colour, typography and visual system",
      "Brand guidelines your team can follow",
      "Print, signage and vehicle applications",
      "Rebranding for established businesses",
      "Remote delivery across Canada"
    ],
    "features": [
      {
        "title": "Identity Built Around Your Business",
        "body": "We begin with a discovery session on your customers, competitors and the reputation you want to earn. From there we develop logo concepts, colour palettes and typography that reflect how your business actually operates, not a passing trend.",
        "benefit": "You get a brand identity that signals credibility the moment a customer sees it."
      },
      {
        "title": "Guidelines That Keep You Consistent",
        "body": "A logo on its own is not a brand. We document clear-space rules, colour values for screen and print, type hierarchy and usage examples in a brand guidelines file your staff, printers and vendors can follow.",
        "benefit": "Your business looks the same on every truck, invoice, sign and social post."
      },
      {
        "title": "Rebranding Without Losing Recognition",
        "body": "For established businesses, we assess what customers already recognise and keep the equity worth keeping. We then plan the rollout across website, signage, print and digital channels so the change feels deliberate rather than disruptive.",
        "benefit": "You modernise your image while keeping the trust you have already built."
      }
    ],
    "galleryIntro": "Brand identity work is shared during your consultation, matched to your industry and goals.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What is included in a brand identity project?",
        "a": "A typical project covers discovery, logo design, colour palette, typography and a brand guidelines document. Depending on your needs it can extend to business cards, stationery, signage, vehicle graphics and social media templates. We confirm exactly what is included in the scope before work begins."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. We are based in Calgary and deliver branding remotely to businesses across Canada. Discovery sessions, concept reviews and revisions all happen by video call and shared files."
      },
      {
        "q": "We already have a logo. Can you refresh it instead of starting over?",
        "a": "Often, yes. We review your current mark and materials to decide whether a refresh, a partial update or a full rebrand makes sense. The recommendation depends on how much recognition your current brand carries and where it is falling short."
      },
      {
        "q": "What files will I receive?",
        "a": "You receive your logo and brand assets in the formats needed for web, print and signage, including vector files and versions for light and dark backgrounds. The brand guidelines explain how to use each one correctly."
      },
      {
        "q": "How much does a branding project cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on whether you need a single logo, a full identity system or a complete rebrand with rollout across signage and print. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Branding Strategy Consultation",
    "ctaSubtitle": "Tell us where your business is headed and how it looks today. We will recommend a clear scope for the brand you need."
  },
  "commercial-construction": {
    "metaTitle": "Commercial Construction Calgary | MRE Developments",
    "metaDescription": "Ground-up commercial and design-build construction in Calgary, Airdrie and Okotoks, with permits and project management handled. Get a free quote.",
    "headline": "Commercial Construction in Calgary, Managed From Ground Up",
    "subheadline": "One general contractor coordinating design, permits, trades and inspections, so your new business space is built to code and ready for opening day.",
    "hero": "2024/08/9-scaled.jpg",
    "heroAlt": "New single-storey commercial building under construction with a graded site in front in the Calgary area",
    "overviewTitle": "Your Commercial General Contractor",
    "summary": "MRE Developments delivers ground-up commercial and design-build projects for business owners and property managers in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region. We manage the build from site preparation and foundations through to exterior work and site concrete, coordinating permits, inspections and trades along the way. You deal with one licensed and insured contractor who is accountable for the whole project.",
    "highlights": [
      "Ground-up commercial buildings",
      "Design-build project delivery",
      "Permits and inspections coordinated",
      "One point of contact for trades",
      "Licensed and insured general contractor",
      "Free, detailed project quotes"
    ],
    "features": [
      {
        "title": "Design-Build Under One Contract",
        "body": "With design-build, the design and construction of your building are handled by one team working from the same plan. Drawings, budget and buildability are worked out together before construction starts, which reduces the back-and-forth that slows many commercial projects in Calgary.",
        "benefit": "You get a single accountable contractor and fewer surprises between drawings and the finished building.",
        "image": "2024/08/7-scaled.jpg",
        "imageAlt": "New concrete sidewalk running along wrapped storefronts of a commercial building under construction"
      },
      {
        "title": "Site Work Built for Daily Use",
        "body": "Commercial sites take constant foot traffic, deliveries and Alberta freeze-thaw cycles. We pay attention to grading, base preparation and concrete placement around entrances, sidewalks and curbs so the exterior holds up as well as the building itself.",
        "benefit": "Customers and staff get safe, durable access from the day your doors open.",
        "image": "2024/08/8-scaled.jpg",
        "imageAlt": "Freshly poured concrete sidewalk and curb corner at the entrance of a new commercial building"
      },
      {
        "title": "Permits, Inspections and Scheduling",
        "body": "Commercial construction in Calgary and area involves development and building permits, staged inspections and trades that need to arrive in the right order. We coordinate the permit process, book inspections and keep the schedule moving so each phase is ready for the next.",
        "benefit": "Your project stays compliant with code and on track toward an opening date you can plan around."
      }
    ],
    "galleryIntro": "A look at commercial construction work by MRE Developments in the Calgary region, from site concrete to building exteriors.",
    "photos": [
      {
        "src": "2024/08/7-scaled.jpg",
        "caption": "Sidewalk poured along storefront entrances",
        "alt": "New concrete sidewalk along storefronts of a commercial building under construction near Calgary"
      },
      {
        "src": "2024/08/8-scaled.jpg",
        "caption": "Concrete curb and sidewalk corner",
        "alt": "Freshly finished concrete curb and sidewalk corner at a new commercial building entrance"
      },
      {
        "src": "2024/08/9-scaled.jpg",
        "caption": "New commercial building and graded site",
        "alt": "Commercial construction in Calgary: new single-storey building with storefront glazing and a graded lot"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do you build new commercial buildings from the ground up?",
        "a": "Yes. MRE Developments takes on ground-up commercial construction for business owners and property managers in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River. We manage the project from site preparation to completion as your general contractor."
      },
      {
        "q": "Do you handle permits and inspections?",
        "a": "Yes. We coordinate the permits your project needs and book the required inspections at each stage of construction. Keeping the paperwork and inspections organized is part of keeping a commercial build on schedule and compliant with code."
      },
      {
        "q": "What is design-build and is it right for my project?",
        "a": "Design-build means the design and construction are delivered by one team under one agreement. It suits owners who want a single point of accountability and early input on cost and buildability. We can talk through whether it fits your project during the free consultation."
      },
      {
        "q": "How long does a commercial construction project take?",
        "a": "The timeline depends on the size of the building, design and permit approvals, site conditions, material lead times and the season. We provide a project schedule with your quote so you can plan financing, leasing and your opening around it."
      },
      {
        "q": "How is a commercial project priced?",
        "a": "Every commercial project is quoted individually based on your drawings, scope and site. We provide a free, detailed quote that sets out what is included, so you can compare options and make decisions with clear numbers."
      },
      {
        "q": "What warranty do you provide on commercial work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know exactly what is covered before construction begins."
      }
    ],
    "ctaTitle": "Plan Your Commercial Build With MRE",
    "ctaSubtitle": "Tell us about your site, timeline and business needs, and we will prepare a free, detailed quote for your commercial construction project in Calgary or area.",
    "projects": [
      {
        "title": "Commercial plaza sidewalks and curb ramp",
        "summary": "Finished concrete sidewalks and curb ramp along new storefronts, plus a site overview.",
        "dates": "Aug 2022",
        "photos": [
          "2024/08/7-scaled.jpg",
          "2024/08/8-scaled.jpg",
          "2024/08/9-scaled.jpg"
        ]
      }
    ]
  },
  "commercial-shrink-wrap": {
    "metaTitle": "Commercial Shrink Wrap Calgary | MRE Developments",
    "metaDescription": "Commercial shrink wrap and temporary weather protection for construction projects in Calgary, Airdrie and Okotoks. Request a project-specific quote today.",
    "headline": "Commercial Shrink Wrap for Calgary Construction Projects",
    "subheadline": "Temporary enclosures that keep wind, snow and rain off your project, so work can continue and materials stay protected through Alberta weather.",
    "hero": "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Multi-storey white building with large windows and horizontal slat railings against a blue sky",
    "overviewTitle": "Weather Protection for Your Project",
    "summary": "MRE Developments provides commercial shrink wrap for project enclosure and temporary weather protection in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region. Shrink wrap can enclose scaffolding, building openings, roofs under construction and stored materials so work areas stay protected from the elements. Tell us what needs to be enclosed, and we will review the site, confirm the scope and provide a project-specific quote.",
    "highlights": [
      "Project review before we quote",
      "Enclosure planning for your site",
      "Temporary weather protection",
      "Site coordination with your schedule",
      "Project-specific quote",
      "Commercial and construction sites"
    ],
    "features": [
      {
        "title": "Keep Work Moving in Any Season",
        "body": "Calgary weather can change quickly, with snow, rain and strong chinook winds arriving with little warning. A shrink-wrapped enclosure shields work areas so crews can keep going and, where heating is used, helps hold temperatures for work such as concrete, drywall and finishing.",
        "benefit": "Your schedule depends less on the forecast."
      },
      {
        "title": "Enclosures Planned for Your Site",
        "body": "Every enclosure starts with a review of what needs protecting, the structure or scaffold it will attach to, access points and ventilation. We plan the layout so the wrap is properly supported, with doors and openings where your crews and deliveries need them.",
        "benefit": "You get an enclosure that fits the site and the way work happens on it."
      },
      {
        "title": "Coordinated With Your Project",
        "body": "Shrink wrap often goes up at a specific stage, such as after framing or scaffolding and before the building is closed in. We coordinate installation timing with the general contractor or site supervisor so it supports the schedule rather than interrupting it.",
        "benefit": "Protection is in place when you need it, with minimal disruption to other trades."
      }
    ],
    "galleryIntro": "Project photos for commercial shrink wrap will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What can commercial shrink wrap be used for?",
        "a": "Shrink wrap is used to enclose scaffolding, building openings, roofs under construction, equipment and stored materials, providing temporary protection from wind, snow and rain. MRE Developments provides it for projects in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "How do I get a quote for shrink wrap?",
        "a": "Tell us what needs to be enclosed, roughly how large the area is and when you need it in place. We review the site and the scope, then provide a project-specific quote."
      },
      {
        "q": "Can a shrink-wrapped enclosure be heated?",
        "a": "Enclosures are often used together with temporary heat to allow winter work. Ventilation and safe heater placement need to be planned with the enclosure, and we discuss these requirements with you during the project review."
      },
      {
        "q": "Will shrink wrap hold up to Calgary winds?",
        "a": "Wind is a major consideration in this region, so the enclosure is planned around how it is supported and secured to the structure or scaffold. We assess exposure during the site review and plan the installation accordingly."
      },
      {
        "q": "Do you coordinate with other trades on site?",
        "a": "Yes. We schedule installation around the project timeline and work with the site supervisor so access points and openings suit the crews and deliveries that need to get through."
      },
      {
        "q": "How long does installation take?",
        "a": "It depends on the size and shape of the area being enclosed, site access and weather conditions. We provide a schedule with your quote."
      }
    ],
    "ctaTitle": "Tell Us What Needs Enclosing",
    "ctaSubtitle": "Share your site details and timing, and we will confirm the scope and provide a project-specific quote for commercial shrink wrap."
  },
  "custom-homes": {
    "metaTitle": "Custom Home Builder Calgary | MRE Developments",
    "metaDescription": "Custom home building in Calgary, Cochrane, Okotoks and area: infills, acreage homes and design-build projects by MRE Developments. Request a free quote.",
    "headline": "Custom Homes in Calgary, Designed Around How You Live",
    "subheadline": "From inner-city infills to acreage builds, we plan, permit and build your home from the ground up, with transparent quotes and one team accountable from design to handover.",
    "hero": "2026/06/lk3-scaled.jpg",
    "heroAlt": "Custom home kitchen in Calgary with a dark wood island, pendant lights and herringbone floor",
    "overviewTitle": "Ground-Up Homes, Built With Care",
    "summary": "MRE Developments builds custom homes across Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region, from narrow inner-city infill lots to rural acreages. We take projects from architectural design and permits through framing, mechanical, finishing and final walkthrough. Every home is planned around your lot, your budget and the way your household actually uses its space.",
    "highlights": [
      "Architectural design and permits coordinated",
      "Inner-city infills and acreage homes",
      "Energy-efficient building envelopes",
      "Smart-home ready wiring and planning",
      "Transparent, detailed project quotes",
      "Licensed and insured general contractor"
    ],
    "features": [
      {
        "title": "Design-Build From Lot to Keys",
        "body": "We start with your lot, your wish list and your budget, then work with designers to produce plans that suit the site and meet City of Calgary or county requirements. With design and construction under one contract, decisions are made once and carried through to the build.",
        "benefit": "One accountable team and a clear path from first sketch to move-in day.",
        "image": "2026/06/sd9-1-scaled.jpg",
        "imageAlt": "Newly built custom bungalow on a graded acreage lot near Calgary with dark roof and covered front entry"
      },
      {
        "title": "Built Tight for Alberta Weather",
        "body": "Chinooks, deep cold snaps and summer heat all test a house. We pay close attention to the building envelope, from insulation and air sealing to window installation and ventilation, and can plan for net-zero-ready performance if that is a goal.",
        "benefit": "A quieter, more comfortable home that costs less to heat and cool.",
        "image": "2026/06/sd2-1-scaled.jpg",
        "imageAlt": "Bright open living room in a new Calgary custom home with fireplace, upper windows and patio door to a deck"
      },
      {
        "title": "Finishes Chosen Around You",
        "body": "Floor plans, kitchens, flooring, lighting and storage are chosen with you rather than picked from a fixed menu. We also rough in for smart-home systems, so lighting, security and climate control are ready when you are.",
        "benefit": "A home that reflects your taste and works for your daily routine.",
        "image": "2026/06/de1-1-1-scaled.jpg",
        "imageAlt": "Custom home front entry with natural stone tile floor and white door opening to a grey feature wall"
      }
    ],
    "galleryIntro": "A look inside and outside custom homes built by MRE Developments in the Calgary region.",
    "photos": [
      {
        "src": "2026/06/lk3-scaled.jpg",
        "caption": "Island kitchen with herringbone flooring",
        "alt": "Custom home kitchen in Calgary with wood island, pendant lighting and herringbone plank floor"
      },
      {
        "src": "2026/06/sd2-1-scaled.jpg",
        "caption": "Open living room with fireplace",
        "alt": "Open-concept living room in a custom home with corner fireplace, high windows and deck access"
      },
      {
        "src": "2026/06/de1-1-1-scaled.jpg",
        "caption": "Stone tile entry and foyer",
        "alt": "Custom home foyer with natural stone tile floor, white entry door and view into the living area"
      },
      {
        "src": "2026/06/sd9-1-scaled.jpg",
        "caption": "New bungalow on an acreage lot",
        "alt": "Exterior of a newly completed custom bungalow on a rural lot near Calgary before landscaping"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do you build custom homes outside Calgary city limits?",
        "a": "Yes. We build in Calgary and across the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore, High River and nearby acreage areas. Rural builds have their own permit and servicing requirements, and we account for those in planning."
      },
      {
        "q": "Can you help with design and permits?",
        "a": "Yes. We coordinate architectural design and drawings and manage the permit applications with the City of Calgary or the relevant municipality. You review and approve the plans before construction begins."
      },
      {
        "q": "How much does a custom home cost?",
        "a": "Cost depends on size, lot conditions, design complexity, finishes and site servicing. After an initial consultation and review of your plans or wish list, we provide a free, detailed quote that breaks down the scope so you can make informed choices."
      },
      {
        "q": "How long does it take to build a custom home?",
        "a": "The timeline is driven by design and permit approvals, the size and complexity of the home, site work, material availability and weather. We lay out a project-specific schedule with your quote and keep you updated as the build progresses."
      },
      {
        "q": "Can you build an energy-efficient or net-zero-ready home?",
        "a": "Yes. We can plan upgraded insulation, air sealing, high-performance windows and mechanical systems to improve efficiency, and design toward net-zero-ready performance if that is your goal. We will explain the options and costs so you can decide what fits your budget."
      },
      {
        "q": "What warranty comes with a new custom home?",
        "a": "New homes in Alberta are covered by provincial new home warranty requirements, and our own warranty and workmanship terms are set out in writing with your quote. We walk you through what is covered before construction starts."
      }
    ],
    "ctaTitle": "Start Planning Your Custom Home",
    "ctaSubtitle": "Tell us about your lot and what you want to build. We will follow up to discuss your plans and prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Custom kitchen with herringbone floor",
        "summary": "Large island, shaker cabinets, statement lighting and herringbone flooring.",
        "dates": "Jan 2026",
        "photos": [
          "2026/06/lk3-scaled.jpg"
        ]
      },
      {
        "title": "Bright living room with skylight",
        "summary": "Open living space with skylight, fireplace and walkout to the deck.",
        "dates": "Jun 2020",
        "photos": [
          "2026/06/sd2-1-scaled.jpg"
        ]
      },
      {
        "title": "Custom home entry with tile floor",
        "summary": "Tiled front entry opening into the main living area.",
        "dates": "",
        "photos": [
          "2026/06/de1-1-1-scaled.jpg"
        ]
      },
      {
        "title": "Custom home exterior near completion",
        "summary": "Two-storey home with dormer, before final grading and landscaping.",
        "dates": "Oct 2018",
        "photos": [
          "2026/06/sd9-1-scaled.jpg"
        ]
      }
    ]
  },
  "data-analytics": {
    "metaTitle": "Data Analytics for Small Business Calgary | MRE",
    "metaDescription": "Business analytics, custom dashboards, KPI reporting and data integration for Calgary and Canadian businesses. Book a free data consultation with MRE.",
    "headline": "Data Analytics for Calgary and Canadian Small Businesses",
    "subheadline": "Your numbers are scattered across spreadsheets, ad accounts and software. We bring them together into dashboards and reports that show what is working and where to grow.",
    "hero": "https://images.unsplash.com/photo-1720139290958-d8676702c3ed?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Row of computer workstations with monitors and office chairs in a modern open-plan office",
    "overviewTitle": "Turn Data Into Decisions",
    "summary": "MRE Developments provides data analytics for small businesses in Calgary and across Canada, covering business analytics, custom dashboards, KPI reporting, data integration and data science. We connect the systems you already use, define the measures that matter and build reporting your team can read at a glance. Projects are delivered remotely with clear scope and transparent pricing.",
    "highlights": [
      "KPI definition and reporting",
      "Custom live dashboards",
      "Data integration across your tools",
      "Sales, marketing and operations analytics",
      "Forecasting and data science",
      "Plain-language insights and training"
    ],
    "features": [
      {
        "title": "Business Analytics You Can Act On",
        "body": "We start by agreeing on the questions your business needs answered, such as where leads come from, which services are most profitable or how demand changes by season. Analysis is then built around those questions rather than around whatever data happens to be available.",
        "benefit": "Clear answers that point to specific decisions."
      },
      {
        "title": "Integrated Data, One Dashboard",
        "body": "We connect sources like your website analytics, ad platforms, CRM, spreadsheets and accounting software, then clean and structure the data so figures agree across systems. Dashboards update automatically and are designed for quick, accurate reading.",
        "benefit": "One reliable view of performance without hours of manual reporting."
      },
      {
        "title": "Forecasting and Data Science",
        "body": "Where your data supports it, we apply forecasting and statistical analysis to spot trends, seasonality and opportunities. Findings are explained in plain language, with the assumptions behind them made clear.",
        "benefit": "Better planning for staffing, budgets and growth."
      }
    ],
    "galleryIntro": "Dashboard examples and sample reports are shown during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Is data analytics worth it for a small business?",
        "a": "Often, yes. Even small businesses generate useful data from sales, marketing and operations. Bringing it together in one place usually reveals where time and money are going and which activities produce results."
      },
      {
        "q": "What systems can you connect?",
        "a": "Common sources include Google Analytics, Google Ads, Meta ads, CRMs, e-commerce platforms, accounting software and spreadsheets. We review your tools during the consultation and confirm what can be integrated."
      },
      {
        "q": "Who can see our data?",
        "a": "Access is limited to the people you approve, and we discuss how data is stored and secured before any integration begins. Privacy and access requirements are documented in the scope."
      },
      {
        "q": "Will my team be able to use the dashboards?",
        "a": "Yes. Dashboards are designed for the people who will use them, and we walk your team through reading and filtering them at handover."
      },
      {
        "q": "How much does data analytics cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number of data sources, the complexity of the dashboards and reports, any forecasting or data science work and whether ongoing support is needed. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Data Strategy Consultation",
    "ctaSubtitle": "Tell us what you wish you knew about your business. We will outline the data, dashboards and scope to get you there."
  },
  "design-drafting-engineering": {
    "metaTitle": "Drafting & Design Services Calgary | MRE Developments",
    "metaDescription": "Architectural drafting, structural engineering, permit drawings and 3D renderings for renovations and new builds in Calgary and area. Get a free quote.",
    "headline": "Design, Drafting and Engineering for Calgary Building Projects",
    "subheadline": "From first concept sketch to stamped permit drawings, get plans that are accurate, buildable and ready for City review, whether you are renovating or building new.",
    "hero": "https://images.unsplash.com/photo-1598911096723-af003b4ea77a?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Modern white building with a cantilevered upper storey against a blue sky",
    "overviewTitle": "Plans That Are Ready to Build",
    "summary": "MRE Developments provides design, drafting and engineering services for renovations, additions, secondary suites and new builds in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region. We take your project from concept sketches and 3D renderings through to permit drawings, with structural engineering where the work requires it. Because we also build, our drawings are prepared with real construction in mind.",
    "highlights": [
      "Architectural drafting",
      "Structural engineering where required",
      "Permit-ready drawing sets",
      "3D renderings and concept designs",
      "Renovations, additions and new builds",
      "Drawings prepared with construction in mind"
    ],
    "features": [
      {
        "title": "See Your Project Before Building",
        "body": "Concept sketches and 3D renderings let you walk through layouts, compare options and settle on finishes before anything is built. It is much easier and less costly to move a wall on a drawing than on site.",
        "benefit": "You make design decisions with confidence and avoid costly changes later."
      },
      {
        "title": "Permit Drawings Done Properly",
        "body": "Permit applications in Calgary and the surrounding municipalities need complete, accurate drawings that show how the project meets code. We prepare floor plans, elevations, sections and details to the standard reviewers expect, and respond to review comments when they come back.",
        "benefit": "Your permit application moves forward with fewer delays and resubmissions."
      },
      {
        "title": "Structural Engineering You Can Trust",
        "body": "Removing walls, adding storeys, building additions and creating new openings all affect how loads travel through a building. Beams, posts, footings and connections are engineered for the actual conditions, with stamped drawings provided where they are required for permit.",
        "benefit": "Your project is built on sound engineering and meets the requirements for approval."
      }
    ],
    "galleryIntro": "Project examples for design, drafting and engineering will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What design and drafting services do you offer?",
        "a": "We provide concept design, 3D renderings, architectural drafting, permit drawings and structural engineering for residential and commercial projects. MRE Developments serves Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "Do I need stamped drawings for my project?",
        "a": "It depends on the scope. Structural changes such as removing load-bearing walls, adding storeys or building larger additions often require engineered, stamped drawings for the permit. We review your project and confirm what the municipality will require."
      },
      {
        "q": "Can you prepare drawings for a secondary suite or basement?",
        "a": "Yes. Secondary suites, basement developments, additions and renovations all typically need drawings for permit. We prepare the drawing set and can also build the project once it is approved."
      },
      {
        "q": "Do I have to hire you to build if you do my drawings?",
        "a": "Design and drafting can be provided on their own. Many clients choose to have us build the project as well, since the same team that drew the plans understands the details on site."
      },
      {
        "q": "How long does it take to get drawings ready?",
        "a": "It depends on the size and complexity of the project, the number of design revisions and whether engineering is needed. We provide a timeline with your quote and keep you updated through each stage."
      },
      {
        "q": "How are design and drafting services priced?",
        "a": "Pricing depends on the project scope and the drawings and engineering it needs. We provide a free, detailed quote specific to your project."
      }
    ],
    "ctaTitle": "Start Your Project on Solid Plans",
    "ctaSubtitle": "Tell us what you want to build or renovate, and we will provide a free, detailed quote for design, drafting and engineering."
  },
  "drywall": {
    "metaTitle": "Drywall Contractor Calgary | Drywall & Taping | MRE",
    "metaDescription": "Drywall installation, taping, mudding and texture in Calgary, Airdrie and Cochrane for renovations and new builds, Level 5 available. Get a free MRE quote.",
    "headline": "Drywall and Taping in Calgary, Finished Paint-Ready",
    "subheadline": "Board hung straight, joints taped and sanded smooth, and walls ready for paint without visible seams or screw pops. Level 5 finishing is available where the light is unforgiving.",
    "hero": "https://images.unsplash.com/photo-1610177534644-34d881503b83?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Bright residential interior with smooth painted walls and ceilings",
    "overviewTitle": "Smooth Walls, Clean Ceilings",
    "summary": "MRE Developments installs and finishes drywall for basement developments, renovations, additions and new homes across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our work covers board installation, taping and mudding, sanding, texture and ceiling finishes, through to a surface that is ready for paint. We pay attention to straight corners, flat joints and clean bulkheads, because those details show once the lights go on.",
    "highlights": [
      "Board hanging on walls and ceilings",
      "Taping, mudding and sanding",
      "Level 5 finishing available",
      "Ceiling texture and smooth finishes",
      "Soundproofing assemblies for suites",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Paint-Ready Without Seams",
        "body": "Poorly finished drywall shows every joint and fastener once paint goes on, especially under pot lights or beside large windows. We tape, coat and sand in stages so joints are flat and corners are crisp before the painter arrives.",
        "benefit": "Walls and ceilings that look smooth and professional after the first coat of paint."
      },
      {
        "title": "Level 5 for Critical Light",
        "body": "Rooms with tall windows, raking light or dark paint benefit from a Level 5 finish, where a thin skim coat is applied over the entire surface. We will recommend the right finish level for each space so you are not paying for more than you need.",
        "benefit": "A uniform surface with no flashing or visible joints in critical areas."
      },
      {
        "title": "Built Into the Whole Project",
        "body": "Because drywall is part of our renovation and development work, we coordinate it with framing, insulation, electrical and plumbing inspections. We can also install resilient channel, acoustic insulation and fire-rated board where a suite or shared wall calls for sound and fire separation.",
        "benefit": "One schedule, fewer handoffs, and assemblies that meet code the first time."
      }
    ],
    "galleryIntro": "Project photos for this service are being added; drywall work appears throughout our basement and renovation galleries.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What is a Level 5 drywall finish?",
        "a": "Level 5 is the highest drywall finish level. After the joints are taped and coated, a thin skim coat is applied over the entire surface to even out texture and porosity. It is recommended for walls and ceilings with strong side lighting, glossy paint or dark colours."
      },
      {
        "q": "Do you take on small drywall patch jobs?",
        "a": "We focus on drywall as part of projects such as basement developments, renovations, additions and new builds rather than one-off patches. If drywall repairs are part of a larger renovation, we include them in that scope."
      },
      {
        "q": "Can you install soundproof drywall assemblies?",
        "a": "Yes. For basement suites, shared walls and home theatres we can combine acoustic insulation, resilient channel and specialty or fire-rated board to reduce sound transfer and meet separation requirements."
      },
      {
        "q": "Do you do ceiling texture?",
        "a": "Yes. We can match common ceiling textures or finish ceilings smooth, depending on the look you want and the condition of the existing surfaces."
      },
      {
        "q": "How much does drywall installation cost?",
        "a": "Cost depends on the square footage, ceiling height, number of corners and bulkheads, finish level and texture. We provide a free, detailed quote as part of your project."
      },
      {
        "q": "How long does drywall take?",
        "a": "Drywall is applied in stages, and each coat needs time to dry before sanding and the next coat. The timeline depends on the size of the space, the finish level and humidity, and we include it in the project schedule that comes with your quote."
      }
    ],
    "ctaTitle": "Get a Quote for Your Drywall Project",
    "ctaSubtitle": "Tell us about your renovation, basement or new build and we will prepare a free, detailed quote that includes the drywall scope."
  },
  "excavation": {
    "metaTitle": "Excavation Contractor Calgary | Earth Works | MRE",
    "metaDescription": "Excavation, trenching, grading and backfill in Calgary, Airdrie and Okotoks, including hand digging in tight side yards. Request a free quote from MRE.",
    "headline": "Excavation and Earth Works in Calgary, Even in Tight Spaces",
    "subheadline": "Foundation access, trenching, grading and backfill that prepare a stable base for your project, dug carefully by hand where machines cannot reach and protected around your home.",
    "hero": "2025/09/Screenshot-2025-09-22-at-3.15.28-PM.png",
    "heroAlt": "Hand-dug excavation along a house foundation in Calgary with shovels and gravel at the edge",
    "overviewTitle": "Prepared Ground for Every Build",
    "summary": "MRE Developments handles excavation and earth works for projects across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, from digging along foundations for waterproofing and separate entries to trenching, grading and backfill. In narrow side yards between homes, our crew excavates by hand to protect the foundation, fences, landscaping and neighbouring property. Every dig is planned around utilities, soil conditions and the work that follows.",
    "highlights": [
      "Excavation along existing foundations",
      "Hand digging in tight side yards",
      "Trenching for drainage and services",
      "Grading and compacted backfill",
      "Utility locates before every dig",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Access Where Machines Cannot Go",
        "body": "Many Calgary homes have side yards too narrow for equipment. Our crew excavates by hand with shovels and wheelbarrows, hauling soil out without damaging fences, siding, sod or the house next door.",
        "benefit": "Foundation work is possible even on tight lots, with minimal disruption to your yard.",
        "image": "2025/09/Screenshot-2025-09-22-at-1.46.52-PM.png",
        "imageAlt": "Crew hand digging along a house foundation in a narrow Calgary side yard with a wheelbarrow"
      },
      {
        "title": "Careful Digging at the Foundation",
        "body": "Excavating beside a foundation calls for care. We confirm utility locates, dig in controlled stages, keep the trench walls stable and expose the wall cleanly for the waterproofing, drainage or entry work that follows.",
        "benefit": "A clean, safe excavation that protects your foundation and the people working in it.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.14.30-PM.png",
        "imageAlt": "Worker excavating soil by shovel along a house foundation with the dirt piled beside the trench"
      },
      {
        "title": "Grading, Backfill and Drainage",
        "body": "Once the work below grade is done, we backfill in lifts, compact the soil and restore grading so surface water moves away from the house. Trenching for drainage and services is planned with the same attention to slope and settlement.",
        "benefit": "A yard that drains properly and stays level after the project is finished.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.14.46-PM.png",
        "imageAlt": "Open trench along a home's foundation with drain rock placed alongside during Calgary earth works"
      }
    ],
    "galleryIntro": "Hand excavation along foundations completed by MRE Developments in Calgary-area side yards.",
    "photos": [
      {
        "src": "2025/09/Screenshot-2025-09-22-at-1.46.52-PM.png",
        "caption": "Hand digging in a narrow side yard",
        "alt": "Crew hand digging along a foundation in a narrow Calgary side yard with a wheelbarrow and buckets"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.06.25-PM.png",
        "caption": "Crew working between two homes",
        "alt": "Excavation crew with shovels and buckets working in a side yard between two Calgary homes"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.14.30-PM.png",
        "caption": "Shovelling beside the foundation",
        "alt": "Worker hand excavating soil along a house foundation, with dirt mounded beside the trench"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.14.46-PM.png",
        "caption": "Trench open beside drain rock",
        "alt": "Open excavation along a foundation wall with drain rock and a crew member working in the trench"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.15.28-PM.png",
        "caption": "Clean trench exposing the foundation",
        "alt": "Hand-dug excavation along a house foundation with straight trench walls and shovels in Calgary"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.41.38-PM.png",
        "caption": "Excavation along the foundation wall",
        "alt": "Trench excavated along a home's foundation with soil piled on the lawn during earth works"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What excavation work do you do?",
        "a": "We excavate along foundations for waterproofing, drainage and separate entries, dig trenches for drainage and services, and handle grading and backfill. Excavation is usually part of a larger project we are building, so the dig is planned around the work that follows."
      },
      {
        "q": "Can you excavate in a narrow side yard?",
        "a": "Yes. Where there is no room for equipment, our crew excavates by hand and removes soil with wheelbarrows. This protects fences, siding, landscaping and neighbouring property while still giving full access to the foundation."
      },
      {
        "q": "Do you arrange utility locates?",
        "a": "Yes. Underground utilities are located and marked before any digging starts, which is required in Alberta and essential for safety."
      },
      {
        "q": "Do you restore the yard after excavation?",
        "a": "We backfill, compact and grade the soil so water drains away from the house. If you want sod, gravel or hardscape restored afterwards, we can include that in the quote."
      },
      {
        "q": "How much does excavation cost?",
        "a": "Cost depends on the length and depth of the dig, access, soil conditions, whether the work is by hand or machine, and how much soil needs to be hauled away. We provide a free, detailed quote after seeing the site."
      },
      {
        "q": "How long does excavation take?",
        "a": "The timeline depends on the size of the excavation, access, soil conditions, weather and the work that has to happen while the ground is open. A project-specific schedule comes with your quote."
      }
    ],
    "ctaTitle": "Get a Quote for Excavation Work",
    "ctaSubtitle": "Tell us about your project and your site access, and we will prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Side-yard trench along a home",
        "summary": "Crew hand-digging a trench along the foundation in a narrow side yard.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-1.46.52-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.06.25-PM.png"
        ]
      },
      {
        "title": "Foundation dig-out to footing",
        "summary": "Soil removed along the foundation down to footing level, exposing the wall.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-3.14.30-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.14.46-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.15.28-PM.png"
        ]
      },
      {
        "title": "More excavation work",
        "summary": "Foundation wall exposed by excavation along a sided home.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-3.41.38-PM.png"
        ]
      }
    ]
  },
  "garages-shops": {
    "metaTitle": "Garage Builder Calgary | Garages & Shops | MRE",
    "metaDescription": "Detached garages, heated shops and garage suites in Calgary, Cochrane and Okotoks, built by MRE Developments with permits handled. Request a free quote.",
    "headline": "Garages and Shops Built for Calgary Lots and Acreages",
    "subheadline": "Detached garages, heated workshops and garage suites designed to match your home, from the concrete pad to the roof, with permits and trades coordinated by one team.",
    "hero": "https://images.unsplash.com/photo-1691425700585-c108acad6467?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Exterior view of a residential building with a finished facade and driveway",
    "overviewTitle": "Garages and Shops, Start to Finish",
    "summary": "MRE Developments builds detached and attached garages, heated shops and garage suites for homeowners in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and nearby acreages. We handle design, permits, the concrete pad, framing, roofing, electrical and finishing, so the new structure is solid, code-compliant and matched to your house. Whether you need parking, a hobby shop or a laneway suite, we plan it around how you will use it.",
    "highlights": [
      "Detached and attached garages",
      "Garage suites above or beside",
      "Heated, insulated workshops",
      "Concrete garage pads and aprons",
      "Permits and inspections handled",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Built to Match Your Home",
        "body": "A garage should look like it belongs on the property. We match rooflines, siding and trim to your house and plan door sizes, ceiling heights and lighting around the vehicles, trailers or equipment you need to store.",
        "benefit": "A garage that adds function and kerb appeal instead of looking like an afterthought."
      },
      {
        "title": "Solid From the Pad Up",
        "body": "Every garage starts with a properly prepared base and a reinforced concrete pad, followed by straight, square framing and a well-sealed roof. For heated shops we plan insulation, vapour barrier, heating and electrical capacity together, so the space stays usable through a Calgary winter.",
        "benefit": "A durable structure that stays square, dry and comfortable year-round."
      },
      {
        "title": "Shops and Garage Suites",
        "body": "Many acreage owners in the Calgary region want a heated workshop, and many city lots can support a garage suite. We design for the uses you have in mind, including power for tools, plumbing for a suite, and the separation and access requirements a suite must meet.",
        "benefit": "Extra workspace or rental income built into one well-planned structure."
      }
    ],
    "galleryIntro": "Project photos for this service are being added; contact us to discuss garages and shops we have built.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Do I need a permit to build a garage in Calgary?",
        "a": "In most cases, yes. Detached garages typically need a building permit, and electrical work and any suite will need additional permits. We prepare the drawings and handle the applications and inspections as part of the project."
      },
      {
        "q": "Can you build a garage suite?",
        "a": "Yes. We can plan and build a suite above or beside a garage where zoning allows it. Suites have specific requirements for access, fire separation, heating and servicing, and we design to those from the start."
      },
      {
        "q": "Do you pour the concrete pad as well?",
        "a": "Yes. The concrete pad and apron are part of our garage builds, including base preparation, reinforcement and finishing, so the foundation and structure are coordinated by one team."
      },
      {
        "q": "Do you build shops on acreages outside Calgary?",
        "a": "Yes. We build garages and heated shops in Calgary and across the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River. Rural sites have their own permit and servicing considerations, which we account for in planning."
      },
      {
        "q": "How much does a new garage or shop cost?",
        "a": "Cost depends on size, foundation, heating and insulation, electrical needs, finishes and whether a suite is included. We provide a free, detailed quote once we understand the site and how you plan to use the building."
      },
      {
        "q": "How long does it take to build a garage?",
        "a": "The timeline depends on permit approval, the size and complexity of the structure, concrete curing, weather and material availability. We include a project-specific schedule with your quote."
      }
    ],
    "ctaTitle": "Get a Quote for Your Garage or Shop",
    "ctaSubtitle": "Tell us about your lot and what you need the space for, and we will prepare a free, detailed quote."
  },
  "graphic-design": {
    "metaTitle": "Graphic Design Services Calgary | MRE Developments",
    "metaDescription": "Print design, marketing collateral, packaging and social graphics for Calgary and Canadian businesses. Book a free consultation with MRE Developments.",
    "headline": "Graphic Design in Calgary That Makes Your Business Look Sharp",
    "subheadline": "Inconsistent flyers, tired brochures and off-brand social posts undercut your credibility. We design print, packaging and digital graphics that look professional and on brand.",
    "hero": "https://images.unsplash.com/photo-1502810190503-8303352d0dd1?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Desktop computer on a wooden desk beneath a wall of pinned prints, sketches and design references",
    "overviewTitle": "Design That Looks the Part",
    "summary": "MRE Developments offers graphic design for businesses in Calgary and across Canada, covering print design, marketing collateral, packaging design and social graphics. Every piece follows your brand standards and is prepared to the correct specifications for printers, packaging suppliers and social platforms. Work is delivered remotely with clear scope and revision rounds.",
    "highlights": [
      "Brochures, flyers and sales sheets",
      "Business cards and stationery",
      "Packaging and label design",
      "Social media graphics and templates",
      "Trade show and event materials",
      "Print-ready and web-ready files"
    ],
    "features": [
      {
        "title": "Print and Marketing Collateral",
        "body": "We design brochures, sales sheets, flyers, proposals and presentation materials that explain your offer clearly and look professional in a client's hands. Layouts are built around your message, with hierarchy that guides the reader to the next step.",
        "benefit": "Sales materials that support your team in every conversation."
      },
      {
        "title": "Files Prepared for Production",
        "body": "Print and packaging work is set up with correct bleed, colour profiles, dielines and resolution for your chosen printer or supplier. Digital assets are exported at the right sizes for each platform, so nothing arrives blurry or cropped.",
        "benefit": "Fewer surprises at the printer and a consistent finish every time."
      },
      {
        "title": "Packaging and Social Graphics",
        "body": "Packaging and labels need to stand out on a shelf while meeting practical requirements. For social media, we create on-brand templates your team can reuse, so posts stay consistent between design projects.",
        "benefit": "Your products and posts are instantly recognisable as yours."
      }
    ],
    "galleryIntro": "Design samples relevant to your project are shared during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What types of graphic design do you offer?",
        "a": "We design print and marketing collateral, business cards and stationery, packaging and labels, signage graphics, presentation decks and social media graphics. If you need a full brand identity first, see our branding and identity service."
      },
      {
        "q": "Do you work from my existing brand guidelines?",
        "a": "Yes. If you have brand guidelines, we follow them closely. If you do not, we can document your colours, fonts and logo usage as part of the project so future work stays consistent."
      },
      {
        "q": "Can you handle printing?",
        "a": "We prepare print-ready files to your printer's specifications and can coordinate with a printer of your choice. Printing costs are quoted separately so you can see exactly what you are paying for."
      },
      {
        "q": "How many revisions are included?",
        "a": "Revision rounds are defined in the project scope so expectations are clear from the start. Most projects include a set number of concept and refinement rounds."
      },
      {
        "q": "How much does graphic design cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number of pieces, their complexity, whether copywriting is needed and how many formats or sizes each design must be adapted to. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Design Strategy Consultation",
    "ctaSubtitle": "Tell us what you need designed and how it will be used. We will outline a clear scope and timeline."
  },
  "hvac": {
    "metaTitle": "HVAC Contractor Calgary | Heating & Cooling | MRE",
    "metaDescription": "Furnace, air conditioning, heat pump and ductwork installation in Calgary, Airdrie and Okotoks for new builds and renovations. Request a free MRE quote.",
    "headline": "Heating and Cooling in Calgary, Sized for Real Alberta Weather",
    "subheadline": "Furnaces, air conditioning, heat pumps and ductwork planned and installed as part of your build or renovation, so every room stays comfortable from January cold snaps to July heat.",
    "hero": "2026/07/20260404_140315-scaled.jpg",
    "heroAlt": "Technician working overhead with a cordless tool beside new ductwork in a Calgary home",
    "overviewTitle": "Comfort Systems Done Properly",
    "summary": "MRE Developments installs heating, cooling and ventilation systems for new homes, additions, basement developments and major renovations across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We size equipment to the home, lay out ductwork for even airflow and coordinate the mechanical work with the rest of the project. The result is a system that runs efficiently and keeps the whole house comfortable.",
    "highlights": [
      "Furnace and air conditioning installation",
      "Heat pumps for efficient heating and cooling",
      "Ductwork design and installation",
      "Ventilation and indoor air quality",
      "Coordinated with your renovation or build",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Even Comfort in Every Room",
        "body": "Cold bedrooms over the garage and hot upper floors usually come down to equipment and ductwork that were not planned for the house. We size the system to the home's heat loss and gain and route supply and return air so every room is served properly.",
        "benefit": "Steady temperatures throughout the house without overworking the equipment.",
        "image": "2026/07/20260404_141011-scaled.jpg",
        "imageAlt": "New sheet metal duct trunk and fittings installed between floor joists during a Calgary HVAC installation"
      },
      {
        "title": "Clean, Secure Mechanical Rough-In",
        "body": "Ductwork is fitted, sealed and supported before ceilings close, and connections are made with the right tools for the job. Because we coordinate HVAC with framing, plumbing and electrical, runs stay tidy and bulkheads are kept to a minimum in finished spaces.",
        "benefit": "A quieter, more efficient system and cleaner ceilings in the finished room.",
        "image": "2026/07/20260404_152349-scaled.jpg",
        "imageAlt": "Installer using a cordless press tool on a pipe connection next to ductwork in a basement ceiling"
      },
      {
        "title": "Heat Pumps and Fresh Air",
        "body": "Heat pumps can provide efficient heating and cooling, often paired with a gas furnace for the coldest Calgary days. We also install ventilation that brings in fresh air and manages humidity, which matters more as homes become tighter and more energy-efficient.",
        "benefit": "Lower energy use and healthier indoor air for your household.",
        "image": "2026/07/20260404_140844-scaled.jpg",
        "imageAlt": "Ductwork, piping and wiring routed through open floor joists during mechanical rough-in"
      }
    ],
    "galleryIntro": "Mechanical rough-in and ductwork from MRE Developments heating and cooling installations in Calgary homes.",
    "photos": [
      {
        "src": "2026/07/20260404_140315-scaled.jpg",
        "caption": "Overhead work beside new ductwork",
        "alt": "Technician working overhead with a cordless tool near round and rectangular ductwork in a Calgary home"
      },
      {
        "src": "2026/07/20260404_140844-scaled.jpg",
        "caption": "Coordinated mechanical rough-in",
        "alt": "Ductwork, PEX lines, gas pipe and wiring routed neatly through joists during an HVAC installation"
      },
      {
        "src": "2026/07/20260404_141011-scaled.jpg",
        "caption": "Duct trunk fitted between joists",
        "alt": "HVAC ductwork trunk and fittings installed between floor joists alongside water and gas lines"
      },
      {
        "src": "2026/07/20260404_152349-scaled.jpg",
        "caption": "Pressed pipe connection at ductwork",
        "alt": "Installer pressing a pipe fitting with a cordless tool next to new ductwork in a basement ceiling"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "Do you install HVAC as a standalone service?",
        "a": "We install heating, cooling and ventilation as part of projects such as new homes, additions, basement developments and larger renovations. Coordinating the mechanical work with the rest of the build gives the best result and the cleanest finished spaces."
      },
      {
        "q": "Is a heat pump a good choice in Calgary?",
        "a": "Modern cold-climate heat pumps can heat a home efficiently through much of the Calgary winter and also provide cooling in summer. Many homeowners pair one with a gas furnace for the coldest days. We will explain the options for your home and the trade-offs in cost and efficiency."
      },
      {
        "q": "How do you size a furnace or air conditioner?",
        "a": "We base equipment size on the home's heat loss and heat gain, which depends on its size, insulation, windows and layout. Oversized or undersized equipment leads to uneven comfort and wasted energy, so sizing is done before equipment is chosen."
      },
      {
        "q": "Do you handle permits for HVAC work?",
        "a": "Yes. Mechanical and gas work in Calgary requires permits and inspections, and we arrange those as part of the project."
      },
      {
        "q": "How much does a new furnace, AC or heat pump installation cost?",
        "a": "Cost depends on the equipment, the size of the home, how much ductwork is new or modified, and any electrical or gas changes needed. We provide a free, detailed quote after reviewing the home and your goals."
      },
      {
        "q": "What warranty comes with the installation?",
        "a": "Equipment carries the manufacturer's warranty, and our workmanship terms are set out in writing with your quote. We review both with you before the work begins."
      }
    ],
    "ctaTitle": "Plan Your Heating and Cooling Upgrade",
    "ctaSubtitle": "Tell us about your home or project and we will prepare a free, detailed quote for the heating, cooling and ventilation work.",
    "projects": [
      {
        "title": "Basement ductwork and pipe fitting",
        "summary": "Ductwork and piping in open basement joists, fitted and pressed into place.",
        "dates": "Apr 2026",
        "photos": [
          "2026/07/20260404_140315-scaled.jpg",
          "2026/07/20260404_140844-scaled.jpg",
          "2026/07/20260404_141011-scaled.jpg",
          "2026/07/20260404_152349-scaled.jpg"
        ]
      }
    ]
  },
  "insulation": {
    "metaTitle": "Insulation Contractor Calgary | MRE Developments",
    "metaDescription": "Spray foam, batt and blown-in insulation plus soundproofing for homes in Calgary, Airdrie, Cochrane and Okotoks. Request a free insulation quote today.",
    "headline": "Insulation in Calgary for Warmer Winters and Quieter Homes",
    "subheadline": "Spray foam, batt and blown-in insulation installed as part of your renovation, addition or new build, to cut drafts, steady indoor temperatures and reduce noise.",
    "hero": "https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "White modern house with a walkway and lawn under a clear blue sky",
    "overviewTitle": "Insulation Matched to Each Space",
    "summary": "MRE Developments installs spray foam, batt and blown-in insulation for homeowners in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area. We choose the right insulation for walls, attics, basements, rim joists and interior partitions, and install it carefully so it performs the way it should. Insulation is usually part of a larger renovation, addition, basement development or new build that we manage from framing to finish.",
    "highlights": [
      "Spray foam insulation",
      "Batt insulation for walls and basements",
      "Blown-in attic insulation",
      "Soundproofing between rooms and floors",
      "Energy-efficient upgrades during renovations",
      "Licensed and insured contractor"
    ],
    "features": [
      {
        "title": "Comfort Through Calgary Winters",
        "body": "Cold floors, drafty rooms and high heating bills often come down to gaps in insulation and air sealing. We insulate exterior walls, attics, basements and rim joists to suit how each area is built, paying attention to the corners and penetrations where heat escapes.",
        "benefit": "Your home stays more comfortable through cold snaps and costs less to heat."
      },
      {
        "title": "The Right Material for Each Area",
        "body": "Spray foam seals and insulates in one step and works well in rim joists, irregular cavities and spots where air leakage is a concern. Batts suit open stud walls and basements, while blown-in insulation fills attics evenly. We recommend the material for each area rather than a single product for the whole house.",
        "benefit": "You get insulation that performs well where it is installed, without paying for more than you need."
      },
      {
        "title": "Quieter Rooms With Soundproofing",
        "body": "Sound insulation in interior walls and between floors cuts down noise from bedrooms, bathrooms, home offices, media rooms and secondary suites. Combined with careful detailing at outlets and doors, it makes a noticeable difference in daily life.",
        "benefit": "Everyone in the house gets more privacy and better rest."
      }
    ],
    "galleryIntro": "Project photos for insulation work will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Which type of insulation is best for my home?",
        "a": "It depends on the area. Spray foam is well suited to rim joists, irregular cavities and spots where air sealing matters most, batts work well in open stud walls and basements, and blown-in insulation is common in attics. We assess your project and recommend the right material for each space."
      },
      {
        "q": "Do you insulate as part of a renovation or basement development?",
        "a": "Yes. Most of our insulation work is part of a larger project, such as a basement development, addition, renovation or new home in Calgary, Airdrie, Cochrane, Okotoks or Chestermere. Insulating while walls are open is the most effective time to do it."
      },
      {
        "q": "Can insulation help with noise between rooms or suites?",
        "a": "Yes. Sound insulation in interior walls and floor assemblies reduces noise between bedrooms, bathrooms, offices and secondary suites. We combine it with good detailing around openings for the best result."
      },
      {
        "q": "Will better insulation lower my energy bills?",
        "a": "Improved insulation and air sealing reduce the heat your home loses in winter and gains in summer, which typically lowers heating and cooling demand. The amount you save depends on your home's current condition and the scope of the upgrade."
      },
      {
        "q": "How long does an insulation project take?",
        "a": "It depends on the areas being insulated, the materials chosen and how the work fits into the rest of your project and inspections. We include a schedule with your quote."
      },
      {
        "q": "How much does insulation cost?",
        "a": "Pricing depends on the area, the insulation type and the level of performance you are aiming for. We provide a free, detailed quote specific to your project."
      }
    ],
    "ctaTitle": "Make Your Home Warmer and Quieter",
    "ctaSubtitle": "Tell us about your home and project, and we will recommend the right insulation and provide a free, detailed quote."
  },
  "interior-finishings": {
    "metaTitle": "Interior Finishing Calgary | MRE Developments",
    "metaDescription": "Interior finishing in Calgary, Airdrie and Cochrane: trim, baseboards, crown molding, stair finishing and custom millwork. Request a free quote today.",
    "headline": "Interior Finishing in Calgary That Completes the Home",
    "subheadline": "Trim, baseboards, doors, crown molding, stair finishing and custom millwork installed with tight joints and clean lines, so every room looks truly finished.",
    "hero": "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_605053b1.jpg",
    "heroAlt": "Finished room with white six-panel doors, white baseboards and grey plank flooring in a Calgary home",
    "overviewTitle": "The Details That Finish a Space",
    "summary": "MRE Developments provides interior finishing for homeowners in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area. We install interior doors, trim, baseboards, crown molding, stair nosings and handrails, and custom millwork that turn drywalled space into a finished home. Finishing is often the last stage of a basement development, renovation or new build that we manage from start to finish.",
    "highlights": [
      "Trim, casings and baseboards",
      "Interior door installation",
      "Crown molding and ceiling details",
      "Stair finishing and handrails",
      "Custom millwork",
      "Finishing for renovations and new builds"
    ],
    "features": [
      {
        "title": "Doors, Trim and Baseboards",
        "body": "Doors, casings and baseboards frame every room, so small gaps and uneven reveals stand out. We hang doors to swing and latch properly, then fit casings and baseboards with tight mitres and consistent reveals before filling and caulking for paint.",
        "benefit": "Your rooms look clean, crisp and properly finished from every angle.",
        "image": "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_02a06db5.jpg",
        "imageAlt": "Hallway finished with white doors, casings and baseboards over light grey laminate flooring"
      },
      {
        "title": "Stairs Finished With Care",
        "body": "Stairs are one of the most used and most noticed parts of a home. We finish treads, nosings and skirt boards so they line up cleanly, and install handrails securely at a comfortable height along the full run.",
        "benefit": "You get a staircase that looks sharp and feels solid underfoot and in hand.",
        "image": "2025/10/8-2-scaled.jpg",
        "imageAlt": "Finished basement staircase with grey treads, white risers and white skirt boards in a Calgary home"
      },
      {
        "title": "Custom Millwork and Details",
        "body": "Crown molding, wall panelling, wood ceiling features and built-ins give a home character. We build and install custom millwork to suit the style of each space, coordinating it with the paint and flooring for a finish that looks intentional.",
        "benefit": "Your home gets distinctive details that hold up to daily life.",
        "image": "2026/05/1-15-scaled.jpg",
        "imageAlt": "Stairwell with wood handrails on both sides and a wood plank feature panel above the opening"
      }
    ],
    "galleryIntro": "Interior finishing work by MRE Developments in Calgary homes, from doors and baseboards to finished staircases and handrails.",
    "photos": [
      {
        "src": "2025/10/8-2-scaled.jpg",
        "caption": "Basement stairs with white skirt boards",
        "alt": "Basement staircase with grey treads, white risers and skirt boards, finished by MRE in Calgary"
      },
      {
        "src": "2025/11/2-3-scaled.jpg",
        "caption": "Stair skirts and wall handrail",
        "alt": "Finished staircase with white skirt boards and a metal wall-mounted handrail in a Calgary home"
      },
      {
        "src": "2025/09/2-4.png",
        "caption": "Straight-run stairs with clean skirt boards",
        "alt": "Straight-run staircase with finished treads, skirt boards and a wall-mounted handrail"
      },
      {
        "src": "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_02a06db5.jpg",
        "caption": "Hallway doors, casings and baseboards",
        "alt": "Finished hallway with white doors, door casings and baseboards over light grey laminate flooring"
      },
      {
        "src": "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_605053b1.jpg",
        "caption": "White doors and baseboards over laminate",
        "alt": "Interior finishing in Calgary: room with white six-panel doors, baseboards and grey plank flooring"
      },
      {
        "src": "2026/05/1-15-scaled.jpg",
        "caption": "Twin wood handrails and plank feature",
        "alt": "Stairwell with wood handrails on both walls and a wood plank panel above, an interior finishing detail"
      },
      {
        "src": "2026/05/2-13-scaled.jpg",
        "caption": "Stairwell with wall-mounted wood handrails",
        "alt": "View down a finished stairwell with wood handrails mounted on both white walls"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What does interior finishing include?",
        "a": "Interior finishing covers the work that turns drywalled space into a finished room, including interior doors, casings, baseboards, crown molding, stair finishing, handrails and custom millwork. MRE Developments provides interior finishing for homes in Calgary, Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "Do you only do finishing, or the whole project?",
        "a": "Interior finishing is usually part of a larger project we manage, such as a basement development, renovation or new home. We take on projects rather than one-off small repairs, which lets us coordinate finishing with flooring, painting and the rest of the work."
      },
      {
        "q": "Can you finish stairs and install handrails?",
        "a": "Yes. We finish stair treads, nosings and skirt boards and install handrails securely along the stair run. Handrails and guards are installed to meet building code requirements."
      },
      {
        "q": "Can you match existing trim in an older home?",
        "a": "In many cases, yes. We review the existing profiles and source or build trim that matches or complements them, so new work blends in with the rest of the house."
      },
      {
        "q": "How long does interior finishing take?",
        "a": "It depends on the size of the space, the amount of trim and millwork, and material lead times. We provide a schedule with your quote that fits finishing into the rest of your project."
      },
      {
        "q": "What warranty do you offer on finishing work?",
        "a": "Warranty and workmanship terms are set out in writing with your quote, so you know what is covered before work begins."
      }
    ],
    "ctaTitle": "Give Your Home a Finished Look",
    "ctaSubtitle": "Tell us about your project and the finishes you have in mind, and we will provide a free, detailed interior finishing quote.",
    "projects": [
      {
        "title": "Basement stairway finishing",
        "summary": "Stairway finished with new treads, painted walls, skirting and handrail.",
        "dates": "Jun 2024 – Aug 2024",
        "photos": [
          "2025/10/8-2-scaled.jpg",
          "2025/11/2-3-scaled.jpg",
          "2025/09/2-4.png"
        ]
      },
      {
        "title": "Finished hallway and bedroom area",
        "summary": "Painted walls, new six-panel doors and plank flooring throughout the hallway.",
        "dates": "",
        "photos": [
          "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_02a06db5.jpg",
          "2024/08/WhatsApp-Image-2025-10-21-at-19.18.01_605053b1.jpg"
        ]
      },
      {
        "title": "More interior finishing work",
        "summary": "Finished stairways with wood handrails and painted walls.",
        "dates": "May 2025 – Mar 2026",
        "photos": [
          "2026/05/1-15-scaled.jpg",
          "2026/05/2-13-scaled.jpg"
        ]
      }
    ]
  },
  "landscaping": {
    "metaTitle": "Landscaping & Hardscaping Calgary | MRE Developments",
    "metaDescription": "Concrete patios, walkways, paving stones, retaining walls and grading in Calgary, Airdrie and Okotoks by MRE Developments. Request a free quote today.",
    "headline": "Landscaping and Hardscaping in Calgary, Built From the Base Up",
    "subheadline": "Patios, walkways, steps, retaining walls and grading that stay level, drain properly and finish your property, with the base work done right before anything is poured or laid.",
    "hero": "2026/04/20240824_193528-scaled.jpg",
    "heroAlt": "Stamped concrete backyard patio with dark border beside new sod in a Calgary yard",
    "overviewTitle": "Outdoor Spaces That Hold Up",
    "summary": "MRE Developments builds hardscape and landscape projects for homes across Calgary, Airdrie, Cochrane, Okotoks and Chestermere, including concrete patios and walkways, steps, paving stones, retaining walls, grading and sod. Our crew prepares the base, sets the forms and finishes the surface in-house, so the work is level, properly sloped and built for freeze-thaw cycles. The result is an outdoor space that looks finished and works the way your yard needs to.",
    "highlights": [
      "Concrete patios, walkways and steps",
      "Stamped and exposed aggregate finishes",
      "Paving stones and retaining walls",
      "Yard grading and drainage",
      "Sod and irrigation to finish",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Patios Made for Real Use",
        "body": "A well-built patio extends your living space outdoors for summer evenings, barbecues and kids' play. We lay out the size and shape around how you use the yard, then finish it in broom, stamped or exposed aggregate concrete, or paving stones.",
        "benefit": "A usable, good-looking outdoor space that adds value to your home.",
        "image": "2024/08/6-scaled.jpg",
        "imageAlt": "Crew finishing a large freshly poured concrete backyard patio beside a wood fence in Calgary"
      },
      {
        "title": "Base, Forms and Finish",
        "body": "Most failed patios and walks fail underneath. We compact a gravel base, build straight, braced forms with slope for drainage, and place, screed and finish the concrete by hand, including tooled edges and control joints.",
        "benefit": "Flat, crack-resistant surfaces that shed water away from your foundation.",
        "image": "2024/08/4-scaled.jpg",
        "imageAlt": "Workers placing concrete into wood forms over a compacted gravel base for a walkway in Calgary"
      },
      {
        "title": "Built for Freeze and Thaw",
        "body": "Calgary's chinooks and cold snaps are hard on outdoor surfaces. Proper grading, drainage, reinforcement and curing help patios, walkways and retaining walls stay level, and finishes such as stamped or exposed aggregate concrete give a durable, slip-resistant surface.",
        "benefit": "Hardscape that keeps its shape and appearance season after season.",
        "image": "2026/04/20240914_145350-scaled.jpg",
        "imageAlt": "Pressure washing a fresh pour to reveal an exposed aggregate concrete finish on a Calgary walkway"
      }
    ],
    "galleryIntro": "Concrete patios, walkways and steps built by MRE Developments in Calgary-area yards, from forming to final finish.",
    "photos": [
      {
        "src": "2024/08/2-scaled.jpg",
        "caption": "Forms set for patio and steps",
        "alt": "Wood forms set for a concrete patio and steps beside a house, ready for the pour"
      },
      {
        "src": "2026/04/3-1-scaled.jpg",
        "caption": "Broom-finished surface for grip",
        "alt": "Applying a broom finish to fresh concrete for a slip-resistant patio surface in Calgary"
      },
      {
        "src": "2026/04/4-1-scaled.jpg",
        "caption": "Hand-tooled concrete edge",
        "alt": "Finisher tooling a rounded edge on a fresh concrete hardscape slab inside wood forms"
      },
      {
        "src": "2024/08/3-scaled.jpg",
        "caption": "Fresh patio under the deck",
        "alt": "Freshly poured concrete patio under a deck with forms still in place at a Calgary home"
      },
      {
        "src": "2024/08/5-scaled.jpg",
        "caption": "Screeding the pour level",
        "alt": "Worker screeding fresh concrete level across forms during a Calgary patio installation"
      },
      {
        "src": "2024/08/4-scaled.jpg",
        "caption": "Placing concrete over gravel base",
        "alt": "Workers placing concrete over a compacted gravel base inside wood forms for a walkway"
      },
      {
        "src": "2024/08/6-scaled.jpg",
        "caption": "Large backyard pad being finished",
        "alt": "Crew bull-floating a large concrete backyard patio beside a wood fence in Calgary"
      },
      {
        "src": "2026/04/20240824_193528-scaled.jpg",
        "caption": "Stamped patio with dark border",
        "alt": "Stamped concrete patio with contrasting border beside new sod in a Calgary backyard"
      },
      {
        "src": "2026/04/20240914_145350-scaled.jpg",
        "caption": "Revealing an exposed aggregate finish",
        "alt": "Pressure washing new concrete to expose decorative aggregate on a walkway landscaping project"
      },
      {
        "src": "2026/02/qq7-scaled.jpg",
        "caption": "Side walkway and concrete steps",
        "alt": "New concrete side walkway and front steps with railing beside a Calgary home"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What hardscaping services do you offer?",
        "a": "We build concrete patios, walkways and steps, paving stone patios and paths, retaining walls, and we grade yards for proper drainage. Sod and irrigation can be added to finish the project."
      },
      {
        "q": "Should I choose concrete or paving stones?",
        "a": "Both work well in Calgary when the base is built properly. Concrete offers a continuous surface and can be stamped or finished with exposed aggregate, while paving stones are easy to lift and reset if the ground moves. We will talk through the look, maintenance and cost of each for your yard."
      },
      {
        "q": "Do you grade the yard to drain away from the house?",
        "a": "Yes. Grading and slope are planned so water moves away from your foundation. Patios and walkways are formed with a slight fall for the same reason."
      },
      {
        "q": "Do you serve areas outside Calgary?",
        "a": "Yes. We work in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "How much does a patio or walkway cost?",
        "a": "Cost depends on size, access, site preparation, material and finish, such as broom, stamped or exposed aggregate concrete or paving stones. We provide a free, detailed quote after seeing the yard."
      },
      {
        "q": "How long does a hardscaping project take?",
        "a": "The timeline depends on the size of the project, site preparation, weather and concrete curing time. We include a project-specific schedule with your quote."
      }
    ],
    "ctaTitle": "Plan Your Patio or Hardscape Project",
    "ctaSubtitle": "Tell us about your yard and what you would like to build, and we will prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Backyard patio slab under a deck",
        "summary": "Forms set along the yard, then the finished broom-finished patio slab under the deck.",
        "dates": "Sep 2022",
        "photos": [
          "2024/08/2-scaled.jpg",
          "2026/04/3-1-scaled.jpg",
          "2026/04/4-1-scaled.jpg",
          "2024/08/3-scaled.jpg"
        ]
      },
      {
        "title": "Fenced backyard concrete pad",
        "summary": "Placing and screeding concrete over gravel, then finishing the pad in a fenced yard.",
        "dates": "Aug 2022",
        "photos": [
          "2024/08/5-scaled.jpg",
          "2024/08/4-scaled.jpg",
          "2024/08/6-scaled.jpg"
        ]
      },
      {
        "title": "More landscaping work",
        "summary": "Stamped patio beside a lawn, exposed aggregate wash-off and a new side walkway.",
        "dates": "Jan 2024 – Sep 2024",
        "photos": [
          "2026/04/20240824_193528-scaled.jpg",
          "2026/04/20240914_145350-scaled.jpg",
          "2026/02/qq7-scaled.jpg"
        ]
      }
    ]
  },
  "office-fitouts": {
    "metaTitle": "Office Build-Outs Calgary | MRE Developments",
    "metaDescription": "Office build-outs and renovations in Calgary, Airdrie and Okotoks: meeting rooms, open-plan areas and cabling-ready spaces. Request a free quote today.",
    "headline": "Office Build-Outs in Calgary Designed Around How Teams Work",
    "subheadline": "Meeting rooms, focus rooms and open-plan areas built to suit your team, with cabling and AV planned in, permits handled and minimal disruption to your business.",
    "hero": "https://images.unsplash.com/photo-1720139290958-d8676702c3ed?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Open-plan office with desks, task chairs, monitors and an exposed industrial ceiling",
    "overviewTitle": "Workplaces That Work",
    "summary": "MRE Developments builds and renovates offices for businesses across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We handle workplace layout, partitions, meeting and focus rooms, open-plan areas, lighting, finishes and the rough-in for cabling and AV. Permits, trades and inspections are coordinated by one licensed and insured contractor.",
    "highlights": [
      "Workplace layout and design input",
      "Meeting rooms and focus rooms",
      "Open-plan office builds",
      "Cabling and AV ready",
      "Office renovations in occupied spaces",
      "Free, detailed project quotes"
    ],
    "features": [
      {
        "title": "Layouts Built Around Your Team",
        "body": "We start by looking at how your people actually work: how many need quiet space, how often teams meet and where visitors arrive. From there we plan the mix of open work areas, meeting rooms, focus rooms and support space before any walls go up.",
        "benefit": "Your office supports daily work instead of forcing people to work around it."
      },
      {
        "title": "Meeting Rooms That Stay Quiet",
        "body": "Meeting and focus rooms only work if conversations stay inside them. We pay attention to wall assemblies, insulation, door selection and ceiling details so rooms give the privacy your team expects, and we plan power, data and display locations before drywall is closed.",
        "benefit": "You get rooms that are private, comfortable and ready for video calls."
      },
      {
        "title": "Ready for Cabling and AV",
        "body": "Running cable after an office is finished is costly and messy. We build in conduit, backing for screens, and power and data locations during construction, then coordinate with your IT or AV provider for the final connections.",
        "benefit": "Move-in day is about unpacking, not chasing cables through finished walls."
      }
    ],
    "galleryIntro": "Project photos for office build-outs will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Do you build new offices and renovate existing ones?",
        "a": "Both. MRE Developments builds out new office space in bare lease units and renovates existing offices that need a new layout, more meeting rooms or updated finishes. We work with businesses in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area."
      },
      {
        "q": "Can you renovate while our team keeps working?",
        "a": "In many cases, yes. We can phase the work so parts of the office stay in use, protect occupied areas from dust, and schedule noisy work after hours. We plan the phasing with you before construction starts."
      },
      {
        "q": "Do you install network cabling and AV equipment?",
        "a": "We prepare the office for cabling and AV by building in conduit, wall backing, and power and data locations during construction. Final network and AV equipment is usually handled by your IT or AV provider, and we coordinate with them so everything lines up."
      },
      {
        "q": "Do office build-outs need permits in Calgary?",
        "a": "Most office build-outs that add or move walls, change electrical or alter mechanical systems need permits. We coordinate the permits and inspections as part of the project."
      },
      {
        "q": "How long does an office build-out take?",
        "a": "The timeline depends on the size of the office, the amount of new construction, permit timing and lead times for doors, glazing and finishes. We provide a schedule with your quote so you can plan your move."
      },
      {
        "q": "How do you price an office build-out?",
        "a": "We review your space and requirements and prepare a free, detailed quote specific to your project. It sets out the scope clearly so you can make decisions with confidence."
      }
    ],
    "ctaTitle": "Build an Office Your Team Will Use",
    "ctaSubtitle": "Tell us about your team, your space and your move-in date, and we will prepare a free, detailed office build-out quote."
  },
  "online-marketing": {
    "metaTitle": "Online Marketing Agency Calgary | MRE Developments",
    "metaDescription": "Google Ads, paid social, email marketing and lead generation for Calgary and Canadian businesses. Book a free marketing strategy consultation with MRE.",
    "headline": "Online Marketing in Calgary That Generates Real Leads",
    "subheadline": "Ad spend without tracking is guesswork. We plan, launch and manage search, social and email campaigns that reach buyers and show where every lead comes from.",
    "hero": "https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Team working at shared desks in a bright brick-walled loft office",
    "overviewTitle": "Campaigns Built for Enquiries",
    "summary": "MRE Developments is a Calgary digital marketing agency running paid advertising, social media marketing, email marketing and lead generation for businesses across Canada. Each campaign starts with a clear offer, a landing page built to convert and tracking set up before launch. You see what is working, what it costs and where to adjust, with transparent pricing and no inflated promises.",
    "highlights": [
      "Google Ads and search campaigns",
      "Paid social on Meta and more",
      "Email marketing and nurture funnels",
      "Landing pages built for conversion",
      "Conversion tracking set up properly",
      "Plain-language performance reporting"
    ],
    "features": [
      {
        "title": "Paid Search and Social Ads",
        "body": "We build Google Ads and paid social campaigns around the services you most want to sell and the areas you serve. Targeting, ad copy and budgets are planned together, then refined based on real performance data.",
        "benefit": "Your ads reach people who are actively looking for what you offer."
      },
      {
        "title": "Tracking From Click to Lead",
        "body": "Before a campaign goes live, we set up conversion tracking for calls, forms and bookings so results can be measured against spend. Reporting shows which campaigns, keywords and audiences produce enquiries, not just clicks.",
        "benefit": "You make budget decisions based on evidence rather than impressions."
      },
      {
        "title": "Email and Lead Nurture Funnels",
        "body": "Not every lead is ready to buy today. We design email sequences and follow-up funnels that keep your business in front of prospects with useful information until they are ready to act.",
        "benefit": "More of the leads you already pay for turn into customers."
      }
    ],
    "galleryIntro": "Campaign examples and reporting samples are reviewed during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "How much should I spend on ads?",
        "a": "It depends on your market, the competition for your keywords and how many leads you can handle. We recommend a starting budget after the consultation and adjust it as performance data comes in. We do not promise specific returns on ad spend."
      },
      {
        "q": "Which platforms do you manage?",
        "a": "We work mainly with Google Ads, Meta (Facebook and Instagram) advertising and email platforms, and we recommend channels based on where your customers spend time. Not every business needs every platform."
      },
      {
        "q": "Do I need a new landing page for my ads?",
        "a": "Often, yes. Sending ad traffic to a general home page usually converts less well than a focused page built around one offer. We can build campaign landing pages or improve your existing ones."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. We are based in Calgary and manage online marketing for businesses across Canada, with targeting set to the regions you serve."
      },
      {
        "q": "How much does online marketing cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. Management fees are separate from ad spend and depend on the number of channels, campaigns and landing pages involved, plus any email or funnel build. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Marketing Strategy Consultation",
    "ctaSubtitle": "Tell us about your offer, your market and your current marketing. We will outline a campaign plan with a clear scope."
  },
  "photography": {
    "metaTitle": "Commercial Photography Calgary | MRE Developments",
    "metaDescription": "Product, brand, real estate and project photography for Calgary businesses, prepared for web and print. Book a free photography consultation with MRE.",
    "headline": "Commercial Photography in Calgary That Sells",
    "subheadline": "Phone snapshots and stock images make a business look ordinary. We shoot product, brand, real estate and project photos that show your work at its best.",
    "hero": "https://images.unsplash.com/photo-1502810190503-8303352d0dd1?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Wall of pinned photographic prints and sketches above a desktop computer on a wooden desk",
    "overviewTitle": "Photos That Show Your Best Work",
    "summary": "MRE Developments provides commercial photography for businesses in Calgary, including product, brand, real estate and project photography. Each shoot is planned around where the images will be used, then edited and delivered in sizes ready for your website, social media and print. Clear scope and transparent pricing are confirmed before every shoot.",
    "highlights": [
      "Product photography for web and print",
      "Brand and team photography",
      "Real estate and interior photography",
      "Project and progress documentation",
      "Professional editing and retouching",
      "Files sized for every channel"
    ],
    "features": [
      {
        "title": "Product and Brand Photography",
        "body": "We photograph products, people and workplaces in a consistent style that matches your brand. Lighting, backgrounds and composition are planned in advance so images work together across your website, catalogue and social channels.",
        "benefit": "A library of images that makes your business look established and trustworthy."
      },
      {
        "title": "Planned, Edited and Delivered Ready",
        "body": "Before the shoot, we agree on a shot list based on how each image will be used. After the shoot, photos are colour corrected, retouched where needed and exported at the right sizes and formats for web and print.",
        "benefit": "Images you can use immediately without further editing."
      },
      {
        "title": "Real Estate and Project Photography",
        "body": "For properties, interiors and completed projects, we shoot wide, well-lit images that show space, finish and detail accurately. Progress photography can document a project from start to finish for marketing or records.",
        "benefit": "Your properties and projects are presented the way they deserve."
      }
    ],
    "galleryIntro": "Photography samples relevant to your industry are shared during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What types of photography do you offer?",
        "a": "We offer product, brand and team, real estate and interior, project documentation and event photography. Each shoot is planned around how the images will be used."
      },
      {
        "q": "Do I own the photos?",
        "a": "Usage rights are set out in writing with the quote. In most commercial projects you receive the rights needed to use the images across your website, social media, advertising and print."
      },
      {
        "q": "How many photos will I receive?",
        "a": "The number of final edited images depends on the shoot length and shot list. We agree on the deliverables in the scope so you know what to expect."
      },
      {
        "q": "Where do you shoot?",
        "a": "We are based in Calgary and shoot on location at your business, property or project site in the Calgary area. Shoots further afield are scoped per project."
      },
      {
        "q": "How much does commercial photography cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the type of shoot, the number of locations and setups, the number of final images and the level of retouching required. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Photography Consultation",
    "ctaSubtitle": "Tell us what you need photographed and where the images will be used. We will plan a shoot with a clear scope."
  },
  "restaurant-buildouts": {
    "metaTitle": "Restaurant Build-Outs Calgary | MRE Developments",
    "metaDescription": "Restaurant, cafe and bar build-outs in Calgary, Airdrie and Cochrane, with commercial kitchens built for health-code compliance. Request a free quote.",
    "headline": "Restaurant Build-Outs in Calgary, Built for Service and Inspection",
    "subheadline": "Commercial kitchens, dining rooms and bars planned for workflow, ventilation and health-code requirements, so you can pass inspection and start serving.",
    "hero": "https://images.unsplash.com/photo-1610177534644-34d881503b83?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Modern interior with a dark counter, bar stools and warm wood cabinetry under soft lighting",
    "overviewTitle": "Kitchens, Dining Rooms and Bars",
    "summary": "MRE Developments builds restaurants, cafes and bars for owners and operators in Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We construct commercial kitchens, dining and bar areas and washrooms, coordinating ventilation, grease management, plumbing and electrical with the requirements of health and building inspectors. One licensed and insured contractor manages the build from permits to final inspection.",
    "highlights": [
      "Commercial kitchen construction",
      "Dining room and bar build-outs",
      "Built for health-code compliance",
      "Ventilation and grease management coordinated",
      "Permits and inspections handled",
      "Cafes, restaurants and bars"
    ],
    "features": [
      {
        "title": "Commercial Kitchens That Flow",
        "body": "A kitchen layout decides how fast food leaves the pass. We plan receiving, storage, prep, cooking, plating and dishwashing as a sequence, then build the walls, floor drains, plumbing and power to suit your equipment list.",
        "benefit": "Your staff work efficiently during a rush instead of crossing paths."
      },
      {
        "title": "Health Code and Ventilation",
        "body": "Restaurant inspections look closely at cleanable surfaces, handwashing sinks, grease interceptors and exhaust. We build with materials suited to commercial kitchens and coordinate hood, makeup air and grease management with the specialists and inspectors involved.",
        "benefit": "You are ready for health and building inspections when it is time to open."
      },
      {
        "title": "Dining Rooms and Bars With Character",
        "body": "The front of house is where guests decide whether to come back. We build bars, banquettes, feature walls, lighting and washrooms to your concept, with durable finishes that stand up to busy service and regular cleaning.",
        "benefit": "Your space looks the way you pictured it and holds up to daily service."
      }
    ],
    "galleryIntro": "Project photos for restaurant build-outs will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Do you build restaurants in existing commercial spaces?",
        "a": "Yes. Most of the restaurants, cafes and bars we build are in existing lease spaces, whether it is a bare unit or a former restaurant being converted. MRE Developments works with operators in Calgary and the surrounding area, including Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "Will my restaurant build-out meet health code?",
        "a": "We build with health-code requirements in mind, including cleanable surfaces, handwashing sinks, floor drains and proper separation of areas. We also coordinate with the health and building inspectors involved so issues are addressed before final inspection."
      },
      {
        "q": "Do you handle kitchen ventilation and grease interceptors?",
        "a": "We coordinate the hood, exhaust, makeup air and grease management as part of the build, working with the specialist trades these systems require. They are planned early because they affect the layout, the roof and the permit drawings."
      },
      {
        "q": "Do you take care of permits?",
        "a": "Yes. Restaurant build-outs in Calgary typically need building and trade permits plus health approvals. We coordinate permits and book inspections throughout the project."
      },
      {
        "q": "How long does a restaurant build-out take?",
        "a": "It depends on the size of the space, the amount of kitchen and mechanical work, permit and health approvals, and equipment lead times. We provide a schedule with your quote so you can plan hiring and your opening."
      },
      {
        "q": "How much does a restaurant build-out cost?",
        "a": "Costs vary widely with the kitchen equipment, mechanical work and finishes involved. We review your concept and space and provide a free, detailed quote specific to your restaurant."
      }
    ],
    "ctaTitle": "Plan Your Restaurant Build-Out",
    "ctaSubtitle": "Share your concept, space and opening target, and we will prepare a free, detailed quote for your restaurant, cafe or bar."
  },
  "retail-buildouts": {
    "metaTitle": "Retail Build-Outs Calgary | MRE Developments",
    "metaDescription": "Retail build-outs, storefronts and shop fit-outs with custom millwork in Calgary, Airdrie and Okotoks. Accessible layouts and permits handled. Free quote.",
    "headline": "Retail Build-Outs in Calgary That Move Customers and Product",
    "subheadline": "Storefronts, custom millwork, lighting and displays built around your brand and your sales floor, with permits and accessibility handled from the start.",
    "hero": "https://images.unsplash.com/photo-1664464683525-29b5d442af54?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Bright commercial interior with white counters, plants and a green feature ceiling",
    "overviewTitle": "Storefronts and Shop Fit-Outs",
    "summary": "MRE Developments builds retail stores and shop fit-outs for business owners and property managers in Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We construct storefronts, sales floors, fitting rooms, cash counters, custom millwork and display walls, along with the lighting that shows off your merchandise. Layouts are planned for customer flow and accessibility, and permits and inspections are coordinated by one licensed and insured contractor.",
    "highlights": [
      "Storefront and shop fit-outs",
      "Custom millwork and display fixtures",
      "Lighting planned for merchandise",
      "Accessible, easy-to-shop layouts",
      "Permits and inspections coordinated",
      "Schedules built around opening dates"
    ],
    "features": [
      {
        "title": "Layouts That Guide Shoppers",
        "body": "A good retail floor leads customers past your products and toward the cash desk without feeling crowded. We plan entry, aisles, displays, fitting rooms and back-of-house storage together, keeping clear routes that meet accessibility requirements.",
        "benefit": "Customers find what they came for and see more of what you sell."
      },
      {
        "title": "Custom Millwork and Displays",
        "body": "Cash counters, wall shelving, display tables and feature walls give a store its identity. We build millwork to your dimensions and finishes, with backing and power planned inside the walls so fixtures are solid and lighting connects cleanly.",
        "benefit": "Your fixtures fit your products and your brand instead of a catalogue."
      },
      {
        "title": "Storefronts and Lighting",
        "body": "The storefront is the first thing people see from the street or the mall corridor. We coordinate entrance and glazing work, signage backing and interior lighting so product is well lit and the store reads clearly from outside.",
        "benefit": "Your shop draws people in and presents merchandise at its best."
      }
    ],
    "galleryIntro": "Project photos for retail build-outs will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What does a retail build-out include?",
        "a": "It can include demolition of the previous fit-out, new walls and fitting rooms, flooring, ceilings, lighting, custom millwork, cash counters, display walls and storefront work. MRE Developments builds retail spaces for businesses in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks and Chestermere."
      },
      {
        "q": "Can you build custom millwork for my store?",
        "a": "Yes. We build counters, shelving, display fixtures and feature walls to suit your products and brand. Backing and power are planned during construction so fixtures are secure and lit properly."
      },
      {
        "q": "Do you work in shopping centres with landlord requirements?",
        "a": "Yes. Malls and retail centres usually have design criteria, approved hours and rules for access and deliveries. We follow those requirements and coordinate with the property manager throughout the build."
      },
      {
        "q": "Will my store be accessible?",
        "a": "We plan entrances, aisles, counters and washrooms with accessibility requirements in mind, and confirm them against the building code and permit drawings. An accessible layout also makes the store easier for every customer to shop."
      },
      {
        "q": "How long does a retail build-out take?",
        "a": "It depends on the size of the store, the amount of millwork and storefront work, permit timing and material lead times. We provide a schedule with your quote, built around your opening date."
      },
      {
        "q": "How is a retail build-out priced?",
        "a": "We review your space, plans and finish choices and provide a free, detailed quote specific to your store. That way you can see what is included and adjust the scope before work starts."
      }
    ],
    "ctaTitle": "Build a Store Customers Remember",
    "ctaSubtitle": "Tell us about your space, products and opening date, and we will prepare a free, detailed retail build-out quote."
  },
  "rtm-homes": {
    "metaTitle": "RTM Homes Calgary & Area | Ready-to-Move | MRE",
    "metaDescription": "Ready-to-move (RTM) homes for acreages and rural lots near Calgary, Cochrane, Okotoks and High River, with site prep coordinated by MRE. Get a free quote.",
    "headline": "Ready-to-Move Homes for Acreages and Rural Lots Near Calgary",
    "subheadline": "A quality home built in a controlled environment, then delivered and set on your property, with the site work, foundation and services coordinated so moving in is straightforward.",
    "hero": "https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Single-family house with a pitched roof and front entry on a residential lot",
    "overviewTitle": "RTM Homes, Simplified",
    "summary": "MRE Developments helps homeowners in Calgary's surrounding region, including Cochrane, Okotoks, Airdrie, Strathmore and High River, put a ready-to-move home on their acreage or rural lot. RTM homes are built in a controlled environment rather than on an open site, so construction is not held up by weather. We coordinate the parts that happen on your land, from site preparation and foundation to delivery and utility connections.",
    "highlights": [
      "Homes built in a controlled environment",
      "Delivered and set on your lot",
      "Ideal for acreage and rural builds",
      "Site prep and foundation coordinated",
      "Permits and utility hookups planned",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "A Home Without the Weather Delays",
        "body": "Because an RTM home is built indoors, framing, mechanical and finishing work carry on through Alberta winters and wet springs. That protects materials from the elements and keeps the schedule more predictable.",
        "benefit": "A well-built home with fewer weather-related surprises."
      },
      {
        "title": "Site Work Done in Parallel",
        "body": "While the home is being built, the site can be prepared at the same time: access, excavation, foundation, well, septic or utility services as the property requires. When the house arrives, the foundation is ready to receive it.",
        "benefit": "A shorter overall path from purchase to move-in."
      },
      {
        "title": "Suited to Acreage Living",
        "body": "Ready-to-move homes are a practical fit for acreages and rural properties where bringing trades to site for months is costly. We help you plan the placement, driveway access and services so the home suits the land around it.",
        "benefit": "A home that fits your property and the way you want to live on it."
      }
    ],
    "galleryIntro": "Project photos for this service are being added; contact us to discuss your acreage or rural lot.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What is an RTM home?",
        "a": "A ready-to-move (RTM) home is built in a controlled environment, then transported in one piece and set on a prepared foundation on your property. It is a full, permanent home, not a temporary structure."
      },
      {
        "q": "Is an RTM home faster than a site-built home?",
        "a": "Often it can be, because the house is built while the site and foundation are being prepared. The actual timeline depends on the home's design, permit approvals, site conditions, delivery logistics and weather, and a project-specific schedule comes with your quote."
      },
      {
        "q": "What site work does an RTM home need?",
        "a": "Typical site work includes access for delivery, excavation, a foundation or basement, and utility services such as power, gas, water or well, and septic where needed. We coordinate this work so the site is ready when the home arrives."
      },
      {
        "q": "Where can you place an RTM home?",
        "a": "RTM homes are well suited to acreages and rural lots around Calgary, including areas near Cochrane, Okotoks, Airdrie, Strathmore and High River. Placement depends on the property, access for transport, and municipal or county requirements, which we review early in planning."
      },
      {
        "q": "How much does an RTM home cost?",
        "a": "Cost depends on the home's size and finishes, transport distance, foundation type and how much site servicing your property needs. We provide a free, detailed quote once we understand the home and the site."
      },
      {
        "q": "What warranty comes with an RTM home?",
        "a": "New homes in Alberta are subject to provincial new home warranty requirements, and our own warranty and workmanship terms are set out in writing with your quote."
      }
    ],
    "ctaTitle": "Talk to Us About an RTM Home",
    "ctaSubtitle": "Tell us about your property and the home you have in mind, and we will prepare a free, detailed quote."
  },
  "seo": {
    "metaTitle": "SEO & Local Search Services Calgary | MRE Developments",
    "metaDescription": "Local SEO, technical SEO and Google Business Profile optimisation for Calgary and Canadian businesses. Book a free SEO strategy consultation with MRE.",
    "headline": "SEO & Local Search Services for Calgary and Canada",
    "subheadline": "Customers are already searching for what you offer. We fix the technical issues, content gaps and local listings that keep them from finding you.",
    "hero": "https://images.unsplash.com/photo-1526887593587-a307ea5d46b4?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Minimal white workspace with a desktop monitor and laptop on a wooden desk",
    "overviewTitle": "Get Found by Ready Customers",
    "summary": "MRE Developments provides SEO services for businesses in Calgary and across Canada, covering local SEO, technical SEO, keyword strategy and content. We build on what search engines reward over time: a fast, well-structured site, accurate local listings and useful pages that match real search intent. Reporting is plain-language, and there are no ranking guarantees, just transparent work.",
    "highlights": [
      "Local SEO and map pack visibility",
      "Google Business Profile optimisation",
      "Technical audits and site fixes",
      "Keyword research and content strategy",
      "Service and location page planning",
      "Clear monthly reporting"
    ],
    "features": [
      {
        "title": "Local Search and Map Visibility",
        "body": "For service businesses, the map pack is often where the phone call starts. We optimise your Google Business Profile, align your business information across directories and build location-relevant pages for the areas you serve.",
        "benefit": "You show up more consistently when nearby customers search for your services."
      },
      {
        "title": "Technical SEO That Removes Barriers",
        "body": "We audit crawlability, indexing, site speed, mobile usability, structured data and internal linking, then prioritise fixes by impact. Many sites are held back by technical problems that are invisible to owners but obvious to search engines.",
        "benefit": "Search engines can find, understand and trust every important page on your site."
      },
      {
        "title": "Keyword Strategy and Content",
        "body": "We research the terms your customers actually use, map them to the right pages and identify gaps worth filling. Content is written to answer real questions clearly, not stuffed with keywords.",
        "benefit": "Your site attracts visitors who are looking for what you sell."
      }
    ],
    "galleryIntro": "Example audits and reporting are shared during your free SEO consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Can you guarantee first-page rankings?",
        "a": "No, and you should be cautious of anyone who does. Rankings depend on competition, search engine changes and many factors outside any agency's control. What we commit to is a clear plan, documented work and honest reporting on visibility, traffic and enquiries."
      },
      {
        "q": "How long does SEO take to show results?",
        "a": "It depends on your site's starting point, the competition in your market and how much technical and content work is needed. Technical fixes and Google Business Profile improvements can be put in place early, while content and authority build over months. We set expectations in the plan after reviewing your site."
      },
      {
        "q": "What is local SEO?",
        "a": "Local SEO helps your business appear when people search for services near them, including in Google Maps results. It covers your Google Business Profile, consistent business information across listings, reviews strategy and location-relevant pages on your website."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. We are based in Calgary and provide SEO for businesses across Canada. Local SEO work is tailored to the specific cities and regions you serve."
      },
      {
        "q": "How much does SEO cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the size and condition of your website, how competitive your market is, the number of locations you serve and how much content is needed. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free SEO Strategy Consultation",
    "ctaSubtitle": "We will review how your business shows up in search today and outline a clear, practical plan to improve it."
  },
  "social-media": {
    "metaTitle": "Social Media Management Calgary | MRE Developments",
    "metaDescription": "Social media strategy, content creation, community management and paid social for Calgary and Canadian businesses. Book a free consultation with MRE today.",
    "headline": "Social Media Management for Calgary and Canadian Brands",
    "subheadline": "Posting only when there is time leaves your accounts quiet and your audience cold. We plan, create and manage consistent, on-brand content that builds an audience.",
    "hero": "https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Colleagues collaborating at computer workstations in an open loft office with brick walls",
    "overviewTitle": "Consistent Social, Handled for You",
    "summary": "MRE Developments provides social media management for businesses in Calgary and across Canada, including strategy, content creation, scheduling, community management and paid social. We build a content plan around your goals and audience, then create and publish posts that look and sound like your brand. Monthly reporting shows reach, engagement and how social is feeding enquiries.",
    "highlights": [
      "Social strategy and content calendars",
      "Content creation for each platform",
      "Scheduling and consistent posting",
      "Community management and replies",
      "Paid social campaigns",
      "Monthly performance reporting"
    ],
    "features": [
      {
        "title": "Strategy Before Content",
        "body": "We start by defining who you are trying to reach, which platforms matter for your business and what each post should accomplish. The result is a content calendar built around your services, seasons and promotions.",
        "benefit": "Every post has a purpose instead of filling a gap in the schedule."
      },
      {
        "title": "Content Created and Scheduled",
        "body": "We write captions, design graphics and edit short video in your brand style, then schedule posts at times your audience is active. You review and approve content before it goes live.",
        "benefit": "Your accounts stay active and professional without taking over your week."
      },
      {
        "title": "Community and Paid Social",
        "body": "We monitor comments and messages, respond within agreed guidelines and flag enquiries to your team. Where it fits your goals, paid social campaigns extend your reach to targeted audiences in the areas you serve.",
        "benefit": "Followers become conversations, and conversations become leads."
      }
    ],
    "galleryIntro": "Content examples and calendars are walked through during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Which social media platforms do you manage?",
        "a": "We commonly manage Facebook, Instagram, LinkedIn and short-form video platforms. We recommend the platforms that fit your audience rather than spreading your effort across all of them."
      },
      {
        "q": "Do I get to approve posts before they go live?",
        "a": "Yes. Content is shared for review on a set schedule, and nothing is published without your approval unless you choose otherwise."
      },
      {
        "q": "Can you guarantee more followers or sales?",
        "a": "No. Results depend on your audience, industry, offer and budget. We commit to consistent, quality content, active management and honest reporting so you can see what social is contributing."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. We are based in Calgary and manage social media for businesses across Canada, with content tailored to your local audience."
      },
      {
        "q": "How much does social media management cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number of platforms, posting frequency, the mix of graphics and video, community management needs and any paid social budget. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Social Media Strategy Consultation",
    "ctaSubtitle": "Share your accounts and your goals. We will recommend a content plan and a clear scope for managing it."
  },
  "solar": {
    "metaTitle": "Solar Panel Installation Calgary | MRE Developments",
    "metaDescription": "Residential and commercial solar panel installation in Calgary, Airdrie, Cochrane and Okotoks, with permits and grid connection handled. Get a free quote.",
    "headline": "Solar Panel Installation for Calgary Homes and Businesses",
    "subheadline": "Generate your own clean power, lower your energy costs and move toward net-zero, with design, permits and grid connection managed by one contractor.",
    "hero": "https://images.unsplash.com/photo-1691425700585-c108acad6467?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Modern two-storey home with a flat roof, wood cladding and stone accents",
    "overviewTitle": "Clean Power on Your Roof",
    "summary": "MRE Developments installs solar panel systems for homes and businesses in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region. We assess your roof and energy use, plan a system that suits the building, handle permits and coordinate the grid connection. Solar can be added to an existing building or planned into a new build or renovation as part of a net-zero ready approach.",
    "highlights": [
      "Residential solar panel installation",
      "Commercial solar systems",
      "Net-zero ready planning",
      "Permits and grid connection handled",
      "Roof and site assessment",
      "Free, detailed project quotes"
    ],
    "features": [
      {
        "title": "Lower Energy Costs, Year After Year",
        "body": "A solar system produces electricity from your own roof, which reduces the power you buy from the grid. Southern Alberta gets plenty of sunshine through the year, which makes solar worth a close look for homeowners and businesses in Calgary and area.",
        "benefit": "You reduce your reliance on grid power and gain more control over energy costs."
      },
      {
        "title": "Planned Around Your Roof",
        "body": "We review roof orientation, pitch, shading and condition along with your electricity use before recommending a system. Panels are laid out to suit the roof, and the mounting and roof penetrations are detailed to keep the roof watertight.",
        "benefit": "Your system is sized sensibly and installed without compromising the roof."
      },
      {
        "title": "Permits and Grid Connection",
        "body": "Solar installations require permits and approvals before the system can be connected to the grid. We prepare and coordinate the paperwork, inspections and interconnection steps so you are not left managing the process yourself.",
        "benefit": "Your system goes from installed to producing power with less hassle."
      }
    ],
    "galleryIntro": "Project photos for solar panel installations will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Do you install solar on homes and commercial buildings?",
        "a": "Yes. MRE Developments installs solar panel systems on residential and commercial buildings in Calgary and the surrounding region, including Airdrie, Cochrane, Okotoks, Chestermere, Strathmore and High River."
      },
      {
        "q": "Is my roof suitable for solar panels?",
        "a": "Suitability depends on roof orientation, pitch, shading, available area and roof condition. We assess these during a site review. If your roof is near the end of its life, it is usually best to address that before installing panels."
      },
      {
        "q": "Do you handle permits and the grid connection?",
        "a": "Yes. We coordinate the permits, inspections and interconnection approvals needed to connect your system to the grid, so the process is managed for you from start to finish."
      },
      {
        "q": "What does net-zero ready mean?",
        "a": "A net-zero ready building is designed to be energy efficient enough that renewable energy, such as solar, can offset most or all of its annual energy use. We can plan solar alongside insulation and other upgrades during a new build or renovation."
      },
      {
        "q": "How long does a solar installation take?",
        "a": "The timeline depends on the size of the system, equipment availability and permit and utility approvals. We provide a schedule with your quote that shows each step."
      },
      {
        "q": "How much does a solar system cost?",
        "a": "Cost depends on system size, roof conditions and equipment selected. We provide a free, detailed quote specific to your building and energy goals."
      }
    ],
    "ctaTitle": "Start Producing Your Own Power",
    "ctaSubtitle": "Tell us about your building and energy use, and we will assess your roof and provide a free, detailed solar quote."
  },
  "soundproofing": {
    "metaTitle": "Soundproofing Contractor Calgary | MRE Developments",
    "metaDescription": "Soundproofing in Calgary, Airdrie and Cochrane for basement suites, home theatres, offices and shared walls, built in by MRE. Request a free quote.",
    "headline": "Soundproofing in Calgary for Suites, Theatres and Shared Walls",
    "subheadline": "Cut footsteps, voices and TV noise between floors and rooms with wall and ceiling assemblies designed to reduce sound transfer, built in while the walls are open.",
    "hero": "https://images.unsplash.com/photo-1610177534644-34d881503b83?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Quiet, finished residential interior with painted walls and ceiling",
    "overviewTitle": "Quieter Rooms, Better Privacy",
    "summary": "MRE Developments builds soundproofing into basement suites, home theatres, offices and multi-family walls across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We combine acoustic insulation, decoupled framing or resilient channel, specialty drywall and careful sealing to reduce both airborne and impact noise. Because we handle the framing and drywall too, the soundproofing is installed correctly as part of the build.",
    "highlights": [
      "Acoustic insulation in walls and ceilings",
      "Resilient channel and decoupled assemblies",
      "Suite separation between floors",
      "Home theatres and media rooms",
      "Quiet home offices",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Privacy Between Suites",
        "body": "In a home with a basement suite, sound travelling through the floor is one of the most common complaints from owners and tenants. We build ceiling and wall assemblies that reduce noise transfer and support the fire and sound separation a legal suite needs.",
        "benefit": "Better privacy for both households and a more rentable suite."
      },
      {
        "title": "Assemblies That Actually Work",
        "body": "Soundproofing depends on the whole assembly, not one product. We combine mass, decoupling, absorption in the cavity and acoustic sealant at gaps and penetrations, because a single unsealed outlet or duct can let sound straight through.",
        "benefit": "Noticeably quieter rooms from a system designed and installed as a whole."
      },
      {
        "title": "Theatres and Home Offices",
        "body": "A home theatre should keep sound in, and a home office should keep household noise out. We plan the room's walls, ceiling, door and ductwork with sound control in mind, then finish it to match the rest of your home.",
        "benefit": "A space where you can watch, work or take calls without disturbing anyone."
      }
    ],
    "galleryIntro": "Project photos for this service are being added; soundproofing is built into many of our basement and suite projects.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Can soundproofing be added to existing walls?",
        "a": "Yes, though it is most effective when walls or ceilings are open, such as during a basement development or renovation. In finished rooms we can add layers to existing surfaces, but opening the cavity usually gives better results."
      },
      {
        "q": "What is the difference between airborne and impact noise?",
        "a": "Airborne noise is voices, music and TV travelling through the air and structure. Impact noise is footsteps and dropped objects on the floor above. Each needs a different approach, and suite ceilings usually need to address both."
      },
      {
        "q": "Do legal basement suites need soundproofing?",
        "a": "Secondary suites must meet building code requirements for separation between units, which include fire and sound provisions. We design suite ceilings and shared walls to meet those requirements as part of the project."
      },
      {
        "q": "Can you soundproof a home theatre?",
        "a": "Yes. We build theatre rooms with insulated, decoupled walls and ceilings, solid doors and sealed penetrations so sound stays in the room and outside noise stays out."
      },
      {
        "q": "How much does soundproofing cost?",
        "a": "Cost depends on the size of the area, whether walls and ceilings are open, the assembly chosen and the level of sound reduction you want. We provide a free, detailed quote as part of your project."
      },
      {
        "q": "Do you take on soundproofing as a small single job?",
        "a": "We focus on soundproofing as part of projects such as basement developments, suites, theatres and renovations, where it can be built into the walls and ceilings properly."
      }
    ],
    "ctaTitle": "Plan a Quieter Space",
    "ctaSubtitle": "Tell us about the rooms or suite you want to quiet down, and we will prepare a free, detailed quote."
  },
  "stainless-steel": {
    "metaTitle": "Stainless Steel Fabrication Calgary | MRE Developments",
    "metaDescription": "Custom stainless steel fabrication in Calgary: countertops, backsplashes, trim and commercial-grade fixtures built to spec. Request a free quote today.",
    "headline": "Custom Stainless Steel Fabrication in Calgary, Built to Spec",
    "subheadline": "Countertops, backsplashes, trim and commercial-grade fixtures made to your measurements, for kitchens that need surfaces that are hygienic, durable and easy to clean.",
    "hero": "https://images.unsplash.com/photo-1502005097973-6a7082348e28?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Long modern kitchen with a stainless range hood, light wood cabinets and a stone counter",
    "overviewTitle": "Stainless Steel Made to Measure",
    "summary": "MRE Developments provides custom stainless steel fabrication for homes and businesses in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding area. We produce countertops, backsplashes, trim and commercial-grade fixtures to your specifications and install them as part of kitchen renovations, restaurant build-outs and commercial projects. Every piece is measured on site so it fits the space it was made for.",
    "highlights": [
      "Custom stainless steel fabrication",
      "Countertops and backsplashes",
      "Commercial-grade fixtures",
      "Trim and finishing details",
      "Measured on site for accurate fit",
      "Residential and commercial projects"
    ],
    "features": [
      {
        "title": "Surfaces Built for Hard Work",
        "body": "Stainless steel resists heat, moisture and stains and is easy to clean and sanitize, which is why it is the standard in commercial kitchens. It also suits residential kitchens where owners want a durable, professional look.",
        "benefit": "You get work surfaces that stay hygienic and hold up to daily use."
      },
      {
        "title": "Fabricated to Your Measurements",
        "body": "We measure the space once cabinets, walls and equipment are in place, then fabricate to those exact dimensions. Edges, seams, cut-outs for sinks and appliances and the finish of each piece are planned before fabrication so everything fits on installation.",
        "benefit": "Your countertops and fixtures fit the space cleanly, with no awkward gaps."
      },
      {
        "title": "Commercial-Grade Fixtures and Trim",
        "body": "Beyond countertops, we build stainless backsplashes, wall cladding, shelving, trim and other fixtures for restaurants, cafes and commercial spaces. Pieces are made to suit the equipment and layout of each kitchen and coordinated with the rest of the build.",
        "benefit": "Your commercial kitchen gets durable, cleanable fixtures made for how it operates."
      }
    ],
    "galleryIntro": "Project photos for stainless steel fabrication will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What stainless steel products do you fabricate?",
        "a": "We fabricate custom countertops, backsplashes, wall cladding, shelving, trim and commercial-grade fixtures to your specifications. MRE Developments serves homes and businesses in Calgary, Airdrie, Cochrane, Okotoks, Chestermere and the surrounding region."
      },
      {
        "q": "Is stainless steel a good choice for a home kitchen?",
        "a": "Stainless steel is heat resistant, non-porous and easy to clean, which makes it practical for busy kitchens. It does show scratches and fingerprints over time, which many owners accept as part of its working character. We can talk through finish options during your consultation."
      },
      {
        "q": "Can you supply stainless steel for a restaurant build-out?",
        "a": "Yes. We fabricate stainless surfaces and fixtures for restaurants, cafes and other commercial kitchens, often as part of a build-out we are managing. Pieces are planned around your equipment list and kitchen layout."
      },
      {
        "q": "Do you install the stainless steel pieces you make?",
        "a": "Yes. We measure on site, fabricate to those measurements and install the finished pieces, coordinating with plumbing, appliances and the rest of the project."
      },
      {
        "q": "How long does stainless steel fabrication take?",
        "a": "It depends on the number and complexity of pieces, material availability and when the space is ready for final measurements. We provide a schedule with your quote."
      },
      {
        "q": "How is custom stainless steel priced?",
        "a": "Pricing depends on the size and complexity of each piece, the gauge and finish selected and installation requirements. We provide a free, detailed quote specific to your project."
      }
    ],
    "ctaTitle": "Get Stainless Steel Made for Your Space",
    "ctaSubtitle": "Send us your measurements, drawings or ideas, and we will provide a free, detailed quote for custom stainless steel fabrication."
  },
  "tenant-improvements": {
    "metaTitle": "Tenant Improvements Calgary | MRE Developments",
    "metaDescription": "Tenant improvement and leasehold improvement contractor in Calgary, Airdrie and Cochrane. Space planning, permits and after-hours work. Free quote.",
    "headline": "Tenant Improvements in Calgary That Get Your Space Open",
    "subheadline": "Leasehold improvements planned around your lease dates and your landlord's requirements, with permits, trades and after-hours work coordinated for you.",
    "hero": "https://images.unsplash.com/photo-1664464683525-29b5d442af54?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Bright open-plan commercial interior with white work counters, desks and a feature ceiling",
    "overviewTitle": "Leasehold Improvements, Done Right",
    "summary": "MRE Developments builds tenant improvements for business owners, landlords and property managers in Calgary, Airdrie, Cochrane, Okotoks and Chestermere. We turn bare or outdated lease space into a working office, shop or service space, coordinating space planning, permits, trades and inspections from start to finish. Our schedules are built around your possession and opening dates, with after-hours work available when neighbouring tenants need to stay open.",
    "highlights": [
      "Leasehold improvements for new tenants",
      "Space planning and layout changes",
      "Fast-track schedules around lease dates",
      "After-hours work in occupied buildings",
      "Permits and inspections coordinated",
      "Licensed and insured contractor"
    ],
    "features": [
      {
        "title": "Built Around Your Lease Dates",
        "body": "Rent often starts before a space is ready, so every week of construction matters. We plan the tenant improvement around your possession date, order long-lead materials early and sequence trades so walls, mechanical, electrical and finishes move without gaps.",
        "benefit": "Your space opens sooner and starts earning instead of sitting under construction."
      },
      {
        "title": "Space Planning That Fits Your Business",
        "body": "Before construction starts, we review how your staff and customers will use the space and work out wall locations, rooms, storage and circulation. Layout changes are checked against building code, accessibility and the base building's systems so the plan is practical to build.",
        "benefit": "You get a layout that works for daily operations, not just on paper."
      },
      {
        "title": "Working in Occupied Buildings",
        "body": "Tenant improvements in Calgary often happen in buildings where other businesses are open. We follow landlord rules for access, noise and loading, protect common areas and schedule disruptive work after hours where needed.",
        "benefit": "Landlords and neighbouring tenants stay on side while your space is built."
      }
    ],
    "galleryIntro": "Project photos for tenant improvements will be added here as new work is documented.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What is a tenant improvement?",
        "a": "A tenant improvement, or leasehold improvement, is the construction work that adapts a commercial lease space to a specific tenant. It can include new walls and rooms, ceilings, lighting, flooring, washrooms and finishes. MRE Developments builds tenant improvements for offices, shops and service businesses in Calgary and area."
      },
      {
        "q": "Do you work with landlords and property managers?",
        "a": "Yes. We work with both tenants and landlords, and we follow the building's rules for access, insurance, noise and working hours. If the landlord has base building requirements or approved trades for certain systems, we plan around them."
      },
      {
        "q": "Can you work after hours?",
        "a": "Yes. When a building is occupied or your business needs to keep operating, we can schedule noisy or disruptive work for evenings or weekends. We confirm the approach with you and the landlord during planning."
      },
      {
        "q": "Do you handle permits for tenant improvements?",
        "a": "Yes. Most tenant improvements in Calgary need a building permit, and many also need trade permits. We coordinate the permits and book the required inspections as the work progresses."
      },
      {
        "q": "How long does a tenant improvement take?",
        "a": "It depends on the size of the space, the amount of new construction, permit timing and material lead times. We provide a schedule with your quote and build it around your possession and opening dates."
      },
      {
        "q": "How much does a tenant improvement cost?",
        "a": "Every space is different, so we quote each project individually after reviewing the space and your plans. The quote is free and detailed, so you and your landlord can see what is included."
      }
    ],
    "ctaTitle": "Get Your Lease Space Ready to Open",
    "ctaSubtitle": "Share your lease details, dates and plans, and we will prepare a free, detailed tenant improvement quote for your Calgary space."
  },
  "video-production": {
    "metaTitle": "Video Production Calgary | MRE Developments",
    "metaDescription": "Promotional videos, social clips, project and drone footage for Calgary and Canadian businesses. Book a free video strategy consultation with MRE today.",
    "headline": "Video Production in Calgary That Shows Your Work",
    "subheadline": "Customers want to see what you do before they call. We plan, shoot and edit promo films and social video that explain your business clearly and build trust.",
    "hero": "https://images.unsplash.com/photo-1496664444929-8c75efb9546f?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Editing desk with two monitors, a desk lamp and shelves of books in a bright studio",
    "overviewTitle": "Video That Shows, Not Tells",
    "summary": "MRE Developments offers video production for businesses in Calgary and across Canada, from promotional and brand films to social video, project footage and aerial drone footage. We handle planning, filming, editing and post-production, then deliver versions sized for your website, social channels and ads. Every project starts with a clear brief, scope and transparent pricing.",
    "highlights": [
      "Promotional and brand films",
      "Short-form social video",
      "Project and progress footage",
      "Drone footage where permitted",
      "Editing, colour and sound",
      "Versions for web, social and ads"
    ],
    "features": [
      {
        "title": "Story-Driven Promo and Brand Films",
        "body": "We start with the message you need to get across and the audience you need to reach, then plan a story, shot list and schedule around it. Interviews, on-site footage and b-roll are combined into a film that explains what makes your business different.",
        "benefit": "A video that builds trust before a customer ever picks up the phone."
      },
      {
        "title": "Planning, Filming and Post",
        "body": "Pre-production covers scripting, locations and scheduling so shoot days run smoothly. In post, we edit, colour correct, mix sound and add captions and graphics so the finished video looks polished on any screen.",
        "benefit": "A professional result without you managing the production details."
      },
      {
        "title": "Social Clips and Project Footage",
        "body": "From one shoot we can cut short vertical clips for social media alongside longer edits for your website. Project and progress footage, including aerial drone shots where site access and airspace rules allow, documents work as it happens.",
        "benefit": "More usable content from every shoot day."
      }
    ],
    "galleryIntro": "Video samples suited to your project are reviewed during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "What does a video production project include?",
        "a": "A typical project includes a discovery call, script or outline, shoot planning, filming, editing, colour correction, sound and delivery in the formats you need. The exact deliverables are listed in the scope."
      },
      {
        "q": "Can you shoot drone footage?",
        "a": "Drone footage can be included where the location, site permissions and Canadian airspace rules allow. We confirm feasibility for each location during planning."
      },
      {
        "q": "How long does a video take to produce?",
        "a": "It depends on the length and number of videos, how many shoot days and locations are involved and the amount of post-production. A schedule is provided with the scope after the consultation."
      },
      {
        "q": "Do you film outside Calgary?",
        "a": "We are based in Calgary and film locally, and editing and post-production can be delivered for businesses across Canada. Travel for shoots outside the Calgary area is scoped per project."
      },
      {
        "q": "How much does video production cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number and length of videos, shoot days and locations, crew and equipment needs, drone footage and the level of editing and graphics. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Video Strategy Consultation",
    "ctaSubtitle": "Tell us what you want your video to achieve. We will outline a concept, deliverables and a clear scope."
  },
  "waterproofing": {
    "metaTitle": "Waterproofing Contractor Calgary | MRE Developments",
    "metaDescription": "Basement and foundation waterproofing in Calgary, Airdrie and Okotoks: membranes, drainage board and leak prevention by MRE Developments. Get a free quote.",
    "headline": "Basement and Foundation Waterproofing in Calgary",
    "subheadline": "Stop water before it reaches your basement. We excavate, seal and protect foundation walls with membrane and drainage systems that guard against leaks, mould and structural damage.",
    "hero": "2025/09/Screenshot-2025-09-22-at-3.43.38-PM.png",
    "heroAlt": "Worker levelling a line on a Calgary foundation wall above new dimpled drainage membrane",
    "overviewTitle": "Dry Basements, Protected Foundations",
    "summary": "MRE Developments waterproofs basements and foundations for homes across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. Our team excavates to expose the foundation, prepares and seals the wall, installs membrane and drainage layers, and backfills so water is directed away from the house. It is the groundwork that keeps a finished basement or suite dry for the long term.",
    "highlights": [
      "Exterior foundation waterproofing",
      "Membrane and sealant systems",
      "Dimpled drainage board protection",
      "Crack sealing and wall preparation",
      "Mould and leak prevention",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Stop Leaks at the Source",
        "body": "Water in a basement usually comes through cracks, joints or a foundation wall that was never properly sealed. Waterproofing from the outside stops it before it reaches the interior, protecting flooring, drywall and belongings.",
        "benefit": "A dry basement and peace of mind before you finish or rent the space.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.43.08-PM.png",
        "imageAlt": "Worker in hi-vis gear marking a level line on a foundation wall above dimpled drainage membrane"
      },
      {
        "title": "Layered Membrane Protection",
        "body": "We clean and repair the exposed foundation, apply a waterproof membrane or sealant, then add dimpled drainage board that creates an air gap and channels water down to the drainage system. The top edge is secured and sealed so water cannot get behind it.",
        "benefit": "Multiple layers of defence that keep water moving away from the wall."
      },
      {
        "title": "Ready for a Finished Basement",
        "body": "Waterproofing is often the first step before basement development, a separate entry or a legal suite. We coordinate it with excavation, foundation cutting and backfill so the whole project is sealed and protected in one sequence.",
        "benefit": "Foundation protection that supports the living space you build inside.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.44.27-PM.png",
        "imageAlt": "Operator cutting a foundation wall with a track-mounted saw above new drainage membrane in Calgary"
      }
    ],
    "galleryIntro": "Foundation waterproofing in progress on homes in the Calgary area, from membrane to finishing details.",
    "photos": [
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.43.08-PM.png",
        "caption": "Laying out the membrane line",
        "alt": "Worker in hi-vis gear marking a level line on a foundation above dimpled drainage membrane"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.43.38-PM.png",
        "caption": "Sealing the top of the membrane",
        "alt": "Installer levelling the top edge of a foundation waterproofing system above dimpled membrane in Calgary"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.44.27-PM.png",
        "caption": "Foundation work above the membrane",
        "alt": "Operator cutting a foundation wall with a track-mounted saw above installed drainage membrane"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "How does exterior foundation waterproofing work?",
        "a": "We excavate along the foundation to expose the wall, clean and repair it, then apply a waterproof membrane or sealant and add drainage board to keep water moving down and away. The trench is then backfilled and graded so surface water drains away from the house."
      },
      {
        "q": "When should I waterproof my basement?",
        "a": "Signs include damp walls, efflorescence, musty smells, water stains or seepage after heavy rain or spring melt. Waterproofing is also worth doing before developing a basement or adding a suite, so the new finishes are protected from the start."
      },
      {
        "q": "Is this the same as Kerdi shower waterproofing?",
        "a": "No. This service protects foundations and below-grade spaces from groundwater. Waterproofing inside showers with Schluter-Kerdi systems is a separate service on our site."
      },
      {
        "q": "Can you waterproof in a narrow side yard?",
        "a": "Yes. Where equipment cannot reach, our crew excavates by hand to give full access to the foundation while protecting fences, landscaping and neighbouring property."
      },
      {
        "q": "How much does foundation waterproofing cost?",
        "a": "Cost depends on how much of the foundation needs to be exposed, depth, access, the condition of the wall and the system used. We provide a free, detailed quote after inspecting the site."
      },
      {
        "q": "What warranty do you offer on waterproofing?",
        "a": "Our warranty and workmanship terms are set out in writing with your quote, along with any manufacturer coverage on the membrane products used."
      }
    ],
    "ctaTitle": "Protect Your Basement From Water",
    "ctaSubtitle": "Tell us what you are seeing in your basement and we will inspect the foundation and prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Foundation membrane waterproofing",
        "summary": "Dimple membrane installed on the exposed foundation wall, levelled and fastened under the siding.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-3.43.08-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.43.38-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.44.27-PM.png"
        ]
      }
    ]
  },
  "web-design": {
    "metaTitle": "Web Design & Development Calgary | MRE Developments",
    "metaDescription": "Custom websites, e-commerce and landing pages built for speed and leads. Calgary web design company serving Canada. Book a free strategy consultation.",
    "headline": "Web Design & Development in Calgary, Built to Convert",
    "subheadline": "A slow, dated website costs you enquiries every day. We design and build fast, modern sites that explain what you do clearly and turn visitors into leads.",
    "hero": "https://images.unsplash.com/photo-1510074377623-8cf13fb86c08?auto=format&fit=crop&w=1600&q=80",
    "heroAlt": "Open-plan design studio with computer workstations on wooden desks and task lamps",
    "overviewTitle": "Websites That Do Real Work",
    "summary": "MRE Developments is a Calgary web design company building custom websites, e-commerce stores and landing pages for businesses across Canada. The site you are reading, including its instant estimator and chat assistant, is our own work. We focus on speed, clear messaging and conversion, then keep your site secure and up to date with ongoing hosting and care.",
    "highlights": [
      "Custom design, no generic templates",
      "Mobile-first and fast-loading",
      "E-commerce and online booking",
      "Landing pages for campaigns",
      "Built-in SEO foundations",
      "Hosting, updates and ongoing care"
    ],
    "features": [
      {
        "title": "Designed Around Your Customers",
        "body": "We plan each site around the questions your customers ask before they call, then structure pages and calls to action to answer them. Every layout is designed for phones first, because that is where most visitors arrive.",
        "benefit": "Visitors find what they need quickly and know exactly how to contact you."
      },
      {
        "title": "Fast, Modern Development",
        "body": "We build with current frameworks, optimised images and clean code so pages load quickly and score well on Core Web Vitals. Interactive tools, like the instant estimator and chat assistant on this site, can be built in where they help customers take the next step.",
        "benefit": "A faster site that search engines and customers both treat as credible."
      },
      {
        "title": "E-commerce, Redesigns and Care",
        "body": "Whether you need an online store, a set of campaign landing pages or a redesign of an existing site, we migrate content carefully and protect your search visibility. After launch, hosting and care plans cover updates, backups and security monitoring.",
        "benefit": "Your website stays fast, secure and current without becoming another job on your list."
      }
    ],
    "galleryIntro": "Website examples, including this site, are walked through during your free consultation.",
    "photos": [],
    "videos": [],
    "faqs": [
      {
        "q": "Did you build this website?",
        "a": "Yes. The MRE Developments website, including its instant estimator and chat assistant, was designed and built in-house. It is a working example of the kind of fast, conversion-focused site we build for clients."
      },
      {
        "q": "How long does a new website take?",
        "a": "It depends on the number of pages, how much content is ready, any e-commerce or custom features and how quickly feedback comes back. After the consultation we provide a schedule with clear milestones alongside the scope."
      },
      {
        "q": "Can you redesign my existing website without losing my Google rankings?",
        "a": "We plan redesigns to protect existing visibility by mapping old URLs to new ones, preserving important content and setting up redirects. No one can guarantee rankings, but a careful migration avoids the most common causes of lost traffic."
      },
      {
        "q": "Do you offer hosting and maintenance?",
        "a": "Yes. Hosting and care plans cover software updates, backups, uptime and security monitoring, and small content changes. The details are set out in the scope so you know what is included."
      },
      {
        "q": "Do you work with businesses outside Calgary?",
        "a": "Yes. We are based in Calgary and build websites for businesses across Canada, with planning, design reviews and training handled by video call."
      },
      {
        "q": "How much does a website cost?",
        "a": "Pricing is scoped per project after a free strategy consultation. The cost depends on the number of pages, custom features such as e-commerce or booking, content and copywriting needs, and whether you add a hosting and care plan. You receive a clear scope and transparent, project-specific pricing in writing before any work begins."
      }
    ],
    "ctaTitle": "Book a Free Website Strategy Consultation",
    "ctaSubtitle": "Share your current site and your goals. We will recommend a clear scope for a website that brings in more enquiries."
  },
  "windows-doors": {
    "metaTitle": "Egress Windows, Windows & Doors Calgary | MRE",
    "metaDescription": "Egress windows, window replacement and exterior door installation in Calgary, Airdrie and Okotoks, sealed for Alberta weather. Request a free MRE quote.",
    "headline": "Egress Windows, Windows and Exterior Doors in Calgary",
    "subheadline": "New openings, replacement windows and exterior doors installed square, sealed and flashed, so they keep out drafts and water and meet code for basement bedrooms and suites.",
    "hero": "2025/09/Screenshot-2025-09-22-at-3.25.51-PM.png",
    "heroAlt": "Finished separate basement entry in Calgary with concrete stairwell, exterior door and black metal railing",
    "overviewTitle": "Openings Built to Last",
    "summary": "MRE Developments installs egress windows, replacement windows, exterior doors and patio doors for homeowners across Calgary, Airdrie, Cochrane, Okotoks and Chestermere. From cutting and framing new openings to setting, levelling and weather-sealing the unit, our team handles the work end to end. Every installation is built to keep out Alberta wind, cold and moisture while meeting egress and building code requirements.",
    "highlights": [
      "Egress windows for basement bedrooms",
      "Window replacement and new openings",
      "Exterior, side and patio doors",
      "Proper flashing and weather sealing",
      "Permits handled for new openings",
      "Licensed, insured, free detailed quotes"
    ],
    "features": [
      {
        "title": "Safe Exits and Legal Suites",
        "body": "Basement bedrooms need an egress window large enough to escape through, and a legal suite often needs its own exterior door. We plan the opening, cut and frame it properly, and install the window or door so it meets code and opens freely.",
        "benefit": "Safer basement bedrooms and an entry that supports a legal suite.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.25.30-PM-1.png",
        "imageAlt": "New exterior door with window set into a concrete foundation at the bottom of a basement entry stairwell"
      },
      {
        "title": "Square, Level and Sealed",
        "body": "A door or window only works as well as it is installed. We frame the rough opening with a solid header, then set, shim and level the unit before sealing and flashing it into the wall so water is directed out, not in.",
        "benefit": "Doors that close smoothly and openings that stay draft-free and dry.",
        "image": "2025/09/Screenshot-2025-09-22-at-2.36.27-PM.png",
        "imageAlt": "Installer checking a new exterior door with a level in a framed opening in vinyl siding in Calgary"
      },
      {
        "title": "Finished to Match the House",
        "body": "We trim and finish each new opening so it blends with your siding, stucco or stone, and pour concrete steps or stairwells where a new door needs them. Energy-efficient units help cut heat loss through Calgary winters.",
        "benefit": "A clean exterior finish and a more comfortable, efficient home.",
        "image": "2025/09/Screenshot-2025-09-22-at-3.46.45-PM.png",
        "imageAlt": "New white exterior door with poured concrete steps on a home with red vinyl siding"
      }
    ],
    "galleryIntro": "Exterior door installations and new openings completed by MRE Developments for homes in the Calgary area.",
    "photos": [
      {
        "src": "2025/09/Screenshot-2025-09-22-at-2.32.02-PM.png",
        "caption": "New opening cut in exterior wall",
        "alt": "Exterior wall opened up for a new door on a Calgary home, with siding removed around the opening"
      },
      {
        "src": "2025/09/3-2.png",
        "caption": "Framed header for a new opening",
        "alt": "New rough opening framed with a solid wood header in an exterior wall before door installation"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-2.36.27-PM.png",
        "caption": "Levelling the door in its frame",
        "alt": "Installer levelling a new exterior door in a framed opening during door installation in Calgary"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-2.37.20-PM.png",
        "caption": "New side door, cleanly trimmed",
        "alt": "New white exterior door installed and trimmed into beige vinyl siding on a Calgary home"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-1.59.33-PM.png",
        "caption": "Concrete stairwell to new door",
        "alt": "Poured concrete stairs leading down to a new basement exterior door installed by MRE Developments"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.25.51-PM.png",
        "caption": "Basement entry with metal railing",
        "alt": "Finished basement separate entry in Calgary with concrete stairwell, door and black metal railing"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.25.30-PM-1.png",
        "caption": "Below-grade door with glass panel",
        "alt": "New exterior door with glass panel set into the foundation at the base of a concrete stairwell"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.46.45-PM.png",
        "caption": "Side door with concrete steps",
        "alt": "New white exterior side door with concrete steps on a Calgary home with red vinyl siding"
      },
      {
        "src": "2025/09/Screenshot-2025-09-22-at-3.23.10-PM.png",
        "caption": "Stairwell before finishing",
        "alt": "Concrete basement entry stairwell under construction beside a house, before the door and railing go in"
      }
    ],
    "videos": [],
    "faqs": [
      {
        "q": "What makes a window an egress window?",
        "a": "An egress window is sized and positioned so a person can climb out in an emergency. Bedrooms in a developed basement need one, and the window well in front must leave enough clear space to get out. We size and install egress windows to meet the current building code."
      },
      {
        "q": "Can you add a new exterior door or separate entry?",
        "a": "Yes. We cut and frame new openings for side doors and basement entries, install the door, and build any concrete steps or stairwell needed. Structural openings follow an engineered design where required, and we handle the permits."
      },
      {
        "q": "Do you replace windows in an existing home?",
        "a": "Yes. We replace windows as part of renovation and upgrade projects, removing the old units, correcting the rough opening if needed, and installing new energy-efficient windows with proper flashing and sealing."
      },
      {
        "q": "How do you keep new windows and doors from leaking?",
        "a": "Water management is built into the installation: a properly prepared rough opening, flashing that sheds water outward, sealed joints and insulation around the frame. These steps matter more than the window or door itself in keeping the wall dry."
      },
      {
        "q": "How much does window or door installation cost?",
        "a": "Cost depends on the number and size of units, the product you choose, whether a new opening must be cut, and exterior finishing. We provide a free, detailed quote after reviewing the home."
      },
      {
        "q": "What warranty do you provide?",
        "a": "Windows and doors carry the manufacturer's product warranty, and our installation workmanship terms are set out in writing with your quote."
      }
    ],
    "ctaTitle": "Get a Quote for Windows or Doors",
    "ctaSubtitle": "Tell us about the openings you want to add or replace, and we will prepare a free, detailed quote.",
    "projects": [
      {
        "title": "Side entry door replacement",
        "summary": "Old door removed, opening reframed, new door set and levelled, trimmed with siding.",
        "dates": "Sep 2025",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-2.32.02-PM.png",
          "2025/09/3-2.png",
          "2025/09/Screenshot-2025-09-22-at-2.36.27-PM.png",
          "2025/09/Screenshot-2025-09-22-at-2.37.20-PM.png"
        ]
      },
      {
        "title": "Below-grade basement entrance stairwell",
        "summary": "Concrete stairwell down to a separate basement entry, finished with railing.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-1.59.33-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.25.51-PM.png"
        ]
      },
      {
        "title": "More windows and doors work",
        "summary": "Basement walkout door, side entry door with concrete steps, stairwell under construction.",
        "dates": "",
        "photos": [
          "2025/09/Screenshot-2025-09-22-at-3.25.30-PM-1.png",
          "2025/09/Screenshot-2025-09-22-at-3.46.45-PM.png",
          "2025/09/Screenshot-2025-09-22-at-3.23.10-PM.png"
        ]
      }
    ]
  }
};
